(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as r0, getPartnerDevApiHeaders as i0, WidgetContextProvider as a0, makeExecuteQuery as o0, makeUseLazyQuery as s0, makeUseQuery as l0, makeUseMutation as c0, validateApiHostName as qb, useTracking as _n, useWidgetContext as hn, hasDownstreamApiForbiddenError as Wm, hasDownstreamApiAuthorizationError as Gm, DisplayErrors as Fn, useCopyWithDelay as or, defaultDateFormat as xt, displayAttributeValue as po, useWidgetSettingsMutations as Ni, useWidgetSettingsQuery as ji, useRenderConditions as wi, PartnerSettingsWrapper as Ci, handleWidgetSubmit as Fi, MisconfigurationBanner as Ii, OAuthSettings as sa, WidgetSettingsFormFooter as Ei, useData as Km, PartnerHookFormSecretText as Ym, isDownstreamApiNotFoundError as d0, isDownstreamApiAuthorizationError as Hb, KlaviyoSubscribeSetting as u0, isDownstreamApiPermissionError as m0, capitalizeFirstCharacter as Wb, humanizeKey as p0, hasDownstreamApiTooManyRequestsError as f0, hasDownstreamApiPermissionError as Gb, PartnerHookFormBasicAuth as h0, hasDownstreamApiNotFoundError as vo, getCountryNameFromCountryCode as y0, parseBoolean as g0, parseString as v0, IntegrationModal as Kb, useInboundOAuthContext as k0, getWidgetConfigurationByIdQuery as b0, createWidgetConfigurationMutation as x0, updateWidgetConfigurationMutation as _0, trackRenderConditionsSaved as S0, deleteWidgetConfigurationMutation as N0 } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Fe, { useMemo as Bn, useState as le, useEffect as He, useRef as vi, useCallback as ot, useReducer as j0, useLayoutEffect as w0, useContext as Qm, createContext as Yb, isValidElement as C0, createElement as F0, Fragment as I0 } from "react";
import { Text as A, FlexBox as b, Spinner as un, Icon as pe, Tooltip as We, List as Ye, Badge as Pn, Button as Gn, IconButton as nr, Switch as im, FieldLabel as E0, FieldWrapper as ln, InputText as Nr, InputSelectionList as ei, FormGrid as st, FormField as be, Tag as An, NavigationButton as Et, Select as wr, CollapseCard as mr, Box as et, Modal as Tt, ModalHead as $t, ModalBody as Dt, ModalFoot as Pt, Textarea as am, TagsInput as Ws, Image as la, Banner as Gs, Divider as Jm, SelectionList as ut, FieldText as pr, FieldTextarea as T0, CopyToClipboardButton as $0, getSelectionListContext as D0, Avatar as Xm, Timestamp as R0, Attachment as O0, EmptyState as Ns, Table as Xn, Checkbox as yf, TextWithHighlight as P0, ErrorBoundaryContext as Qb, FieldSwitch as Jb } from "@dixa/lib-shared-habla";
import it from "classnames";
import { ApolloLink as Zm, Observable as Xb, ApolloClient as A0, InMemoryCache as L0, createHttpLink as V0, ApolloProvider as z0, useApolloClient as U0, ApolloConsumer as M0, NetworkStatus as er, isApolloError as Zb, ApolloError as ex, gql as Ks, useQuery as B0, useMutation as gf } from "@apollo/client";
import q0 from "cross-fetch";
import { config as fo } from "lib-shared-backend-config";
import Ln from "moment";
import "moment-timezone";
import { __rest as H0, __assign as yl } from "tslib";
import { useLocation as W0 } from "react-router-dom";
function ep(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $o = { exports: {} }, ya = {};
var vf;
function G0() {
  if (vf) return ya;
  vf = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return ya.Fragment = t, ya.jsx = s, ya.jsxs = s, ya;
}
var ga = {};
var kf;
function K0() {
  return kf || (kf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c, P));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ga.Fragment = i, ga.jsx = Rn, ga.jsxs = Mn;
  })()), ga;
}
var bf;
function Y0() {
  return bf || (bf = 1, process.env.NODE_ENV === "production" ? $o.exports = G0() : $o.exports = K0()), $o.exports;
}
var Ve = Y0();
function nx(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: Q0 } = Object.prototype, { getPrototypeOf: Ys } = Object, { iterator: Qs, toStringTag: tx } = Symbol, Js = /* @__PURE__ */ ((e) => (n) => {
  const t = Q0.call(n);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Cr = (e) => (e = e.toLowerCase(), (n) => Js(n) === e), Xs = (e) => (n) => typeof n === e, { isArray: ca } = Array, ta = Xs("undefined");
function ko(e) {
  return e !== null && !ta(e) && e.constructor !== null && !ta(e.constructor) && Jt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const rx = Cr("ArrayBuffer");
function J0(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && rx(e.buffer), n;
}
const X0 = Xs("string"), Jt = Xs("function"), ix = Xs("number"), bo = (e) => e !== null && typeof e == "object", Z0 = (e) => e === !0 || e === !1, cs = (e) => {
  if (Js(e) !== "object")
    return !1;
  const n = Ys(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(tx in e) && !(Qs in e);
}, eN = (e) => {
  if (!bo(e) || ko(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, nN = Cr("Date"), tN = Cr("File"), rN = (e) => !!(e && typeof e.uri < "u"), iN = (e) => e && typeof e.getParts < "u", aN = Cr("Blob"), oN = Cr("FileList"), sN = (e) => bo(e) && Jt(e.pipe);
function lN() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const xf = lN(), _f = typeof xf.FormData < "u" ? xf.FormData : void 0, cN = (e) => {
  if (!e) return !1;
  if (_f && e instanceof _f) return !0;
  const n = Ys(e);
  if (!n || n === Object.prototype || !Jt(e.append)) return !1;
  const t = Js(e);
  return t === "formdata" || // detect form-data instance
  t === "object" && Jt(e.toString) && e.toString() === "[object FormData]";
}, dN = Cr("URLSearchParams"), [uN, mN, pN, fN] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Cr), hN = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function xo(e, n, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), ca(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (ko(e))
      return;
    const o = t ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function ax(e, n) {
  if (ko(e))
    return null;
  n = n.toLowerCase();
  const t = Object.keys(e);
  let i = t.length, a;
  for (; i-- > 0; )
    if (a = t[i], n === a.toLowerCase())
      return a;
  return null;
}
const fi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ox = (e) => !ta(e) && e !== fi;
function om() {
  const { caseless: e, skipUndefined: n } = ox(this) && this || {}, t = {}, i = (a, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const s = e && ax(t, o) || o;
    cs(t[s]) && cs(a) ? t[s] = om(t[s], a) : cs(a) ? t[s] = om({}, a) : ca(a) ? t[s] = a.slice() : (!n || !ta(a)) && (t[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && xo(arguments[a], i);
  return t;
}
const yN = (e, n, t, { allOwnKeys: i } = {}) => (xo(
  n,
  (a, o) => {
    t && Jt(a) ? Object.defineProperty(e, o, {
      value: nx(a, t),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), gN = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), vN = (e, n, t, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: n.prototype
  }), t && Object.assign(e.prototype, t);
}, kN = (e, n, t, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = t !== !1 && Ys(e);
  } while (e && (!t || t(e, n)) && e !== Object.prototype);
  return n;
}, bN = (e, n, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= n.length;
  const i = e.indexOf(n, t);
  return i !== -1 && i === t;
}, xN = (e) => {
  if (!e) return null;
  if (ca(e)) return e;
  let n = e.length;
  if (!ix(n)) return null;
  const t = new Array(n);
  for (; n-- > 0; )
    t[n] = e[n];
  return t;
}, _N = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ys(Uint8Array)), SN = (e, n) => {
  const i = (e && e[Qs]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, NN = (e, n) => {
  let t;
  const i = [];
  for (; (t = e.exec(n)) !== null; )
    i.push(t);
  return i;
}, jN = Cr("HTMLFormElement"), wN = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, i, a) {
  return i.toUpperCase() + a;
}), Sf = (({ hasOwnProperty: e }) => (n, t) => e.call(n, t))(Object.prototype), CN = Cr("RegExp"), sx = (e, n) => {
  const t = Object.getOwnPropertyDescriptors(e), i = {};
  xo(t, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, FN = (e) => {
  sx(e, (n, t) => {
    if (Jt(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const i = e[t];
    if (Jt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, IN = (e, n) => {
  const t = {}, i = (a) => {
    a.forEach((o) => {
      t[o] = !0;
    });
  };
  return ca(e) ? i(e) : i(String(e).split(n)), t;
}, EN = () => {
}, TN = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function $N(e) {
  return !!(e && Jt(e.append) && e[tx] === "FormData" && e[Qs]);
}
const DN = (e) => {
  const n = new Array(10), t = (i, a) => {
    if (bo(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (ko(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = ca(i) ? [] : {};
        return xo(i, (s, l) => {
          const d = t(s, a + 1);
          !ta(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return t(e, 0);
}, RN = Cr("AsyncFunction"), ON = (e) => e && (bo(e) || Jt(e)) && Jt(e.then) && Jt(e.catch), lx = ((e, n) => e ? setImmediate : n ? ((t, i) => (fi.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === fi && o === t && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), fi.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(typeof setImmediate == "function", Jt(fi.postMessage)), PN = typeof queueMicrotask < "u" ? queueMicrotask.bind(fi) : typeof process < "u" && process.nextTick || lx, AN = (e) => e != null && Jt(e[Qs]), ke = {
  isArray: ca,
  isArrayBuffer: rx,
  isBuffer: ko,
  isFormData: cN,
  isArrayBufferView: J0,
  isString: X0,
  isNumber: ix,
  isBoolean: Z0,
  isObject: bo,
  isPlainObject: cs,
  isEmptyObject: eN,
  isReadableStream: uN,
  isRequest: mN,
  isResponse: pN,
  isHeaders: fN,
  isUndefined: ta,
  isDate: nN,
  isFile: tN,
  isReactNativeBlob: rN,
  isReactNative: iN,
  isBlob: aN,
  isRegExp: CN,
  isFunction: Jt,
  isStream: sN,
  isURLSearchParams: dN,
  isTypedArray: _N,
  isFileList: oN,
  forEach: xo,
  merge: om,
  extend: yN,
  trim: hN,
  stripBOM: gN,
  inherits: vN,
  toFlatObject: kN,
  kindOf: Js,
  kindOfTest: Cr,
  endsWith: bN,
  toArray: xN,
  forEachEntry: SN,
  matchAll: NN,
  isHTMLForm: jN,
  hasOwnProperty: Sf,
  hasOwnProp: Sf,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: sx,
  freezeMethods: FN,
  toObjectSet: IN,
  toCamelCase: wN,
  noop: EN,
  toFiniteNumber: TN,
  findKey: ax,
  global: fi,
  isContextDefined: ox,
  isSpecCompliantForm: $N,
  toJSONObject: DN,
  isAsyncFn: RN,
  isThenable: ON,
  setImmediate: lx,
  asap: PN,
  isIterable: AN
};
let yn = class cx extends Error {
  static from(n, t, i, a, o, s) {
    const l = new cx(n.message, t || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, t, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ke.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
yn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
yn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
yn.ECONNABORTED = "ECONNABORTED";
yn.ETIMEDOUT = "ETIMEDOUT";
yn.ERR_NETWORK = "ERR_NETWORK";
yn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
yn.ERR_DEPRECATED = "ERR_DEPRECATED";
yn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
yn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
yn.ERR_CANCELED = "ERR_CANCELED";
yn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
yn.ERR_INVALID_URL = "ERR_INVALID_URL";
yn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const LN = null;
function sm(e) {
  return ke.isPlainObject(e) || ke.isArray(e);
}
function dx(e) {
  return ke.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function gl(e, n, t) {
  return e ? e.concat(n).map(function(a, o) {
    return a = dx(a), !t && o ? "[" + a + "]" : a;
  }).join(t ? "." : "") : n;
}
function VN(e) {
  return ke.isArray(e) && !e.some(sm);
}
const zN = ke.toFlatObject(ke, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Zs(e, n, t) {
  if (!ke.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), t = ke.toFlatObject(
    t,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(N, w) {
      return !ke.isUndefined(w[N]);
    }
  );
  const i = t.metaTokens, a = t.visitor || f, o = t.dots, s = t.indexes, l = t.Blob || typeof Blob < "u" && Blob, d = t.maxDepth === void 0 ? 100 : t.maxDepth, m = l && ke.isSpecCompliantForm(n);
  if (!ke.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(S) {
    if (S === null) return "";
    if (ke.isDate(S))
      return S.toISOString();
    if (ke.isBoolean(S))
      return S.toString();
    if (!m && ke.isBlob(S))
      throw new yn("Blob is not supported. Use a Buffer instead.");
    return ke.isArrayBuffer(S) || ke.isTypedArray(S) ? m && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  function f(S, N, w) {
    let y = S;
    if (ke.isReactNative(n) && ke.isReactNativeBlob(S))
      return n.append(gl(w, N, o), u(S)), !1;
    if (S && !w && typeof S == "object") {
      if (ke.endsWith(N, "{}"))
        N = i ? N : N.slice(0, -2), S = JSON.stringify(S);
      else if (ke.isArray(S) && VN(S) || (ke.isFileList(S) || ke.endsWith(N, "[]")) && (y = ke.toArray(S)))
        return N = dx(N), y.forEach(function($, I) {
          !(ke.isUndefined($) || $ === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? gl([N], I, o) : s === null ? N : N + "[]",
            u($)
          );
        }), !1;
    }
    return sm(S) ? !0 : (n.append(gl(w, N, o), u(S)), !1);
  }
  const h = [], g = Object.assign(zN, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: sm
  });
  function C(S, N, w = 0) {
    if (!ke.isUndefined(S)) {
      if (w > d)
        throw new yn(
          "Object is too deeply nested (" + w + " levels). Max depth: " + d,
          yn.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (h.indexOf(S) !== -1)
        throw Error("Circular reference detected in " + N.join("."));
      h.push(S), ke.forEach(S, function(z, $) {
        (!(ke.isUndefined(z) || z === null) && a.call(n, z, ke.isString($) ? $.trim() : $, N, g)) === !0 && C(z, N ? N.concat($) : [$], w + 1);
      }), h.pop();
    }
  }
  if (!ke.isObject(e))
    throw new TypeError("data must be an object");
  return C(e), n;
}
function Nf(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function np(e, n) {
  this._pairs = [], e && Zs(e, this, n);
}
const ux = np.prototype;
ux.append = function(n, t) {
  this._pairs.push([n, t]);
};
ux.toString = function(n) {
  const t = n ? function(i) {
    return n.call(this, i, Nf);
  } : Nf;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function UN(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function mx(e, n, t) {
  if (!n)
    return e;
  const i = t && t.encode || UN, a = ke.isFunction(t) ? {
    serialize: t
  } : t, o = a && a.serialize;
  let s;
  if (o ? s = o(n, a) : s = ke.isURLSearchParams(n) ? n.toString() : new np(n, a).toString(i), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class jf {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, t, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: t,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ke.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const tp = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, MN = typeof URLSearchParams < "u" ? URLSearchParams : np, BN = typeof FormData < "u" ? FormData : null, qN = typeof Blob < "u" ? Blob : null, HN = {
  isBrowser: !0,
  classes: {
    URLSearchParams: MN,
    FormData: BN,
    Blob: qN
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, rp = typeof window < "u" && typeof document < "u", lm = typeof navigator == "object" && navigator || void 0, WN = rp && (!lm || ["ReactNative", "NativeScript", "NS"].indexOf(lm.product) < 0), GN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", KN = rp && window.location.href || "http://localhost", YN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: rp,
  hasStandardBrowserEnv: WN,
  hasStandardBrowserWebWorkerEnv: GN,
  navigator: lm,
  origin: KN
}, Symbol.toStringTag, { value: "Module" })), Rt = {
  ...YN,
  ...HN
};
function QN(e, n) {
  return Zs(e, new Rt.classes.URLSearchParams(), {
    visitor: function(t, i, a, o) {
      return Rt.isNode && ke.isBuffer(t) ? (this.append(i, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function JN(e) {
  return ke.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function XN(e) {
  const n = {}, t = Object.keys(e);
  let i;
  const a = t.length;
  let o;
  for (i = 0; i < a; i++)
    o = t[i], n[o] = e[o];
  return n;
}
function px(e) {
  function n(t, i, a, o) {
    let s = t[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= t.length;
    return s = !s && ke.isArray(a) ? a.length : s, d ? (ke.hasOwnProp(a, s) ? a[s] = ke.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!a[s] || !ke.isObject(a[s])) && (a[s] = []), n(t, i, a[s], o) && ke.isArray(a[s]) && (a[s] = XN(a[s])), !l);
  }
  if (ke.isFormData(e) && ke.isFunction(e.entries)) {
    const t = {};
    return ke.forEachEntry(e, (i, a) => {
      n(JN(i), a, t, 0);
    }), t;
  }
  return null;
}
const Pi = (e, n) => e != null && ke.hasOwnProp(e, n) ? e[n] : void 0;
function ZN(e, n, t) {
  if (ke.isString(e))
    try {
      return (n || JSON.parse)(e), ke.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (t || JSON.stringify)(e);
}
const _o = {
  transitional: tp,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, t) {
      const i = t.getContentType() || "", a = i.indexOf("application/json") > -1, o = ke.isObject(n);
      if (o && ke.isHTMLForm(n) && (n = new FormData(n)), ke.isFormData(n))
        return a ? JSON.stringify(px(n)) : n;
      if (ke.isArrayBuffer(n) || ke.isBuffer(n) || ke.isStream(n) || ke.isFile(n) || ke.isBlob(n) || ke.isReadableStream(n))
        return n;
      if (ke.isArrayBufferView(n))
        return n.buffer;
      if (ke.isURLSearchParams(n))
        return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = Pi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return QN(n, d).toString();
        if ((l = ke.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = Pi(this, "env"), u = m && m.FormData;
          return Zs(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (t.setContentType("application/json", !1), ZN(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const t = Pi(this, "transitional") || _o.transitional, i = t && t.forcedJSONParsing, a = Pi(this, "responseType"), o = a === "json";
      if (ke.isResponse(n) || ke.isReadableStream(n))
        return n;
      if (n && ke.isString(n) && (i && !a || o)) {
        const l = !(t && t.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Pi(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? yn.from(d, yn.ERR_BAD_RESPONSE, this, null, Pi(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Rt.classes.FormData,
    Blob: Rt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ke.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  _o.headers[e] = {};
});
const ej = ke.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), nj = (e) => {
  const n = {};
  let t, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), t = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!t || n[t] && ej[t]) && (t === "set-cookie" ? n[t] ? n[t].push(i) : n[t] = [i] : n[t] = n[t] ? n[t] + ", " + i : i);
  }), n;
}, wf = Symbol("internals"), tj = /[^\x09\x20-\x7E\x80-\xFF]/g;
function rj(e) {
  let n = 0, t = e.length;
  for (; n < t; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; t > n; ) {
    const i = e.charCodeAt(t - 1);
    if (i !== 9 && i !== 32)
      break;
    t -= 1;
  }
  return n === 0 && t === e.length ? e : e.slice(n, t);
}
function va(e) {
  return e && String(e).trim().toLowerCase();
}
function ij(e) {
  return rj(e.replace(tj, ""));
}
function ds(e) {
  return e === !1 || e == null ? e : ke.isArray(e) ? e.map(ds) : ij(String(e));
}
function aj(e) {
  const n = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = t.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const oj = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function vl(e, n, t, i, a) {
  if (ke.isFunction(i))
    return i.call(this, n, t);
  if (a && (n = t), !!ke.isString(n)) {
    if (ke.isString(i))
      return n.indexOf(i) !== -1;
    if (ke.isRegExp(i))
      return i.test(n);
  }
}
function sj(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, t, i) => t.toUpperCase() + i);
}
function lj(e, n) {
  const t = ke.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + t, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Xt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, t, i) {
    const a = this;
    function o(l, d, m) {
      const u = va(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ke.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = ds(l));
    }
    const s = (l, d) => ke.forEach(l, (m, u) => o(m, u, d));
    if (ke.isPlainObject(n) || n instanceof this.constructor)
      s(n, t);
    else if (ke.isString(n) && (n = n.trim()) && !oj(n))
      s(nj(n), t);
    else if (ke.isObject(n) && ke.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ke.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ke.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, t);
    } else
      n != null && o(t, n, i);
    return this;
  }
  get(n, t) {
    if (n = va(n), n) {
      const i = ke.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!t)
          return a;
        if (t === !0)
          return aj(a);
        if (ke.isFunction(t))
          return t.call(this, a, i);
        if (ke.isRegExp(t))
          return t.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, t) {
    if (n = va(n), n) {
      const i = ke.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!t || vl(this, this[i], i, t)));
    }
    return !1;
  }
  delete(n, t) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = va(s), s) {
        const l = ke.findKey(i, s);
        l && (!t || vl(i, i[l], l, t)) && (delete i[l], a = !0);
      }
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const t = Object.keys(this);
    let i = t.length, a = !1;
    for (; i--; ) {
      const o = t[i];
      (!n || vl(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const t = this, i = {};
    return ke.forEach(this, (a, o) => {
      const s = ke.findKey(i, o);
      if (s) {
        t[s] = ds(a), delete t[o];
        return;
      }
      const l = n ? sj(o) : String(o).trim();
      l !== o && delete t[o], t[l] = ds(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const t = /* @__PURE__ */ Object.create(null);
    return ke.forEach(this, (i, a) => {
      i != null && i !== !1 && (t[a] = n && ke.isArray(i) ? i.join(", ") : i);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, t]) => n + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...t) {
    const i = new this(n);
    return t.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[wf] = this[wf] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = va(s);
      i[l] || (lj(a, s), i[l] = !0);
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Xt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ke.reduceDescriptors(Xt.prototype, ({ value: e }, n) => {
  let t = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[t] = i;
    }
  };
});
ke.freezeMethods(Xt);
function kl(e, n) {
  const t = this || _o, i = n || t, a = Xt.from(i.headers);
  let o = i.data;
  return ke.forEach(e, function(l) {
    o = l.call(t, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function fx(e) {
  return !!(e && e.__CANCEL__);
}
let So = class extends yn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, t, i) {
    super(n ?? "canceled", yn.ERR_CANCELED, t, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function hx(e, n, t) {
  const i = t.config.validateStatus;
  !t.status || !i || i(t.status) ? e(t) : n(
    new yn(
      "Request failed with status code " + t.status,
      [yn.ERR_BAD_REQUEST, yn.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
      t.config,
      t.request,
      t
    )
  );
}
function cj(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function dj(e, n) {
  e = e || 10;
  const t = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), t[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += t[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const g = u && m - u;
    return g ? Math.round(h * 1e3 / g) : void 0;
  };
}
function uj(e, n) {
  let t = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    t = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - t;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const js = (e, n, t = 3) => {
  let i = 0;
  const a = dj(50, 250);
  return uj((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, t);
}, Cf = (e, n) => {
  const t = e != null;
  return [
    (i) => n[0]({
      lengthComputable: t,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, Ff = (e) => (...n) => ke.asap(() => e(...n)), mj = Rt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (t) => (t = new URL(t, Rt.origin), e.protocol === t.protocol && e.host === t.host && (n || e.port === t.port)))(
  new URL(Rt.origin),
  Rt.navigator && /(msie|trident)/i.test(Rt.navigator.userAgent)
) : () => !0, pj = Rt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, t, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ke.isNumber(t) && l.push(`expires=${new Date(t).toUTCString()}`), ke.isString(i) && l.push(`path=${i}`), ke.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ke.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return n ? decodeURIComponent(n[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function fj(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function hj(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function yx(e, n, t) {
  let i = !fj(n);
  return e && (i || t === !1) ? hj(e, n) : n;
}
const If = (e) => e instanceof Xt ? { ...e } : e;
function Si(e, n) {
  n = n || {};
  const t = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(t, "hasOwnProperty", {
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(m, u, f, h) {
    return ke.isPlainObject(m) && ke.isPlainObject(u) ? ke.merge.call({ caseless: h }, m, u) : ke.isPlainObject(u) ? ke.merge({}, u) : ke.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ke.isUndefined(u)) {
      if (!ke.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ke.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ke.isUndefined(u)) {
      if (!ke.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (ke.hasOwnProp(n, f))
      return i(m, u);
    if (ke.hasOwnProp(e, f))
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(If(m), If(u), f, !0)
  };
  return ke.forEach(Object.keys({ ...e, ...n }), function(u) {
    if (u === "__proto__" || u === "constructor" || u === "prototype") return;
    const f = ke.hasOwnProp(d, u) ? d[u] : a, h = ke.hasOwnProp(e, u) ? e[u] : void 0, g = ke.hasOwnProp(n, u) ? n[u] : void 0, C = f(h, g, u);
    ke.isUndefined(C) && f !== l || (t[u] = C);
  }), t;
}
const gx = (e) => {
  const n = Si({}, e), t = (h) => ke.hasOwnProp(n, h) ? n[h] : void 0, i = t("data");
  let a = t("withXSRFToken");
  const o = t("xsrfHeaderName"), s = t("xsrfCookieName");
  let l = t("headers");
  const d = t("auth"), m = t("baseURL"), u = t("allowAbsoluteUrls"), f = t("url");
  if (n.headers = l = Xt.from(l), n.url = mx(
    yx(m, f, u),
    e.params,
    e.paramsSerializer
  ), d && l.set(
    "Authorization",
    "Basic " + btoa(
      (d.username || "") + ":" + (d.password ? unescape(encodeURIComponent(d.password)) : "")
    )
  ), ke.isFormData(i)) {
    if (Rt.hasStandardBrowserEnv || Rt.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (ke.isFunction(i.getHeaders)) {
      const h = i.getHeaders(), g = ["content-type", "content-length"];
      Object.entries(h).forEach(([C, S]) => {
        g.includes(C.toLowerCase()) && l.set(C, S);
      });
    }
  }
  if (Rt.hasStandardBrowserEnv && (ke.isFunction(a) && (a = a(n)), a === !0 || a == null && mj(n.url))) {
    const g = o && s && pj.read(s);
    g && l.set(o, g);
  }
  return n;
}, yj = typeof XMLHttpRequest < "u", gj = yj && function(e) {
  return new Promise(function(t, i) {
    const a = gx(e);
    let o = a.data;
    const s = Xt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, g, C;
    function S() {
      g && g(), C && C(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let N = new XMLHttpRequest();
    N.open(a.method.toUpperCase(), a.url, !0), N.timeout = a.timeout;
    function w() {
      if (!N)
        return;
      const z = Xt.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), I = {
        data: !l || l === "text" || l === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: z,
        config: e,
        request: N
      };
      hx(
        function(U) {
          t(U), S();
        },
        function(U) {
          i(U), S();
        },
        I
      ), N = null;
    }
    "onloadend" in N ? N.onloadend = w : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, N.onabort = function() {
      N && (i(new yn("Request aborted", yn.ECONNABORTED, e, N)), N = null);
    }, N.onerror = function($) {
      const I = $ && $.message ? $.message : "Network Error", T = new yn(I, yn.ERR_NETWORK, e, N);
      T.event = $ || null, i(T), N = null;
    }, N.ontimeout = function() {
      let $ = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const I = a.transitional || tp;
      a.timeoutErrorMessage && ($ = a.timeoutErrorMessage), i(
        new yn(
          $,
          I.clarifyTimeoutError ? yn.ETIMEDOUT : yn.ECONNABORTED,
          e,
          N
        )
      ), N = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in N && ke.forEach(s.toJSON(), function($, I) {
      N.setRequestHeader(I, $);
    }), ke.isUndefined(a.withCredentials) || (N.withCredentials = !!a.withCredentials), l && l !== "json" && (N.responseType = a.responseType), m && ([h, C] = js(m, !0), N.addEventListener("progress", h)), d && N.upload && ([f, g] = js(d), N.upload.addEventListener("progress", f), N.upload.addEventListener("loadend", g)), (a.cancelToken || a.signal) && (u = (z) => {
      N && (i(!z || z.type ? new So(null, e, N) : z), N.abort(), N = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const y = cj(a.url);
    if (y && Rt.protocols.indexOf(y) === -1) {
      i(
        new yn(
          "Unsupported protocol " + y + ":",
          yn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    N.send(o || null);
  });
}, vj = (e, n) => {
  const { length: t } = e = e ? e.filter(Boolean) : [];
  if (n || t) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(
          u instanceof yn ? u : new So(u instanceof Error ? u.message : u)
        );
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new yn(`timeout of ${n}ms exceeded`, yn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ke.asap(l), d;
  }
}, kj = function* (e, n) {
  let t = e.byteLength;
  if (t < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < t; )
    a = i + n, yield e.slice(i, a), i = a;
}, bj = async function* (e, n) {
  for await (const t of xj(e))
    yield* kj(t, n);
}, xj = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: t, value: i } = await n.read();
      if (t)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Ef = (e, n, t, i) => {
  const a = bj(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (t) {
            let h = o += f;
            t(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Tf = 64 * 1024, { isFunction: Do } = ke, _j = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ke.global), { ReadableStream: $f, TextEncoder: Df } = ke.global, Rf = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, Sj = (e) => {
  e = ke.merge.call(
    {
      skipUndefined: !0
    },
    _j,
    e
  );
  const { fetch: n, Request: t, Response: i } = e, a = n ? Do(n) : typeof fetch == "function", o = Do(t), s = Do(i);
  if (!a)
    return !1;
  const l = a && Do($f), d = a && (typeof Df == "function" ? /* @__PURE__ */ ((C) => (S) => C.encode(S))(new Df()) : async (C) => new Uint8Array(await new t(C).arrayBuffer())), m = o && l && Rf(() => {
    let C = !1;
    const S = new t(Rt.origin, {
      body: new $f(),
      method: "POST",
      get duplex() {
        return C = !0, "half";
      }
    }), N = S.headers.has("Content-Type");
    return S.body != null && S.body.cancel(), C && !N;
  }), u = s && l && Rf(() => ke.isReadableStream(new i("").body)), f = {
    stream: u && ((C) => C.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((C) => {
    !f[C] && (f[C] = (S, N) => {
      let w = S && S[C];
      if (w)
        return w.call(S);
      throw new yn(
        `Response type '${C}' is not supported`,
        yn.ERR_NOT_SUPPORT,
        N
      );
    });
  });
  const h = async (C) => {
    if (C == null)
      return 0;
    if (ke.isBlob(C))
      return C.size;
    if (ke.isSpecCompliantForm(C))
      return (await new t(Rt.origin, {
        method: "POST",
        body: C
      }).arrayBuffer()).byteLength;
    if (ke.isArrayBufferView(C) || ke.isArrayBuffer(C))
      return C.byteLength;
    if (ke.isURLSearchParams(C) && (C = C + ""), ke.isString(C))
      return (await d(C)).byteLength;
  }, g = async (C, S) => {
    const N = ke.toFiniteNumber(C.getContentLength());
    return N ?? h(S);
  };
  return async (C) => {
    let {
      url: S,
      method: N,
      data: w,
      signal: y,
      cancelToken: z,
      timeout: $,
      onDownloadProgress: I,
      onUploadProgress: T,
      responseType: U,
      headers: Q,
      withCredentials: J = "same-origin",
      fetchOptions: ie
    } = gx(C), X = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let B = vj(
      [y, z && z.toAbortSignal()],
      $
    ), O = null;
    const q = B && B.unsubscribe && (() => {
      B.unsubscribe();
    });
    let ee;
    try {
      if (T && m && N !== "get" && N !== "head" && (ee = await g(Q, w)) !== 0) {
        let xe = new t(S, {
          method: "POST",
          body: w,
          duplex: "half"
        }), Ie;
        if (ke.isFormData(w) && (Ie = xe.headers.get("content-type")) && Q.setContentType(Ie), xe.body) {
          const [K, qe] = Cf(
            ee,
            js(Ff(T))
          );
          w = Ef(xe.body, Tf, K, qe);
        }
      }
      ke.isString(J) || (J = J ? "include" : "omit");
      const ve = o && "credentials" in t.prototype;
      if (ke.isFormData(w)) {
        const xe = Q.getContentType();
        xe && /^multipart\/form-data/i.test(xe) && !/boundary=/i.test(xe) && Q.delete("content-type");
      }
      const ue = {
        ...ie,
        signal: B,
        method: N.toUpperCase(),
        headers: Q.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: ve ? J : void 0
      };
      O = o && new t(S, ue);
      let ce = await (o ? X(O, ie) : X(S, ue));
      const fe = u && (U === "stream" || U === "response");
      if (u && (I || fe && q)) {
        const xe = {};
        ["status", "statusText", "headers"].forEach((Be) => {
          xe[Be] = ce[Be];
        });
        const Ie = ke.toFiniteNumber(ce.headers.get("content-length")), [K, qe] = I && Cf(
          Ie,
          js(Ff(I), !0)
        ) || [];
        ce = new i(
          Ef(ce.body, Tf, K, () => {
            qe && qe(), q && q();
          }),
          xe
        );
      }
      U = U || "text";
      let W = await f[ke.findKey(f, U) || "text"](
        ce,
        C
      );
      return !fe && q && q(), await new Promise((xe, Ie) => {
        hx(xe, Ie, {
          data: W,
          headers: Xt.from(ce.headers),
          status: ce.status,
          statusText: ce.statusText,
          config: C,
          request: O
        });
      });
    } catch (ve) {
      throw q && q(), ve && ve.name === "TypeError" && /Load failed|fetch/i.test(ve.message) ? Object.assign(
        new yn(
          "Network Error",
          yn.ERR_NETWORK,
          C,
          O,
          ve && ve.response
        ),
        {
          cause: ve.cause || ve
        }
      ) : yn.from(ve, ve && ve.code, C, O, ve && ve.response);
    }
  };
}, Nj = /* @__PURE__ */ new Map(), vx = (e) => {
  let n = e && e.env || {};
  const { fetch: t, Request: i, Response: a } = n, o = [i, a, t];
  let s = o.length, l = s, d, m, u = Nj;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : Sj(n)), u = m;
  return m;
};
vx();
const ip = {
  http: LN,
  xhr: gj,
  fetch: {
    get: vx
  }
};
ke.forEach(ip, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const Of = (e) => `- ${e}`, jj = (e) => ke.isFunction(e) || e === null || e === !1;
function wj(e, n) {
  e = ke.isArray(e) ? e : [e];
  const { length: t } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < t; s++) {
    i = e[s];
    let l;
    if (a = i, !jj(i) && (a = ip[(l = String(i)).toLowerCase()], a === void 0))
      throw new yn(`Unknown adapter '${l}'`);
    if (a && (ke.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = t ? s.length > 1 ? `since :
` + s.map(Of).join(`
`) : " " + Of(s[0]) : "as no adapter specified";
    throw new yn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const kx = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: wj,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: ip
};
function bl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new So(null, e);
}
function Pf(e) {
  return bl(e), e.headers = Xt.from(e.headers), e.data = kl.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), kx.getAdapter(e.adapter || _o.adapter, e)(e).then(
    function(i) {
      return bl(e), i.data = kl.call(e, e.transformResponse, i), i.headers = Xt.from(i.headers), i;
    },
    function(i) {
      return fx(i) || (bl(e), i && i.response && (i.response.data = kl.call(
        e,
        e.transformResponse,
        i.response
      ), i.response.headers = Xt.from(i.response.headers))), Promise.reject(i);
    }
  );
}
const bx = "1.15.2", el = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  el[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Af = {};
el.transitional = function(n, t, i) {
  function a(o, s) {
    return "[Axios v" + bx + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new yn(
        a(s, " has been removed" + (t ? " in " + t : "")),
        yn.ERR_DEPRECATED
      );
    return t && !Af[s] && (Af[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
el.spelling = function(n) {
  return (t, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function Cj(e, n, t) {
  if (typeof e != "object")
    throw new yn("options must be an object", yn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new yn(
          "option " + o + " must be " + d,
          yn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (t !== !0)
      throw new yn("Unknown option " + o, yn.ERR_BAD_OPTION);
  }
}
const us = {
  assertOptions: Cj,
  validators: el
}, lr = us.validators;
let ki = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new jf(),
      response: new jf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, t) {
    try {
      return await this._request(n, t);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, t) {
    typeof n == "string" ? (t = t || {}, t.url = n) : t = n || {}, t = Si(this.defaults, t);
    const { transitional: i, paramsSerializer: a, headers: o } = t;
    i !== void 0 && us.assertOptions(
      i,
      {
        silentJSONParsing: lr.transitional(lr.boolean),
        forcedJSONParsing: lr.transitional(lr.boolean),
        clarifyTimeoutError: lr.transitional(lr.boolean),
        legacyInterceptorReqResOrdering: lr.transitional(lr.boolean)
      },
      !1
    ), a != null && (ke.isFunction(a) ? t.paramsSerializer = {
      serialize: a
    } : us.assertOptions(
      a,
      {
        encode: lr.function,
        serialize: lr.function
      },
      !0
    )), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), us.assertOptions(
      t,
      {
        baseUrl: lr.spelling("baseURL"),
        withXsrfToken: lr.spelling("withXSRFToken")
      },
      !0
    ), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let s = o && ke.merge(o.common, o[t.method]);
    o && ke.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (C) => {
      delete o[C];
    }), t.headers = Xt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(S) {
      if (typeof S.runWhen == "function" && S.runWhen(t) === !1)
        return;
      d = d && S.synchronous;
      const N = t.transitional || tp;
      N && N.legacyInterceptorReqResOrdering ? l.unshift(S.fulfilled, S.rejected) : l.push(S.fulfilled, S.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(S) {
      m.push(S.fulfilled, S.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const C = [Pf.bind(this), void 0];
      for (C.unshift(...l), C.push(...m), h = C.length, u = Promise.resolve(t); f < h; )
        u = u.then(C[f++], C[f++]);
      return u;
    }
    h = l.length;
    let g = t;
    for (; f < h; ) {
      const C = l[f++], S = l[f++];
      try {
        g = C(g);
      } catch (N) {
        S.call(this, N);
        break;
      }
    }
    try {
      u = Pf.call(this, g);
    } catch (C) {
      return Promise.reject(C);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = Si(this.defaults, n);
    const t = yx(n.baseURL, n.url, n.allowAbsoluteUrls);
    return mx(t, n.params, n.paramsSerializer);
  }
};
ke.forEach(["delete", "get", "head", "options"], function(n) {
  ki.prototype[n] = function(t, i) {
    return this.request(
      Si(i || {}, {
        method: n,
        url: t,
        data: (i || {}).data
      })
    );
  };
});
ke.forEach(["post", "put", "patch"], function(n) {
  function t(i) {
    return function(o, s, l) {
      return this.request(
        Si(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  ki.prototype[n] = t(), ki.prototype[n + "Form"] = t(!0);
});
let Fj = class xx {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new So(o, s, l), t(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(n);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), t = (i) => {
      n.abort(i);
    };
    return this.subscribe(t), n.signal.unsubscribe = () => this.unsubscribe(t), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new xx(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function Ij(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function Ej(e) {
  return ke.isObject(e) && e.isAxiosError === !0;
}
const cm = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(cm).forEach(([e, n]) => {
  cm[n] = e;
});
function _x(e) {
  const n = new ki(e), t = nx(ki.prototype.request, n);
  return ke.extend(t, ki.prototype, n, { allOwnKeys: !0 }), ke.extend(t, n, null, { allOwnKeys: !0 }), t.create = function(a) {
    return _x(Si(e, a));
  }, t;
}
const ht = _x(_o);
ht.Axios = ki;
ht.CanceledError = So;
ht.CancelToken = Fj;
ht.isCancel = fx;
ht.VERSION = bx;
ht.toFormData = Zs;
ht.AxiosError = yn;
ht.Cancel = ht.CanceledError;
ht.all = function(n) {
  return Promise.all(n);
};
ht.spread = Ij;
ht.isAxiosError = Ej;
ht.mergeConfig = Si;
ht.AxiosHeaders = Xt;
ht.formToJSON = (e) => px(ke.isHTMLForm(e) ? new FormData(e) : e);
ht.getAdapter = kx.getAdapter;
ht.HttpStatusCode = cm;
ht.default = ht;
const {
  Axios: PB,
  AxiosError: AB,
  CanceledError: LB,
  isCancel: VB,
  CancelToken: zB,
  VERSION: UB,
  all: MB,
  Cancel: BB,
  isAxiosError: Tj,
  spread: qB,
  toFormData: HB,
  AxiosHeaders: WB,
  HttpStatusCode: GB,
  formToJSON: KB,
  getAdapter: YB,
  mergeConfig: QB
} = ht;
class $j {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const Lf = new $j();
function Dj(e, n) {
  return Vf(e), Vf(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Vf(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const Rj = Object.prototype.toString;
function Oj(e, n) {
  return Rj.call(e) === `[object ${n}]`;
}
function Pj(e) {
  return Oj(e, "Object");
}
function Aj(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const no = "8.36.0", Kr = globalThis;
function ap(e, n, t) {
  const i = t || Kr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[no] = a[no] || {};
  return o[e] || (o[e] = n());
}
const Sx = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Lj = "Sentry Logger ", zf = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Uf = {};
function Nx(e) {
  if (!("console" in Kr))
    return e();
  const n = Kr.console, t = {}, i = Object.keys(Uf);
  i.forEach((a) => {
    const o = Uf[a];
    t[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = t[a];
    });
  }
}
function Vj() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Sx ? zf.forEach((t) => {
    n[t] = (...i) => {
      e && Nx(() => {
        Kr.console[t](`${Lj}[${t}]:`, ...i);
      });
    };
  }) : zf.forEach((t) => {
    n[t] = () => {
    };
  }), n;
}
const ms = ap("logger", Vj);
function zj(e, n, t) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    Sx && ms.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const jx = 1e3;
function op() {
  return Date.now() / jx;
}
function Uj() {
  const { performance: e } = Kr;
  if (!e || !e.now)
    return op;
  const n = Date.now() - e.now(), t = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (t + e.now()) / jx;
}
const Mj = Uj();
(() => {
  const { performance: e } = Kr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, t = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + t - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + t - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Ji() {
  const e = Kr, n = e.crypto || e.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (t = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (t() & 15) >> i / 4).toString(16)
    )
  );
}
function Mf() {
  return {
    traceId: Ji(),
    spanId: Ji().substring(16)
  };
}
function sp() {
  return lp(Kr), Kr;
}
function lp(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || no, n[no] = n[no] || {};
}
function Bj(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || Mj(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Ji()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const t = e.timestamp - e.started;
    e.duration = t >= 0 ? t : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const dm = "_sentrySpan";
function Bf(e, n) {
  n ? zj(e, dm, n) : delete e[dm];
}
function qf(e) {
  return e[dm];
}
const qj = 100;
class cp {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Mf();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new cp();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Bf(n, qf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Bj(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, t) {
    return this._tags = { ...this._tags, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, t) {
    return this._extra = { ...this._extra, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, t) {
    return t === null ? delete this._contexts[n] : this._contexts[n] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const t = typeof n == "function" ? n(this) : n, [i, a] = t instanceof ra ? [t.getScopeData(), t.getRequestSession()] : Pj(t) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Bf(this, void 0), this._attachments = [], this._propagationContext = Mf(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, t) {
    const i = typeof t == "number" ? t : qj;
    if (i <= 0)
      return this;
    const a = {
      timestamp: op(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: qf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, t) {
    const i = t && t.event_id ? t.event_id : Ji();
    if (!this._client)
      return ms.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...t,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, t, i) {
    const a = i && i.event_id ? i.event_id : Ji();
    if (!this._client)
      return ms.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      t,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, t) {
    const i = t && t.event_id ? t.event_id : Ji();
    return this._client ? (this._client.captureEvent(n, { ...t, event_id: i }, this), i) : (ms.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const ra = cp;
function Hj() {
  return ap("defaultCurrentScope", () => new ra());
}
function Wj() {
  return ap("defaultIsolationScope", () => new ra());
}
class Gj {
  constructor(n, t) {
    let i;
    n ? i = n : i = new ra();
    let a;
    t ? a = t : a = new ra(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const t = this._pushScope();
    let i;
    try {
      i = n(t);
    } catch (a) {
      throw this._popScope(), a;
    }
    return Aj(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function ia() {
  const e = sp(), n = lp(e);
  return n.stack = n.stack || new Gj(Hj(), Wj());
}
function Kj(e) {
  return ia().withScope(e);
}
function Yj(e, n) {
  const t = ia();
  return t.withScope(() => (t.getStackTop().scope = e, n(e)));
}
function Hf(e) {
  return ia().withScope(() => e(ia().getIsolationScope()));
}
function Qj() {
  return {
    withIsolationScope: Hf,
    withScope: Kj,
    withSetScope: Yj,
    withSetIsolationScope: (e, n) => Hf(n),
    getCurrentScope: () => ia().getScope(),
    getIsolationScope: () => ia().getIsolationScope()
  };
}
function wx(e) {
  const n = lp(e);
  return n.acs ? n.acs : Qj();
}
function dp() {
  const e = sp();
  return wx(e).getCurrentScope();
}
function Cx() {
  const e = sp();
  return wx(e).getIsolationScope();
}
function Jj() {
  return dp().getClient();
}
function Xj(e) {
  if (e)
    return Zj(e) ? { captureContext: e } : nw(e) ? {
      captureContext: e
    } : e;
}
function Zj(e) {
  return e instanceof ra || typeof e == "function";
}
const ew = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function nw(e) {
  return Object.keys(e).some((n) => ew.includes(n));
}
function Wf(e, n) {
  return dp().captureException(e, Xj(n));
}
function tw(e, n) {
  const t = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return dp().captureMessage(e, t, i);
}
function rw(e, n) {
  Cx().setContext(e, n);
}
const iw = 100;
function ui(e, n) {
  const t = Jj(), i = Cx();
  if (!t) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = iw } = t.getOptions();
  if (o <= 0) return;
  const l = { timestamp: op(), ...e }, d = a ? Nx(() => a(l, n)) : l;
  d !== null && (t.emit && t.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var ho;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(ho || (ho = {}));
function Xi(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const t = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(t, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const aw = fo.backendDomain ? {
  "backend-domain": fo.backendDomain
} : void 0;
function ps() {
  const e = new URLSearchParams({
    noToken: "true",
    ...aw
  }).toString();
  document.location.href = `${fo.url.logIn}?${e}`;
}
const xl = "authData", _l = 30, ow = 600, Sl = 5;
class sw {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Sl || this.clientServerTimeDiff <= -Sl ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + ow, a = Xi(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Sl) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(xl, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(xl), t = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(t) && (this.authData = t), t;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(xl);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const t = this.accessTokenExpiresAt - _l;
    return this.estimatedServerTime() >= t;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const t = Xi(n), i = t.exp - _l;
    return !t || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - _l - this.estimatedServerTime()) * 1e3;
  }
}
const Nt = new sw();
async function lw(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), t = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || t.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Xi(o).exp : "None", l = await nl.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Xi(m).exp : "None", h = u ? Xi(u).exp : "None", g = typeof s == "number" ? d - s : "Unknown", C = typeof f == "number" ? d - f : "Unknown", S = typeof h == "number" ? d - h : "Unknown", N = e.response.headers["x-dixa-rid"];
      rw("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: g,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: C,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: S,
        xDixaRid: N,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    tw("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: ho.Platform,
        domain: n
      }
    });
  }
}
const Nl = /* @__PURE__ */ new Map(), cw = 3;
function dw(e) {
  e.interceptors.response.use((n) => (Nl.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: t } = n.response;
      switch (t) {
        case um.Unauthorized:
          if (!nl.isRefreshTokenExpired() && n.config) {
            ui({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = Nl.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= cw)
              return Nl.set(n.config.url, i + 1), e(n.config);
          }
          lw(n), console.error("401 unauthorized interceptor"), ps();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Fx = ht.create();
dw(Fx);
const zr = console.log;
async function Gf(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class uw extends Error {
  constructor(n, t) {
    super(n, t);
  }
}
function mw(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const pw = 5;
class fw {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const t = await this.refresh(n);
    if (t)
      Nt.setAuthData(t);
    else {
      const i = Nt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new uw("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = Nt.getAccessToken();
    if (!n)
      return {};
    const t = Xi(n), { exp: i } = t;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return Nt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const t = Nt.getAuthData();
    return t ? Nt.isAccessTokenExpired() ? (ui({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(t.refresh_token).then((i) => (i && Nt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : t : null;
  }
  removeAuthData() {
    return Nt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Nt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Nt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Nt.getAuthData();
    return n ? Nt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!Lf.isElectron())
      return !0;
    const n = await Lf.getVersion();
    return Dj(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, t = pw) {
    try {
      return await Fx.post(`${fo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, t);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (zr("AUTH", "Network connection offline - waiting..."), ui({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Gf(5);
    n && (zr("AUTH", "Network connection restored"), ui({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, t) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = mw(this.retryCount);
    return zr("AUTH", `Retrying in ${i} seconds`), await Gf(i), await this.refresh(n, t);
  }
  async handleRefreshError(n, t, i) {
    if (Nt.isRefreshTokenExpired(t))
      return zr("AUTH", "Refresh token expired"), ui({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), Nt.removeAuthData(), ps(), null;
    if (Tj(n)) {
      if (n.message === "timeout exceeded")
        return zr("AUTH", "Timeout exceeded"), ui({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(t, i);
      if (n.message === "Network Error")
        return zr("AUTH", "Network error"), ui({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(t, i);
      if (n.response?.status === 401)
        return zr("AUTH", "Refresh token invalid (401)"), Nt.removeAuthData(), ps(), null;
      Wf(n, {
        level: "error",
        tags: {
          team: ho.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (zr("AUTH", "Retries exhausted, logging out"), Wf(n, {
      level: "error",
      tags: {
        team: ho.Platform,
        errorSource: "authManager.refresh"
      }
    }), Nt.removeAuthData(), ps(), null) : (zr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(t, i - 1));
  }
  accessTokenExpiresInMs() {
    return Nt.accessTokenExpiresInMs();
  }
}
const nl = new fw();
var um;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(um || (um = {}));
const hw = new Zm((e, n) => new Xb((t) => {
  nl.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(t);
  }).catch((i) => t.error(i));
})), yw = new Zm(
  (e, n) => new Xb((t) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    nl.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...r0(fo.url.partnerIntegrations) && d?.access_token && i0(d.access_token)
      }
    }), n(e).subscribe(t))).catch((d) => t.error(d));
  })
), gw = new AbortController(), Ix = (e) => new A0({
  queryDeduplication: !1,
  cache: new L0(),
  link: Zm.from([
    hw,
    yw,
    V0({
      uri: `${e}/graphql`,
      fetch: q0,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: gw.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), vw = ({
  configuration: e,
  children: n
}) => {
  const t = Bn(
    () => Ix(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ve.jsx(z0, { client: t, children: n });
};
function kw() {
  try {
    return U0(), !0;
  } catch {
    return !1;
  }
}
const bw = ({
  configuration: e,
  children: n
}) => kw() ? n : /* @__PURE__ */ Ve.jsx(vw, { configuration: e, children: n }), xw = ({
  integrationId: e,
  type: n,
  showNotification: t,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ve.jsx(M0, { children: (o) => /* @__PURE__ */ Ve.jsx(
  a0,
  {
    value: {
      useMutation: c0(e, n),
      useQuery: l0(e, n),
      useLazyQuery: s0(e, n),
      executeQuery: o0(e, n, o),
      showNotification: t,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Ex = ({
  integrationId: e,
  type: n,
  configuration: t,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ve.jsx(bw, { configuration: t, children: s ? /* @__PURE__ */ Ve.jsx(
    xw,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, _w = "_unmatchedHeader_qcj19_1", Sw = {
  unmatchedHeader: _w
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var jl = { exports: {} }, ka = {}, Kf;
function Nw() {
  if (Kf) return ka;
  Kf = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return ka.Fragment = t, ka.jsx = s, ka.jsxs = s, ka;
}
var Ro = {}, Yf;
function jw() {
  return Yf || (Yf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ro.Fragment = i, Ro.jsx = Rn, Ro.jsxs = Mn;
  })()), Ro;
}
var Qf;
function ww() {
  return Qf || (Qf = 1, process.env.NODE_ENV === "production" ? jl.exports = Nw() : jl.exports = jw()), jl.exports;
}
var oe = ww();
const Cw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, Fw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, Iw = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": Cw,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": Fw
};
function Tx(e) {
  return Iw[e] ?? {};
}
const Ew = Tx(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), Tw = Tx(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), $w = "_copyIcon_1wjfs_48", Dw = "_list_1wjfs_53", Rw = "_listItem_1wjfs_63", Ow = "_collapsible_1wjfs_72", Pw = "_collapsibleIsOpen_1wjfs_80", Aw = "_collapsibleHeader_1wjfs_83", Lw = "_collapsibleIconTrue_1wjfs_86", Vw = "_collapsibleIconFalse_1wjfs_89", On = {
  copyIcon: $w,
  list: Dw,
  listItem: Rw,
  collapsible: Ow,
  collapsibleIsOpen: Pw,
  collapsibleHeader: Aw,
  collapsibleIconTrue: Lw,
  collapsibleIconFalse: Vw
}, zw = ({
  app: e,
  openByDefault: n
}) => {
  const [t, i] = le(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: it(On.collapsible, {
        [On.collapsibleIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ oe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ oe.jsxs(Ye, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(d).format(xt) })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(m).format(xt) })
          ] }) })
        ] })
      ]
    }
  );
}, Uw = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ oe.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((t, i) => /* @__PURE__ */ oe.jsx(zw, { app: t, openByDefault: i === 0 }, i))
  ] });
}, Mw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, t = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !t && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    t && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ oe.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: i }),
          po(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Bw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, t = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = t && t.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: t.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            We,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  xt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  xt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, ws = ({
  state: e,
  noTooltip: n = !1,
  isPush: t = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = t ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ oe.jsx(We, { content: n ? null : l(), children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(pe, { size: 14, name: o(), color: s() }) }) });
}, qw = "_wrapper_1xucg_1", Hw = "_externalLink_1xucg_7", wl = {
  wrapper: qw,
  externalLink: Hw
}, Ww = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: t } = or(), { isCopied: i, copy: a } = or(), { isCopied: o, copy: s } = or(), { isCopied: l, copy: d } = or(), { isCopied: m, copy: u } = or();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: g,
    last_name: C,
    home_city: S,
    country: N,
    email: w,
    phone: y,
    dob: z,
    created_at: $,
    email_subscribe: I,
    push_subscribe: T
  } = e, U = 14, Q = `${g || ""} ${C || ""}`.trim() || "A customer has no name", J = `${S ? `${S} /` : ""} ${N || ""}`.trim(), ie = z ? Ln(z).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { className: wl.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: wl.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-2", children: Q }),
          ie && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    $ && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: Ln($).format(xt) })
    ] }),
    J && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "map-pin" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: J })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy location", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: o ? "done" : "copy",
          onClick: () => s(J),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    w && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "mail" }),
        /* @__PURE__ */ oe.jsx("span", { className: wl.externalLink, children: w })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy email", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: n ? "done" : "copy",
          onClick: () => t(w),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "phone" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "user" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ oe.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy Braze ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "tag" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ oe.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy External ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    I && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "sync" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(ws, { state: I })
    ] }),
    T && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "bell" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(ws, { isPush: !0, state: T })
    ] })
  ] }) });
}, Gw = ({
  device: e,
  openByDefault: n
}) => {
  const [t, i] = le(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: it(On.collapsible, {
        [On.collapsibleIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ oe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ oe.jsxs(Ye, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ oe.jsx(
              pe,
              {
                size: a,
                className: it({
                  [On.collapsibleIconTrue]: d,
                  [On.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ oe.jsx(We, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(We, { content: "For iOS", children: /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, Kw = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ oe.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((t, i) => /* @__PURE__ */ oe.jsx(Gw, { device: t, openByDefault: i === 0 }, i))
  ] });
}, ba = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, Oo = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: t
}) => {
  const { track: i } = _n(), { useMutation: a } = hn(), [o, s] = le(!1), [l] = a(
    Tw,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: ba[n].parameter
        }
      }
    }), setTimeout(async () => {
      await t().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ oe.jsx(We, { content: ba[n].tooltipContent, children: /* @__PURE__ */ oe.jsx(
    Gn,
    {
      variant: "secondary",
      color: ba[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(
          ws,
          {
            noTooltip: !0,
            state: ba[n].parameter
          }
        ),
        ba[n].label
      ] })
    }
  ) });
}, Yw = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: t
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: 14, name: "sync" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(ws, { state: a })
    ] }) }) }),
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
        /* @__PURE__ */ oe.jsx(
          Oo,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: t
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Oo,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: t
          }
        )
      ] }),
      s && /* @__PURE__ */ oe.jsx(
        Oo,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: t
        }
      ),
      l && /* @__PURE__ */ oe.jsx(
        Oo,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: t
        }
      )
    ] })
  ] }) });
}, Qw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, t = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = t && t.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: t.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            We,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  xt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  xt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Jw = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: t } = _n(), { useMutation: i } = hn(), [a, o] = le(), [s, l] = le(!1), [d, m] = le(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, g = n.updateEmailSubscriptionState ?? !1, C = n.displayCustomAttributes ?? !1, S = n.displayCustomEvents ?? !1, N = n.displayPuchases ?? !1, w = n.displayDevices ?? !1, y = n.displayApps ?? !1, z = !h && !g && !C && !S && !N, [$, { error: I }] = i(
    Ew,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Q = U?.Braze?.exportUserDetails?.users?.[0];
        Q ? (o(Q), l(!1), t("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), T = async () => {
    u || f ? await $({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (He(() => {
    async function U() {
      m(!0), await T();
    }
    U().finally(() => m(!1));
  }, [u, f]), I) {
    const U = I.graphQLErrors;
    return Wm({ errors: U }) ? /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Gm({ errors: U }) ? /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ oe.jsx(Fn, { error: I });
  }
  return d ? /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ oe.jsx(un, {}) }) : z ? /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ oe.jsx(Ww, { customerDetails: a }),
        g && !!a && /* @__PURE__ */ oe.jsx(
          Yw,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await T()
          }
        ),
        C && !!a && /* @__PURE__ */ oe.jsx(Mw, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ oe.jsx(Bw, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ oe.jsx(Qw, { customerDetails: a }),
        w && !!a && /* @__PURE__ */ oe.jsx(Kw, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ oe.jsx(Uw, { apps: a?.apps })
      ]
    }
  );
}, Xw = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => qb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function Zw() {
  var e = vi(!1), n = ot(function() {
    return e.current;
  }, []);
  return He(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var eC = function(e) {
  e === void 0 && (e = {});
  var n = le(e), t = n[0], i = n[1], a = ot(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [t, a];
}, nC = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Jf = function(e) {
  return j0(nC, e);
}, Cl, Xf;
function tC() {
  return Xf || (Xf = 1, Cl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, t = [], i = 0; i < e.rangeCount; i++)
      t.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || t.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), Cl;
}
var Fl, Zf;
function rC() {
  if (Zf) return Fl;
  Zf = 1;
  var e = tC(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, t = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, g = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(S) {
        if (S.stopPropagation(), s.format)
          if (S.preventDefault(), typeof S.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var N = n[s.format] || n.default;
            window.clipboardData.setData(N, o);
          } else
            S.clipboardData.clearData(), S.clipboardData.setData(s.format, o);
        s.onCopy && (S.preventDefault(), s.onCopy(S.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      g = !0;
    } catch (S) {
      l && console.error("unable to copy using execCommand: ", S), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), g = !0;
      } catch (N) {
        l && console.error("unable to copy using clipboardData: ", N), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : t), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return g;
  }
  return Fl = a, Fl;
}
var iC = rC();
const aC = /* @__PURE__ */ ep(iC);
var $x = function() {
  var e = Zw(), n = eC({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), t = n[0], i = n[1], a = ot(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = aC(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [t, a];
};
function oC(e, n) {
  n === void 0 && (n = 0);
  var t = vi(!1), i = vi(), a = vi(e), o = ot(function() {
    return t.current;
  }, []), s = ot(function() {
    t.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      t.current = !0, a.current();
    }, n);
  }, [n]), l = ot(function() {
    t.current = null, i.current && clearTimeout(i.current);
  }, []);
  return He(function() {
    a.current = e;
  }, [e]), He(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Ti(e, n, t) {
  n === void 0 && (n = 0), t === void 0 && (t = []);
  var i = oC(e, n), a = i[0], o = i[1], s = i[2];
  return He(s, t), [a, o];
}
var sC = function(e) {
  He(e, []);
}, lC = function(e, n) {
  var t = vi(function() {
  });
  He(function() {
    t.current = e;
  }), He(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return t.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, cC = function(e) {
  e === void 0 && (e = {});
  var n = le(e), t = n[0], i = n[1], a = Bn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return yl(yl({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = H0(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = yl({ get: ot(function(s) {
    return t[s];
  }, [t]) }, a);
  return [t, o];
}, dC = function(e) {
  var n = vi(e);
  n.current = e, sC(function() {
    return function() {
      return n.current();
    };
  });
}, No = (e) => e.type === "checkbox", hi = (e) => e instanceof Date, Bt = (e) => e == null;
const Dx = (e) => typeof e == "object";
var mt = (e) => !Bt(e) && !Array.isArray(e) && Dx(e) && !hi(e), Rx = (e) => mt(e) && e.target ? No(e.target) ? e.target.checked : e.target.value : e, uC = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Ox = (e, n) => e.has(uC(n)), mC = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return mt(n) && n.hasOwnProperty("isPrototypeOf");
}, up = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ct(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(up && (e instanceof Blob || i)) && (t || mt(e)))
    if (n = t ? [] : {}, !t && !mC(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ct(e[a]));
  else
    return e;
  return n;
}
var tl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], lt = (e) => e === void 0, Je = (e, n, t) => {
  if (!n || !mt(e))
    return t;
  const i = tl(n.split(/[,[\].]+?/)).reduce((a, o) => Bt(a) ? a : a[o], e);
  return lt(i) || i === e ? lt(e[n]) ? t : e[n] : i;
}, rr = (e) => typeof e == "boolean", mp = (e) => /^\w*$/.test(e), Px = (e) => tl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Kn = (e, n, t) => {
  let i = -1;
  const a = mp(n) ? [n] : Px(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = t;
    if (i !== s) {
      const m = e[l];
      d = mt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Cs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, vr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ur = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Ax = Fe.createContext(null), Lr = () => Fe.useContext(Ax), pp = (e) => {
  const { children: n, ...t } = e;
  return Fe.createElement(Ax.Provider, { value: t }, n);
};
var Lx = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== vr.all && (n._proxyFormState[s] = !i || vr.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function pC(e) {
  const n = Lr(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Fe.useState(t._formState), d = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Fe.useRef(a);
  return m.current = a, Fe.useEffect(() => t._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...t._formState,
        ...u
      });
    }
  }), [t, i, o]), Fe.useEffect(() => {
    d.current.isValid && t._setValid(!0);
  }, [t]), Fe.useMemo(() => Lx(s, t, d.current, !1), [s, t]);
}
var Dr = (e) => typeof e == "string", Vx = (e, n, t, i, a) => Dr(e) ? (i && n.watch.add(e), Je(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(t, o))) : (i && (n.watchAll = !0), t);
function fs(e) {
  const n = Lr(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Fe.useRef(i), d = Fe.useRef(a);
  l.current = i, Fe.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Vx(l.current, t._names, f.values || t._formValues, !1, d.current))
  }), [t, o, s]);
  const [m, u] = Fe.useState(t._getWatch(i, a));
  return Fe.useEffect(() => t._removeUnmounted()), m;
}
function fp(e) {
  const n = Lr(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Ox(a._names.array, t), l = fs({
    control: a,
    name: t,
    defaultValue: Je(a._formValues, t, Je(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), d = pC({
    control: a,
    name: t,
    exact: !0
  }), m = Fe.useRef(e), u = Fe.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...rr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Fe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, t)
    }
  }), [d, t]), h = Fe.useCallback((N) => u.current.onChange({
    target: {
      value: Rx(N),
      name: t
    },
    type: Cs.CHANGE
  }), [t]), g = Fe.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, t),
      name: t
    },
    type: Cs.BLUR
  }), [t, a._formValues]), C = Fe.useCallback((N) => {
    const w = Je(a._fields, t);
    w && N && (w._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, t]), S = Fe.useMemo(() => ({
    name: t,
    value: l,
    ...rr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: g,
    ref: C
  }), [t, i, d.disabled, h, g, C, l]);
  return Fe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...rr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (y, z) => {
      const $ = Je(a._fields, y);
      $ && $._f && ($._f.mount = z);
    };
    if (w(t, !0), N) {
      const y = Ct(Je(a._options.defaultValues, t));
      Kn(a._defaultValues, t, y), lt(Je(a._formValues, t)) && Kn(a._formValues, t, y);
    }
    return !s && a.register(t), () => {
      (s ? N && !a._state.action : N) ? a.unregister(t) : w(t, !1);
    };
  }, [t, a, s, o]), Fe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), Fe.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Wt = (e) => e.render(fp(e));
var fC = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, to = (e) => Array.isArray(e) ? e : [e], eh = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, mm = (e) => Bt(e) || !Dx(e);
function ni(e, n) {
  if (mm(e) || mm(n))
    return e === n;
  if (hi(e) && hi(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (hi(o) && hi(s) || mt(o) && mt(s) || Array.isArray(o) && Array.isArray(s) ? !ni(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var zt = (e) => mt(e) && !Object.keys(e).length, hp = (e) => e.type === "file", kr = (e) => typeof e == "function", Fs = (e) => {
  if (!up)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, zx = (e) => e.type === "select-multiple", yp = (e) => e.type === "radio", hC = (e) => yp(e) || No(e), Il = (e) => Fs(e) && e.isConnected;
function yC(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = lt(e) ? i++ : e[n[i++]];
  return e;
}
function gC(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !lt(e[n]))
      return !1;
  return !0;
}
function vt(e, n) {
  const t = Array.isArray(n) ? n : mp(n) ? [n] : Px(n), i = t.length === 1 ? e : yC(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (mt(i) && zt(i) || Array.isArray(i) && gC(i)) && vt(e, t.slice(0, -1)), e;
}
var Ux = (e) => {
  for (const n in e)
    if (kr(e[n]))
      return !0;
  return !1;
};
function Is(e, n = {}) {
  const t = Array.isArray(e);
  if (mt(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || mt(e[i]) && !Ux(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Is(e[i], n[i])) : Bt(e[i]) || (n[i] = !0);
  return n;
}
function Mx(e, n, t) {
  const i = Array.isArray(e);
  if (mt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || mt(e[a]) && !Ux(e[a]) ? lt(n) || mm(t[a]) ? t[a] = Array.isArray(e[a]) ? Is(e[a], []) : { ...Is(e[a]) } : Mx(e[a], Bt(n) ? {} : n[a], t[a]) : t[a] = !ni(e[a], n[a]);
  return t;
}
var xa = (e, n) => Mx(e, n, Is(n));
const nh = {
  value: !1,
  isValid: !1
}, th = { value: !0, isValid: !0 };
var Bx = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !lt(e[0].attributes.value) ? lt(e[0].value) || e[0].value === "" ? th : { value: e[0].value, isValid: !0 } : th
    ) : nh;
  }
  return nh;
}, qx = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => lt(e) ? e : n ? e === "" ? NaN : e && +e : t && Dr(e) ? new Date(e) : i ? i(e) : e;
const rh = {
  isValid: !1,
  value: null
};
var Hx = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, rh) : rh;
function ih(e) {
  const n = e.ref;
  return hp(n) ? n.files : yp(n) ? Hx(e.refs).value : zx(n) ? [...n.selectedOptions].map(({ value: t }) => t) : No(n) ? Bx(e.refs).value : qx(lt(n.value) ? e.ref.value : n.value, e);
}
var vC = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Kn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Es = (e) => e instanceof RegExp, _a = (e) => lt(e) ? e : Es(e) ? e.source : mt(e) ? Es(e.value) ? e.value.source : e.value : e, ah = (e) => ({
  isOnSubmit: !e || e === vr.onSubmit,
  isOnBlur: e === vr.onBlur,
  isOnChange: e === vr.onChange,
  isOnAll: e === vr.all,
  isOnTouch: e === vr.onTouched
});
const oh = "AsyncFunction";
var kC = (e) => !!e && !!e.validate && !!(kr(e.validate) && e.validate.constructor.name === oh || mt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === oh)), bC = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), sh = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const ro = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (ro(l, n))
          break;
      } else if (mt(l) && ro(l, n))
        break;
    }
  }
};
function lh(e, n, t) {
  const i = Je(e, t);
  if (i || mp(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var xC = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return zt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || vr.all));
}, _C = (e, n, t) => !e || !n || e === n || to(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), SC = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, NC = (e, n) => !tl(Je(e, n)).length && vt(e, n), jC = (e, n, t) => {
  const i = to(Je(e, t));
  return Kn(i, "root", n[t]), Kn(e, t, i), e;
}, hs = (e) => Dr(e);
function ch(e, n, t = "validate") {
  if (hs(e) || Array.isArray(e) && e.every(hs) || rr(e) && !e)
    return {
      type: t,
      message: hs(e) ? e : "",
      ref: n
    };
}
var Ai = (e) => mt(e) && !Es(e) ? e : {
  value: e,
  message: ""
}, dh = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: g, validate: C, name: S, valueAsNumber: N, mount: w } = e._f, y = Je(t, S);
  if (!w || n.has(S))
    return {};
  const z = l ? l[0] : s, $ = (B) => {
    a && z.reportValidity && (z.setCustomValidity(rr(B) ? "" : B || ""), z.reportValidity());
  }, I = {}, T = yp(s), U = No(s), Q = T || U, J = (N || hp(s)) && lt(s.value) && lt(y) || Fs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = fC.bind(null, S, i, I), X = (B, O, q, ee = Ur.maxLength, ve = Ur.minLength) => {
    const ue = B ? O : q;
    I[S] = {
      type: B ? ee : ve,
      message: ue,
      ref: s,
      ...ie(B ? ee : ve, ue)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Q && (J || Bt(y)) || rr(y) && !y || U && !Bx(l).isValid || T && !Hx(l).isValid)) {
    const { value: B, message: O } = hs(d) ? { value: !!d, message: d } : Ai(d);
    if (B && (I[S] = {
      type: Ur.required,
      message: O,
      ref: z,
      ...ie(Ur.required, O)
    }, !i))
      return $(O), I;
  }
  if (!J && (!Bt(f) || !Bt(h))) {
    let B, O;
    const q = Ai(h), ee = Ai(f);
    if (!Bt(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      Bt(q.value) || (B = ve > q.value), Bt(ee.value) || (O = ve < ee.value);
    } else {
      const ve = s.valueAsDate || new Date(y), ue = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), ce = s.type == "time", fe = s.type == "week";
      Dr(q.value) && y && (B = ce ? ue(y) > ue(q.value) : fe ? y > q.value : ve > new Date(q.value)), Dr(ee.value) && y && (O = ce ? ue(y) < ue(ee.value) : fe ? y < ee.value : ve < new Date(ee.value));
    }
    if ((B || O) && (X(!!B, q.message, ee.message, Ur.max, Ur.min), !i))
      return $(I[S].message), I;
  }
  if ((m || u) && !J && (Dr(y) || o && Array.isArray(y))) {
    const B = Ai(m), O = Ai(u), q = !Bt(B.value) && y.length > +B.value, ee = !Bt(O.value) && y.length < +O.value;
    if ((q || ee) && (X(q, B.message, O.message), !i))
      return $(I[S].message), I;
  }
  if (g && !J && Dr(y)) {
    const { value: B, message: O } = Ai(g);
    if (Es(B) && !y.match(B) && (I[S] = {
      type: Ur.pattern,
      message: O,
      ref: s,
      ...ie(Ur.pattern, O)
    }, !i))
      return $(O), I;
  }
  if (C) {
    if (kr(C)) {
      const B = await C(y, t), O = ch(B, z);
      if (O && (I[S] = {
        ...O,
        ...ie(Ur.validate, O.message)
      }, !i))
        return $(O.message), I;
    } else if (mt(C)) {
      let B = {};
      for (const O in C) {
        if (!zt(B) && !i)
          break;
        const q = ch(await C[O](y, t), z, O);
        q && (B = {
          ...q,
          ...ie(O, q.message)
        }, $(q.message), i && (I[S] = B));
      }
      if (!zt(B) && (I[S] = {
        ref: z,
        ...B
      }, !i))
        return I;
    }
  }
  return $(!0), I;
};
const wC = {
  mode: vr.onSubmit,
  reValidateMode: vr.onChange,
  shouldFocusError: !0
};
function CC(e = {}) {
  let n = {
    ...wC,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: kr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = mt(n.defaultValues) || mt(n.values) ? Ct(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ct(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: eh(),
    state: eh()
  }, g = ah(n.mode), C = ah(n.reValidateMode), S = n.criteriaMode === vr.all, N = (x) => (D) => {
    clearTimeout(m), m = setTimeout(x, D);
  }, w = async (x) => {
    if (!n.disabled && (u.isValid || f.isValid || x)) {
      const D = n.resolver ? zt((await J()).errors) : await X(i, !0);
      D !== t.isValid && h.state.next({
        isValid: D
      });
    }
  }, y = (x, D) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((x || Array.from(l.mount)).forEach((H) => {
      H && (D ? Kn(t.validatingFields, H, D) : vt(t.validatingFields, H));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !zt(t.validatingFields)
    }));
  }, z = (x, D = [], H, Y, R = !0, V = !0) => {
    if (Y && H && !n.disabled) {
      if (s.action = !0, V && Array.isArray(Je(i, x))) {
        const ae = H(Je(i, x), Y.argA, Y.argB);
        R && Kn(i, x, ae);
      }
      if (V && Array.isArray(Je(t.errors, x))) {
        const ae = H(Je(t.errors, x), Y.argA, Y.argB);
        R && Kn(t.errors, x, ae), NC(t.errors, x);
      }
      if ((u.touchedFields || f.touchedFields) && V && Array.isArray(Je(t.touchedFields, x))) {
        const ae = H(Je(t.touchedFields, x), Y.argA, Y.argB);
        R && Kn(t.touchedFields, x, ae);
      }
      (u.dirtyFields || f.dirtyFields) && (t.dirtyFields = xa(a, o)), h.state.next({
        name: x,
        isDirty: O(x, D),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Kn(o, x, D);
  }, $ = (x, D) => {
    Kn(t.errors, x, D), h.state.next({
      errors: t.errors
    });
  }, I = (x) => {
    t.errors = x, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, T = (x, D, H, Y) => {
    const R = Je(i, x);
    if (R) {
      const V = Je(o, x, lt(H) ? Je(a, x) : H);
      lt(V) || Y && Y.defaultChecked || D ? Kn(o, x, D ? V : ih(R._f)) : ve(x, V), s.mount && w();
    }
  }, U = (x, D, H, Y, R) => {
    let V = !1, ae = !1;
    const me = {
      name: x
    };
    if (!n.disabled) {
      if (!H || Y) {
        (u.isDirty || f.isDirty) && (ae = t.isDirty, t.isDirty = me.isDirty = O(), V = ae !== me.isDirty);
        const Ne = ni(Je(a, x), D);
        ae = !!Je(t.dirtyFields, x), Ne ? vt(t.dirtyFields, x) : Kn(t.dirtyFields, x, !0), me.dirtyFields = t.dirtyFields, V = V || (u.dirtyFields || f.dirtyFields) && ae !== !Ne;
      }
      if (H) {
        const Ne = Je(t.touchedFields, x);
        Ne || (Kn(t.touchedFields, x, H), me.touchedFields = t.touchedFields, V = V || (u.touchedFields || f.touchedFields) && Ne !== H);
      }
      V && R && h.state.next(me);
    }
    return V ? me : {};
  }, Q = (x, D, H, Y) => {
    const R = Je(t.errors, x), V = (u.isValid || f.isValid) && rr(D) && t.isValid !== D;
    if (n.delayError && H ? (d = N(() => $(x, H)), d(n.delayError)) : (clearTimeout(m), d = null, H ? Kn(t.errors, x, H) : vt(t.errors, x)), (H ? !ni(R, H) : R) || !zt(Y) || V) {
      const ae = {
        ...Y,
        ...V && rr(D) ? { isValid: D } : {},
        errors: t.errors,
        name: x
      };
      t = {
        ...t,
        ...ae
      }, h.state.next(ae);
    }
  }, J = async (x) => {
    y(x, !0);
    const D = await n.resolver(o, n.context, vC(x || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(x), D;
  }, ie = async (x) => {
    const { errors: D } = await J(x);
    if (x)
      for (const H of x) {
        const Y = Je(D, H);
        Y ? Kn(t.errors, H, Y) : vt(t.errors, H);
      }
    else
      t.errors = D;
    return D;
  }, X = async (x, D, H = {
    valid: !0
  }) => {
    for (const Y in x) {
      const R = x[Y];
      if (R) {
        const { _f: V, ...ae } = R;
        if (V) {
          const me = l.array.has(V.name), Ne = R._f && kC(R._f);
          Ne && u.validatingFields && y([Y], !0);
          const nn = await dh(R, l.disabled, o, S, n.shouldUseNativeValidation && !D, me);
          if (Ne && u.validatingFields && y([Y]), nn[V.name] && (H.valid = !1, D))
            break;
          !D && (Je(nn, V.name) ? me ? jC(t.errors, nn, V.name) : Kn(t.errors, V.name, nn[V.name]) : vt(t.errors, V.name));
        }
        !zt(ae) && await X(ae, D, H);
      }
    }
    return H.valid;
  }, B = () => {
    for (const x of l.unMount) {
      const D = Je(i, x);
      D && (D._f.refs ? D._f.refs.every((H) => !Il(H)) : !Il(D._f.ref)) && ze(x);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (x, D) => !n.disabled && (x && D && Kn(o, x, D), !ni(Ie(), a)), q = (x, D, H) => Vx(x, l, {
    ...s.mount ? o : lt(D) ? a : Dr(x) ? { [x]: D } : D
  }, H, D), ee = (x) => tl(Je(s.mount ? o : a, x, n.shouldUnregister ? Je(a, x, []) : [])), ve = (x, D, H = {}) => {
    const Y = Je(i, x);
    let R = D;
    if (Y) {
      const V = Y._f;
      V && (!V.disabled && Kn(o, x, qx(D, V)), R = Fs(V.ref) && Bt(D) ? "" : D, zx(V.ref) ? [...V.ref.options].forEach((ae) => ae.selected = R.includes(ae.value)) : V.refs ? No(V.ref) ? V.refs.length > 1 ? V.refs.forEach((ae) => (!ae.defaultChecked || !ae.disabled) && (ae.checked = Array.isArray(R) ? !!R.find((me) => me === ae.value) : R === ae.value)) : V.refs[0] && (V.refs[0].checked = !!R) : V.refs.forEach((ae) => ae.checked = ae.value === R) : hp(V.ref) ? V.ref.value = "" : (V.ref.value = R, V.ref.type || h.state.next({
        name: x,
        values: Ct(o)
      })));
    }
    (H.shouldDirty || H.shouldTouch) && U(x, R, H.shouldTouch, H.shouldDirty, !0), H.shouldValidate && xe(x);
  }, ue = (x, D, H) => {
    for (const Y in D) {
      const R = D[Y], V = `${x}.${Y}`, ae = Je(i, V);
      (l.array.has(x) || mt(R) || ae && !ae._f) && !hi(R) ? ue(V, R, H) : ve(V, R, H);
    }
  }, ce = (x, D, H = {}) => {
    const Y = Je(i, x), R = l.array.has(x), V = Ct(D);
    Kn(o, x, V), R ? (h.array.next({
      name: x,
      values: Ct(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && H.shouldDirty && h.state.next({
      name: x,
      dirtyFields: xa(a, o),
      isDirty: O(x, V)
    })) : Y && !Y._f && !Bt(V) ? ue(x, V, H) : ve(x, V, H), sh(x, l) && h.state.next({ ...t }), h.state.next({
      name: s.mount ? x : void 0,
      values: Ct(o)
    });
  }, fe = async (x) => {
    s.mount = !0;
    const D = x.target;
    let H = D.name, Y = !0;
    const R = Je(i, H), V = (ae) => {
      Y = Number.isNaN(ae) || hi(ae) && isNaN(ae.getTime()) || ni(ae, Je(o, H, ae));
    };
    if (R) {
      let ae, me;
      const Ne = D.type ? ih(R._f) : Rx(x), nn = x.type === Cs.BLUR || x.type === Cs.FOCUS_OUT, fn = !bC(R._f) && !n.resolver && !Je(t.errors, H) && !R._f.deps || SC(nn, Je(t.touchedFields, H), t.isSubmitted, C, g), tn = sh(H, l, nn);
      Kn(o, H, Ne), nn ? (R._f.onBlur && R._f.onBlur(x), d && d(0)) : R._f.onChange && R._f.onChange(x);
      const cn = U(H, Ne, nn), pn = !zt(cn) || tn;
      if (!nn && h.state.next({
        name: H,
        type: x.type,
        values: Ct(o)
      }), fn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? nn && w() : nn || w()), pn && h.state.next({ name: H, ...tn ? {} : cn });
      if (!nn && tn && h.state.next({ ...t }), n.resolver) {
        const { errors: dn } = await J([H]);
        if (V(Ne), Y) {
          const xn = lh(t.errors, i, H), en = lh(dn, i, xn.name || H);
          ae = en.error, H = en.name, me = zt(dn);
        }
      } else
        y([H], !0), ae = (await dh(R, l.disabled, o, S, n.shouldUseNativeValidation))[H], y([H]), V(Ne), Y && (ae ? me = !1 : (u.isValid || f.isValid) && (me = await X(i, !0)));
      Y && (R._f.deps && xe(R._f.deps), Q(H, me, ae, cn));
    }
  }, W = (x, D) => {
    if (Je(t.errors, D) && x.focus)
      return x.focus(), 1;
  }, xe = async (x, D = {}) => {
    let H, Y;
    const R = to(x);
    if (n.resolver) {
      const V = await ie(lt(x) ? x : R);
      H = zt(V), Y = x ? !R.some((ae) => Je(V, ae)) : H;
    } else x ? (Y = (await Promise.all(R.map(async (V) => {
      const ae = Je(i, V);
      return await X(ae && ae._f ? { [V]: ae } : ae);
    }))).every(Boolean), !(!Y && !t.isValid) && w()) : Y = H = await X(i);
    return h.state.next({
      ...!Dr(x) || (u.isValid || f.isValid) && H !== t.isValid ? {} : { name: x },
      ...n.resolver || !x ? { isValid: H } : {},
      errors: t.errors
    }), D.shouldFocus && !Y && ro(i, W, x ? R : l.mount), Y;
  }, Ie = (x) => {
    const D = {
      ...s.mount ? o : a
    };
    return lt(x) ? D : Dr(x) ? Je(D, x) : x.map((H) => Je(D, H));
  }, K = (x, D) => ({
    invalid: !!Je((D || t).errors, x),
    isDirty: !!Je((D || t).dirtyFields, x),
    error: Je((D || t).errors, x),
    isValidating: !!Je(t.validatingFields, x),
    isTouched: !!Je((D || t).touchedFields, x)
  }), qe = (x) => {
    x && to(x).forEach((D) => vt(t.errors, D)), h.state.next({
      errors: x ? t.errors : {}
    });
  }, Be = (x, D, H) => {
    const Y = (Je(i, x, { _f: {} })._f || {}).ref, R = Je(t.errors, x) || {}, { ref: V, message: ae, type: me, ...Ne } = R;
    Kn(t.errors, x, {
      ...Ne,
      ...D,
      ref: Y
    }), h.state.next({
      name: x,
      errors: t.errors,
      isValid: !1
    }), H && H.shouldFocus && Y && Y.focus && Y.focus();
  }, Oe = (x, D) => kr(x) ? h.state.subscribe({
    next: (H) => x(q(void 0, D), H)
  }) : q(x, D, !0), Me = (x) => h.state.subscribe({
    next: (D) => {
      _C(x.name, D.name, x.exact) && xC(D, x.formState || u, Pe, x.reRenderRoot) && x.callback({
        values: { ...o },
        ...t,
        ...D
      });
    }
  }).unsubscribe, $e = (x) => (s.mount = !0, f = {
    ...f,
    ...x.formState
  }, Me({
    ...x,
    formState: f
  })), ze = (x, D = {}) => {
    for (const H of x ? to(x) : l.mount)
      l.mount.delete(H), l.array.delete(H), D.keepValue || (vt(i, H), vt(o, H)), !D.keepError && vt(t.errors, H), !D.keepDirty && vt(t.dirtyFields, H), !D.keepTouched && vt(t.touchedFields, H), !D.keepIsValidating && vt(t.validatingFields, H), !n.shouldUnregister && !D.keepDefaultValue && vt(a, H);
    h.state.next({
      values: Ct(o)
    }), h.state.next({
      ...t,
      ...D.keepDirty ? { isDirty: O() } : {}
    }), !D.keepIsValid && w();
  }, Re = ({ disabled: x, name: D }) => {
    (rr(x) && s.mount || x || l.disabled.has(D)) && (x ? l.disabled.add(D) : l.disabled.delete(D));
  }, an = (x, D = {}) => {
    let H = Je(i, x);
    const Y = rr(D.disabled) || rr(n.disabled);
    return Kn(i, x, {
      ...H || {},
      _f: {
        ...H && H._f ? H._f : { ref: { name: x } },
        name: x,
        mount: !0,
        ...D
      }
    }), l.mount.add(x), H ? Re({
      disabled: rr(D.disabled) ? D.disabled : n.disabled,
      name: x
    }) : T(x, !0, D.value), {
      ...Y ? { disabled: D.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!D.required,
        min: _a(D.min),
        max: _a(D.max),
        minLength: _a(D.minLength),
        maxLength: _a(D.maxLength),
        pattern: _a(D.pattern)
      } : {},
      name: x,
      onChange: fe,
      onBlur: fe,
      ref: (R) => {
        if (R) {
          an(x, D), H = Je(i, x);
          const V = lt(R.value) && R.querySelectorAll && R.querySelectorAll("input,select,textarea")[0] || R, ae = hC(V), me = H._f.refs || [];
          if (ae ? me.find((Ne) => Ne === V) : V === H._f.ref)
            return;
          Kn(i, x, {
            _f: {
              ...H._f,
              ...ae ? {
                refs: [
                  ...me.filter(Il),
                  V,
                  ...Array.isArray(Je(a, x)) ? [{}] : []
                ],
                ref: { type: V.type, name: x }
              } : { ref: V }
            }
          }), T(x, !1, void 0, V);
        } else
          H = Je(i, x, {}), H._f && (H._f.mount = !1), (n.shouldUnregister || D.shouldUnregister) && !(Ox(l.array, x) && s.action) && l.unMount.add(x);
      }
    };
  }, Ee = () => n.shouldFocusError && ro(i, W, l.mount), Ge = (x) => {
    rr(x) && (h.state.next({ disabled: x }), ro(i, (D, H) => {
      const Y = Je(i, H);
      Y && (D.disabled = Y._f.disabled || x, Array.isArray(Y._f.refs) && Y._f.refs.forEach((R) => {
        R.disabled = Y._f.disabled || x;
      }));
    }, 0, !1));
  }, Qe = (x, D) => async (H) => {
    let Y;
    H && (H.preventDefault && H.preventDefault(), H.persist && H.persist());
    let R = Ct(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: V, values: ae } = await J();
      t.errors = V, R = ae;
    } else
      await X(i);
    if (l.disabled.size)
      for (const V of l.disabled)
        Kn(R, V, void 0);
    if (vt(t.errors, "root"), zt(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await x(R, H);
      } catch (V) {
        Y = V;
      }
    } else
      D && await D({ ...t.errors }, H), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: zt(t.errors) && !Y,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), Y)
      throw Y;
  }, he = (x, D = {}) => {
    Je(i, x) && (lt(D.defaultValue) ? ce(x, Ct(Je(a, x))) : (ce(x, D.defaultValue), Kn(a, x, Ct(D.defaultValue))), D.keepTouched || vt(t.touchedFields, x), D.keepDirty || (vt(t.dirtyFields, x), t.isDirty = D.defaultValue ? O(x, Ct(Je(a, x))) : O()), D.keepError || (vt(t.errors, x), u.isValid && w()), h.state.next({ ...t }));
  }, ge = (x, D = {}) => {
    const H = x ? Ct(x) : a, Y = Ct(H), R = zt(x), V = R ? a : Y;
    if (D.keepDefaultValues || (a = H), !D.keepValues) {
      if (D.keepDirtyValues) {
        const ae = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(xa(a, o))
        ]);
        for (const me of Array.from(ae))
          Je(t.dirtyFields, me) ? Kn(V, me, Je(o, me)) : ce(me, Je(V, me));
      } else {
        if (up && lt(x))
          for (const ae of l.mount) {
            const me = Je(i, ae);
            if (me && me._f) {
              const Ne = Array.isArray(me._f.refs) ? me._f.refs[0] : me._f.ref;
              if (Fs(Ne)) {
                const nn = Ne.closest("form");
                if (nn) {
                  nn.reset();
                  break;
                }
              }
            }
          }
        for (const ae of l.mount)
          ce(ae, Je(V, ae));
      }
      o = Ct(V), h.array.next({
        values: { ...V }
      }), h.state.next({
        values: { ...V }
      });
    }
    l = {
      mount: D.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!D.keepIsValid || !!D.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: D.keepSubmitCount ? t.submitCount : 0,
      isDirty: R ? !1 : D.keepDirty ? t.isDirty : !!(D.keepDefaultValues && !ni(x, a)),
      isSubmitted: D.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: R ? {} : D.keepDirtyValues ? D.keepDefaultValues && o ? xa(a, o) : t.dirtyFields : D.keepDefaultValues && x ? xa(a, x) : D.keepDirty ? t.dirtyFields : {},
      touchedFields: D.keepTouched ? t.touchedFields : {},
      errors: D.keepErrors ? t.errors : {},
      isSubmitSuccessful: D.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, De = (x, D) => ge(kr(x) ? x(o) : x, D), Le = (x, D = {}) => {
    const H = Je(i, x), Y = H && H._f;
    if (Y) {
      const R = Y.refs ? Y.refs[0] : Y.ref;
      R.focus && (R.focus(), D.shouldSelect && kr(R.select) && R.select());
    }
  }, Pe = (x) => {
    t = {
      ...t,
      ...x
    };
  }, E = {
    control: {
      register: an,
      unregister: ze,
      getFieldState: K,
      handleSubmit: Qe,
      setError: Be,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: q,
      _getDirty: O,
      _setValid: w,
      _setFieldArray: z,
      _setDisabledField: Re,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: ge,
      _resetDefaultValues: () => kr(n.defaultValues) && n.defaultValues().then((x) => {
        De(x, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ge,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(x) {
        s = x;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(x) {
        l = x;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(x) {
        n = {
          ...n,
          ...x
        };
      }
    },
    subscribe: $e,
    trigger: xe,
    register: an,
    handleSubmit: Qe,
    watch: Oe,
    setValue: ce,
    getValues: Ie,
    reset: De,
    resetField: he,
    clearErrors: qe,
    unregister: ze,
    setError: Be,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...E,
    formControl: E
  };
}
function _t(e = {}) {
  const n = Fe.useRef(void 0), t = Fe.useRef(void 0), [i, a] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: kr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: kr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : CC(e),
    formState: i
  }, e.formControl && e.defaultValues && !kr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Fe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Fe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Fe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Fe.useEffect(() => {
    e.values && !ni(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Fe.useEffect(() => {
    e.errors && !zt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Fe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Fe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Lx(i, o), n.current;
}
var Po = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var El = { exports: {} }, Sa = {}, uh;
function FC() {
  if (uh) return Sa;
  uh = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Sa.Fragment = t, Sa.jsx = s, Sa.jsxs = s, Sa;
}
var Ao = {}, mh;
function IC() {
  return mh || (mh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ao.Fragment = i, Ao.jsx = Rn, Ao.jsxs = Mn;
  })()), Ao;
}
var ph;
function EC() {
  return ph || (ph = 1, process.env.NODE_ENV === "production" ? El.exports = FC() : El.exports = IC()), El.exports;
}
var bi = EC();
function TC(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Tl, fh;
function ii() {
  if (fh) return Tl;
  fh = 1;
  var e = Array.isArray;
  return Tl = e, Tl;
}
var $l, hh;
function Gx() {
  if (hh) return $l;
  hh = 1;
  var e = typeof Po == "object" && Po && Po.Object === Object && Po;
  return $l = e, $l;
}
var Dl, yh;
function Vr() {
  if (yh) return Dl;
  yh = 1;
  var e = Gx(), n = typeof self == "object" && self && self.Object === Object && self, t = e || n || Function("return this")();
  return Dl = t, Dl;
}
var Rl, gh;
function jo() {
  if (gh) return Rl;
  gh = 1;
  var e = Vr(), n = e.Symbol;
  return Rl = n, Rl;
}
var Ol, vh;
function $C() {
  if (vh) return Ol;
  vh = 1;
  var e = jo(), n = Object.prototype, t = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = t.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Ol = o, Ol;
}
var Pl, kh;
function DC() {
  if (kh) return Pl;
  kh = 1;
  var e = Object.prototype, n = e.toString;
  function t(i) {
    return n.call(i);
  }
  return Pl = t, Pl;
}
var Al, bh;
function da() {
  if (bh) return Al;
  bh = 1;
  var e = jo(), n = $C(), t = DC(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : t(l);
  }
  return Al = s, Al;
}
var Ll, xh;
function $i() {
  if (xh) return Ll;
  xh = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Ll = e, Ll;
}
var Vl, _h;
function gp() {
  if (_h) return Vl;
  _h = 1;
  var e = da(), n = $i(), t = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == t;
  }
  return Vl = i, Vl;
}
var zl, Sh;
function RC() {
  if (Sh) return zl;
  Sh = 1;
  var e = ii(), n = gp(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !t.test(o) || s != null && o in Object(s);
  }
  return zl = a, zl;
}
var Ul, Nh;
function ua() {
  if (Nh) return Ul;
  Nh = 1;
  function e(n) {
    var t = typeof n;
    return n != null && (t == "object" || t == "function");
  }
  return Ul = e, Ul;
}
var Ml, jh;
function Kx() {
  if (jh) return Ml;
  jh = 1;
  var e = da(), n = ua(), t = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == t || d == o;
  }
  return Ml = s, Ml;
}
var Bl, wh;
function OC() {
  if (wh) return Bl;
  wh = 1;
  var e = Vr(), n = e["__core-js_shared__"];
  return Bl = n, Bl;
}
var ql, Ch;
function PC() {
  if (Ch) return ql;
  Ch = 1;
  var e = OC(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function t(i) {
    return !!n && n in i;
  }
  return ql = t, ql;
}
var Hl, Fh;
function Yx() {
  if (Fh) return Hl;
  Fh = 1;
  var e = Function.prototype, n = e.toString;
  function t(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Hl = t, Hl;
}
var Wl, Ih;
function AC() {
  if (Ih) return Wl;
  Ih = 1;
  var e = Kx(), n = PC(), t = ua(), i = Yx(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!t(h) || n(h))
      return !1;
    var g = e(h) ? u : o;
    return g.test(i(h));
  }
  return Wl = f, Wl;
}
var Gl, Eh;
function LC() {
  if (Eh) return Gl;
  Eh = 1;
  function e(n, t) {
    return n?.[t];
  }
  return Gl = e, Gl;
}
var Kl, Th;
function Di() {
  if (Th) return Kl;
  Th = 1;
  var e = AC(), n = LC();
  function t(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Kl = t, Kl;
}
var Yl, $h;
function rl() {
  if ($h) return Yl;
  $h = 1;
  var e = Di(), n = e(Object, "create");
  return Yl = n, Yl;
}
var Ql, Dh;
function VC() {
  if (Dh) return Ql;
  Dh = 1;
  var e = rl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ql = n, Ql;
}
var Jl, Rh;
function zC() {
  if (Rh) return Jl;
  Rh = 1;
  function e(n) {
    var t = this.has(n) && delete this.__data__[n];
    return this.size -= t ? 1 : 0, t;
  }
  return Jl = e, Jl;
}
var Xl, Oh;
function UC() {
  if (Oh) return Xl;
  Oh = 1;
  var e = rl(), n = "__lodash_hash_undefined__", t = Object.prototype, i = t.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Xl = a, Xl;
}
var Zl, Ph;
function MC() {
  if (Ph) return Zl;
  Ph = 1;
  var e = rl(), n = Object.prototype, t = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : t.call(o, a);
  }
  return Zl = i, Zl;
}
var ec, Ah;
function BC() {
  if (Ah) return ec;
  Ah = 1;
  var e = rl(), n = "__lodash_hash_undefined__";
  function t(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return ec = t, ec;
}
var nc, Lh;
function qC() {
  if (Lh) return nc;
  Lh = 1;
  var e = VC(), n = zC(), t = UC(), i = MC(), a = BC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, nc = o, nc;
}
var tc, Vh;
function HC() {
  if (Vh) return tc;
  Vh = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return tc = e, tc;
}
var rc, zh;
function Qx() {
  if (zh) return rc;
  zh = 1;
  function e(n, t) {
    return n === t || n !== n && t !== t;
  }
  return rc = e, rc;
}
var ic, Uh;
function il() {
  if (Uh) return ic;
  Uh = 1;
  var e = Qx();
  function n(t, i) {
    for (var a = t.length; a--; )
      if (e(t[a][0], i))
        return a;
    return -1;
  }
  return ic = n, ic;
}
var ac, Mh;
function WC() {
  if (Mh) return ac;
  Mh = 1;
  var e = il(), n = Array.prototype, t = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : t.call(o, s, 1), --this.size, !0;
  }
  return ac = i, ac;
}
var oc, Bh;
function GC() {
  if (Bh) return oc;
  Bh = 1;
  var e = il();
  function n(t) {
    var i = this.__data__, a = e(i, t);
    return a < 0 ? void 0 : i[a][1];
  }
  return oc = n, oc;
}
var sc, qh;
function KC() {
  if (qh) return sc;
  qh = 1;
  var e = il();
  function n(t) {
    return e(this.__data__, t) > -1;
  }
  return sc = n, sc;
}
var lc, Hh;
function YC() {
  if (Hh) return lc;
  Hh = 1;
  var e = il();
  function n(t, i) {
    var a = this.__data__, o = e(a, t);
    return o < 0 ? (++this.size, a.push([t, i])) : a[o][1] = i, this;
  }
  return lc = n, lc;
}
var cc, Wh;
function al() {
  if (Wh) return cc;
  Wh = 1;
  var e = HC(), n = WC(), t = GC(), i = KC(), a = YC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, cc = o, cc;
}
var dc, Gh;
function vp() {
  if (Gh) return dc;
  Gh = 1;
  var e = Di(), n = Vr(), t = e(n, "Map");
  return dc = t, dc;
}
var uc, Kh;
function QC() {
  if (Kh) return uc;
  Kh = 1;
  var e = qC(), n = al(), t = vp();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || n)(),
      string: new e()
    };
  }
  return uc = i, uc;
}
var mc, Yh;
function JC() {
  if (Yh) return mc;
  Yh = 1;
  function e(n) {
    var t = typeof n;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
  }
  return mc = e, mc;
}
var pc, Qh;
function ol() {
  if (Qh) return pc;
  Qh = 1;
  var e = JC();
  function n(t, i) {
    var a = t.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return pc = n, pc;
}
var fc, Jh;
function XC() {
  if (Jh) return fc;
  Jh = 1;
  var e = ol();
  function n(t) {
    var i = e(this, t).delete(t);
    return this.size -= i ? 1 : 0, i;
  }
  return fc = n, fc;
}
var hc, Xh;
function ZC() {
  if (Xh) return hc;
  Xh = 1;
  var e = ol();
  function n(t) {
    return e(this, t).get(t);
  }
  return hc = n, hc;
}
var yc, Zh;
function e1() {
  if (Zh) return yc;
  Zh = 1;
  var e = ol();
  function n(t) {
    return e(this, t).has(t);
  }
  return yc = n, yc;
}
var gc, ey;
function n1() {
  if (ey) return gc;
  ey = 1;
  var e = ol();
  function n(t, i) {
    var a = e(this, t), o = a.size;
    return a.set(t, i), this.size += a.size == o ? 0 : 1, this;
  }
  return gc = n, gc;
}
var vc, ny;
function Jx() {
  if (ny) return vc;
  ny = 1;
  var e = QC(), n = XC(), t = ZC(), i = e1(), a = n1();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, vc = o, vc;
}
var kc, ty;
function t1() {
  if (ty) return kc;
  ty = 1;
  var e = Jx(), n = "Expected a function";
  function t(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (t.Cache || e)(), o;
  }
  return t.Cache = e, kc = t, kc;
}
var bc, ry;
function r1() {
  if (ry) return bc;
  ry = 1;
  var e = t1(), n = 500;
  function t(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return bc = t, bc;
}
var xc, iy;
function i1() {
  if (iy) return xc;
  iy = 1;
  var e = r1(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(t, "$1") : l || s);
    }), o;
  });
  return xc = i, xc;
}
var _c, ay;
function Xx() {
  if (ay) return _c;
  ay = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = t(n[i], i, n);
    return o;
  }
  return _c = e, _c;
}
var Sc, oy;
function a1() {
  if (oy) return Sc;
  oy = 1;
  var e = jo(), n = Xx(), t = ii(), i = gp(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (t(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return Sc = s, Sc;
}
var Nc, sy;
function o1() {
  if (sy) return Nc;
  sy = 1;
  var e = a1();
  function n(t) {
    return t == null ? "" : e(t);
  }
  return Nc = n, Nc;
}
var jc, ly;
function ma() {
  if (ly) return jc;
  ly = 1;
  var e = ii(), n = RC(), t = i1(), i = o1();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : t(i(o));
  }
  return jc = a, jc;
}
var wc, cy;
function sl() {
  if (cy) return wc;
  cy = 1;
  var e = gp();
  function n(t) {
    if (typeof t == "string" || e(t))
      return t;
    var i = t + "";
    return i == "0" && 1 / t == -1 / 0 ? "-0" : i;
  }
  return wc = n, wc;
}
var Cc, dy;
function Zx() {
  if (dy) return Cc;
  dy = 1;
  var e = ma(), n = sl();
  function t(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Cc = t, Cc;
}
var Fc, uy;
function e_() {
  if (uy) return Fc;
  uy = 1;
  var e = Di(), n = (function() {
    try {
      var t = e(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  })();
  return Fc = n, Fc;
}
var Ic, my;
function n_() {
  if (my) return Ic;
  my = 1;
  var e = e_();
  function n(t, i, a) {
    i == "__proto__" && e ? e(t, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : t[i] = a;
  }
  return Ic = n, Ic;
}
var Ec, py;
function kp() {
  if (py) return Ec;
  py = 1;
  var e = n_(), n = Qx(), t = Object.prototype, i = t.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Ec = a, Ec;
}
var Tc, fy;
function bp() {
  if (fy) return Tc;
  fy = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function t(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Tc = t, Tc;
}
var $c, hy;
function s1() {
  if (hy) return $c;
  hy = 1;
  var e = kp(), n = ma(), t = bp(), i = ua(), a = sl();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, g = s; g != null && ++u < f; ) {
      var C = a(l[u]), S = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var N = g[C];
        S = m ? m(N, C, g) : void 0, S === void 0 && (S = i(N) ? N : t(l[u + 1]) ? [] : {});
      }
      e(g, C, S), g = g[C];
    }
    return s;
  }
  return $c = o, $c;
}
var Dc, yy;
function l1() {
  if (yy) return Dc;
  yy = 1;
  var e = Zx(), n = s1(), t = ma();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, t(u, a), f);
    }
    return m;
  }
  return Dc = i, Dc;
}
var Rc, gy;
function c1() {
  if (gy) return Rc;
  gy = 1;
  function e(n, t) {
    return n != null && t in Object(n);
  }
  return Rc = e, Rc;
}
var Oc, vy;
function d1() {
  if (vy) return Oc;
  vy = 1;
  var e = da(), n = $i(), t = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return Oc = i, Oc;
}
var Pc, ky;
function xp() {
  if (ky) return Pc;
  ky = 1;
  var e = d1(), n = $i(), t = Object.prototype, i = t.hasOwnProperty, a = t.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Pc = o, Pc;
}
var Ac, by;
function _p() {
  if (by) return Ac;
  by = 1;
  var e = 9007199254740991;
  function n(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
  }
  return Ac = n, Ac;
}
var Lc, xy;
function u1() {
  if (xy) return Lc;
  xy = 1;
  var e = ma(), n = xp(), t = ii(), i = bp(), a = _p(), o = sl();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var g = o(d[u]);
      if (!(h = l != null && m(l, g)))
        break;
      l = l[g];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(g, f) && (t(l) || n(l)));
  }
  return Lc = s, Lc;
}
var Vc, _y;
function m1() {
  if (_y) return Vc;
  _y = 1;
  var e = c1(), n = u1();
  function t(i, a) {
    return i != null && n(i, a, e);
  }
  return Vc = t, Vc;
}
var zc, Sy;
function p1() {
  if (Sy) return zc;
  Sy = 1;
  var e = l1(), n = m1();
  function t(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return zc = t, zc;
}
var Uc, Ny;
function Sp() {
  if (Ny) return Uc;
  Ny = 1;
  function e(n, t) {
    for (var i = -1, a = t.length, o = n.length; ++i < a; )
      n[o + i] = t[i];
    return n;
  }
  return Uc = e, Uc;
}
var Mc, jy;
function f1() {
  if (jy) return Mc;
  jy = 1;
  var e = jo(), n = xp(), t = ii(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return t(o) || n(o) || !!(i && o && o[i]);
  }
  return Mc = a, Mc;
}
var Bc, wy;
function h1() {
  if (wy) return Bc;
  wy = 1;
  var e = Sp(), n = f1();
  function t(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? t(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Bc = t, Bc;
}
var qc, Cy;
function y1() {
  if (Cy) return qc;
  Cy = 1;
  var e = h1();
  function n(t) {
    var i = t == null ? 0 : t.length;
    return i ? e(t, 1) : [];
  }
  return qc = n, qc;
}
var Hc, Fy;
function g1() {
  if (Fy) return Hc;
  Fy = 1;
  function e(n, t, i) {
    switch (i.length) {
      case 0:
        return n.call(t);
      case 1:
        return n.call(t, i[0]);
      case 2:
        return n.call(t, i[0], i[1]);
      case 3:
        return n.call(t, i[0], i[1], i[2]);
    }
    return n.apply(t, i);
  }
  return Hc = e, Hc;
}
var Wc, Iy;
function v1() {
  if (Iy) return Wc;
  Iy = 1;
  var e = g1(), n = Math.max;
  function t(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Wc = t, Wc;
}
var Gc, Ey;
function k1() {
  if (Ey) return Gc;
  Ey = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Gc = e, Gc;
}
var Kc, Ty;
function t_() {
  if (Ty) return Kc;
  Ty = 1;
  function e(n) {
    return n;
  }
  return Kc = e, Kc;
}
var Yc, $y;
function b1() {
  if ($y) return Yc;
  $y = 1;
  var e = k1(), n = e_(), t = t_(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : t;
  return Yc = i, Yc;
}
var Qc, Dy;
function x1() {
  if (Dy) return Qc;
  Dy = 1;
  var e = 800, n = 16, t = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = t(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Qc = i, Qc;
}
var Jc, Ry;
function _1() {
  if (Ry) return Jc;
  Ry = 1;
  var e = b1(), n = x1(), t = n(e);
  return Jc = t, Jc;
}
var Xc, Oy;
function r_() {
  if (Oy) return Xc;
  Oy = 1;
  var e = y1(), n = v1(), t = _1();
  function i(a) {
    return t(n(a, void 0, e), a + "");
  }
  return Xc = i, Xc;
}
var Zc, Py;
function S1() {
  if (Py) return Zc;
  Py = 1;
  var e = p1(), n = r_(), t = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Zc = t, Zc;
}
var N1 = S1();
const i_ = /* @__PURE__ */ Wx(N1), j1 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function a_(e) {
  const n = i_(e, j1);
  return {
    controller: fp(n),
    controllerProps: n
  };
}
const w1 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function o_(e) {
  const { controller: n, controllerProps: t } = a_(e), i = {
    ...i_(e, w1),
    required: TC(t.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: t.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: t,
    fieldWrapperProps: i
  };
}
var ed, Ay;
function C1() {
  if (Ay) return ed;
  Ay = 1;
  var e = al();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return ed = n, ed;
}
var nd, Ly;
function F1() {
  if (Ly) return nd;
  Ly = 1;
  function e(n) {
    var t = this.__data__, i = t.delete(n);
    return this.size = t.size, i;
  }
  return nd = e, nd;
}
var td, Vy;
function I1() {
  if (Vy) return td;
  Vy = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return td = e, td;
}
var rd, zy;
function E1() {
  if (zy) return rd;
  zy = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return rd = e, rd;
}
var id, Uy;
function T1() {
  if (Uy) return id;
  Uy = 1;
  var e = al(), n = vp(), t = Jx(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new t(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return id = a, id;
}
var ad, My;
function $1() {
  if (My) return ad;
  My = 1;
  var e = al(), n = C1(), t = F1(), i = I1(), a = E1(), o = T1();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = t, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, ad = s, ad;
}
var od, By;
function D1() {
  if (By) return od;
  By = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && t(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return od = e, od;
}
var sd, qy;
function wo() {
  if (qy) return sd;
  qy = 1;
  var e = kp(), n = n_();
  function t(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return sd = t, sd;
}
var ld, Hy;
function R1() {
  if (Hy) return ld;
  Hy = 1;
  function e(n, t) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = t(i);
    return a;
  }
  return ld = e, ld;
}
var ys = { exports: {} }, cd, Wy;
function O1() {
  if (Wy) return cd;
  Wy = 1;
  function e() {
    return !1;
  }
  return cd = e, cd;
}
ys.exports;
var Gy;
function s_() {
  return Gy || (Gy = 1, (function(e, n) {
    var t = Vr(), i = O1(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? t.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(ys, ys.exports)), ys.exports;
}
var dd, Ky;
function P1() {
  if (Ky) return dd;
  Ky = 1;
  var e = da(), n = _p(), t = $i(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", g = "[object Set]", C = "[object String]", S = "[object WeakMap]", N = "[object ArrayBuffer]", w = "[object DataView]", y = "[object Float32Array]", z = "[object Float64Array]", $ = "[object Int8Array]", I = "[object Int16Array]", T = "[object Int32Array]", U = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", J = "[object Uint16Array]", ie = "[object Uint32Array]", X = {};
  X[y] = X[z] = X[$] = X[I] = X[T] = X[U] = X[Q] = X[J] = X[ie] = !0, X[i] = X[a] = X[N] = X[o] = X[w] = X[s] = X[l] = X[d] = X[m] = X[u] = X[f] = X[h] = X[g] = X[C] = X[S] = !1;
  function B(O) {
    return t(O) && n(O.length) && !!X[e(O)];
  }
  return dd = B, dd;
}
var ud, Yy;
function Np() {
  if (Yy) return ud;
  Yy = 1;
  function e(n) {
    return function(t) {
      return n(t);
    };
  }
  return ud = e, ud;
}
var gs = { exports: {} };
gs.exports;
var Qy;
function jp() {
  return Qy || (Qy = 1, (function(e, n) {
    var t = Gx(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && t.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(gs, gs.exports)), gs.exports;
}
var md, Jy;
function A1() {
  if (Jy) return md;
  Jy = 1;
  var e = P1(), n = Np(), t = jp(), i = t && t.isTypedArray, a = i ? n(i) : e;
  return md = a, md;
}
var pd, Xy;
function l_() {
  if (Xy) return pd;
  Xy = 1;
  var e = R1(), n = xp(), t = ii(), i = s_(), a = bp(), o = A1(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = t(m), h = !f && n(m), g = !f && !h && i(m), C = !f && !h && !g && o(m), S = f || h || g || C, N = S ? e(m.length, String) : [], w = N.length;
    for (var y in m)
      (u || l.call(m, y)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      g && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, w))) && N.push(y);
    return N;
  }
  return pd = d, pd;
}
var fd, Zy;
function wp() {
  if (Zy) return fd;
  Zy = 1;
  var e = Object.prototype;
  function n(t) {
    var i = t && t.constructor, a = typeof i == "function" && i.prototype || e;
    return t === a;
  }
  return fd = n, fd;
}
var hd, eg;
function c_() {
  if (eg) return hd;
  eg = 1;
  function e(n, t) {
    return function(i) {
      return n(t(i));
    };
  }
  return hd = e, hd;
}
var yd, ng;
function L1() {
  if (ng) return yd;
  ng = 1;
  var e = c_(), n = e(Object.keys, Object);
  return yd = n, yd;
}
var gd, tg;
function V1() {
  if (tg) return gd;
  tg = 1;
  var e = wp(), n = L1(), t = Object.prototype, i = t.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return gd = a, gd;
}
var vd, rg;
function d_() {
  if (rg) return vd;
  rg = 1;
  var e = Kx(), n = _p();
  function t(i) {
    return i != null && n(i.length) && !e(i);
  }
  return vd = t, vd;
}
var kd, ig;
function Cp() {
  if (ig) return kd;
  ig = 1;
  var e = l_(), n = V1(), t = d_();
  function i(a) {
    return t(a) ? e(a) : n(a);
  }
  return kd = i, kd;
}
var bd, ag;
function z1() {
  if (ag) return bd;
  ag = 1;
  var e = wo(), n = Cp();
  function t(i, a) {
    return i && e(a, n(a), i);
  }
  return bd = t, bd;
}
var xd, og;
function U1() {
  if (og) return xd;
  og = 1;
  function e(n) {
    var t = [];
    if (n != null)
      for (var i in Object(n))
        t.push(i);
    return t;
  }
  return xd = e, xd;
}
var _d, sg;
function M1() {
  if (sg) return _d;
  sg = 1;
  var e = ua(), n = wp(), t = U1(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return t(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return _d = o, _d;
}
var Sd, lg;
function Fp() {
  if (lg) return Sd;
  lg = 1;
  var e = l_(), n = M1(), t = d_();
  function i(a) {
    return t(a) ? e(a, !0) : n(a);
  }
  return Sd = i, Sd;
}
var Nd, cg;
function B1() {
  if (cg) return Nd;
  cg = 1;
  var e = wo(), n = Fp();
  function t(i, a) {
    return i && e(a, n(a), i);
  }
  return Nd = t, Nd;
}
var vs = { exports: {} };
vs.exports;
var dg;
function q1() {
  return dg || (dg = 1, (function(e, n) {
    var t = Vr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? t.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(vs, vs.exports)), vs.exports;
}
var jd, ug;
function H1() {
  if (ug) return jd;
  ug = 1;
  function e(n, t) {
    var i = -1, a = n.length;
    for (t || (t = Array(a)); ++i < a; )
      t[i] = n[i];
    return t;
  }
  return jd = e, jd;
}
var wd, mg;
function W1() {
  if (mg) return wd;
  mg = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      t(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return wd = e, wd;
}
var Cd, pg;
function u_() {
  if (pg) return Cd;
  pg = 1;
  function e() {
    return [];
  }
  return Cd = e, Cd;
}
var Fd, fg;
function Ip() {
  if (fg) return Fd;
  fg = 1;
  var e = W1(), n = u_(), t = Object.prototype, i = t.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Fd = o, Fd;
}
var Id, hg;
function G1() {
  if (hg) return Id;
  hg = 1;
  var e = wo(), n = Ip();
  function t(i, a) {
    return e(i, n(i), a);
  }
  return Id = t, Id;
}
var Ed, yg;
function Ep() {
  if (yg) return Ed;
  yg = 1;
  var e = c_(), n = e(Object.getPrototypeOf, Object);
  return Ed = n, Ed;
}
var Td, gg;
function m_() {
  if (gg) return Td;
  gg = 1;
  var e = Sp(), n = Ep(), t = Ip(), i = u_(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, t(s)), s = n(s);
    return l;
  } : i;
  return Td = o, Td;
}
var $d, vg;
function K1() {
  if (vg) return $d;
  vg = 1;
  var e = wo(), n = m_();
  function t(i, a) {
    return e(i, n(i), a);
  }
  return $d = t, $d;
}
var Dd, kg;
function p_() {
  if (kg) return Dd;
  kg = 1;
  var e = Sp(), n = ii();
  function t(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Dd = t, Dd;
}
var Rd, bg;
function Y1() {
  if (bg) return Rd;
  bg = 1;
  var e = p_(), n = Ip(), t = Cp();
  function i(a) {
    return e(a, t, n);
  }
  return Rd = i, Rd;
}
var Od, xg;
function f_() {
  if (xg) return Od;
  xg = 1;
  var e = p_(), n = m_(), t = Fp();
  function i(a) {
    return e(a, t, n);
  }
  return Od = i, Od;
}
var Pd, _g;
function Q1() {
  if (_g) return Pd;
  _g = 1;
  var e = Di(), n = Vr(), t = e(n, "DataView");
  return Pd = t, Pd;
}
var Ad, Sg;
function J1() {
  if (Sg) return Ad;
  Sg = 1;
  var e = Di(), n = Vr(), t = e(n, "Promise");
  return Ad = t, Ad;
}
var Ld, Ng;
function X1() {
  if (Ng) return Ld;
  Ng = 1;
  var e = Di(), n = Vr(), t = e(n, "Set");
  return Ld = t, Ld;
}
var Vd, jg;
function Z1() {
  if (jg) return Vd;
  jg = 1;
  var e = Di(), n = Vr(), t = e(n, "WeakMap");
  return Vd = t, Vd;
}
var zd, wg;
function Tp() {
  if (wg) return zd;
  wg = 1;
  var e = Q1(), n = vp(), t = J1(), i = X1(), a = Z1(), o = da(), s = Yx(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", g = s(e), C = s(n), S = s(t), N = s(i), w = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || t && y(t.resolve()) != m || i && y(new i()) != u || a && y(new a()) != f) && (y = function(z) {
    var $ = o(z), I = $ == d ? z.constructor : void 0, T = I ? s(I) : "";
    if (T)
      switch (T) {
        case g:
          return h;
        case C:
          return l;
        case S:
          return m;
        case N:
          return u;
        case w:
          return f;
      }
    return $;
  }), zd = y, zd;
}
var Ud, Cg;
function eF() {
  if (Cg) return Ud;
  Cg = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function t(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Ud = t, Ud;
}
var Md, Fg;
function nF() {
  if (Fg) return Md;
  Fg = 1;
  var e = Vr(), n = e.Uint8Array;
  return Md = n, Md;
}
var Bd, Ig;
function $p() {
  if (Ig) return Bd;
  Ig = 1;
  var e = nF();
  function n(t) {
    var i = new t.constructor(t.byteLength);
    return new e(i).set(new e(t)), i;
  }
  return Bd = n, Bd;
}
var qd, Eg;
function tF() {
  if (Eg) return qd;
  Eg = 1;
  var e = $p();
  function n(t, i) {
    var a = i ? e(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.byteLength);
  }
  return qd = n, qd;
}
var Hd, Tg;
function rF() {
  if (Tg) return Hd;
  Tg = 1;
  var e = /\w*$/;
  function n(t) {
    var i = new t.constructor(t.source, e.exec(t));
    return i.lastIndex = t.lastIndex, i;
  }
  return Hd = n, Hd;
}
var Wd, $g;
function iF() {
  if ($g) return Wd;
  $g = 1;
  var e = jo(), n = e ? e.prototype : void 0, t = n ? n.valueOf : void 0;
  function i(a) {
    return t ? Object(t.call(a)) : {};
  }
  return Wd = i, Wd;
}
var Gd, Dg;
function aF() {
  if (Dg) return Gd;
  Dg = 1;
  var e = $p();
  function n(t, i) {
    var a = i ? e(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.length);
  }
  return Gd = n, Gd;
}
var Kd, Rg;
function oF() {
  if (Rg) return Kd;
  Rg = 1;
  var e = $p(), n = tF(), t = rF(), i = iF(), a = aF(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", g = "[object ArrayBuffer]", C = "[object DataView]", S = "[object Float32Array]", N = "[object Float64Array]", w = "[object Int8Array]", y = "[object Int16Array]", z = "[object Int32Array]", $ = "[object Uint8Array]", I = "[object Uint8ClampedArray]", T = "[object Uint16Array]", U = "[object Uint32Array]";
  function Q(J, ie, X) {
    var B = J.constructor;
    switch (ie) {
      case g:
        return e(J);
      case o:
      case s:
        return new B(+J);
      case C:
        return n(J, X);
      case S:
      case N:
      case w:
      case y:
      case z:
      case $:
      case I:
      case T:
      case U:
        return a(J, X);
      case l:
        return new B();
      case d:
      case f:
        return new B(J);
      case m:
        return t(J);
      case u:
        return new B();
      case h:
        return i(J);
    }
  }
  return Kd = Q, Kd;
}
var Yd, Og;
function sF() {
  if (Og) return Yd;
  Og = 1;
  var e = ua(), n = Object.create, t = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Yd = t, Yd;
}
var Qd, Pg;
function lF() {
  if (Pg) return Qd;
  Pg = 1;
  var e = sF(), n = Ep(), t = wp();
  function i(a) {
    return typeof a.constructor == "function" && !t(a) ? e(n(a)) : {};
  }
  return Qd = i, Qd;
}
var Jd, Ag;
function cF() {
  if (Ag) return Jd;
  Ag = 1;
  var e = Tp(), n = $i(), t = "[object Map]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return Jd = i, Jd;
}
var Xd, Lg;
function dF() {
  if (Lg) return Xd;
  Lg = 1;
  var e = cF(), n = Np(), t = jp(), i = t && t.isMap, a = i ? n(i) : e;
  return Xd = a, Xd;
}
var Zd, Vg;
function uF() {
  if (Vg) return Zd;
  Vg = 1;
  var e = Tp(), n = $i(), t = "[object Set]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return Zd = i, Zd;
}
var eu, zg;
function mF() {
  if (zg) return eu;
  zg = 1;
  var e = uF(), n = Np(), t = jp(), i = t && t.isSet, a = i ? n(i) : e;
  return eu = a, eu;
}
var nu, Ug;
function pF() {
  if (Ug) return nu;
  Ug = 1;
  var e = $1(), n = D1(), t = kp(), i = z1(), a = B1(), o = q1(), s = H1(), l = G1(), d = K1(), m = Y1(), u = f_(), f = Tp(), h = eF(), g = oF(), C = lF(), S = ii(), N = s_(), w = dF(), y = ua(), z = mF(), $ = Cp(), I = Fp(), T = 1, U = 2, Q = 4, J = "[object Arguments]", ie = "[object Array]", X = "[object Boolean]", B = "[object Date]", O = "[object Error]", q = "[object Function]", ee = "[object GeneratorFunction]", ve = "[object Map]", ue = "[object Number]", ce = "[object Object]", fe = "[object RegExp]", W = "[object Set]", xe = "[object String]", Ie = "[object Symbol]", K = "[object WeakMap]", qe = "[object ArrayBuffer]", Be = "[object DataView]", Oe = "[object Float32Array]", Me = "[object Float64Array]", $e = "[object Int8Array]", ze = "[object Int16Array]", Re = "[object Int32Array]", an = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Ge = "[object Uint16Array]", Qe = "[object Uint32Array]", he = {};
  he[J] = he[ie] = he[qe] = he[Be] = he[X] = he[B] = he[Oe] = he[Me] = he[$e] = he[ze] = he[Re] = he[ve] = he[ue] = he[ce] = he[fe] = he[W] = he[xe] = he[Ie] = he[an] = he[Ee] = he[Ge] = he[Qe] = !0, he[O] = he[q] = he[K] = !1;
  function ge(De, Le, Pe, mn, E, x) {
    var D, H = Le & T, Y = Le & U, R = Le & Q;
    if (Pe && (D = E ? Pe(De, mn, E, x) : Pe(De)), D !== void 0)
      return D;
    if (!y(De))
      return De;
    var V = S(De);
    if (V) {
      if (D = h(De), !H)
        return s(De, D);
    } else {
      var ae = f(De), me = ae == q || ae == ee;
      if (N(De))
        return o(De, H);
      if (ae == ce || ae == J || me && !E) {
        if (D = Y || me ? {} : C(De), !H)
          return Y ? d(De, a(D, De)) : l(De, i(D, De));
      } else {
        if (!he[ae])
          return E ? De : {};
        D = g(De, ae, H);
      }
    }
    x || (x = new e());
    var Ne = x.get(De);
    if (Ne)
      return Ne;
    x.set(De, D), z(De) ? De.forEach(function(tn) {
      D.add(ge(tn, Le, Pe, tn, De, x));
    }) : w(De) && De.forEach(function(tn, cn) {
      D.set(cn, ge(tn, Le, Pe, cn, De, x));
    });
    var nn = R ? Y ? u : m : Y ? I : $, fn = V ? void 0 : nn(De);
    return n(fn || De, function(tn, cn) {
      fn && (cn = tn, tn = De[cn]), t(D, cn, ge(tn, Le, Pe, cn, De, x));
    }), D;
  }
  return nu = ge, nu;
}
var tu, Mg;
function fF() {
  if (Mg) return tu;
  Mg = 1;
  function e(n) {
    var t = n == null ? 0 : n.length;
    return t ? n[t - 1] : void 0;
  }
  return tu = e, tu;
}
var ru, Bg;
function hF() {
  if (Bg) return ru;
  Bg = 1;
  function e(n, t, i) {
    var a = -1, o = n.length;
    t < 0 && (t = -t > o ? 0 : o + t), i = i > o ? o : i, i < 0 && (i += o), o = t > i ? 0 : i - t >>> 0, t >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + t];
    return s;
  }
  return ru = e, ru;
}
var iu, qg;
function yF() {
  if (qg) return iu;
  qg = 1;
  var e = Zx(), n = hF();
  function t(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return iu = t, iu;
}
var au, Hg;
function gF() {
  if (Hg) return au;
  Hg = 1;
  var e = ma(), n = fF(), t = yF(), i = sl(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = t(l, d);
    return h == null || delete h[i(n(d))];
  }
  return au = s, au;
}
var ou, Wg;
function vF() {
  if (Wg) return ou;
  Wg = 1;
  var e = da(), n = Ep(), t = $i(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!t(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return ou = m, ou;
}
var su, Gg;
function kF() {
  if (Gg) return su;
  Gg = 1;
  var e = vF();
  function n(t) {
    return e(t) ? void 0 : t;
  }
  return su = n, su;
}
var lu, Kg;
function bF() {
  if (Kg) return lu;
  Kg = 1;
  var e = Xx(), n = pF(), t = gF(), i = ma(), a = wo(), o = kF(), s = r_(), l = f_(), d = 1, m = 2, u = 4, f = s(function(h, g) {
    var C = {};
    if (h == null)
      return C;
    var S = !1;
    g = e(g, function(w) {
      return w = i(w, h), S || (S = w.length > 1), w;
    }), a(h, l(h), C), S && (C = n(C, d | m | u, o));
    for (var N = g.length; N--; )
      t(C, g[N]);
    return C;
  });
  return lu = f, lu;
}
bF();
const jr = ({
  children: e,
  ...n
}) => {
  const { controller: t, controllerProps: i, fieldWrapperProps: a } = o_(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = t.field;
  return /* @__PURE__ */ bi.jsx(ln, { ...a, children: /* @__PURE__ */ bi.jsx(
    ei,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: ln.getStatus(a.meta),
      children: e
    }
  ) });
};
var xF = t_();
const _F = /* @__PURE__ */ Wx(xF), Jn = ({
  transformValue: e = _F,
  label: n,
  helpIcon: t,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = a_(a);
  return /* @__PURE__ */ bi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ bi.jsx(
      im,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ bi.jsx(E0, { htmlFor: s, helpIcon: t, children: n })
  ] });
}, tt = (e) => {
  const { controller: n, controllerProps: t, fieldWrapperProps: i } = o_(e);
  return /* @__PURE__ */ bi.jsx(ln, { ...i, children: /* @__PURE__ */ bi.jsx(
    Nr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: t.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: ln.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var cu = { exports: {} }, Na = {}, Yg;
function SF() {
  if (Yg) return Na;
  Yg = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Na.Fragment = t, Na.jsx = s, Na.jsxs = s, Na;
}
var Lo = {}, Qg;
function NF() {
  return Qg || (Qg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Lo.Fragment = i, Lo.jsx = Rn, Lo.jsxs = Mn;
  })()), Lo;
}
var Jg;
function jF() {
  return Jg || (Jg = 1, process.env.NODE_ENV === "production" ? cu.exports = SF() : cu.exports = NF()), cu.exports;
}
var ye = jF();
const wF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, CF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, FF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, IF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, EF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, TF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, $F = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, DF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, RF = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": FF,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": IF,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": EF,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": wF,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": CF,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": TF,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": $F,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": DF
};
function pa(e) {
  return RF[e] ?? {};
}
const OF = pa(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), PF = pa(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), AF = pa(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Xg = ({
  owner: e,
  repository: n,
  number: t
}) => `https://github.com/${e}/${n}/issues/${t}`, dr = ({
  owner: e,
  repository: n,
  number: t
}) => `${e}/${n} #${t}`, LF = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Zg = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, pm = (e, n, t) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ ye.jsxs(
    "svg",
    {
      className: t,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ ye.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ ye.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ ye.jsxs(
    "svg",
    {
      className: t,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ ye.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ ye.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ ye.jsx(
    "svg",
    {
      className: t,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ye.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ ye.jsx(
    "svg",
    {
      className: t,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ye.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ ye.jsx(
    "svg",
    {
      className: t,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ye.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function VF({
  conversationId: e,
  githubOrganization: n
}) {
  const t = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = le(
    []
  ), [o, s] = le([]), [l, d] = le([]), [m, u] = le([]), [f, h] = le(), { showNotification: g, showModal: C, executeQuery: S } = hn(), { track: N } = _n(), {
    loading: w,
    data: y,
    error: z,
    store: $
  } = Km(e ?? null), I = y?.github?.issues || [], T = y?.github?.pullRequests || [], [U, Q] = le(!1), [J, ie] = le();
  He(
    () => h(z || J || void 0),
    [z, J]
  ), He(
    () => {
      !w && (I?.length || T?.length) ? (a(I), s(T), B(I, T)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const X = async (fe, W) => {
    await $(fe).then(() => {
      g({
        icon: "check-circle-filled",
        severity: "success",
        title: W.success.title,
        text: W.success.text
      });
    }).catch((xe) => {
      g({
        title: W.error.title,
        text: `${W.error.text} ${xe.message && " (" + xe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (fe, W) => {
    if (!fe?.length && !W?.length) {
      d([]), u([]);
      return;
    }
    const xe = (fe || []).map(
      (qe) => S(PF, {
        owner: qe.owner,
        repositoryName: qe.repository,
        issueNumber: qe.number
      })
    ), Ie = (W || []).map(
      (qe) => S(AF, {
        owner: qe.owner,
        repositoryName: qe.repository,
        prNumber: qe.number
      })
    ), K = [...xe, ...Ie];
    Q(!0), Promise.all(K).then((qe) => {
      const Be = [], Oe = [];
      qe.forEach((Me) => {
        const $e = Me?.data?.GitHub;
        if (!$e) {
          d([]), u([]);
          return;
        }
        Object.keys($e).forEach((ze) => {
          if (ze.startsWith("repository")) {
            const Re = $e[ze];
            Object.keys(Re).forEach((an) => {
              const Ee = Re[an], Ge = {
                number: Ee?.number,
                owner: Ee?.repository?.owner?.login,
                repository: Ee?.repository?.name
              };
              an.startsWith("issue") && Be.push({
                ...Ee,
                type: "ISSUE",
                key: Ge
              }), an.startsWith("pullRequest") && Oe.push({
                ...Ee,
                type: "PR",
                key: Ge
              });
            });
          }
        });
      }), d(Be), u(Oe);
    }).catch(ie).finally(() => {
      Q(!1);
    });
  }, O = ({ key: fe, type: W }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const xe = y && (I.length || T.length) ? y : t, Ie = W === "ISSUE" ? "issues" : "pullRequests";
    xe.github[Ie] = Array.from(
      new Set(xe.github[Ie]).add(fe)
    ), X(xe, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${dr(
          fe
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${dr(fe)} failed. Please try again.`
      }
    });
  }, q = async ({ key: fe, type: W }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const xe = y && (I.length || T.length) ? y : t, Ie = W === "ISSUE" ? "issues" : "pullRequests";
    xe.github[Ie] = Array.from(
      new Set(xe.github[Ie]).add(fe)
    ), await $(xe).catch((K) => {
      g({
        title: "Linking failed",
        text: `Linking ${fe} failed. Please try again. ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: fe, type: W }) => {
    N("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const xe = W === "ISSUE" ? "issue" : "pull request";
    C({
      headline: `Unlink ${xe} ${dr(fe)}?`,
      text: `You are about to unlink the ${xe} ${dr(
        fe
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${xe}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ie = W === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const K = {
          ...y,
          github: {
            ...y?.github,
            [Ie]: y?.github?.[Ie].filter(
              (qe) => qe.number !== fe.number || qe.owner !== fe.owner || qe.repository !== fe.repository
            )
          }
        };
        N("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), X(K, {
          success: {
            title: `GitHub ${xe} unlinked`,
            text: `You unlinked the GitHub ${xe} ${dr(
              fe
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${dr(fe)} failed.`
          }
        });
      },
      onCancel: () => {
        N("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ve = () => {
    N("github:unlink:all:clicked", {
      githubOrganization: n
    }), C({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        N("github:unlink:all:confirmed", {
          githubOrganization: n
        }), X(t, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        N("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ue = I.filter(
    (fe) => !i?.includes(fe)
  ) || [], ce = T.filter(
    (fe) => !o?.includes(fe)
  ) || [];
  return {
    linkGithubItem: O,
    linkGithubItemQuietly: q,
    unlinkGithubItem: ee,
    loadGithubItems: B,
    removeDanglingGithubItemLinks: () => {
      const fe = {
        ...y,
        github: {
          ...y?.github,
          issues: I.filter(
            (W) => !ue.includes(W)
          ) || [],
          pullRequests: T.filter(
            (W) => !ce.includes(W)
          ) || []
        }
      };
      $(fe);
    },
    unlinkAllGithubItems: ve,
    isLoadingGithubItemLinks: w,
    danglingIssueLinks: ue,
    danglingPullRequestLinks: ce,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const zF = "_contentWrapper_1vx3c_1", UF = "_contentWrapperHeadline_1vx3c_4", MF = "_contentWrapperBody_1vx3c_11", BF = "_contentWrapperAssigneeIcon_1vx3c_15", qF = "_contentWrapperStatusTag_1vx3c_20", Mr = {
  contentWrapper: zF,
  contentWrapperHeadline: UF,
  contentWrapperBody: MF,
  contentWrapperAssigneeIcon: BF,
  contentWrapperStatusTag: qF
}, h_ = ({
  description: e,
  assignees: n,
  labels: t
}) => /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
  e && /* @__PURE__ */ ye.jsxs(et, { className: Mr.contentWrapper, children: [
    /* @__PURE__ */ ye.jsx(et, { className: Mr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ ye.jsx(et, { className: Mr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ ye.jsxs(et, { className: Mr.contentWrapper, children: [
    /* @__PURE__ */ ye.jsx(et, { className: Mr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ ye.jsx(et, { className: Mr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ ye.jsxs(et, { margin: "100 0", children: [
        /* @__PURE__ */ ye.jsx(
          "img",
          {
            className: Mr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  t?.nodes && t?.nodes.length > 0 && /* @__PURE__ */ ye.jsx(et, { className: Mr.contentWrapper, children: t.nodes.map(
    (i) => i && /* @__PURE__ */ ye.jsx(
      An,
      {
        className: Mr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), HF = "_collapse_1bdjy_1", WF = "_collapseHeader_1bdjy_10", GF = "_collapseHeaderKey_1bdjy_31", KF = "_collapseHeaderKeyIcon_1bdjy_36", YF = "_collapseHeaderKeyLink_1bdjy_41", QF = "_collapseHeaderIcon_1bdjy_44", JF = "_collapseHeaderTitle_1bdjy_49", XF = "_collapseContent_1bdjy_57", ZF = "_collapseContentButtonSpacer_1bdjy_60", eI = "_collapseContentButtonLink_1bdjy_63", Fr = {
  collapse: HF,
  collapseHeader: WF,
  collapseHeaderKey: GF,
  collapseHeaderKeyIcon: KF,
  collapseHeaderKeyLink: YF,
  collapseHeaderIcon: QF,
  collapseHeaderTitle: JF,
  collapseContent: XF,
  collapseContentButtonSpacer: ZF,
  collapseContentButtonLink: eI
}, nI = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: t
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = le(i), { track: s } = _n(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ye.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: g,
      repository: C,
      type: S,
      state: N,
      assignees: w,
      labels: y
    } = d, z = a[m];
    return /* @__PURE__ */ ye.jsxs(
      mr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: z,
        className: Fr.collapse,
        children: [
          /* @__PURE__ */ ye.jsx(mr.Header, { className: Fr.collapseHeader, children: /* @__PURE__ */ ye.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ye.jsx(et, { children: /* @__PURE__ */ ye.jsxs(et, { as: "span", className: Fr.collapseHeaderKey, children: [
                  pm(
                    S,
                    N,
                    Fr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ ye.jsxs(
                    "a",
                    {
                      href: Xg(f),
                      className: Fr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: ($) => {
                        $.stopPropagation();
                      },
                      children: [
                        dr(f),
                        /* @__PURE__ */ ye.jsx(
                          pe,
                          {
                            className: Fr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ ye.jsx(et, { className: Fr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ye.jsx(mr.Content, { className: Fr.collapseContent, children: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ye.jsx(
              h_,
              {
                description: g,
                assignees: w,
                labels: y
              }
            ),
            /* @__PURE__ */ ye.jsxs(
              Gn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Fr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: C?.owner.login,
                    repository: d.repository.name
                  },
                  type: S
                }),
                children: [
                  "Unlink ",
                  Zg(S)
                ]
              }
            ),
            /* @__PURE__ */ ye.jsxs(
              Et,
              {
                slotEnd: /* @__PURE__ */ ye.jsx(pe, { name: "external-link" }),
                variant: "tertiary",
                className: Fr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: t
                  }), window.open(Xg(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Zg(S),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ ye.jsx(ye.Fragment, {}) });
}, tI = "_result_1uaom_1", rI = "_resultName_1uaom_21", iI = "_resultItemIcon_1uaom_29", aI = "_resultDescription_1uaom_34", oI = "_resultLinkIcon_1uaom_46", sI = "_tooltip_1uaom_55", lI = "_tooltipName_1uaom_61", cI = "_tooltipTag_1uaom_71", Br = {
  result: tI,
  resultName: rI,
  resultItemIcon: iI,
  resultDescription: aI,
  resultLinkIcon: oI,
  tooltip: sI,
  tooltipName: lI,
  tooltipTag: cI
}, dI = ({
  item: e,
  onSelect: n
}) => {
  const { key: t, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = le(!1);
  return /* @__PURE__ */ ye.jsx(
    We,
    {
      className: Br.tooltip,
      content: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ ye.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ ye.jsxs(et, { as: "span", className: Br.tooltipName, children: [
                pm(a, o, Br.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ ye.jsx(An, { className: Br.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ ye.jsx(
          h_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ye.jsxs(
        "button",
        {
          className: Br.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ ye.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ye.jsxs(et, { as: "span", className: Br.resultName, children: [
                    pm(a, o, Br.resultItemIcon),
                    dr(t)
                  ] }) }),
                  /* @__PURE__ */ ye.jsx(et, { className: Br.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ ye.jsx(
              pe,
              {
                className: Br.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, uI = ({
  className: e,
  searched: n,
  githubOrganization: t
}) => /* @__PURE__ */ ye.jsx(
  Et,
  {
    slotEnd: /* @__PURE__ */ ye.jsx(pe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${t}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), Ts = "[a-zA-z0-9_.-]+", y_ = "[0-9]+", mI = new RegExp(
  `(${Ts})/(${Ts})/(?:issues|pull)/(${y_})`,
  "i"
), ev = new RegExp(`^${mI.source}$`), nv = new RegExp(
  `https://github.com/(${Ts})/(${Ts})/(?:issues|pull)/(${y_})`,
  "i"
), pI = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: t,
  linkedPullRequests: i
}) => {
  const a = Bn(() => t?.map((T) => T.id) || [], [t]), o = Bn(() => i?.map((T) => T.id) || [], [i]), [s, l] = le([]), { useLazyQuery: d } = hn(), [m, u] = le(), [f, { loading: h, error: g, data: C, networkStatus: S }] = d(OF, {
    notifyOnNetworkStatusChange: !0
  });
  Ti(
    () => {
      !h && m && S === er.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), He(() => {
    let T = C?.GitHub?.issues?.nodes || [], U = C?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (T = T.filter((Q) => !a.includes(Q.id))), o.length > 0 && (U = U.filter(
      (Q) => !o.includes(Q.id)
    )), l([
      ...T.map((Q) => ({
        ...Q,
        type: "ISSUE",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      })),
      ...U.map((Q) => ({
        ...Q,
        type: "PR",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      }))
    ]);
  }, [C, a, o]);
  function N(T) {
    const U = T?.trim();
    if (ev.test(U)) {
      const [Q, J, ie, X] = U.match(ev) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(X)
      };
    }
    if (nv.test(U)) {
      const [Q, J, ie, X] = U.match(nv) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(X)
      };
    }
  }
  const w = (T) => {
    e({
      key: LF(T),
      type: T.type
    }), u(void 0);
  }, y = (T) => {
    const U = N(T);
    u(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${T}`
    );
  }, z = () => {
    u(void 0);
  }, $ = ({ className: T, searched: U }) => /* @__PURE__ */ ye.jsx(
    uI,
    {
      className: T,
      searched: U,
      githubOrganization: n
    }
  ), I = ({ item: T, onSelect: U }) => /* @__PURE__ */ ye.jsx(dI, { item: T, onSelect: U });
  return !h && g ? /* @__PURE__ */ ye.jsx(Fn, { error: g }) : /* @__PURE__ */ ye.jsx(
    wr,
    {
      items: s?.map((T) => ({ name: T.title, ...T })),
      loading: h,
      onSearch: y,
      onSelect: w,
      onClear: z,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: $,
      itemComponent: I,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, fI = "_itemButton_3sxfy_1", hI = "_result_3sxfy_6", yI = "_resultName_3sxfy_30", gI = "_resultCheckIcon_3sxfy_38", vI = "_resultAssigneeIcon_3sxfy_41", ja = {
  itemButton: fI,
  result: hI,
  resultName: yI,
  resultCheckIcon: gI,
  resultAssigneeIcon: vI
}, g_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: t
}) => /* @__PURE__ */ ye.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ ye.jsx(
      "button",
      {
        onClick: () => {
          t(e);
        },
        className: ja.itemButton,
        children: /* @__PURE__ */ ye.jsxs(b, { className: ja.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ ye.jsx(et, { margin: "100 0", children: /* @__PURE__ */ ye.jsx(
            "img",
            {
              className: ja.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ ye.jsx(et, { className: ja.resultName, children: e.name }),
          n && /* @__PURE__ */ ye.jsx(et, { className: ja.resultCheckIcon, children: /* @__PURE__ */ ye.jsx(pe, { name: "done" }) })
        ] })
      }
    )
  }
), kI = pa(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), bI = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: t,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = le([]), [l, d] = le(""), m = 2, [u, { loading: f, error: h, data: g, networkStatus: C }] = a(
    kI,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Ti(
    () => {
      !f && l && l.length >= m && C === er.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const S = g?.GitHub?.organization?.teams || { edges: [] }, N = [];
    S?.edges?.forEach((w) => {
      const y = w?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((z) => {
        const $ = z?.node;
        $ && ($?.id && N.find((I) => I.id === $.id) || N.push($));
      });
    }), s(
      N.sort((w, y) => {
        const z = w.name?.toLowerCase() || w.login?.toLowerCase(), $ = y.name?.toLowerCase() || y.login?.toLowerCase();
        return z.localeCompare($, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [g]), !f && h ? /* @__PURE__ */ ye.jsx(Fn, { error: h }) : /* @__PURE__ */ ye.jsx(
    wr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: S, name: N, login: w, avatarUrl: y }) => ({
        id: S,
        name: N || w,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (S) => d(S),
      onChange: (S, N) => {
        const w = S.id;
        i ? (N && !n.find(
          (y) => y.id === w
        ) && n.push(S), N || (n = n.filter(
          (y) => y.id !== w
        ))) : n = N ? [S] : [], t(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: S, onSelect: N, checked: w }) => /* @__PURE__ */ ye.jsx(
        g_,
        {
          item: S,
          checked: w,
          onSelectItem: N
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, xI = ({
  field: e,
  value: n,
  onChange: t,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ ye.jsx(Nr, { onChange: t, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ ye.jsx(
        wr,
        {
          onSelect: t,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ ye.jsx(
        Ws,
        {
          onChange: t,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ ye.jsx(Nr, { type: "number", onChange: t, value: n });
    case "option":
      return /* @__PURE__ */ ye.jsx(
        wr,
        {
          onSelect: t,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ ye.jsx(Nr, { onChange: t, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ ye.jsx(am, { onChange: t, value: n || "" });
    case "user":
      return /* @__PURE__ */ ye.jsx(
        bI,
        {
          githubOrganization: i,
          onChange: t,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ ye.jsx(ye.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, _I = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: t,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ye.jsx(ye.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ ye.jsx(
  Wt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ye.jsx(
      ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: xI({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: t
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), SI = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: t,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ ye.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ ye.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ ye.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ ye.jsx(pe, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ ye.jsx(ln, { label: "GitHub issue link", children: /* @__PURE__ */ ye.jsx(
          Nr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: t ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, NI = "_modalBody_1hk1o_1", jI = "_modalBodyFormFields_1hk1o_4", du = {
  modalBody: NI,
  modalBodyFormFields: jI
}, wI = pa(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), CI = pa(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), FI = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], II = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: t,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = hn(), { track: d } = _n(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: g
  } = _t(), [C, S] = le(""), [N, w] = le([]), [y, z] = le(), [$, I] = le(!1), [T, U] = le(!1), [Q, J] = $x(), [
    ie,
    {
      loading: X,
      error: B,
      networkStatus: O
    }
  ] = s(wI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ie) => {
      w(
        Ie.GitHub.search?.edges?.map((K) => K?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), w([]);
    }
  });
  Ti(
    () => {
      !X && C && O === er.ready ? ie({
        variables: {
          query: C,
          maxResults: 10
        }
      }) : w([]);
    },
    500,
    [C]
  );
  const [q, { error: ee }] = l(
    CI,
    {
      onError: (Ie) => {
        I(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ie);
      },
      onCompleted: (Ie) => {
        I(!1);
        const K = Ie.GitHub.createIssue?.issue;
        z(K), o({
          title: "Success",
          text: `GitHub issue '${K.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), t({
          owner: a,
          repository: K.repository.name,
          number: K.number
        });
      }
    }
  ), ve = (Ie) => {
    S(`org:${a} ${Ie}`);
  }, ue = (Ie, K) => {
    K(Ie), S("");
  }, ce = () => {
    S("");
  }, fe = (Ie) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), I(!0), q({
      variables: {
        input: {
          repositoryId: Ie.repository.id,
          title: Ie.title,
          body: Ie.body,
          assigneeIds: Ie.assignees?.length > 0 ? Ie.assignees.map((K) => K.id) : void 0
        }
      }
    });
  };
  He(() => {
    const Ie = T ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ie);
  }, [T]);
  const W = () => {
    S(""), w([]), z(void 0), I(!1), U(!1);
  }, xe = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), W(), h(), n();
  };
  return /* @__PURE__ */ ye.jsxs(
    Tt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: xe,
      children: [
        /* @__PURE__ */ ye.jsx(
          $t,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: xe
          }
        ),
        /* @__PURE__ */ ye.jsxs(Dt, { className: du.modalBody, children: [
          !X && B && /* @__PURE__ */ ye.jsx(Fn, { error: B }),
          !$ && ee && /* @__PURE__ */ ye.jsx(Fn, { error: ee }),
          y ? /* @__PURE__ */ ye.jsx(
            SI,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: T,
              setIssueLinkCopied: U,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ ye.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(fe),
              children: /* @__PURE__ */ ye.jsxs(st, { children: [
                /* @__PURE__ */ ye.jsx(be, { children: /* @__PURE__ */ ye.jsx(ln, { label: "Repository", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Wt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ie, value: K } }) => /* @__PURE__ */ ye.jsx(
                      wr,
                      {
                        className: du.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: X,
                        onSearch: ve,
                        onSelect: (qe) => ue(qe, Ie),
                        onClear: ce,
                        selectedItems: [K],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: B ? "No repositories found" : "No repositories available",
                        items: N || [],
                        itemComponent: ({ item: qe, onSelect: Be, checked: Oe }) => /* @__PURE__ */ ye.jsx(
                          g_,
                          {
                            item: qe,
                            checked: Oe,
                            onSelectItem: Be
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ye.jsx(be, { className: du.modalBodyFormFields, children: /* @__PURE__ */ ye.jsx(
                  _I,
                  {
                    control: m,
                    errors: f,
                    getValues: g,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: FI
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ye.jsx(
          Pt,
          {
            confirmOnClick: y ? xe : u(fe),
            confirmProps: {
              isLoading: $,
              loadingIndicator: /* @__PURE__ */ ye.jsx(un, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : xe
          }
        )
      ]
    }
  );
}, EI = "_wrapper_19v8w_1", TI = "_inputWrapper_19v8w_6", $I = "_buttonLink_19v8w_19", DI = "_noItemsFound_19v8w_23", RI = "_createIssueButton_19v8w_28", Li = {
  wrapper: EI,
  inputWrapper: TI,
  buttonLink: $I,
  noItemsFound: DI,
  createIssueButton: RI
}, OI = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = le(!1), { track: a } = _n(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: g,
    danglingIssueLinks: C,
    danglingPullRequestLinks: S,
    isLoadingGithubItems: N,
    issues: w,
    pullRequests: y,
    error: z
  } = VF({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), $ = (J) => d({ key: J, type: "ISSUE" }), I = !(!!w?.length).valueOf() && !(!!y?.length).valueOf() && !(!!C?.length).valueOf() && !(!!S?.length).valueOf(), T = !g && !N && !!C?.length && !!S?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Q = !!w?.length || !!y?.length;
  return !N && z ? /* @__PURE__ */ ye.jsx(Fn, { error: z, retry: () => u() }) : /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
    /* @__PURE__ */ ye.jsxs(b, { className: Li.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ye.jsxs(b, { className: Li.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
          /* @__PURE__ */ ye.jsx(
            Gn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Li.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ye.jsx("div", { className: Li.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ye.jsx(
          pI,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: w,
            linkedPullRequests: y
          }
        )
      ] }),
      N ? /* @__PURE__ */ ye.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ye.jsx(un, { "data-testid": "github-widget-item-spinner" }) }) : Q ? /* @__PURE__ */ ye.jsx(
        nI,
        {
          items: [...w, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ ye.jsx(A.Paragraph, { align: "center", className: Li.noItemsFound, children: "No linked items found." }),
      T && /* @__PURE__ */ ye.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ye.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ ye.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              C.map((J) => /* @__PURE__ */ ye.jsx(
                An,
                {
                  onDelete: () => m({
                    key: J,
                    type: "ISSUE"
                  }),
                  children: dr(J)
                },
                dr(J)
              )),
              S.map((J) => /* @__PURE__ */ ye.jsx(
                An,
                {
                  onDelete: () => m({ key: J, type: "PR" }),
                  children: dr(J)
                },
                dr(J)
              ))
            ] }),
            /* @__PURE__ */ ye.jsx(
              Gn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Q && /* @__PURE__ */ ye.jsx(
        Gn,
        {
          variant: "secondary",
          disabled: I,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ ye.jsx(
        Et,
        {
          slotEnd: /* @__PURE__ */ ye.jsx(pe, { name: "external-link" }),
          variant: "tertiary",
          className: Li.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ ye.jsx(
      II,
      {
        isOpen: t,
        onClose: () => i(!1),
        linkGithubIssueQuietly: $,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, fm = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], oi = "GITHUB", PI = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, AI = ({
  integrationId: e,
  configuration: n,
  handleRedirect: t,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = _t({
    mode: "onChange",
    defaultValues: PI
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = Ni({
    integrationId: e,
    integrationType: oi,
    handleRedirect: t,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: z
  } = ji({
    integrationId: e,
    fieldDefinitions: fm,
    form: l,
    onMisconfigured: C
  }), { renderConditions: $, setRenderConditions: I, renderConditionsForSubmit: T } = wi({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (J) => Fi(J, {
    fieldDefinitions: fm,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: T
  }), Q = l.watch("name");
  return /* @__PURE__ */ ye.jsxs(
    Ci,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ ye.jsx(Ii, { cause: g }),
        /* @__PURE__ */ ye.jsxs(st, { children: [
          /* @__PURE__ */ ye.jsx(be, { children: /* @__PURE__ */ ye.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ye.jsx(
            Jn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(
            tt,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(ln, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ ye.jsx(
            Jn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(ln, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ ye.jsx(
            Jn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(ln, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ ye.jsx(
            Jn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          !s && e && /* @__PURE__ */ ye.jsx(
            sa,
            {
              configuration: n,
              integrationId: e,
              integrationType: oi,
              label: "Authorize with OAuth"
            }
          ),
          o && $ !== null && /* @__PURE__ */ ye.jsx(be, { children: o({
            value: $,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ ye.jsx(
          Ei,
          {
            integrationType: oi,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ye.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ye.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ye.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ye.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  oi,
                  " integration, all links between Dixa and ",
                  oi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ye.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  oi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ye.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  oi,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var uu = { exports: {} }, wa = {}, tv;
function LI() {
  if (tv) return wa;
  tv = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return wa.Fragment = t, wa.jsx = s, wa.jsxs = s, wa;
}
var Vo = {}, rv;
function VI() {
  return rv || (rv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Vo.Fragment = i, Vo.jsx = Rn, Vo.jsxs = Mn;
  })()), Vo;
}
var iv;
function zI() {
  return iv || (iv = 1, process.env.NODE_ENV === "production" ? uu.exports = LI() : uu.exports = VI()), uu.exports;
}
var _e = zI(), Za = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Za || {}), mi = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(mi || {}), Kt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Kt || {});
const UI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, MI = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": UI
};
function BI(e) {
  return MI[e] ?? {};
}
const qI = BI(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), av = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, v_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, HI = "_listItem_16pij_4", WI = "_clickableIcon_16pij_15", yo = {
  listItem: HI,
  clickableIcon: WI
}, k_ = ({
  items: e,
  title: n,
  currency: t,
  openByDefault: i = !1
}) => {
  const [a, o] = le(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ _e.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ _e.jsx(pe, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ _e.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ _e.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: yo.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ _e.jsx(
              pe,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ _e.jsx(Ye, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: g } = l, C = l.currency ?? t;
      return /* @__PURE__ */ _e.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ _e.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ _e.jsx(A.Paragraph, { children: u }),
            /* @__PURE__ */ _e.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: v_(f / 100, C) })
          ] }),
          contentRight: h && /* @__PURE__ */ _e.jsx(la, { src: h, alt: m ?? "Product image" }),
          className: yo.listItem
        },
        `item-${d}-${g}`
      );
    }) })
  ] }) });
}, GI = "_boxWrapper_89s7l_1", KI = "_trackButton_89s7l_10", ov = {
  boxWrapper: GI,
  trackButton: KI
}, YI = {
  [Kt.StepUnknown]: "Unknown",
  [Kt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Kt.StepPreparedByMerchant]: "Prepared by merchant",
  [Kt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Kt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Kt.StepOnRoute]: "On route",
  [Kt.StepDeliveredToPickupPoint]: "At pickup point",
  [Kt.StepDeliveredToConsumer]: "Delivered to customer",
  [Kt.StepDeliveredToMerchant]: "Returned to merchant",
  [Kt.StepReturnRequested]: "Return requested",
  [Kt.StepSentBack]: "Sent back",
  [Kt.StepTerminated]: "Terminated",
  [Kt.StepAwaitingSupplier]: "Awaiting supplier"
}, QI = {
  [mi.Delivery]: "Home delivery",
  [mi.Pickup]: "Pickup point",
  [mi.Instore]: "In-store pickup",
  [mi.Mailbox]: "Mailbox",
  [mi.Inwarehouse]: "Warehouse",
  [mi.Unknown]: "Unknown"
}, JI = {
  [Za.Outbound]: "From merchant to customer",
  [Za.Return]: "Return from customer to merchant",
  [Za.Unspecified]: "Unspecified",
  [Za.UnknownDirectionType]: "Unknown"
}, XI = (e) => e ? YI[e] ?? e : "", ZI = (e) => e ? QI[e] ?? e : "", eE = (e) => e ? JI[e] ?? e : "", nE = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, tE = ({
  parcel: e
}) => {
  const { isCopied: n, copy: t } = or();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, g = m || l || i, C = a?.filter(($) => $?.time !== ""), S = XI(C?.[0]?.step), N = ZI(u), w = eE(f), y = nE(e.location?.address), z = 14;
  return /* @__PURE__ */ _e.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: ov.boxWrapper,
      children: [
        /* @__PURE__ */ _e.jsx(A.Heading, { variant: "heading-4", children: g }),
        /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ _e.jsx(
              pe,
              {
                size: z,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsx(We, { content: "Copy tracking ID", children: /* @__PURE__ */ _e.jsx(
            pe,
            {
              size: z,
              name: n ? "done" : "copy",
              className: yo.clickableIcon,
              onClick: () => t(o)
            }
          ) }) })
        ] }),
        S && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: S })
          ] })
        ] }),
        w && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: w })
          ] })
        ] }),
        h && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ _e.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              av(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: av(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "info", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        y && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ _e.jsx(k_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ _e.jsxs(
          Et,
          {
            variant: "secondary",
            className: ov.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ _e.jsx(pe, { name: "external-link" }),
            children: [
              "Track on ",
              g ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, rE = "_order_135ze_1", iE = "_orderIsOpen_135ze_9", aE = "_orderHeader_135ze_12", mu = {
  order: rE,
  orderIsOpen: iE,
  orderHeader: aE
}, sv = "No order number found", oE = ({
  order: e,
  openByDefault: n
}) => {
  const [t, i] = le(n), { isCopied: a, copy: o } = or(), { isCopied: s, copy: l } = or();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), g = d?.currency || "", C = d?.prices?.total?.price ?? 0, S = v_(C / 100, g), N = 14, w = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ _e.jsxs(
    b,
    {
      className: it(mu.order, {
        [mu.orderIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ _e.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: mu.orderHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  w
                ] }),
                h ? /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: /* @__PURE__ */ _e.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: sv })
              ] }),
              /* @__PURE__ */ _e.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ _e.jsx(pe, { size: N, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ _e.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: sv }) })
              ] })
            ] }),
            h && /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsx(We, { content: "Copy order number", children: /* @__PURE__ */ _e.jsx(
              pe,
              {
                size: N,
                name: s ? "done" : "copy",
                className: yo.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ _e.jsx(
                pe,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsx(We, { content: "Copy tracking ID", children: /* @__PURE__ */ _e.jsx(
              pe,
              {
                size: N,
                name: a ? "done" : "copy",
                className: yo.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ _e.jsx(pe, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ _e.jsx(pe, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", children: S })
            ] })
          ] }),
          /* @__PURE__ */ _e.jsx(
            k_,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((y) => y),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ _e.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ _e.jsx(Pn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ _e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((y, z) => /* @__PURE__ */ _e.jsx(
              tE,
              {
                parcel: y
              },
              `parcel-${z}-${y?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, sE = (e) => {
  const n = [], t = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = t.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      t.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, lv = (e) => {
  let n = 1 / 0;
  for (const t of e?.parcels ?? [])
    for (const i of t?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, lE = (e) => [...e].sort(
  (n, t) => lv(t) - lv(n)
), cE = ({
  customerEmail: e
}) => {
  const { useQuery: n } = hn(), [t, i] = le([]), a = !e, { data: o, loading: s, error: l } = n(qI, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && t.length > 0, m = l ? d0({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? Hb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return He(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      lE(
        sE(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ _e.jsx(un, {}) }) : m || !d && !l ? /* @__PURE__ */ _e.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ _e.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ _e.jsx(Fn, { error: l }) : /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ _e.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ _e.jsx(Pn, { variant: "success", size: "small", children: t.length })
    ] }),
    /* @__PURE__ */ _e.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ _e.jsx(b, { gap: "200", flexDirection: "column", children: t.map((f, h) => /* @__PURE__ */ _e.jsx(
      oE,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, dE = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ _e.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ _e.jsx(cE, { customerEmail: n })
    }
  );
}, hm = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], uE = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, mE = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: t,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = _t({
    mode: "onChange",
    defaultValues: uE
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: g
  } = Ni({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: t
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: w,
    widgetConfiguration: y
  } = ji({
    integrationId: e,
    fieldDefinitions: hm,
    form: s,
    onMisconfigured: g
  }), { renderConditions: z, setRenderConditions: $, renderConditionsForSubmit: I } = wi({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), T = (Q) => Fi(Q, {
    fieldDefinitions: hm,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ _e.jsxs(
    Ci,
    {
      form: s,
      integrationId: e,
      onValidSubmit: T,
      error: S ?? f,
      onRetry: S ? w : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ _e.jsx(Ii, { cause: h }),
        /* @__PURE__ */ _e.jsxs(st, { children: [
          /* @__PURE__ */ _e.jsx(be, { children: /* @__PURE__ */ _e.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ _e.jsx(
            Jn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3, children: /* @__PURE__ */ _e.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3 }),
          /* @__PURE__ */ _e.jsx(be, { span: 3, children: /* @__PURE__ */ _e.jsx(ln, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ _e.jsx(
            Jn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3 }),
          /* @__PURE__ */ _e.jsx(be, { span: 3, children: /* @__PURE__ */ _e.jsx(
            tt,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3 }),
          /* @__PURE__ */ _e.jsx(be, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Ym,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3 }),
          a && z !== null && /* @__PURE__ */ _e.jsx(be, { children: a({
            value: z,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ _e.jsx(
          Ei,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var pu = { exports: {} }, Ca = {}, cv;
function pE() {
  if (cv) return Ca;
  cv = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ca.Fragment = t, Ca.jsx = s, Ca.jsxs = s, Ca;
}
var zo = {}, dv;
function fE() {
  return dv || (dv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    zo.Fragment = i, zo.jsx = Rn, zo.jsxs = Mn;
  })()), zo;
}
var uv;
function hE() {
  return uv || (uv = 1, process.env.NODE_ENV === "production" ? pu.exports = pE() : pu.exports = fE()), pu.exports;
}
var se = hE();
const Dp = (e, n) => {
  const t = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Dp(l, s)) : [], a = n.nodes[e.type] || n.default;
  return t(
    a(e, i(e, n))
  );
}, yE = "_jiraCode_h30p6_1", gE = "_jiraCodeInline_h30p6_8", fu = {
  jiraCode: yE,
  jiraCodeInline: gE
}, b_ = {
  default: (e, n) => n().every((t) => typeof t == "string") ? n().join(" ") : /* @__PURE__ */ se.jsx(se.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ se.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ se.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ se.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ se.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ se.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ se.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ se.jsx("pre", { children: /* @__PURE__ */ se.jsx("code", { className: fu.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ se.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ se.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ se.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ se.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ se.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ se.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ se.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ se.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ se.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ se.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ se.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ se.jsx("code", { className: it(fu.jiraCode, fu.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, $s = ({
  iconUrl: e,
  className: n,
  width: t
}) => {
  const [i, a] = le(!1);
  return !e || i ? /* @__PURE__ */ se.jsx(pe, { size: t, name: "question", className: n }) : /* @__PURE__ */ se.jsx(
    "img",
    {
      src: e,
      width: t,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, vE = "_collapse_m2gjh_1", kE = "_collapseHeader_m2gjh_10", bE = "_collapseHeaderLink_m2gjh_31", xE = "_collapseHeaderStatus_m2gjh_40", _E = "_collapseHeaderTitle_m2gjh_51", SE = "_collapseContent_m2gjh_59", NE = "_collapseContentHeadline_m2gjh_62", jE = "_collapseContentButtonSpacer_m2gjh_68", wE = "_collapseContentButtonLink_m2gjh_71", CE = "_collapseContentStatusTag_m2gjh_74", FE = "_collapseContentDescription_m2gjh_77", gr = {
  collapse: vE,
  collapseHeader: kE,
  collapseHeaderLink: bE,
  collapseHeaderStatus: xE,
  collapseHeaderTitle: _E,
  collapseContent: SE,
  collapseContentHeadline: NE,
  collapseContentButtonSpacer: jE,
  collapseContentButtonLink: wE,
  collapseContentStatusTag: CE,
  collapseContentDescription: FE
}, x_ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: t
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : t, IE = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: t
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = le(i), { track: s } = _n(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ se.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, g = x_({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), C = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ se.jsxs(
      mr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: C,
        className: gr.collapse,
        children: [
          /* @__PURE__ */ se.jsx(mr.Header, { className: gr.collapseHeader, children: /* @__PURE__ */ se.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ se.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ se.jsx($s, { width: 16, iconUrl: g }),
                    /* @__PURE__ */ se.jsx(
                      "a",
                      {
                        className: gr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (S) => {
                          S.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ se.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ se.jsx(pe, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ se.jsx("span", { className: gr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ se.jsx(An, { className: gr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ se.jsx("div", { className: gr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ se.jsx(mr.Content, { className: gr.collapseContent, children: /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ se.jsx("div", { className: gr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ se.jsx(et, { className: gr.collapseContentDescription, children: u ? Dp(u, b_) : "" }),
            /* @__PURE__ */ se.jsx(
              Gn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: gr.collapseContentButtonSpacer,
                onClick: () => d?.key && t(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ se.jsx(
              Et,
              {
                slotEnd: /* @__PURE__ */ se.jsx(pe, { name: "external-link" }),
                variant: "tertiary",
                className: gr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ se.jsx(se.Fragment, {}) });
}, EE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, TE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, $E = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, DE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, RE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, OE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, PE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, AE = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': EE,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": TE,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": $E,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": DE,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': RE,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': OE,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": PE
};
function Ri(e) {
  return AE[e] ?? {};
}
const __ = Ri(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), LE = Ri(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), VE = Ri(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), zE = Ri(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), UE = Ri(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), ME = Ri(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), BE = Ri(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Rp = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), qE = new RegExp(`^${Rp.source}$`), HE = new RegExp(`/${Rp.source}$`), mv = new RegExp(
  `.+?[&?]selectedIssue=(${Rp.source})[&?]?.*`
);
function S_(e, n) {
  const t = { jira: { issues: [] } }, [i, a] = le([]), [o, s] = le([]), [l, d] = le(), { track: m } = _n(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: g } = hn(), {
    loading: C,
    data: S,
    error: N,
    store: w
  } = Km(e ?? null), [
    y,
    { loading: z, error: $, data: I }
  ] = h(__, {
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    const ce = I?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    ce?.length && (s(ce), a(ce.map((fe) => fe?.key).filter(Boolean)));
  }, [I]), He(
    () => d(N || $ || void 0),
    [N, $]
  ), He(
    () => {
      C || B();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S?.jira?.issues, C]
  );
  const T = async (ce, fe) => {
    await w(ce).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: fe.success.title,
        text: fe.success.text
      });
    }).catch((W) => {
      u({
        title: fe.error.title,
        text: `${fe.error.text} ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = g(LE, {
    onError: (ce) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${ce.message && " (" + ce.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Q = (ce, fe) => {
    const W = window.location.href, xe = fe ? W.replace(
      e?.toString() ?? "",
      fe?.toString()
    ) : W, Ie = fe ? `# ${fe}` : `# ${e}`;
    U({
      variables: {
        issueKey: ce,
        title: Ie,
        url: xe,
        globalId: `system=${xe}`
      }
    });
  }, [J] = g(VE, {
    onError: (ce) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${ce.message && " (" + ce.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ie = (ce) => {
    const fe = window.location.href;
    J({
      variables: {
        issueKey: ce,
        globalId: `system=${fe}`
      }
    });
  }, X = (ce) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: ce
  }), B = () => {
    S && S.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${S?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, O = async (ce, fe) => {
    m("jira:issue:link:clicked", X(ce));
    const W = S?.jira?.issues ? S : t;
    W.jira.issues = Array.from(
      new Set(W.jira.issues).add(ce)
    ), await w(W, fe?.toString()).then(() => Q(ce, fe)).catch((xe) => {
      u({
        title: "Linking failed",
        text: `Linking ${ce} failed. Please try again. ${xe.message && " (" + xe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, q = (ce) => {
    m("jira:issue:link:clicked", X(ce));
    const fe = S?.jira?.issues ? S : t;
    fe.jira.issues = Array.from(
      new Set(fe.jira.issues).add(ce)
    ), T(fe, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${ce} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ce} failed. Please try again.`
      }
    }).then(() => Q(ce));
  }, ee = (ce) => {
    m("jira:issue:unlink:clicked", X(ce)), f({
      headline: `Unlink issue ${ce}?`,
      text: `You are about to unlink the issue ${ce}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", X(ce));
        const fe = {
          ...S,
          jira: {
            ...S?.jira,
            issues: S?.jira?.issues.filter((W) => W !== ce) || []
          }
        };
        T(fe, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${ce}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ce} failed.`
          }
        }).then(() => ie(ce));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", X(ce))
    });
  }, ve = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((ce) => ce?.key && ie(ce.key)), T(t, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ue = S?.jira?.issues?.filter(
    (ce) => !i?.includes(ce)
  ) || [];
  return {
    linkIssue: q,
    linkIssueQuietly: O,
    unlinkIssue: ee,
    loadIssues: B,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const ce = {
        ...S,
        jira: {
          ...S?.jira,
          issues: S?.jira?.issues.filter(
            (fe) => !ue.includes(fe)
          ) || []
        }
      };
      w(ce);
    },
    unlinkAllIssues: ve,
    maybeExtractIssueKey: (ce) => {
      const fe = ce.replace(/\s/g, "");
      if (qE.test(fe))
        return fe;
      if (mv.test(ce))
        return ce.match(mv)?.[1];
      if (ce.startsWith(n) && HE.test(ce))
        return ce.substring(ce.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: C,
    danglingIssueLinks: ue,
    isLoadingIssues: z,
    issues: o,
    error: l
  };
}
function WE(e = !1, n) {
  const [t, i] = le(e);
  return He(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const GE = "_result_axxxc_48", KE = "_resultName_axxxc_68", YE = "_resultNameIcon_axxxc_76", QE = "_resultDescription_axxxc_81", JE = "_resultLinkIcon_axxxc_93", XE = "_tooltip_axxxc_102", ZE = "_tooltipContent_axxxc_108", eT = "_tooltipName_axxxc_115", nT = "_tooltipNameIcon_axxxc_120", tT = "_tooltipDescription_axxxc_125", rT = "_tooltipSummary_axxxc_133", iT = "_tooltipTag_axxxc_137", cr = {
  result: GE,
  resultName: KE,
  resultNameIcon: YE,
  resultDescription: QE,
  resultLinkIcon: JE,
  tooltip: XE,
  tooltipContent: ZE,
  tooltipName: eT,
  tooltipNameIcon: nT,
  tooltipDescription: tT,
  tooltipSummary: rT,
  tooltipTag: iT
}, aT = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: t,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = le(!1), h = x_({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ se.jsx(
    We,
    {
      disabled: i,
      className: cr.tooltip,
      content: /* @__PURE__ */ se.jsxs("div", { className: cr.tooltipContent, children: [
        /* @__PURE__ */ se.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ se.jsxs("span", { className: cr.tooltipName, children: [
                /* @__PURE__ */ se.jsx(
                  $s,
                  {
                    width: 16,
                    iconUrl: h,
                    className: cr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ se.jsx(An, { className: cr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ se.jsx("div", { className: cr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ se.jsx("div", { className: cr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ se.jsxs(
        "button",
        {
          ...a,
          className: cr.result,
          type: "button",
          onClick: () => {
            t(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ se.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ se.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ se.jsxs("span", { className: cr.resultName, children: [
                    /* @__PURE__ */ se.jsx(
                      $s,
                      {
                        width: 16,
                        iconUrl: h,
                        className: cr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ se.jsx("div", { className: cr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ se.jsx(
              pe,
              {
                className: cr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, oT = ({
  className: e,
  searched: n,
  jiraInstanceUrl: t
}) => /* @__PURE__ */ se.jsx(
  Et,
  {
    slotEnd: /* @__PURE__ */ se.jsx(pe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${t}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), sT = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: t,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = le([]), [l, d] = le(""), [m, { loading: u, error: f, data: h, networkStatus: g }] = a(__, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: C } = S_(null, n);
  Ti(
    () => {
      !u && l && g === er.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const $ = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      $.map((I) => ({
        id: I?.key ?? "",
        name: I?.key ?? "",
        description: I?.fields.summary,
        status: I?.fields.status,
        issuetype: I?.fields.issuetype,
        text: I?.fields.description ? Dp(I?.fields.description, b_) : /* @__PURE__ */ se.jsx(se.Fragment, {})
      }))
    );
  }, [h]);
  const S = ($) => {
    e($.id), d("");
  }, N = ($) => {
    const I = $.trim(), T = C(I);
    if (T) {
      const U = T.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${U}'`);
    } else I !== "" && d(
      `text ~ '${I}'${t ? " and project = " + t : ""}`
    );
  }, w = () => {
    d("");
  }, y = ($) => /* @__PURE__ */ se.jsx(oT, { ...$, jiraInstanceUrl: n }), z = ($) => /* @__PURE__ */ se.jsx(
    aT,
    {
      ...$,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ se.jsx(Fn, { error: f }) : /* @__PURE__ */ se.jsx(
    wr,
    {
      items: o,
      loading: u,
      onSearch: N,
      onSelect: S,
      onClear: w,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: z,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, lT = ({
  field: e,
  value: n,
  onChange: t
}) => {
  const [i, a] = le(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return He(() => {
    t(i);
  }, [i]), /* @__PURE__ */ se.jsx(
    wr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, cT = "_itemButton_1hl53_1", dT = "_result_1hl53_6", uT = "_resultIcon_1hl53_26", mT = "_resultName_1hl53_30", pT = "_resultCheckIcon_1hl53_38", Fa = {
  itemButton: cT,
  result: dT,
  resultIcon: uT,
  resultName: mT,
  resultCheckIcon: pT
}, ym = ({
  item: e,
  checked: n = !1,
  onSelectItem: t,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ se.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ se.jsx(
        "button",
        {
          onClick: () => {
            t(e);
          },
          className: Fa.itemButton,
          children: /* @__PURE__ */ se.jsxs(b, { className: Fa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ se.jsx(
              $s,
              {
                width: 36,
                iconUrl: o || "",
                className: Fa.resultIcon
              }
            ),
            /* @__PURE__ */ se.jsx(et, { className: Fa.resultName, children: e.name }),
            n && /* @__PURE__ */ se.jsx(et, { className: Fa.resultCheckIcon, children: /* @__PURE__ */ se.jsx(pe, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, fT = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: t,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = le([]), [l, d] = le(), m = 2, [u, { loading: f, error: h, data: g, networkStatus: C }] = a(BE, {
    notifyOnNetworkStatusChange: !0
  });
  return Ti(
    () => {
      !f && l && l.length >= m && C === er.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((S) => {
      if (S?.data?.Jira.findUsers?.length === 1) {
        const N = S?.data?.Jira?.findUsers[0];
        t(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), He(() => {
    const S = g?.Jira?.findUsers || [];
    s(
      S.filter(({ active: N }) => N).map(({ accountId: N, displayName: w, avatarUrls: y, active: z }) => ({
        id: N,
        name: w,
        avatarUrls: y,
        active: z
      }))
    );
  }, [g]), !f && h ? /* @__PURE__ */ se.jsx(Fn, { error: h }) : /* @__PURE__ */ se.jsx(
    wr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (S) => d(S),
      onSelect: t,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: S, onSelect: N, checked: w }) => /* @__PURE__ */ se.jsx(
        ym,
        {
          item: S,
          checked: w,
          onSelectItem: N,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, pv = ({
  field: e
}) => {
  const [n, t] = le(!1), [i, a] = $x();
  return He(() => {
    const o = n ? window.setTimeout(() => t(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ se.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ se.jsx(b, { children: /* @__PURE__ */ se.jsx(pe, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ se.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ se.jsx(We, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ se.jsx(
      nr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), t(!0);
        }
      }
    ) })
  ] });
}, hT = ({
  field: e,
  onChange: n,
  value: t,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ se.jsx(pv, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ se.jsx(Nr, { onChange: n, value: t });
    case "string":
      return s === "description" ? /* @__PURE__ */ se.jsx(am, { onChange: n, value: t }) : /* @__PURE__ */ se.jsx(Nr, { onChange: n, value: t });
    case "textarea":
      return /* @__PURE__ */ se.jsx(am, { onChange: n, value: t });
    case "number":
      return /* @__PURE__ */ se.jsx(Nr, { type: "number", onChange: n, value: t });
    case "user":
      return /* @__PURE__ */ se.jsx(
        fT,
        {
          onSelect: n,
          selectedItems: t ? [t] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ se.jsx(
        wr,
        {
          onSelect: n,
          selectedItems: t ? [t] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ se.jsx(lT, { field: e, value: t, onChange: n });
    default:
      return /* @__PURE__ */ se.jsx(pv, { field: e });
  }
}, yT = ["description", "reporter", "summary"], gT = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: t,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ se.jsx(se.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || yT.includes(o)
).map((o) => /* @__PURE__ */ se.jsx(
  Wt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ se.jsx(
      ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: hT({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: t
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), vT = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: t,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ se.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ se.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ se.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ se.jsx(pe, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ se.jsx(ln, { label: "Jira issue link", children: /* @__PURE__ */ se.jsx(
        Nr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: t ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), kT = "_modalBody_1hk1o_1", bT = "_modalBodyFormFields_1hk1o_4", fv = {
  modalBody: kT,
  modalBodyFormFields: bT
}, xT = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), _T = (e) => e?.custom?.split(":")?.[1] || null, ST = (e, n) => {
  if (e.startsWith("customfield_")) {
    const t = n.find((i) => i.key === e)?.schema;
    if (t)
      return t;
  }
  return null;
}, NT = (e, n) => {
  const t = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = ST(a, n), l = _T(s) ?? a;
        return t.includes(l) ? i[a] = xT(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, jT = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: t,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = le([]), [m, u] = le(), [f, h] = le(0), [g, C] = le([]), [S, N] = le([]), [w, y] = le(!1), [z, $] = le(!1), [I, T] = le({}), { track: U } = _n(), { isCopied: Q, copyToClipboard: J } = WE(), ie = Bn(() => i?.conversationId, [e]), { useMutation: X, useLazyQuery: B, showNotification: O } = hn(), {
    control: q,
    handleSubmit: ee,
    formState: { errors: ve },
    reset: ue,
    setValue: ce,
    getValues: fe
  } = _t({
    defaultValues: s
  }), W = S.length > 0, xe = `${a}/browse`, Ie = Object.keys(I).length > 0, [K, { loading: qe, error: Be }] = B(zE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ge) => {
      d(ge.Jira.getAllProjects);
    },
    onError: (ge) => {
      O({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", ge), d([]);
    }
  }), [
    Oe,
    { loading: Me, error: $e }
  ] = B(UE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ge) => {
      h(0);
      const De = ge?.Jira?.getCreateIssueMeta?.projects[0];
      if (De) {
        const Le = De?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        C(Le || []), ce(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        O({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), C([]), N([]);
    },
    onError: (ge) => {
      O({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", ge), C([]), N([]), h(0);
    }
  }), [ze, { error: Re }] = X(
    ME,
    {
      onError: () => {
        y(!1), O({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (ge) => {
        if (y(!1), ge?.Jira && "key" in ge.Jira.createIssue)
          u(ge?.Jira?.createIssue), O({
            title: "Success",
            text: `Jira issue '${ge.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: ge.Jira.createIssue.key
          }), ie && t(
            ge.Jira.createIssue.key,
            ie
          );
        else if ("errorMessages" in ge.Jira.createIssue || "errors" in ge.Jira.createIssue) {
          const De = ge?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", De), O({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), an = (ge) => {
    y(!0), T({}), ze({
      variables: {
        input: NT(ge, S)
      }
    });
  };
  He(() => {
    if (e)
      try {
        K();
      } catch (ge) {
        console.warn("Error when fetching initial projects", ge);
      }
  }, [e]), He(() => {
    const ge = z ? window.setTimeout(() => $(!1), 2e3) : void 0;
    return () => window.clearTimeout(ge);
  }, [z]), He(() => {
    if (g?.length > 0) {
      ce("issuetype", g[f]);
      const ge = g[f]?.fields?.additionalProperties;
      if (ge?.length > 0) {
        const De = ge.map(
          ({ value: E }) => E
        ), Le = (o ? De.sort(({ name: E }, { name: x }) => E.localeCompare(x)) : De).sort(
          ({ required: E }, { required: x }) => Number(x) - Number(E)
        ), { project: Pe, issuetype: mn } = fe();
        ue({ project: Pe, issuetype: mn }), N(Le);
      }
    } else
      N([]), ce("issuetype", void 0);
  }, [g, ce, f]), He(() => {
    if (Re && Zb(Re)) {
      if (Re?.graphQLErrors?.length > 0) {
        const { graphQLErrors: ge } = Re, De = ge[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(De);
          if (Le?.errors) {
            const Pe = Object.keys(Le.errors).reduce(
              (mn, E) => ({
                ...mn,
                [E]: {
                  type: "required",
                  message: Le.errors[E],
                  ref: {
                    name: E
                  }
                }
              }),
              {}
            );
            T(Pe);
          }
        } catch {
        }
      }
    } else
      T({});
  }, [Re]);
  const Ee = () => {
    d([]), N([]), C([]), u(void 0), h(0), y(!1), T({});
  }, Ge = () => {
    Ee(), ue(s), n();
  }, Qe = (ge) => {
    ge && Oe({
      variables: {
        projectKey: ge
      }
    });
  }, he = (ge) => {
    const De = g.map((Le) => Le.id).indexOf(ge);
    h(De ?? 0);
  };
  return /* @__PURE__ */ se.jsxs(
    Tt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Ge,
      children: [
        /* @__PURE__ */ se.jsx(
          $t,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Ge
          }
        ),
        /* @__PURE__ */ se.jsxs(Dt, { className: fv.modalBody, children: [
          !qe && Be && /* @__PURE__ */ se.jsx(Fn, { error: Be, retry: K }),
          !Me && $e && /* @__PURE__ */ se.jsx(
            Fn,
            {
              error: $e,
              retry: Oe
            }
          ),
          !w && Ie && /* @__PURE__ */ se.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ se.jsx(
            Gs,
            {
              variant: "warning",
              description: /* @__PURE__ */ se.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ se.jsx(
                      Gn,
                      {
                        icon: Q ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => J(JSON.stringify(S, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ se.jsx(
            vT,
            {
              createdIssue: m,
              issueBaseLink: xe,
              issueLinkCopied: z,
              setIssueLinkCopied: $,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ se.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(an),
              children: /* @__PURE__ */ se.jsxs(st, { children: [
                /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: "Project", required: !0, children: /* @__PURE__ */ se.jsx(
                  Wt,
                  {
                    control: q,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: ge, value: De } }) => /* @__PURE__ */ se.jsx(
                      wr,
                      {
                        searchable: !0,
                        loading: qe,
                        onSelect: (Le) => {
                          Qe(Le.key), ge(Le);
                        },
                        selectedItems: [De],
                        placeholder: "Select Jira project",
                        emptyMessage: Be ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Pe, checked: mn }) => /* @__PURE__ */ se.jsx(
                          ym,
                          {
                            item: Le,
                            checked: mn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: "Issue type", required: !0, children: /* @__PURE__ */ se.jsx(
                  Wt,
                  {
                    control: q,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: ge, value: De } }) => /* @__PURE__ */ se.jsx(
                      wr,
                      {
                        disabled: g.length === 0,
                        loading: Me,
                        onSelect: (Le) => {
                          he(Le.id), ge(Le);
                        },
                        selectedItems: [De],
                        placeholder: g.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: $e ? "No issues found" : "No issues available",
                        items: g,
                        itemComponent: ({ item: Le, onSelect: Pe, checked: mn }) => /* @__PURE__ */ se.jsx(
                          ym,
                          {
                            item: Le,
                            checked: mn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                W && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ se.jsx(be, { className: fv.modalBodyFormFields, children: /* @__PURE__ */ se.jsx(
                  gT,
                  {
                    control: q,
                    errors: { ...ve, ...I },
                    getValues: fe,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: S
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ se.jsx(
          Pt,
          {
            confirmOnClick: m ? Ge : ee(an),
            confirmProps: {
              disabled: !W,
              isLoading: w,
              loadingIndicator: /* @__PURE__ */ se.jsx(un, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Ge
          }
        )
      ]
    }
  );
}, wT = (e) => {
  if (!e) return "";
  const n = "https://", t = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${t}`;
}, CT = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const t = e.startsWith(n);
  if (t) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = t ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, FT = "_wrapper_1bylq_1", IT = "_inputWrapper_1bylq_6", ET = "_inputSeparator_1bylq_18", TT = "_buttonLink_1bylq_23", $T = "_noIssuesFound_1bylq_27", Ia = {
  wrapper: FT,
  inputWrapper: IT,
  inputSeparator: ET,
  buttonLink: TT,
  noIssuesFound: $T
}, DT = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: t } = _n(), i = wT(n?.jiraSiteUrl), [a, o] = le(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: g,
    isLoadingIssueLinks: C,
    isLoadingIssues: S,
    issues: N,
    error: w
  } = S_(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, z = !!n?.enableSortIssueTypeByLabel, $ = !!(N?.length || g?.length), I = !!n?.enableRemoveAllLinks && $, T = !C && !S && g?.length > 0 && !!n?.showDanglingLinks;
  return !S && w ? /* @__PURE__ */ se.jsx(Fn, { error: w, retry: () => f() }) : /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
    /* @__PURE__ */ se.jsxs(b, { className: Ia.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ se.jsxs(b, { className: Ia.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
          /* @__PURE__ */ se.jsx(
            Gn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ se.jsx("div", { className: Ia.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ se.jsx(
          sT,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      S ? /* @__PURE__ */ se.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ se.jsx(un, { "data-testid": "jira-widget-issue-spinner" }) }) : N?.length ? /* @__PURE__ */ se.jsx(
        IE,
        {
          issues: N,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ se.jsx(A.Paragraph, { align: "center", className: Ia.noIssuesFound, children: "No linked issues found" }),
      I && N?.length > 0 && /* @__PURE__ */ se.jsx(
        Gn,
        {
          variant: "secondary",
          disabled: !N?.length && !g?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      T && /* @__PURE__ */ se.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ se.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ se.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: g.map((U) => /* @__PURE__ */ se.jsx(An, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ se.jsx(
              Gn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ se.jsx(
        Et,
        {
          slotEnd: /* @__PURE__ */ se.jsx(pe, { name: "external-link" }),
          variant: "tertiary",
          className: Ia.buttonLink,
          navigate: () => {
            t("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ se.jsx(
      jT,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: z
      }
    )
  ] });
}, gm = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], RT = (e) => {
  const n = CT(e);
  return typeof n == "string" ? n : !0;
}, si = "JIRA", OT = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, PT = ({
  integrationId: e,
  configuration: n,
  handleRedirect: t,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = _t({
    mode: "onChange",
    defaultValues: OT
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = Ni({
    integrationId: e,
    integrationType: si,
    handleRedirect: t,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: z
  } = ji({
    integrationId: e,
    fieldDefinitions: gm,
    form: l,
    onMisconfigured: C
  }), { renderConditions: $, setRenderConditions: I, renderConditionsForSubmit: T } = wi({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (J) => Fi(J, {
    fieldDefinitions: gm,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: T
  }), Q = l.watch("name");
  return /* @__PURE__ */ se.jsxs(
    Ci,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ se.jsx(Ii, { cause: g }),
        /* @__PURE__ */ se.jsxs(st, { children: [
          /* @__PURE__ */ se.jsx(be, { children: /* @__PURE__ */ se.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(
            tt,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (J) => RT(J)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          !s && e && /* @__PURE__ */ se.jsx(
            sa,
            {
              configuration: n,
              integrationId: e,
              integrationType: si,
              label: "Authorize with OAuth"
            }
          ),
          o && $ !== null && /* @__PURE__ */ se.jsx(be, { children: o({
            value: $,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ se.jsx(
          Ei,
          {
            integrationType: si,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ se.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ se.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ se.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ se.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  si,
                  " integration, all links between Dixa and ",
                  si,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ se.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  si,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ se.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  si,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hu = { exports: {} }, Ea = {}, hv;
function AT() {
  if (hv) return Ea;
  hv = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ea.Fragment = t, Ea.jsx = s, Ea.jsxs = s, Ea;
}
var Uo = {}, yv;
function LT() {
  return yv || (yv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Uo.Fragment = i, Uo.jsx = Rn, Uo.jsxs = Mn;
  })()), Uo;
}
var gv;
function VT() {
  return gv || (gv = 1, process.env.NODE_ENV === "production" ? hu.exports = AT() : hu.exports = LT()), hu.exports;
}
var Ce = VT();
function zT({
  query: e,
  options: n,
  delayMs: t
}) {
  const { useLazyQuery: i } = hn(), [a, o] = le([]), [s] = i(e, n), [l, d] = le(
    []
  );
  return He(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((C) => {
        const S = setTimeout(C, t);
        d([...l, S]);
      });
      const g = await s({
        variables: h
      });
      u.push(g);
    }
    o(u);
  }, a];
}
var N_ = /* @__PURE__ */ ((e) => (e.List = "list", e))(N_ || {}), vm = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(vm || {}), km = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(km || {}), bm = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(bm || {});
const UT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, MT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, BT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, qT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, HT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, WT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, GT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, KT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, YT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, QT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, JT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, XT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ZT = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": UT,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": MT,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": qT,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": HT,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": BT,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": WT,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": GT,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": KT,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": YT,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": QT,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": JT,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": XT
};
function Yr(e) {
  return ZT[e] ?? {};
}
const e$ = Yr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), n$ = Yr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), t$ = Yr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), r$ = Yr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), i$ = Yr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), a$ = Yr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), o$ = Yr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), s$ = Yr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), l$ = Yr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function xm(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function vv(e) {
  return xm(e) && e?.attributes?.event_properties?.$message;
}
function c$(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function kv(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function d$(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function u$(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function m$(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function p$(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function f$(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function h$(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function bv(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function y$(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function g$(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const v$ = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function k$(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function b$(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function x$({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: t, useQuery: i } = hn(), { track: a } = _n(), [o, s] = le(null), [l, d] = le(
    null
  ), [m, u] = le(null), [f, h] = le(null), [g, C] = le(
    null
  ), [S, N] = le([]), {
    data: w,
    error: y,
    loading: z,
    networkStatus: $
  } = i(t$, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    I,
    {
      data: T,
      error: U,
      loading: Q,
      networkStatus: J
    }
  ] = t(e$, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return He(() => {
    if (w && !z && $ === er.ready) {
      const ie = d$(w);
      s(
        ie.find((X) => X?.attributes?.name === "Received Email")?.id || null
      ), d(
        ie.find((X) => X?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ie.find((X) => X?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ie.find((X) => X?.attributes?.name === "Bounced Email")?.id || null
      ), C(
        ie.find((X) => X?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), C(null);
  }, [w]), He(() => {
    o && l && m && f && g && !Q && J === er.ready ? I({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${g}")`,
        pageSize: n
      }
    }) : N([]);
  }, [
    o,
    l,
    m,
    f,
    g
  ]), He(() => {
    if (!Q && T) {
      const ie = u$(T), X = p$(
        T
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      ), B = f$(
        T
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      );
      ie.forEach((ue) => {
        const ce = ue.attributes?.event_properties.$message;
        ue.opened = X.includes(ce), ue.clicked = B.includes(ce);
      });
      const O = m$(T), q = h$(T), ee = [
        ...ie,
        ...q,
        ...O
      ].sort((ue, ce) => {
        const fe = kv(ue), W = kv(ce);
        return fe == null && W == null ? 0 : fe == null ? 1 : W == null ? -1 : W - fe;
      }).slice(0, n);
      N(ee);
      const ve = ee.map((ue) => ue.id);
      a("klaviyo:messages:received", {
        emailsReceived: ie.filter(
          (ue) => ve.includes(ue.id)
        ).length,
        emailsBounced: q.filter(
          (ue) => ve.includes(ue.id)
        ).length,
        smsReceived: O.filter(
          (ue) => ve.includes(ue.id)
        ).length,
        total: ve.length
      });
    } else
      N([]);
  }, [Q, T]), Bn(
    () => ({
      receivedMessages: S,
      isLoading: z || Q,
      error: y || U
    }),
    [
      S,
      z,
      Q,
      y,
      U
    ]
  );
}
function _$({ profileId: e }) {
  const { useQuery: n } = hn(), [t, i] = le(), [a, o] = le(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(i$, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  He(() => {
    l && o(l);
  }, [l]), He(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Bn(
    () => ({
      profile: t,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, d, a]
  );
}
function S$({
  email: e,
  phoneNumber: n
}) {
  const { track: t } = _n(), { useLazyQuery: i } = hn(), [a, o] = le(), [s, l] = le(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(r$, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    if (!f && m) {
      const g = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, C = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(g, C);
    }
  }, [f, m]);
  const h = (g, C) => {
    const S = g?.data?.length === 1 && g.data[0]?.id || void 0, N = C?.data?.length === 1 && C.data[0]?.id || void 0, w = S || N, y = !S || !N || S === N;
    if (w && y) {
      o(S || N), t("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), t("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${S}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return Bn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const xv = 800, N$ = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, j$ = 3, w$ = 1.5, C$ = ({
  query: e,
  delay: n,
  delayRange: t,
  maxCount: i = j$,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = le(0), [d, m] = le(n || xv), [u, f] = le(t || N$), [h, g] = le(!1), [C, S] = le(!1), N = a || !!t, w = N ? o(u) : n || xv, [y, z] = le(w);
  lC(
    async () => {
      const U = s + 1, Q = w$ ** U;
      l(U), z(
        (N ? o(u) : d) * Q
      ), await e().then(() => {
        S(!0), T();
      });
    },
    h ? y : null
  ), dC(() => T());
  const $ = ot(() => {
    l(0), z(w);
  }, [w]), I = ot(
    (U = {}) => {
      const { delay: Q, delayRange: J } = U;
      S(!1), $(), J && (f(J), z(o(J))), Q && (m(Q), z(Q)), g(!0);
    },
    [$]
  ), T = ot(() => {
    g(!1), $();
  }, [$]);
  return He(() => {
    s >= i && T();
  }, [s, i, T]), Bn(
    () => ({ isRunning: h, isSuccessful: C, start: I, stop: T }),
    [h, C, I, T]
  );
}, F$ = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, I$ = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function E$({
  profileId: e,
  query: n
}) {
  const { useQuery: t } = hn(), [i, a] = le(), [o, s] = le(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = t(
    n === "lists" ? a$ : o$,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: g,
    stop: C
  } = C$({
    query: u,
    useDelayRange: !0
  }), S = m || h;
  return He(() => {
    if (d)
      if (f0({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const N = F$(d);
          g({
            ...N && {
              delayRange: I$(N)
            }
          });
        }
      } else
        s(d);
  }, [d]), He(() => {
    if (!m && l?.Klaviyo) {
      let N = {}, w = {};
      n === "lists" && (N = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (w = l?.Klaviyo?.get_segments_for_profile), (N?.data || w?.data) && (C(), a(
        (n === "lists" ? N?.data : w?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Bn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: g,
      isLoading: S,
      error: o,
      networkStatus: f
    }),
    [i, S, o, f, g]
  );
}
const T$ = "_notificationText_1polx_1", Op = {
  notificationText: T$
}, ll = ({ error: e }) => {
  const { track: n } = _n();
  let t = e;
  if (Zb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && Hb({ error: i[0] }), o = i.length === 1 && m0({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), t = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), t = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Ce.jsx(Fn, { error: e });
  }
  return /* @__PURE__ */ Ce.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Ce.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ Ce.jsx(pe, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: t.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, $$ = "_message_1vrar_48", D$ = "_messageIsOpen_1vrar_56", R$ = "_messageHeader_1vrar_59", O$ = "_messageLabel_1vrar_65", P$ = "_messageText_1vrar_68", Zi = {
  message: $$,
  messageIsOpen: D$,
  messageHeader: R$,
  messageLabel: O$,
  messageText: P$
}, A$ = ({ event: e, isLoadingPreview: n }) => {
  const t = e?.attributes?.event_properties, i = e.flowMessage && y$(e.flowMessage);
  return /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
    /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", className: Zi.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { children: t["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Ce.jsx(un, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Ce.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Ce.jsx(b, { children: /* @__PURE__ */ Ce.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: Zi.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", className: Zi.messageText, children: i })
        ]
      }
    )
  ] });
}, L$ = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Ce.jsx(b, { children: /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Ce.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, V$ = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: t
}) => {
  const [i, a] = le(t), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Bn(
    () => () => l ? Ln(l).format(m) : d ? Ln.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", g = f && e.opened, C = f && e.clicked, S = f && o?.event_properties.Subject, N = h && o?.event_properties["Message Name"], w = f ? "mail" : "sms";
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: it(Zi.message, {
        [Zi.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Ce.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Zi.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Ce.jsx(pe, { size: 16, name: w }),
                  " ",
                  v$(s),
                  u && /* @__PURE__ */ Ce.jsx(Pn, { size: "small", variant: "info", children: u })
                ] }),
                S && S,
                N && N
              ] }),
              /* @__PURE__ */ Ce.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Ce.jsx(Jm, {}),
          c$(e) && /* @__PURE__ */ Ce.jsx(b, { children: /* @__PURE__ */ Ce.jsx(Pn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Ce.jsx(An, { children: /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ce.jsx(
                  pe,
                  {
                    size: 16,
                    color: g ? "green.400" : "red.400",
                    name: g ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Ce.jsx(An, { children: /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ce.jsx(
                  pe,
                  {
                    size: 16,
                    color: C ? "green.400" : "red.400",
                    name: C ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Ce.jsx(A$, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Ce.jsx(L$, { event: e })
        ] })
      ]
    }
  );
}, z$ = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, U$ = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [t, i] = le(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = x$({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = zT({
    query: n$,
    options: z$,
    delayMs: 1e3
  }), [m, u] = le([]);
  He(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((g) => xm(g)).map((g) => vv(g));
      h.length > 0 && (i(!0), l(
        h.map((g) => ({
          messageId: g
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), He(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && xm(h) && !h.flowMessage) {
          const g = vv(h), C = d.find((N) => (N.data && bv(N.data))?.id === g), S = C?.data && bv(C.data);
          if (S)
            return {
              ...g$(h),
              flowMessage: S
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: f.map((h, g) => h.graphQLErrors ? /* @__PURE__ */ Ce.jsx(
    Fn,
    {
      error: h
    },
    `lastMessagesError${g}`
  ) : /* @__PURE__ */ Ce.jsx(
    ll,
    {
      error: h
    },
    `lastMessagesError${g}`
  )) }) : /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ce.jsx(un, {}) }) : /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, g) => /* @__PURE__ */ Ce.jsx(
      V$,
      {
        event: h,
        isLoadingPreview: t,
        openByDefault: g === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Op.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, M$ = "_list_ld0hf_1", B$ = "_listItem_ld0hf_4", Gr = {
  list: M$,
  listItem: B$
}, q$ = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, t = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = t.length > 0;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ Ce.jsx(Ye, { className: Gr.list, children: t.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Gr.listItem, children: /* @__PURE__ */ Ce.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: p0(a) }),
          /* @__PURE__ */ Ce.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: po(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, _v = ({
  profileId: e,
  type: n
}) => {
  const [t, i] = le(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = E$({ profileId: e, query: n });
  He(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ Ce.jsx(ll, { error: o }) : s ? /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Gr.listItem, children: /* @__PURE__ */ Ce.jsx(un, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: u.map(
    ({ attributes: f, type: h }, g) => /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Gr.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Ce.jsx(An, { children: Wb(h) })
    ] }) }, g)
  ) }) : t && !a ? /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Gr.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(pe, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Ce.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Ce.jsx(We, { content: "Refresh lists and segments", children: /* @__PURE__ */ Ce.jsx(Gn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Gr.listItem, children: /* @__PURE__ */ Ce.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Ce.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, H$ = 0.7, W$ = 0.3, G$ = (e) => e >= H$ ? { variant: "error", label: "High risk" } : e >= W$ ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, K$ = (e) => /* @__PURE__ */ Ce.jsx(A.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), Y$ = (e) => {
  const n = G$(e);
  return /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ Ce.jsx(Pn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ Ce.jsx(A.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, Q$ = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const t = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...t.flatMap(
      ([s, l]) => l ? [{ label: s, content: K$(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: po(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: Y$(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: po(o)
      }
    ] : []
  ];
}, J$ = ({
  profile: e
}) => {
  const n = Q$(e);
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ Ce.jsx(Ye, { className: Gr.list, children: n.map(({ label: t, content: i }) => /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Gr.listItem, children: /* @__PURE__ */ Ce.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ Ce.jsx(A.Paragraph, { as: "span", variant: "4", children: t }),
          i
        ]
      }
    ) }, t)) })
  ] });
}, X$ = "_tagHover_kzbzk_1", Z$ = "_channelUnsubscribed_kzbzk_6", Sv = {
  tagHover: X$,
  channelUnsubscribed: Z$
}, Nv = ({
  isSubscribed: e,
  isLoading: n,
  channelName: t,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Ce.jsx(
    We,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Ce.jsx(
        An,
        {
          className: Sv.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Ce.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: it({
                [Sv.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Ce.jsx(un, { size: 16 }) : /* @__PURE__ */ Ce.jsx(pe, { size: 16, name: i }),
                t
              ]
            }
          )
        }
      )
    }
  );
}, eD = "_subscriptionError_1qhhx_1", nD = {
  subscriptionError: eD
}, tD = ({
  subscriptionListId: e,
  profile: n,
  email: t,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = le(!1), [d, m] = le(!1), [u, f] = le(), { track: h } = _n(), [g, C] = cC({
    channel: null,
    request: null
  }), S = k$(n), N = b$(n), w = !!e, { useMutation: y } = hn(), [z] = y(
    s$
  ), [$] = y(
    l$
  ), I = (Q) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Q }), C.setAll({
      channel: Q,
      request: "subscribed"
    }), ((J) => z({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: vm.Profile,
                id: a,
                attributes: {
                  email: t,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...J === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: km.Subscribed
                        }
                      }
                    },
                    ...J === "SMS" && {
                      sms: {
                        marketing: {
                          consent: km.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: N_.List,
              id: e
            }
          }
        }
      }
    }))(Q).then(
      (J) => U({
        channel: Q,
        mutationResponse: J,
        isSubscriptionRequest: !0
      })
    ).catch(
      (J) => U({
        channel: Q,
        mutationErrorResponse: J,
        isSubscriptionRequest: !0
      })
    );
  }, T = (Q) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Q }), C.setAll({
      channel: Q,
      request: "unsubscribed"
    }), $({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: vm.Profile,
                attributes: {
                  ...Q === "EMAIL" ? { email: t } : {},
                  // eslint-disable-next-line camelcase
                  ...Q === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: bm.Unsubscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: bm.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (J) => U({
        channel: Q,
        mutationResponse: J,
        isSubscriptionRequest: !1
      })
    ).catch(
      (J) => U({
        channel: Q,
        mutationErrorResponse: J,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Q,
    mutationResponse: J,
    mutationErrorResponse: ie,
    isSubscriptionRequest: X
  }) => {
    const B = ie?.networkError, O = B ? B?.statusCode : NaN, q = J?.errors, ee = !!q && Gb({
      errors: q
    });
    O === 202 ? (h(
      X ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Q }
    ), await o()) : ee ? (h(
      X ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${X ? "opt-in" : "opt-out"}.`
    )) : (h(
      X ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: B?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${X ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return He(() => {
    if (g.request === "subscribed") {
      const Q = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${g.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      g.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Q), C.reset()), g.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Q), C.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ Ce.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(
            Nv,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: S,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: w,
              handleAction: () => {
                l(!0), f(void 0), S ? T("EMAIL") : I("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            Nv,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: N,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: w,
              handleAction: () => {
                m(!0), f(void 0), N ? T("SMS") : I("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ Ce.jsx(b, { className: nD.subscriptionError, children: u })
      ] })
    }
  );
}, rD = ({
  profileId: e,
  email: n,
  phoneNumber: t,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: g
  } = _$({ profileId: e });
  return f ? /* @__PURE__ */ Ce.jsx(ll, { error: f }) : h ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ce.jsx(un, {}) }) : !u && !h ? /* @__PURE__ */ Ce.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Op.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Ce.jsxs(Ye, { className: Gr.list, children: [
        i && /* @__PURE__ */ Ce.jsx(_v, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Ce.jsx(
          _v,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ Ce.jsx(
      tD,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: g,
        email: n,
        phoneNumber: t
      }
    ),
    u && l && /* @__PURE__ */ Ce.jsx(J$, { profile: u }),
    u && s && /* @__PURE__ */ Ce.jsx(q$, { profile: u }),
    /* @__PURE__ */ Ce.jsx(
      U$,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, iD = ({
  conversationContext: e,
  settings: n
}) => {
  const t = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: g,
    error: C
  } = S$({ email: t, phoneNumber: i });
  return w0(() => {
    (t || i) && h({
      variables: {
        emailFilter: t ? `equals(email,"${t}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!t,
        hasPhoneNumber: !!i
      }
    });
  }, [t, i]), !t && !i ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : g ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ce.jsx(un, {}) }) : C ? /* @__PURE__ */ Ce.jsx(ll, { error: C }) : f ? /* @__PURE__ */ Ce.jsx(
    rD,
    {
      profileId: f,
      email: t,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ Ce.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Op.notificationText,
      children: "No profile ID found"
    }
  );
}, aD = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: u0
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], oD = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: sa
  }
], sD = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function lD(e, n) {
  const t = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const cD = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, dD = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, uD = {};
function jv(e, n) {
  return (uD.jsx ? dD : cD).test(e);
}
const mD = /[ \t\n\f\r]/g;
function pD(e) {
  return typeof e == "object" ? e.type === "text" ? wv(e.value) : !1 : wv(e);
}
function wv(e) {
  return e.replace(mD, "") === "";
}
class Co {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, t, i) {
    this.property = n, this.normal = t, i && (this.space = i);
  }
}
Co.prototype.property = {};
Co.prototype.normal = {};
Co.prototype.space = null;
function j_(e, n) {
  const t = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(t, e[a].property), Object.assign(i, e[a].normal);
  return new Co(t, i, n);
}
function _m(e) {
  return e.toLowerCase();
}
class hr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, t) {
    this.property = n, this.attribute = t;
  }
}
hr.prototype.space = null;
hr.prototype.boolean = !1;
hr.prototype.booleanish = !1;
hr.prototype.overloadedBoolean = !1;
hr.prototype.number = !1;
hr.prototype.commaSeparated = !1;
hr.prototype.spaceSeparated = !1;
hr.prototype.commaOrSpaceSeparated = !1;
hr.prototype.mustUseProperty = !1;
hr.prototype.defined = !1;
let fD = 0;
const In = Oi(), yt = Oi(), w_ = Oi(), Ue = Oi(), Zn = Oi(), ea = Oi(), tr = Oi();
function Oi() {
  return 2 ** ++fD;
}
const Sm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: In,
  booleanish: yt,
  commaOrSpaceSeparated: tr,
  commaSeparated: ea,
  number: Ue,
  overloadedBoolean: w_,
  spaceSeparated: Zn
}, Symbol.toStringTag, { value: "Module" })), yu = Object.keys(Sm);
class Pp extends hr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, t, i, a) {
    let o = -1;
    if (super(n, t), Cv(this, "space", a), typeof i == "number")
      for (; ++o < yu.length; ) {
        const s = yu[o];
        Cv(this, yu[o], (i & Sm[s]) === Sm[s]);
      }
  }
}
Pp.prototype.defined = !0;
function Cv(e, n, t) {
  t && (e[n] = t);
}
const hD = {}.hasOwnProperty;
function fa(e) {
  const n = {}, t = {};
  let i;
  for (i in e.properties)
    if (hD.call(e.properties, i)) {
      const a = e.properties[i], o = new Pp(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, t[_m(i)] = i, t[_m(o.attribute)] = i;
    }
  return new Co(n, t, e.space);
}
const C_ = fa({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), F_ = fa({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function I_(e, n) {
  return n in e ? e[n] : n;
}
function E_(e, n) {
  return I_(e, n.toLowerCase());
}
const T_ = fa({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: E_,
  properties: { xmlns: null, xmlnsXLink: null }
}), $_ = fa({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: yt,
    ariaAutoComplete: null,
    ariaBusy: yt,
    ariaChecked: yt,
    ariaColCount: Ue,
    ariaColIndex: Ue,
    ariaColSpan: Ue,
    ariaControls: Zn,
    ariaCurrent: null,
    ariaDescribedBy: Zn,
    ariaDetails: null,
    ariaDisabled: yt,
    ariaDropEffect: Zn,
    ariaErrorMessage: null,
    ariaExpanded: yt,
    ariaFlowTo: Zn,
    ariaGrabbed: yt,
    ariaHasPopup: null,
    ariaHidden: yt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Zn,
    ariaLevel: Ue,
    ariaLive: null,
    ariaModal: yt,
    ariaMultiLine: yt,
    ariaMultiSelectable: yt,
    ariaOrientation: null,
    ariaOwns: Zn,
    ariaPlaceholder: null,
    ariaPosInSet: Ue,
    ariaPressed: yt,
    ariaReadOnly: yt,
    ariaRelevant: null,
    ariaRequired: yt,
    ariaRoleDescription: Zn,
    ariaRowCount: Ue,
    ariaRowIndex: Ue,
    ariaRowSpan: Ue,
    ariaSelected: yt,
    ariaSetSize: Ue,
    ariaSort: null,
    ariaValueMax: Ue,
    ariaValueMin: Ue,
    ariaValueNow: Ue,
    ariaValueText: null,
    role: null
  }
}), yD = fa({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: E_,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ea,
    acceptCharset: Zn,
    accessKey: Zn,
    action: null,
    allow: null,
    allowFullScreen: In,
    allowPaymentRequest: In,
    allowUserMedia: In,
    alt: null,
    as: null,
    async: In,
    autoCapitalize: null,
    autoComplete: Zn,
    autoFocus: In,
    autoPlay: In,
    blocking: Zn,
    capture: null,
    charSet: null,
    checked: In,
    cite: null,
    className: Zn,
    cols: Ue,
    colSpan: null,
    content: null,
    contentEditable: yt,
    controls: In,
    controlsList: Zn,
    coords: Ue | ea,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: In,
    defer: In,
    dir: null,
    dirName: null,
    disabled: In,
    download: w_,
    draggable: yt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: In,
    formTarget: null,
    headers: Zn,
    height: Ue,
    hidden: In,
    high: Ue,
    href: null,
    hrefLang: null,
    htmlFor: Zn,
    httpEquiv: Zn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: In,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: In,
    itemId: null,
    itemProp: Zn,
    itemRef: Zn,
    itemScope: In,
    itemType: Zn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: In,
    low: Ue,
    manifest: null,
    max: null,
    maxLength: Ue,
    media: null,
    method: null,
    min: null,
    minLength: Ue,
    multiple: In,
    muted: In,
    name: null,
    nonce: null,
    noModule: In,
    noValidate: In,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: In,
    optimum: Ue,
    pattern: null,
    ping: Zn,
    placeholder: null,
    playsInline: In,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: In,
    referrerPolicy: null,
    rel: Zn,
    required: In,
    reversed: In,
    rows: Ue,
    rowSpan: Ue,
    sandbox: Zn,
    scope: null,
    scoped: In,
    seamless: In,
    selected: In,
    shadowRootClonable: In,
    shadowRootDelegatesFocus: In,
    shadowRootMode: null,
    shape: null,
    size: Ue,
    sizes: null,
    slot: null,
    span: Ue,
    spellCheck: yt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ue,
    step: null,
    style: null,
    tabIndex: Ue,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: In,
    useMap: null,
    value: yt,
    width: Ue,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Zn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ue,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ue,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: In,
    // Lists. Use CSS to reduce space between items instead
    declare: In,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ue,
    // `<img>` and `<object>`
    leftMargin: Ue,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ue,
    // `<body>`
    marginWidth: Ue,
    // `<body>`
    noResize: In,
    // `<frame>`
    noHref: In,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: In,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: In,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ue,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: yt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ue,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ue,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: In,
    disableRemotePlayback: In,
    prefix: null,
    property: null,
    results: Ue,
    security: null,
    unselectable: null
  }
}), gD = fa({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: I_,
  properties: {
    about: tr,
    accentHeight: Ue,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ue,
    amplitude: Ue,
    arabicForm: null,
    ascent: Ue,
    attributeName: null,
    attributeType: null,
    azimuth: Ue,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ue,
    by: null,
    calcMode: null,
    capHeight: Ue,
    className: Zn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ue,
    diffuseConstant: Ue,
    direction: null,
    display: null,
    dur: null,
    divisor: Ue,
    dominantBaseline: null,
    download: In,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ue,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ue,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ue,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ea,
    g2: ea,
    glyphName: ea,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ue,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ue,
    horizOriginX: Ue,
    horizOriginY: Ue,
    id: null,
    ideographic: Ue,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ue,
    k: Ue,
    k1: Ue,
    k2: Ue,
    k3: Ue,
    k4: Ue,
    kernelMatrix: tr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ue,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ue,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ue,
    overlineThickness: Ue,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ue,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Zn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ue,
    pointsAtY: Ue,
    pointsAtZ: Ue,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: tr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: tr,
    rev: tr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: tr,
    requiredFeatures: tr,
    requiredFonts: tr,
    requiredFormats: tr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ue,
    specularExponent: Ue,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ue,
    strikethroughThickness: Ue,
    string: null,
    stroke: null,
    strokeDashArray: tr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ue,
    strokeOpacity: Ue,
    strokeWidth: null,
    style: null,
    surfaceScale: Ue,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: tr,
    tabIndex: Ue,
    tableValues: null,
    target: null,
    targetX: Ue,
    targetY: Ue,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: tr,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ue,
    underlineThickness: Ue,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ue,
    values: null,
    vAlphabetic: Ue,
    vMathematical: Ue,
    vectorEffect: null,
    vHanging: Ue,
    vIdeographic: Ue,
    version: null,
    vertAdvY: Ue,
    vertOriginX: Ue,
    vertOriginY: Ue,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ue,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), vD = /^data[-\w.:]+$/i, Fv = /-[a-z]/g, kD = /[A-Z]/g;
function bD(e, n) {
  const t = _m(n);
  let i = n, a = hr;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && vD.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(Fv, _D);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!Fv.test(o)) {
        let s = o.replace(kD, xD);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Pp;
  }
  return new a(i, n);
}
function xD(e) {
  return "-" + e.toLowerCase();
}
function _D(e) {
  return e.charAt(1).toUpperCase();
}
const SD = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, ND = j_([F_, C_, T_, $_, yD], "html"), Ap = j_([F_, C_, T_, $_, gD], "svg");
function jD(e) {
  return e.join(" ").trim();
}
var Vi = {}, gu, Iv;
function wD() {
  if (Iv) return gu;
  Iv = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, t = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", g = "declaration";
  gu = function(S, N) {
    if (typeof S != "string")
      throw new TypeError("First argument must be a string");
    if (!S) return [];
    N = N || {};
    var w = 1, y = 1;
    function z(O) {
      var q = O.match(n);
      q && (w += q.length);
      var ee = O.lastIndexOf(d);
      y = ~ee ? O.length - ee : y + O.length;
    }
    function $() {
      var O = { line: w, column: y };
      return function(q) {
        return q.position = new I(O), Q(), q;
      };
    }
    function I(O) {
      this.start = O, this.end = { line: w, column: y }, this.source = N.source;
    }
    I.prototype.content = S;
    function T(O) {
      var q = new Error(
        N.source + ":" + w + ":" + y + ": " + O
      );
      if (q.reason = O, q.filename = N.source, q.line = w, q.column = y, q.source = S, !N.silent) throw q;
    }
    function U(O) {
      var q = O.exec(S);
      if (q) {
        var ee = q[0];
        return z(ee), S = S.slice(ee.length), q;
      }
    }
    function Q() {
      U(t);
    }
    function J(O) {
      var q;
      for (O = O || []; q = ie(); )
        q !== !1 && O.push(q);
      return O;
    }
    function ie() {
      var O = $();
      if (!(m != S.charAt(0) || u != S.charAt(1))) {
        for (var q = 2; f != S.charAt(q) && (u != S.charAt(q) || m != S.charAt(q + 1)); )
          ++q;
        if (q += 2, f === S.charAt(q - 1))
          return T("End of comment missing");
        var ee = S.slice(2, q - 2);
        return y += 2, z(ee), S = S.slice(q), y += 2, O({
          type: h,
          comment: ee
        });
      }
    }
    function X() {
      var O = $(), q = U(i);
      if (q) {
        if (ie(), !U(a)) return T("property missing ':'");
        var ee = U(o), ve = O({
          type: g,
          property: C(q[0].replace(e, f)),
          value: ee ? C(ee[0].replace(e, f)) : f
        });
        return U(s), ve;
      }
    }
    function B() {
      var O = [];
      J(O);
      for (var q; q = X(); )
        q !== !1 && (O.push(q), J(O));
      return O;
    }
    return Q(), B();
  };
  function C(S) {
    return S ? S.replace(l, f) : f;
  }
  return gu;
}
var Ev;
function CD() {
  if (Ev) return Vi;
  Ev = 1;
  var e = Vi && Vi.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Vi, "__esModule", { value: !0 }), Vi.default = t;
  var n = e(wD());
  function t(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Vi;
}
var FD = CD();
const Tv = /* @__PURE__ */ ep(FD), ID = Tv.default || Tv, D_ = R_("end"), Lp = R_("start");
function R_(e) {
  return n;
  function n(t) {
    const i = t && t.position && t.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function ED(e) {
  const n = Lp(e), t = D_(e);
  if (n && t)
    return { start: n, end: t };
}
function io(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? $v(e.position) : "start" in e || "end" in e ? $v(e) : "line" in e || "column" in e ? Nm(e) : "";
}
function Nm(e) {
  return Dv(e && e.line) + ":" + Dv(e && e.column);
}
function $v(e) {
  return Nm(e && e.start) + "-" + Nm(e && e.end);
}
function Dv(e) {
  return e && typeof e == "number" ? e : 1;
}
class At extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, i) {
    super(), typeof t == "string" && (i = t, t = void 0);
    let a = "", o = {}, s = !1;
    if (t && ("line" in t && "column" in t ? o = { place: t } : "start" in t && "end" in t ? o = { place: t } : "type" in t ? o = {
      ancestors: [t],
      place: t.position
    } : o = { ...t }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = io(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
At.prototype.file = "";
At.prototype.name = "";
At.prototype.reason = "";
At.prototype.message = "";
At.prototype.stack = "";
At.prototype.column = void 0;
At.prototype.line = void 0;
At.prototype.ancestors = void 0;
At.prototype.cause = void 0;
At.prototype.fatal = void 0;
At.prototype.place = void 0;
At.prototype.ruleId = void 0;
At.prototype.source = void 0;
const Vp = {}.hasOwnProperty, TD = /* @__PURE__ */ new Map(), $D = /[A-Z]/g, DD = /-([a-z])/g, RD = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), OD = /* @__PURE__ */ new Set(["td", "th"]), O_ = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function PD(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = qD(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = BD(t, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Ap : ND,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = P_(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function P_(e, n, t) {
  if (n.type === "element")
    return AD(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return LD(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return zD(e, n, t);
  if (n.type === "mdxjsEsm")
    return VD(e, n);
  if (n.type === "root")
    return UD(e, n, t);
  if (n.type === "text")
    return MD(e, n);
}
function AD(e, n, t) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Ap, e.schema = a), e.ancestors.push(n);
  const o = L_(e, n.tagName, !1), s = HD(e, n);
  let l = Up(e, n);
  return RD.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !pD(d) : !0;
  })), A_(e, s, o, n), zp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, t);
}
function LD(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  go(e, n.position);
}
function VD(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  go(e, n.position);
}
function zD(e, n, t) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Ap, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : L_(e, n.name, !0), s = WD(e, n), l = Up(e, n);
  return A_(e, s, o, n), zp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, t);
}
function UD(e, n, t) {
  const i = {};
  return zp(i, Up(e, n)), e.create(n, e.Fragment, i, t);
}
function MD(e, n) {
  return n.value;
}
function A_(e, n, t, i) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = i);
}
function zp(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function BD(e, n, t) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? t : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function qD(e, n) {
  return t;
  function t(i, a, o, s) {
    const l = Array.isArray(o.children), d = Lp(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function HD(e, n) {
  const t = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Vp.call(n.properties, a)) {
      const o = GD(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && OD.has(n.tagName) ? i = l : t[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return t;
}
function WD(e, n) {
  const t = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        go(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          go(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      t[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return t;
}
function Up(e, n) {
  const t = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : TD;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = P_(e, o, s);
    l !== void 0 && t.push(l);
  }
  return t;
}
function GD(e, n, t) {
  const i = bD(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = i.commaSeparated ? lD(t) : jD(t)), i.property === "style") {
      let a = typeof t == "object" ? t : KD(e, String(t));
      return e.stylePropertyNameCase === "css" && (a = YD(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? SD[i.property] || i.property : i.attribute,
      t
    ];
  }
}
function KD(e, n) {
  const t = {};
  try {
    ID(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new At("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = O_ + "#cannot-parse-style-attribute", s;
    }
  }
  return t;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(DD, JD)), t[s] = o;
  }
}
function L_(e, n, t) {
  let i;
  if (!t)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = jv(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = jv(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Vp.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  go(e);
}
function go(e, n) {
  const t = new At(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = O_ + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function YD(e) {
  const n = {};
  let t;
  for (t in e)
    Vp.call(e, t) && (n[QD(t)] = e[t]);
  return n;
}
function QD(e) {
  let n = e.replace($D, XD);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function JD(e, n) {
  return n.toUpperCase();
}
function XD(e) {
  return "-" + e.toLowerCase();
}
const vu = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, ZD = {};
function eR(e, n) {
  const t = ZD, i = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, a = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return V_(e, i, a);
}
function V_(e, n, t) {
  if (nR(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Rv(e.children, n, t);
  }
  return Array.isArray(e) ? Rv(e, n, t) : "";
}
function Rv(e, n, t) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = V_(e[a], n, t);
  return i.join("");
}
function nR(e) {
  return !!(e && typeof e == "object");
}
const Ov = document.createElement("i");
function Mp(e) {
  const n = "&" + e + ";";
  Ov.innerHTML = n;
  const t = Ov.textContent;
  return t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t;
}
function Ar(e, n, t, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, t = t > 0 ? t : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, t), e.splice(...s);
  else
    for (t && e.splice(n, t); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function ur(e, n) {
  return e.length > 0 ? (Ar(e, e.length, 0, n), e) : n;
}
const Pv = {}.hasOwnProperty;
function tR(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    rR(n, e[t]);
  return n;
}
function rR(e, n) {
  let t;
  for (t in n) {
    const a = (Pv.call(e, t) ? e[t] : void 0) || (e[t] = {}), o = n[t];
    let s;
    if (o)
      for (s in o) {
        Pv.call(a, s) || (a[s] = []);
        const l = o[s];
        iR(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function iR(e, n) {
  let t = -1;
  const i = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : i).push(n[t]);
  Ar(e, 0, 0, i);
}
function z_(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function na(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Tr = ai(/[A-Za-z]/), sr = ai(/[\dA-Za-z]/), aR = ai(/[#-'*+\--9=?A-Z^-~]/);
function jm(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const wm = ai(/\d/), oR = ai(/[\dA-Fa-f]/), sR = ai(/[!-/:-@[-`{-~]/);
function bn(e) {
  return e !== null && e < -2;
}
function Zt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const lR = ai(new RegExp("\\p{P}|\\p{S}", "u")), cR = ai(/\s/);
function ai(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function ha(e) {
  const n = [];
  let t = -1, i = 0, a = 0;
  for (; ++t < e.length; ) {
    const o = e.charCodeAt(t);
    let s = "";
    if (o === 37 && sr(e.charCodeAt(t + 1)) && sr(e.charCodeAt(t + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(t + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, t), encodeURIComponent(s)), i = t + a + 1, s = ""), a && (t += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function nt(e, n, t, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(t), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(t), n(d));
  }
}
const dR = {
  tokenize: uR
};
function uR(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let t;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), nt(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = d), t = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return bn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const mR = {
  tokenize: pR
}, Av = {
  tokenize: fR
};
function pR(e) {
  const n = this, t = [];
  let i = 0, a, o, s;
  return l;
  function l(z) {
    if (i < t.length) {
      const $ = t[i];
      return n.containerState = $[1], e.attempt($[0].continuation, d, m)(z);
    }
    return m(z);
  }
  function d(z) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const $ = n.events.length;
      let I = $, T;
      for (; I--; )
        if (n.events[I][0] === "exit" && n.events[I][1].type === "chunkFlow") {
          T = n.events[I][1].end;
          break;
        }
      w(i);
      let U = $;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...T
        }, U++;
      return Ar(n.events, I + 1, 0, n.events.slice($)), n.events.length = U, m(z);
    }
    return l(z);
  }
  function m(z) {
    if (i === t.length) {
      if (!a)
        return h(z);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return C(z);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Av, u, f)(z);
  }
  function u(z) {
    return a && y(), w(i), h(z);
  }
  function f(z) {
    return n.parser.lazy[n.now().line] = i !== t.length, s = n.now().offset, C(z);
  }
  function h(z) {
    return n.containerState = {}, e.attempt(Av, g, C)(z);
  }
  function g(z) {
    return i++, t.push([n.currentConstruct, n.containerState]), h(z);
  }
  function C(z) {
    if (z === null) {
      a && y(), w(0), e.consume(z);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), S(z);
  }
  function S(z) {
    if (z === null) {
      N(e.exit("chunkFlow"), !0), w(0), e.consume(z);
      return;
    }
    return bn(z) ? (e.consume(z), N(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(z), S);
  }
  function N(z, $) {
    const I = n.sliceStream(z);
    if ($ && I.push(null), z.previous = o, o && (o.next = z), o = z, a.defineSkip(z.start), a.write(I), n.parser.lazy[z.start.line]) {
      let T = a.events.length;
      for (; T--; )
        if (
          // The token starts before the line ending…
          a.events[T][1].start.offset < s && // …and either is not ended yet…
          (!a.events[T][1].end || // …or ends after it.
          a.events[T][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Q = U, J, ie;
      for (; Q--; )
        if (n.events[Q][0] === "exit" && n.events[Q][1].type === "chunkFlow") {
          if (J) {
            ie = n.events[Q][1].end;
            break;
          }
          J = !0;
        }
      for (w(i), T = U; T < n.events.length; )
        n.events[T][1].end = {
          ...ie
        }, T++;
      Ar(n.events, Q + 1, 0, n.events.slice(U)), n.events.length = T;
    }
  }
  function w(z) {
    let $ = t.length;
    for (; $-- > z; ) {
      const I = t[$];
      n.containerState = I[1], I[0].exit.call(n, e);
    }
    t.length = z;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function fR(e, n, t) {
  return nt(e, e.attempt(this.parser.constructs.document, n, t), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Lv(e) {
  if (e === null || Zt(e) || cR(e))
    return 1;
  if (lR(e))
    return 2;
}
function Bp(e, n, t) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, t), i.push(o));
  }
  return n;
}
const Cm = {
  name: "attention",
  resolveAll: hR,
  tokenize: yR
};
function hR(e, n) {
  let t = -1, i, a, o, s, l, d, m, u;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (i = t; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[t][1].start
          };
          Vv(f, -d), Vv(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[t][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[t][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[t][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = ur(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = ur(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = ur(m, Bp(n.parser.constructs.insideSpan.null, e.slice(i + 1, t), n)), m = ur(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[t][1].end.offset - e[t][1].start.offset ? (u = 2, m = ur(m, [["enter", e[t][1], n], ["exit", e[t][1], n]])) : u = 0, Ar(e, i - 1, t - i + 3, m), t = i + m.length - u - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function yR(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, i = this.previous, a = Lv(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = Lv(d), f = !u || u === 2 && a || t.includes(d), h = !a || a === 2 && u || t.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function Vv(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const gR = {
  name: "autolink",
  tokenize: vR
};
function vR(e, n, t) {
  let i = 0;
  return a;
  function a(g) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(g) {
    return Tr(g) ? (e.consume(g), s) : g === 64 ? t(g) : m(g);
  }
  function s(g) {
    return g === 43 || g === 45 || g === 46 || sr(g) ? (i = 1, l(g)) : m(g);
  }
  function l(g) {
    return g === 58 ? (e.consume(g), i = 0, d) : (g === 43 || g === 45 || g === 46 || sr(g)) && i++ < 32 ? (e.consume(g), l) : (i = 0, m(g));
  }
  function d(g) {
    return g === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), n) : g === null || g === 32 || g === 60 || jm(g) ? t(g) : (e.consume(g), d);
  }
  function m(g) {
    return g === 64 ? (e.consume(g), u) : aR(g) ? (e.consume(g), m) : t(g);
  }
  function u(g) {
    return sr(g) ? f(g) : t(g);
  }
  function f(g) {
    return g === 46 ? (e.consume(g), i = 0, u) : g === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(g);
  }
  function h(g) {
    if ((g === 45 || sr(g)) && i++ < 63) {
      const C = g === 45 ? h : f;
      return e.consume(g), C;
    }
    return t(g);
  }
}
const cl = {
  partial: !0,
  tokenize: kR
};
function kR(e, n, t) {
  return i;
  function i(o) {
    return zn(o) ? nt(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || bn(o) ? n(o) : t(o);
  }
}
const U_ = {
  continuation: {
    tokenize: xR
  },
  exit: _R,
  name: "blockQuote",
  tokenize: bR
};
function bR(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return t(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function xR(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? nt(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(U_, n, t)(s);
  }
}
function _R(e) {
  e.exit("blockQuote");
}
const M_ = {
  name: "characterEscape",
  tokenize: SR
};
function SR(e, n, t) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return sR(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(o);
  }
}
const B_ = {
  name: "characterReference",
  tokenize: NR
};
function NR(e, n, t) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = sr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = oR, u) : (e.enter("characterReferenceValue"), o = 7, s = wm, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === sr && !Mp(i.sliceSerialize(h)) ? t(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : t(f);
  }
}
const zv = {
  partial: !0,
  tokenize: wR
}, Uv = {
  concrete: !0,
  name: "codeFenced",
  tokenize: jR
};
function jR(e, n, t) {
  const i = this, a = {
    partial: !0,
    tokenize: I
  };
  let o = 0, s = 0, l;
  return d;
  function d(T) {
    return m(T);
  }
  function m(T) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = T, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(T);
  }
  function u(T) {
    return T === l ? (s++, e.consume(T), u) : s < 3 ? t(T) : (e.exit("codeFencedFenceSequence"), zn(T) ? nt(e, f, "whitespace")(T) : f(T));
  }
  function f(T) {
    return T === null || bn(T) ? (e.exit("codeFencedFence"), i.interrupt ? n(T) : e.check(zv, S, $)(T)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(T));
  }
  function h(T) {
    return T === null || bn(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(T)) : zn(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), nt(e, g, "whitespace")(T)) : T === 96 && T === l ? t(T) : (e.consume(T), h);
  }
  function g(T) {
    return T === null || bn(T) ? f(T) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(T));
  }
  function C(T) {
    return T === null || bn(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(T)) : T === 96 && T === l ? t(T) : (e.consume(T), C);
  }
  function S(T) {
    return e.attempt(a, $, N)(T);
  }
  function N(T) {
    return e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), w;
  }
  function w(T) {
    return o > 0 && zn(T) ? nt(e, y, "linePrefix", o + 1)(T) : y(T);
  }
  function y(T) {
    return T === null || bn(T) ? e.check(zv, S, $)(T) : (e.enter("codeFlowValue"), z(T));
  }
  function z(T) {
    return T === null || bn(T) ? (e.exit("codeFlowValue"), y(T)) : (e.consume(T), z);
  }
  function $(T) {
    return e.exit("codeFenced"), n(T);
  }
  function I(T, U, Q) {
    let J = 0;
    return ie;
    function ie(ee) {
      return T.enter("lineEnding"), T.consume(ee), T.exit("lineEnding"), X;
    }
    function X(ee) {
      return T.enter("codeFencedFence"), zn(ee) ? nt(T, B, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : B(ee);
    }
    function B(ee) {
      return ee === l ? (T.enter("codeFencedFenceSequence"), O(ee)) : Q(ee);
    }
    function O(ee) {
      return ee === l ? (J++, T.consume(ee), O) : J >= s ? (T.exit("codeFencedFenceSequence"), zn(ee) ? nt(T, q, "whitespace")(ee) : q(ee)) : Q(ee);
    }
    function q(ee) {
      return ee === null || bn(ee) ? (T.exit("codeFencedFence"), U(ee)) : Q(ee);
    }
  }
}
function wR(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? t(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? t(s) : n(s);
  }
}
const ku = {
  name: "codeIndented",
  tokenize: FR
}, CR = {
  partial: !0,
  tokenize: IR
};
function FR(e, n, t) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), nt(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : t(m);
  }
  function s(m) {
    return m === null ? d(m) : bn(m) ? e.attempt(CR, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || bn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function IR(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? t(s) : bn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : nt(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : bn(s) ? a(s) : t(s);
  }
}
const ER = {
  name: "codeText",
  previous: $R,
  resolve: TR,
  tokenize: DR
};
function TR(e) {
  let n = e.length - 4, t = 3, i, a;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = t; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (i = t - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function $R(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function DR(e, n, t) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? t(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : bn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || bn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class RR {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, t) {
    const i = t ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, t, i) {
    const a = t || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && Ta(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Ta(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Ta(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const t = this.left.splice(n, Number.POSITIVE_INFINITY);
        Ta(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Ta(this.left, t.reverse());
      }
  }
}
function Ta(e, n) {
  let t = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; t < n.length; )
      e.push(...n.slice(t, t + 1e4)), t += 1e4;
}
function q_(e) {
  const n = {};
  let t = -1, i, a, o, s, l, d, m;
  const u = new RR(e);
  for (; ++t < u.length; ) {
    for (; t in n; )
      t = n[t];
    if (i = u.get(t), t && i[1].type === "chunkFlow" && u.get(t - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, OR(u, t)), t = n[t], m = !0);
    else if (i[1]._container) {
      for (o = t, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, t), l.unshift(i), u.splice(a, t - a + 1, l));
    }
  }
  return Ar(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function OR(e, n) {
  const t = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = t._tokenizer || i.parser[t.contentType](t.start), l = s.events, d = [], m = {};
  let u, f, h = -1, g = t, C = 0, S = 0;
  const N = [S];
  for (; g; ) {
    for (; e.get(++a)[1] !== g; )
      ;
    o.push(a), g._tokenizer || (u = i.sliceStream(g), g.next || u.push(null), f && s.defineSkip(g.start), g._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), g._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = g, g = g.next;
  }
  for (g = t; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (S = h + 1, N.push(S), g._tokenizer = void 0, g.previous = void 0, g = g.next);
  for (s.events = [], g ? (g._tokenizer = void 0, g.previous = void 0) : N.pop(), h = N.length; h--; ) {
    const w = l.slice(N[h], N[h + 1]), y = o.pop();
    d.push([y, y + w.length - 1]), e.splice(y, 2, w);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[C + d[h][0]] = C + d[h][1], C += d[h][1] - d[h][0] - 1;
  return m;
}
const PR = {
  resolve: LR,
  tokenize: VR
}, AR = {
  partial: !0,
  tokenize: zR
};
function LR(e) {
  return q_(e), e;
}
function VR(e, n) {
  let t;
  return i;
  function i(l) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : bn(l) ? e.check(AR, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, a;
  }
}
function zR(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), nt(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || bn(s))
      return t(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, t, n)(s);
  }
}
function H_(e, n, t, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(w) {
    return w === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(w), e.exit(o), h) : w === null || w === 32 || w === 41 || jm(w) ? t(w) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), S(w));
  }
  function h(w) {
    return w === 62 ? (e.enter(o), e.consume(w), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), g(w));
  }
  function g(w) {
    return w === 62 ? (e.exit("chunkString"), e.exit(l), h(w)) : w === null || w === 60 || bn(w) ? t(w) : (e.consume(w), w === 92 ? C : g);
  }
  function C(w) {
    return w === 60 || w === 62 || w === 92 ? (e.consume(w), g) : g(w);
  }
  function S(w) {
    return !u && (w === null || w === 41 || Zt(w)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(w)) : u < m && w === 40 ? (e.consume(w), u++, S) : w === 41 ? (e.consume(w), u--, S) : w === null || w === 32 || w === 40 || jm(w) ? t(w) : (e.consume(w), w === 92 ? N : S);
  }
  function N(w) {
    return w === 40 || w === 41 || w === 92 ? (e.consume(w), S) : S(w);
  }
}
function W_(e, n, t, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(g) {
    return e.enter(i), e.enter(a), e.consume(g), e.exit(a), e.enter(o), u;
  }
  function u(g) {
    return l > 999 || g === null || g === 91 || g === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    g === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? t(g) : g === 93 ? (e.exit(o), e.enter(a), e.consume(g), e.exit(a), e.exit(i), n) : bn(g) ? (e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(g));
  }
  function f(g) {
    return g === null || g === 91 || g === 93 || bn(g) || l++ > 999 ? (e.exit("chunkString"), u(g)) : (e.consume(g), d || (d = !zn(g)), g === 92 ? h : f);
  }
  function h(g) {
    return g === 91 || g === 92 || g === 93 ? (e.consume(g), l++, f) : f(g);
  }
}
function G_(e, n, t, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : t(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? t(h) : bn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), nt(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || bn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function ao(e, n) {
  let t;
  return i;
  function i(a) {
    return bn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t = !0, i) : zn(a) ? nt(e, i, t ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const UR = {
  name: "definition",
  tokenize: BR
}, MR = {
  partial: !0,
  tokenize: qR
};
function BR(e, n, t) {
  const i = this;
  let a;
  return o;
  function o(g) {
    return e.enter("definition"), s(g);
  }
  function s(g) {
    return W_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(g);
  }
  function l(g) {
    return a = na(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), g === 58 ? (e.enter("definitionMarker"), e.consume(g), e.exit("definitionMarker"), d) : t(g);
  }
  function d(g) {
    return Zt(g) ? ao(e, m)(g) : m(g);
  }
  function m(g) {
    return H_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(g);
  }
  function u(g) {
    return e.attempt(MR, f, f)(g);
  }
  function f(g) {
    return zn(g) ? nt(e, h, "whitespace")(g) : h(g);
  }
  function h(g) {
    return g === null || bn(g) ? (e.exit("definition"), i.parser.defined.push(a), n(g)) : t(g);
  }
}
function qR(e, n, t) {
  return i;
  function i(l) {
    return Zt(l) ? ao(e, a)(l) : t(l);
  }
  function a(l) {
    return G_(e, o, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? nt(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || bn(l) ? n(l) : t(l);
  }
}
const HR = {
  name: "hardBreakEscape",
  tokenize: WR
};
function WR(e, n, t) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return bn(o) ? (e.exit("hardBreakEscape"), n(o)) : t(o);
  }
}
const GR = {
  name: "headingAtx",
  resolve: KR,
  tokenize: YR
};
function KR(e, n) {
  let t = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), t - 2 > i && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (i === t - 1 || t - 4 > i && e[t - 2][1].type === "whitespace") && (t -= i + 1 === t ? 2 : 4), t > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[t][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, Ar(e, i, t - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function YR(e, n, t) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Zt(u) ? (e.exit("atxHeadingSequence"), l(u)) : t(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || bn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? nt(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Zt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const QR = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Mv = ["pre", "script", "style", "textarea"], JR = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: eO,
  tokenize: nO
}, XR = {
  partial: !0,
  tokenize: rO
}, ZR = {
  partial: !0,
  tokenize: tO
};
function eO(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function nO(e, n, t) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(K) {
    return u(K);
  }
  function u(K) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(K), f;
  }
  function f(K) {
    return K === 33 ? (e.consume(K), h) : K === 47 ? (e.consume(K), o = !0, S) : K === 63 ? (e.consume(K), a = 3, i.interrupt ? n : W) : Tr(K) ? (e.consume(K), s = String.fromCharCode(K), N) : t(K);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), a = 2, g) : K === 91 ? (e.consume(K), a = 5, l = 0, C) : Tr(K) ? (e.consume(K), a = 4, i.interrupt ? n : W) : t(K);
  }
  function g(K) {
    return K === 45 ? (e.consume(K), i.interrupt ? n : W) : t(K);
  }
  function C(K) {
    const qe = "CDATA[";
    return K === qe.charCodeAt(l++) ? (e.consume(K), l === qe.length ? i.interrupt ? n : B : C) : t(K);
  }
  function S(K) {
    return Tr(K) ? (e.consume(K), s = String.fromCharCode(K), N) : t(K);
  }
  function N(K) {
    if (K === null || K === 47 || K === 62 || Zt(K)) {
      const qe = K === 47, Be = s.toLowerCase();
      return !qe && !o && Mv.includes(Be) ? (a = 1, i.interrupt ? n(K) : B(K)) : QR.includes(s.toLowerCase()) ? (a = 6, qe ? (e.consume(K), w) : i.interrupt ? n(K) : B(K)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? t(K) : o ? y(K) : z(K));
    }
    return K === 45 || sr(K) ? (e.consume(K), s += String.fromCharCode(K), N) : t(K);
  }
  function w(K) {
    return K === 62 ? (e.consume(K), i.interrupt ? n : B) : t(K);
  }
  function y(K) {
    return zn(K) ? (e.consume(K), y) : ie(K);
  }
  function z(K) {
    return K === 47 ? (e.consume(K), ie) : K === 58 || K === 95 || Tr(K) ? (e.consume(K), $) : zn(K) ? (e.consume(K), z) : ie(K);
  }
  function $(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || sr(K) ? (e.consume(K), $) : I(K);
  }
  function I(K) {
    return K === 61 ? (e.consume(K), T) : zn(K) ? (e.consume(K), I) : z(K);
  }
  function T(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? t(K) : K === 34 || K === 39 ? (e.consume(K), d = K, U) : zn(K) ? (e.consume(K), T) : Q(K);
  }
  function U(K) {
    return K === d ? (e.consume(K), d = null, J) : K === null || bn(K) ? t(K) : (e.consume(K), U);
  }
  function Q(K) {
    return K === null || K === 34 || K === 39 || K === 47 || K === 60 || K === 61 || K === 62 || K === 96 || Zt(K) ? I(K) : (e.consume(K), Q);
  }
  function J(K) {
    return K === 47 || K === 62 || zn(K) ? z(K) : t(K);
  }
  function ie(K) {
    return K === 62 ? (e.consume(K), X) : t(K);
  }
  function X(K) {
    return K === null || bn(K) ? B(K) : zn(K) ? (e.consume(K), X) : t(K);
  }
  function B(K) {
    return K === 45 && a === 2 ? (e.consume(K), ve) : K === 60 && a === 1 ? (e.consume(K), ue) : K === 62 && a === 4 ? (e.consume(K), xe) : K === 63 && a === 3 ? (e.consume(K), W) : K === 93 && a === 5 ? (e.consume(K), fe) : bn(K) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(XR, Ie, O)(K)) : K === null || bn(K) ? (e.exit("htmlFlowData"), O(K)) : (e.consume(K), B);
  }
  function O(K) {
    return e.check(ZR, q, Ie)(K);
  }
  function q(K) {
    return e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), ee;
  }
  function ee(K) {
    return K === null || bn(K) ? O(K) : (e.enter("htmlFlowData"), B(K));
  }
  function ve(K) {
    return K === 45 ? (e.consume(K), W) : B(K);
  }
  function ue(K) {
    return K === 47 ? (e.consume(K), s = "", ce) : B(K);
  }
  function ce(K) {
    if (K === 62) {
      const qe = s.toLowerCase();
      return Mv.includes(qe) ? (e.consume(K), xe) : B(K);
    }
    return Tr(K) && s.length < 8 ? (e.consume(K), s += String.fromCharCode(K), ce) : B(K);
  }
  function fe(K) {
    return K === 93 ? (e.consume(K), W) : B(K);
  }
  function W(K) {
    return K === 62 ? (e.consume(K), xe) : K === 45 && a === 2 ? (e.consume(K), W) : B(K);
  }
  function xe(K) {
    return K === null || bn(K) ? (e.exit("htmlFlowData"), Ie(K)) : (e.consume(K), xe);
  }
  function Ie(K) {
    return e.exit("htmlFlow"), n(K);
  }
}
function tO(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return bn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : t(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? t(s) : n(s);
  }
}
function rO(e, n, t) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(cl, n, t);
  }
}
const iO = {
  name: "htmlText",
  tokenize: aO
};
function aO(e, n, t) {
  const i = this;
  let a, o, s;
  return l;
  function l(W) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(W), d;
  }
  function d(W) {
    return W === 33 ? (e.consume(W), m) : W === 47 ? (e.consume(W), I) : W === 63 ? (e.consume(W), z) : Tr(W) ? (e.consume(W), Q) : t(W);
  }
  function m(W) {
    return W === 45 ? (e.consume(W), u) : W === 91 ? (e.consume(W), o = 0, C) : Tr(W) ? (e.consume(W), y) : t(W);
  }
  function u(W) {
    return W === 45 ? (e.consume(W), g) : t(W);
  }
  function f(W) {
    return W === null ? t(W) : W === 45 ? (e.consume(W), h) : bn(W) ? (s = f, ue(W)) : (e.consume(W), f);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), g) : f(W);
  }
  function g(W) {
    return W === 62 ? ve(W) : W === 45 ? h(W) : f(W);
  }
  function C(W) {
    const xe = "CDATA[";
    return W === xe.charCodeAt(o++) ? (e.consume(W), o === xe.length ? S : C) : t(W);
  }
  function S(W) {
    return W === null ? t(W) : W === 93 ? (e.consume(W), N) : bn(W) ? (s = S, ue(W)) : (e.consume(W), S);
  }
  function N(W) {
    return W === 93 ? (e.consume(W), w) : S(W);
  }
  function w(W) {
    return W === 62 ? ve(W) : W === 93 ? (e.consume(W), w) : S(W);
  }
  function y(W) {
    return W === null || W === 62 ? ve(W) : bn(W) ? (s = y, ue(W)) : (e.consume(W), y);
  }
  function z(W) {
    return W === null ? t(W) : W === 63 ? (e.consume(W), $) : bn(W) ? (s = z, ue(W)) : (e.consume(W), z);
  }
  function $(W) {
    return W === 62 ? ve(W) : z(W);
  }
  function I(W) {
    return Tr(W) ? (e.consume(W), T) : t(W);
  }
  function T(W) {
    return W === 45 || sr(W) ? (e.consume(W), T) : U(W);
  }
  function U(W) {
    return bn(W) ? (s = U, ue(W)) : zn(W) ? (e.consume(W), U) : ve(W);
  }
  function Q(W) {
    return W === 45 || sr(W) ? (e.consume(W), Q) : W === 47 || W === 62 || Zt(W) ? J(W) : t(W);
  }
  function J(W) {
    return W === 47 ? (e.consume(W), ve) : W === 58 || W === 95 || Tr(W) ? (e.consume(W), ie) : bn(W) ? (s = J, ue(W)) : zn(W) ? (e.consume(W), J) : ve(W);
  }
  function ie(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || sr(W) ? (e.consume(W), ie) : X(W);
  }
  function X(W) {
    return W === 61 ? (e.consume(W), B) : bn(W) ? (s = X, ue(W)) : zn(W) ? (e.consume(W), X) : J(W);
  }
  function B(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? t(W) : W === 34 || W === 39 ? (e.consume(W), a = W, O) : bn(W) ? (s = B, ue(W)) : zn(W) ? (e.consume(W), B) : (e.consume(W), q);
  }
  function O(W) {
    return W === a ? (e.consume(W), a = void 0, ee) : W === null ? t(W) : bn(W) ? (s = O, ue(W)) : (e.consume(W), O);
  }
  function q(W) {
    return W === null || W === 34 || W === 39 || W === 60 || W === 61 || W === 96 ? t(W) : W === 47 || W === 62 || Zt(W) ? J(W) : (e.consume(W), q);
  }
  function ee(W) {
    return W === 47 || W === 62 || Zt(W) ? J(W) : t(W);
  }
  function ve(W) {
    return W === 62 ? (e.consume(W), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(W);
  }
  function ue(W) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), ce;
  }
  function ce(W) {
    return zn(W) ? nt(e, fe, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : fe(W);
  }
  function fe(W) {
    return e.enter("htmlTextData"), s(W);
  }
}
const qp = {
  name: "labelEnd",
  resolveAll: cO,
  resolveTo: dO,
  tokenize: uO
}, oO = {
  tokenize: mO
}, sO = {
  tokenize: pO
}, lO = {
  tokenize: fO
};
function cO(e) {
  let n = -1;
  const t = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (t.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== t.length && Ar(e, 0, e.length, t), e;
}
function dO(e, n) {
  let t = e.length, i = 0, a, o, s, l;
  for (; t--; )
    if (a = e[t][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[t][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[t][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = t, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = t);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = ur(l, e.slice(o + 1, o + i + 3)), l = ur(l, [["enter", u, n]]), l = ur(l, Bp(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = ur(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = ur(l, e.slice(s + 1)), l = ur(l, [["exit", d, n]]), Ar(e, o, e.length, l), e;
}
function uO(e, n, t) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(na(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : t(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(oO, u, s ? u : f)(h) : h === 91 ? e.attempt(sO, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(lO, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, t(h);
  }
}
function mO(e, n, t) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Zt(f) ? ao(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : H_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Zt(f) ? ao(e, d)(f) : u(f);
  }
  function l(f) {
    return t(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? G_(e, m, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Zt(f) ? ao(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : t(f);
  }
}
function pO(e, n, t) {
  const i = this;
  return a;
  function a(l) {
    return W_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(na(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : t(l);
  }
  function s(l) {
    return t(l);
  }
}
function fO(e, n, t) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : t(o);
  }
}
const hO = {
  name: "labelStartImage",
  resolveAll: qp.resolveAll,
  tokenize: yO
};
function yO(e, n, t) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : t(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(l) : n(l);
  }
}
const gO = {
  name: "labelStartLink",
  resolveAll: qp.resolveAll,
  tokenize: vO
};
function vO(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(s) : n(s);
  }
}
const bu = {
  name: "lineEnding",
  tokenize: kO
};
function kO(e, n) {
  return t;
  function t(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), nt(e, n, "linePrefix");
  }
}
const ks = {
  name: "thematicBreak",
  tokenize: bO
};
function bO(e, n, t) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || bn(m)) ? (e.exit("thematicBreak"), n(m)) : t(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? nt(e, l, "whitespace")(m) : l(m));
  }
}
const Yt = {
  continuation: {
    tokenize: NO
  },
  exit: wO,
  name: "list",
  tokenize: SO
}, xO = {
  partial: !0,
  tokenize: CO
}, _O = {
  partial: !0,
  tokenize: jO
};
function SO(e, n, t) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(g) {
    const C = i.containerState.type || (g === 42 || g === 43 || g === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !i.containerState.marker || g === i.containerState.marker : wm(g)) {
      if (i.containerState.type || (i.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), g === 42 || g === 45 ? e.check(ks, t, m)(g) : m(g);
      if (!i.interrupt || g === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(g);
    }
    return t(g);
  }
  function d(g) {
    return wm(g) && ++s < 10 ? (e.consume(g), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? g === i.containerState.marker : g === 41 || g === 46) ? (e.exit("listItemValue"), m(g)) : t(g);
  }
  function m(g) {
    return e.enter("listItemMarker"), e.consume(g), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || g, e.check(
      cl,
      // Can’t be empty when interrupting.
      i.interrupt ? t : u,
      e.attempt(xO, h, f)
    );
  }
  function u(g) {
    return i.containerState.initialBlankLine = !0, o++, h(g);
  }
  function f(g) {
    return zn(g) ? (e.enter("listItemPrefixWhitespace"), e.consume(g), e.exit("listItemPrefixWhitespace"), h) : t(g);
  }
  function h(g) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(g);
  }
}
function NO(e, n, t) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(cl, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, nt(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(_O, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, nt(e, e.attempt(Yt, n, t), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function jO(e, n, t) {
  const i = this;
  return nt(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : t(o);
  }
}
function wO(e) {
  e.exit(this.containerState.type);
}
function CO(e, n, t) {
  const i = this;
  return nt(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : t(o);
  }
}
const Bv = {
  name: "setextUnderline",
  resolveTo: FO,
  tokenize: IO
};
function FO(e, n) {
  let t = e.length, i, a, o;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        i = t;
        break;
      }
      e[t][1].type === "paragraph" && (a = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !o && e[t][1].type === "definition" && (o = t);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function IO(e, n, t) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : t(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? nt(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || bn(m) ? (e.exit("setextHeadingLine"), n(m)) : t(m);
  }
}
const EO = {
  tokenize: TO
};
function TO(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    cl,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, nt(e, e.attempt(this.parser.constructs.flow, a, e.attempt(PR, a)), "linePrefix"))
  );
  return t;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const $O = {
  resolveAll: Y_()
}, DO = K_("string"), RO = K_("text");
function K_(e) {
  return {
    resolveAll: Y_(e === "text" ? OO : void 0),
    tokenize: n
  };
  function n(t) {
    const i = this, a = this.parser.constructs[e], o = t.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        t.consume(u);
        return;
      }
      return t.enter("data"), t.consume(u), d;
    }
    function d(u) {
      return m(u) ? (t.exit("data"), o(u)) : (t.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const g = f[h];
          if (!g.previous || g.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Y_(e) {
  return n;
  function n(t, i) {
    let a = -1, o;
    for (; ++a <= t.length; )
      o === void 0 ? t[a] && t[a][1].type === "data" && (o = a, a++) : (!t[a] || t[a][1].type !== "data") && (a !== o + 2 && (t[o][1].end = t[a - 1][1].end, t.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(t, i) : t;
  }
}
function OO(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const i = e[t - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: t === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(t, 0, ["enter", m, n], ["exit", m, n]), t += 2);
      }
      t++;
    }
  return e;
}
const PO = {
  42: Yt,
  43: Yt,
  45: Yt,
  48: Yt,
  49: Yt,
  50: Yt,
  51: Yt,
  52: Yt,
  53: Yt,
  54: Yt,
  55: Yt,
  56: Yt,
  57: Yt,
  62: U_
}, AO = {
  91: UR
}, LO = {
  [-2]: ku,
  [-1]: ku,
  32: ku
}, VO = {
  35: GR,
  42: ks,
  45: [Bv, ks],
  60: JR,
  61: Bv,
  95: ks,
  96: Uv,
  126: Uv
}, zO = {
  38: B_,
  92: M_
}, UO = {
  [-5]: bu,
  [-4]: bu,
  [-3]: bu,
  33: hO,
  38: B_,
  42: Cm,
  60: [gR, iO],
  91: gO,
  92: [HR, M_],
  93: qp,
  95: Cm,
  96: ER
}, MO = {
  null: [Cm, $O]
}, BO = {
  null: [42, 95]
}, qO = {
  null: []
}, HO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: BO,
  contentInitial: AO,
  disable: qO,
  document: PO,
  flow: VO,
  flowInitial: LO,
  insideSpan: MO,
  string: zO,
  text: UO
}, Symbol.toStringTag, { value: "Module" }));
function WO(e, n, t) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: t && t.line || 1,
    column: t && t.column || 1,
    offset: t && t.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: U(I),
    check: U(T),
    consume: y,
    enter: z,
    exit: $,
    interrupt: U(T, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: S,
    events: [],
    now: C,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: g,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(X) {
    return s = ur(s, X), N(), s[s.length - 1] !== null ? [] : (Q(n, 0), m.events = Bp(o, m.events, m), m.events);
  }
  function h(X, B) {
    return KO(g(X), B);
  }
  function g(X) {
    return GO(s, X);
  }
  function C() {
    const {
      _bufferIndex: X,
      _index: B,
      line: O,
      column: q,
      offset: ee
    } = i;
    return {
      _bufferIndex: X,
      _index: B,
      line: O,
      column: q,
      offset: ee
    };
  }
  function S(X) {
    a[X.line] = X.column, ie();
  }
  function N() {
    let X;
    for (; i._index < s.length; ) {
      const B = s[i._index];
      if (typeof B == "string")
        for (X = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === X && i._bufferIndex < B.length; )
          w(B.charCodeAt(i._bufferIndex));
      else
        w(B);
    }
  }
  function w(X) {
    u = u(X);
  }
  function y(X) {
    bn(X) ? (i.line++, i.column = 1, i.offset += X === -3 ? 2 : 1, ie()) : X !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = X;
  }
  function z(X, B) {
    const O = B || {};
    return O.type = X, O.start = C(), m.events.push(["enter", O, m]), l.push(O), O;
  }
  function $(X) {
    const B = l.pop();
    return B.end = C(), m.events.push(["exit", B, m]), B;
  }
  function I(X, B) {
    Q(X, B.from);
  }
  function T(X, B) {
    B.restore();
  }
  function U(X, B) {
    return O;
    function O(q, ee, ve) {
      let ue, ce, fe, W;
      return Array.isArray(q) ? (
        /* c8 ignore next 1 */
        Ie(q)
      ) : "tokenize" in q ? (
        // Looks like a construct.
        Ie([
          /** @type {Construct} */
          q
        ])
      ) : xe(q);
      function xe(Oe) {
        return Me;
        function Me($e) {
          const ze = $e !== null && Oe[$e], Re = $e !== null && Oe.null, an = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ze) ? ze : ze ? [ze] : [],
            ...Array.isArray(Re) ? Re : Re ? [Re] : []
          ];
          return Ie(an)($e);
        }
      }
      function Ie(Oe) {
        return ue = Oe, ce = 0, Oe.length === 0 ? ve : K(Oe[ce]);
      }
      function K(Oe) {
        return Me;
        function Me($e) {
          return W = J(), fe = Oe, Oe.partial || (m.currentConstruct = Oe), Oe.name && m.parser.constructs.disable.null.includes(Oe.name) ? Be() : Oe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            B ? Object.assign(Object.create(m), B) : m,
            d,
            qe,
            Be
          )($e);
        }
      }
      function qe(Oe) {
        return X(fe, W), ee;
      }
      function Be(Oe) {
        return W.restore(), ++ce < ue.length ? K(ue[ce]) : ve;
      }
    }
  }
  function Q(X, B) {
    X.resolveAll && !o.includes(X) && o.push(X), X.resolve && Ar(m.events, B, m.events.length - B, X.resolve(m.events.slice(B), m)), X.resolveTo && (m.events = X.resolveTo(m.events, m));
  }
  function J() {
    const X = C(), B = m.previous, O = m.currentConstruct, q = m.events.length, ee = Array.from(l);
    return {
      from: q,
      restore: ve
    };
    function ve() {
      i = X, m.previous = B, m.currentConstruct = O, m.events.length = q, l = ee, ie();
    }
  }
  function ie() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function GO(e, n) {
  const t = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (t === a)
    s = [e[t].slice(i, o)];
  else {
    if (s = e.slice(t, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function KO(e, n) {
  let t = -1;
  const i = [];
  let a;
  for (; ++t < e.length; ) {
    const o = e[t];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function YO(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      tR([HO, ...(e || {}).extensions || []])
    ),
    content: a(dR),
    defined: [],
    document: a(mR),
    flow: a(EO),
    lazy: {},
    string: a(DO),
    text: a(RO)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return WO(i, o, l);
    }
  }
}
function QO(e) {
  for (; !q_(e); )
    ;
  return e;
}
const qv = /[\0\t\n\r]/g;
function JO() {
  let e = 1, n = "", t = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, g;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", t && (o.charCodeAt(0) === 65279 && f++, t = void 0); f < o.length; ) {
      if (qv.lastIndex = f, m = qv.exec(o), h = m && m.index !== void 0 ? m.index : o.length, g = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (g === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), g) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const XO = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function ZO(e) {
  return e.replace(XO, eP);
}
function eP(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const a = t.charCodeAt(1), o = a === 120 || a === 88;
    return z_(t.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Mp(t) || e;
}
const Q_ = {}.hasOwnProperty;
function nP(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), tP(t)(QO(YO(t).document().write(JO()(e, n, !0))));
}
function tP(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: J,
      autolinkEmail: J,
      atxHeading: o(he),
      blockQuote: o(Re),
      characterEscape: J,
      characterReference: J,
      codeFenced: o(an),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(an, s),
      codeText: o(Ee, s),
      codeTextData: J,
      data: J,
      codeFlowValue: J,
      definition: o(Ge),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Qe),
      hardBreakEscape: o(ge),
      hardBreakTrailing: o(ge),
      htmlFlow: o(De, s),
      htmlFlowData: J,
      htmlText: o(De, s),
      htmlTextData: J,
      image: o(Le),
      label: s,
      link: o(Pe),
      listItem: o(E),
      listItemValue: h,
      listOrdered: o(mn, f),
      listUnordered: o(mn),
      paragraph: o(x),
      reference: K,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(he),
      strong: o(D),
      thematicBreak: o(Y)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: I,
      autolink: d(),
      autolinkEmail: ze,
      autolinkProtocol: $e,
      blockQuote: d(),
      characterEscapeValue: ie,
      characterReferenceMarkerHexadecimal: Be,
      characterReferenceMarkerNumeric: Be,
      characterReferenceValue: Oe,
      characterReference: Me,
      codeFenced: d(N),
      codeFencedFence: S,
      codeFencedFenceInfo: g,
      codeFencedFenceMeta: C,
      codeFlowValue: ie,
      codeIndented: d(w),
      codeText: d(ee),
      codeTextData: ie,
      data: ie,
      definition: d(),
      definitionDestinationString: $,
      definitionLabelString: y,
      definitionTitleString: z,
      emphasis: d(),
      hardBreakEscape: d(B),
      hardBreakTrailing: d(B),
      htmlFlow: d(O),
      htmlFlowData: ie,
      htmlText: d(q),
      htmlTextData: ie,
      image: d(ue),
      label: fe,
      labelText: ce,
      lineEnding: X,
      link: d(ve),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: qe,
      resourceDestinationString: W,
      resourceTitleString: xe,
      resource: Ie,
      setextHeading: d(Q),
      setextHeadingLineSequence: U,
      setextHeadingText: T,
      strong: d(),
      thematicBreak: d()
    }
  };
  J_(n, (e || {}).mdastExtensions || []);
  const t = {};
  return i;
  function i(R) {
    let V = {
      type: "root",
      children: []
    };
    const ae = {
      stack: [V],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: t
    }, me = [];
    let Ne = -1;
    for (; ++Ne < R.length; )
      if (R[Ne][1].type === "listOrdered" || R[Ne][1].type === "listUnordered")
        if (R[Ne][0] === "enter")
          me.push(Ne);
        else {
          const nn = me.pop();
          Ne = a(R, nn, Ne);
        }
    for (Ne = -1; ++Ne < R.length; ) {
      const nn = n[R[Ne][0]];
      Q_.call(nn, R[Ne][1].type) && nn[R[Ne][1].type].call(Object.assign({
        sliceSerialize: R[Ne][2].sliceSerialize
      }, ae), R[Ne][1]);
    }
    if (ae.tokenStack.length > 0) {
      const nn = ae.tokenStack[ae.tokenStack.length - 1];
      (nn[1] || Hv).call(ae, void 0, nn[0]);
    }
    for (V.position = {
      start: Xr(R.length > 0 ? R[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Xr(R.length > 0 ? R[R.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Ne = -1; ++Ne < n.transforms.length; )
      V = n.transforms[Ne](V) || V;
    return V;
  }
  function a(R, V, ae) {
    let me = V - 1, Ne = -1, nn = !1, fn, tn, cn, pn;
    for (; ++me <= ae; ) {
      const dn = R[me];
      switch (dn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          dn[0] === "enter" ? Ne++ : Ne--, pn = void 0;
          break;
        }
        case "lineEndingBlank": {
          dn[0] === "enter" && (fn && !pn && !Ne && !cn && (cn = me), pn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          pn = void 0;
      }
      if (!Ne && dn[0] === "enter" && dn[1].type === "listItemPrefix" || Ne === -1 && dn[0] === "exit" && (dn[1].type === "listUnordered" || dn[1].type === "listOrdered")) {
        if (fn) {
          let xn = me;
          for (tn = void 0; xn--; ) {
            const en = R[xn];
            if (en[1].type === "lineEnding" || en[1].type === "lineEndingBlank") {
              if (en[0] === "exit") continue;
              tn && (R[tn][1].type = "lineEndingBlank", nn = !0), en[1].type = "lineEnding", tn = xn;
            } else if (!(en[1].type === "linePrefix" || en[1].type === "blockQuotePrefix" || en[1].type === "blockQuotePrefixWhitespace" || en[1].type === "blockQuoteMarker" || en[1].type === "listItemIndent")) break;
          }
          cn && (!tn || cn < tn) && (fn._spread = !0), fn.end = Object.assign({}, tn ? R[tn][1].start : dn[1].end), R.splice(tn || me, 0, ["exit", fn, dn[2]]), me++, ae++;
        }
        if (dn[1].type === "listItemPrefix") {
          const xn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, dn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          fn = xn, R.splice(me, 0, ["enter", xn, dn[2]]), me++, ae++, cn = void 0, pn = !0;
        }
      }
    }
    return R[V][1]._spread = nn, ae;
  }
  function o(R, V) {
    return ae;
    function ae(me) {
      l.call(this, R(me), me), V && V.call(this, me);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(R, V, ae) {
    this.stack[this.stack.length - 1].children.push(R), this.stack.push(R), this.tokenStack.push([V, ae || void 0]), R.position = {
      start: Xr(V.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(R) {
    return V;
    function V(ae) {
      R && R.call(this, ae), m.call(this, ae);
    }
  }
  function m(R, V) {
    const ae = this.stack.pop(), me = this.tokenStack.pop();
    if (me)
      me[0].type !== R.type && (V ? V.call(this, R, me[0]) : (me[1] || Hv).call(this, R, me[0]));
    else throw new Error("Cannot close `" + R.type + "` (" + io({
      start: R.start,
      end: R.end
    }) + "): it’s not open");
    ae.position.end = Xr(R.end);
  }
  function u() {
    return eR(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(R) {
    if (this.data.expectingFirstListItemValue) {
      const V = this.stack[this.stack.length - 2];
      V.start = Number.parseInt(this.sliceSerialize(R), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function g() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.lang = R;
  }
  function C() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.meta = R;
  }
  function S() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function N() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R.replace(/(\r?\n|\r)$/g, "");
  }
  function y(R) {
    const V = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.label = V, ae.identifier = na(this.sliceSerialize(R)).toLowerCase();
  }
  function z() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.title = R;
  }
  function $() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.url = R;
  }
  function I(R) {
    const V = this.stack[this.stack.length - 1];
    if (!V.depth) {
      const ae = this.sliceSerialize(R).length;
      V.depth = ae;
    }
  }
  function T() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(R) {
    const V = this.stack[this.stack.length - 1];
    V.depth = this.sliceSerialize(R).codePointAt(0) === 61 ? 1 : 2;
  }
  function Q() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function J(R) {
    const ae = this.stack[this.stack.length - 1].children;
    let me = ae[ae.length - 1];
    (!me || me.type !== "text") && (me = H(), me.position = {
      start: Xr(R.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ae.push(me)), this.stack.push(me);
  }
  function ie(R) {
    const V = this.stack.pop();
    V.value += this.sliceSerialize(R), V.position.end = Xr(R.end);
  }
  function X(R) {
    const V = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ae = V.children[V.children.length - 1];
      ae.position.end = Xr(R.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(V.type) && (J.call(this, R), ie.call(this, R));
  }
  function B() {
    this.data.atHardBreak = !0;
  }
  function O() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R;
  }
  function q() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R;
  }
  function ee() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R;
  }
  function ve() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const V = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = V, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function ue() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const V = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = V, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function ce(R) {
    const V = this.sliceSerialize(R), ae = this.stack[this.stack.length - 2];
    ae.label = ZO(V), ae.identifier = na(V).toLowerCase();
  }
  function fe() {
    const R = this.stack[this.stack.length - 1], V = this.resume(), ae = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ae.type === "link") {
      const me = R.children;
      ae.children = me;
    } else
      ae.alt = V;
  }
  function W() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.url = R;
  }
  function xe() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.title = R;
  }
  function Ie() {
    this.data.inReference = void 0;
  }
  function K() {
    this.data.referenceType = "collapsed";
  }
  function qe(R) {
    const V = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.label = V, ae.identifier = na(this.sliceSerialize(R)).toLowerCase(), this.data.referenceType = "full";
  }
  function Be(R) {
    this.data.characterReferenceType = R.type;
  }
  function Oe(R) {
    const V = this.sliceSerialize(R), ae = this.data.characterReferenceType;
    let me;
    ae ? (me = z_(V, ae === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : me = Mp(V);
    const Ne = this.stack[this.stack.length - 1];
    Ne.value += me;
  }
  function Me(R) {
    const V = this.stack.pop();
    V.position.end = Xr(R.end);
  }
  function $e(R) {
    ie.call(this, R);
    const V = this.stack[this.stack.length - 1];
    V.url = this.sliceSerialize(R);
  }
  function ze(R) {
    ie.call(this, R);
    const V = this.stack[this.stack.length - 1];
    V.url = "mailto:" + this.sliceSerialize(R);
  }
  function Re() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function an() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ee() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ge() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Qe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function he() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ge() {
    return {
      type: "break"
    };
  }
  function De() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function mn(R) {
    return {
      type: "list",
      ordered: R.type === "listOrdered",
      start: null,
      spread: R._spread,
      children: []
    };
  }
  function E(R) {
    return {
      type: "listItem",
      spread: R._spread,
      checked: null,
      children: []
    };
  }
  function x() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function D() {
    return {
      type: "strong",
      children: []
    };
  }
  function H() {
    return {
      type: "text",
      value: ""
    };
  }
  function Y() {
    return {
      type: "thematicBreak"
    };
  }
}
function Xr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function J_(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const i = n[t];
    Array.isArray(i) ? J_(e, i) : rP(e, i);
  }
}
function rP(e, n) {
  let t;
  for (t in n)
    if (Q_.call(n, t))
      switch (t) {
        case "canContainEols": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "transforms": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[t];
          i && Object.assign(e[t], i);
          break;
        }
      }
}
function Hv(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + io({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + io({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + io({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function iP(e) {
  const n = this;
  n.parser = t;
  function t(i) {
    return nP(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function aP(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function oP(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function sP(e, n) {
  const t = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function lP(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function cP(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function dP(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = ha(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + a,
      id: t + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function uP(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function mP(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function X_(e, n) {
  const t = n.referenceType;
  let i = "]";
  if (t === "collapsed" ? i += "[]" : t === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function pP(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return X_(e, n);
  const a = { src: ha(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function fP(e, n) {
  const t = { src: ha(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function hP(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function yP(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return X_(e, n);
  const a = { href: ha(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function gP(e, n) {
  const t = { href: ha(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function vP(e, n, t) {
  const i = e.all(n), a = t ? kP(t) : Z_(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function kP(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let i = -1;
    for (; !n && ++i < t.length; )
      n = Z_(t[i]);
  }
  return n;
}
function Z_(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function bP(e, n) {
  const t = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function xP(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function _P(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function SP(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function NP(e, n) {
  const t = e.all(n), i = t.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (t.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, l = Lp(n.children[1]), d = D_(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function jP(e, n, t) {
  const i = t ? t.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = t && t.type === "table" ? t.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, g = s ? s[d] : void 0;
    g && (h.align = g);
    let C = { type: "element", tagName: o, properties: h, children: [] };
    f && (C.children = e.all(f), e.patch(f, C), C = e.applyData(f, C)), m.push(C);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function wP(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const Wv = 9, Gv = 32;
function CP(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let i = t.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Kv(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = t.exec(n);
  return o.push(Kv(n.slice(a), a > 0, !1)), o.join("");
}
function Kv(e, n, t) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Wv || o === Gv; )
      i++, o = e.codePointAt(i);
  }
  if (t) {
    let o = e.codePointAt(a - 1);
    for (; o === Wv || o === Gv; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function FP(e, n) {
  const t = { type: "text", value: CP(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function IP(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const EP = {
  blockquote: aP,
  break: oP,
  code: sP,
  delete: lP,
  emphasis: cP,
  footnoteReference: dP,
  heading: uP,
  html: mP,
  imageReference: pP,
  image: fP,
  inlineCode: hP,
  linkReference: yP,
  link: gP,
  listItem: vP,
  list: bP,
  paragraph: xP,
  // @ts-expect-error: root is different, but hard to type.
  root: _P,
  strong: SP,
  table: NP,
  tableCell: wP,
  tableRow: jP,
  text: FP,
  thematicBreak: IP,
  toml: Mo,
  yaml: Mo,
  definition: Mo,
  footnoteDefinition: Mo
};
function Mo() {
}
const eS = -1, dl = 0, Ds = 1, Rs = 2, Hp = 3, Wp = 4, Gp = 5, Kp = 6, nS = 7, tS = 8, Yv = typeof self == "object" ? self : globalThis, TP = (e, n) => {
  const t = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case dl:
      case eS:
        return t(s, a);
      case Ds: {
        const l = t([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case Rs: {
        const l = t({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case Hp:
        return t(new Date(s), a);
      case Wp: {
        const { source: l, flags: d } = s;
        return t(new RegExp(l, d), a);
      }
      case Gp: {
        const l = t(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case Kp: {
        const l = t(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case nS: {
        const { name: l, message: d } = s;
        return t(new Yv[l](d), a);
      }
      case tS:
        return t(BigInt(s), a);
      case "BigInt":
        return t(Object(BigInt(s)), a);
    }
    return t(new Yv[o](s), a);
  };
  return i;
}, Qv = (e) => TP(/* @__PURE__ */ new Map(), e)(0), zi = "", { toString: $P } = {}, { keys: DP } = Object, $a = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [dl, n];
  const t = $P.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [Ds, zi];
    case "Object":
      return [Rs, zi];
    case "Date":
      return [Hp, zi];
    case "RegExp":
      return [Wp, zi];
    case "Map":
      return [Gp, zi];
    case "Set":
      return [Kp, zi];
  }
  return t.includes("Array") ? [Ds, t] : t.includes("Error") ? [nS, t] : [Rs, t];
}, Bo = ([e, n]) => e === dl && (n === "function" || n === "symbol"), RP = (e, n, t, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return t.set(l, d), d;
  }, o = (s) => {
    if (t.has(s))
      return t.get(s);
    let [l, d] = $a(s);
    switch (l) {
      case dl: {
        let u = s;
        switch (d) {
          case "bigint":
            l = tS, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([eS], s);
        }
        return a([l, u], s);
      }
      case Ds: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case Rs: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of DP(s))
          (e || !Bo($a(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case Hp:
        return a([l, s.toISOString()], s);
      case Wp: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case Gp: {
        const u = [], f = a([l, u], s);
        for (const [h, g] of s)
          (e || !(Bo($a(h)) || Bo($a(g)))) && u.push([o(h), o(g)]);
        return f;
      }
      case Kp: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !Bo($a(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Jv = (e, { json: n, lossy: t } = {}) => {
  const i = [];
  return RP(!(n || t), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, Os = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Qv(Jv(e, n)) : structuredClone(e)
) : (e, n) => Qv(Jv(e, n));
function OP(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function PP(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function AP(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || OP, i = e.options.footnoteBackLabel || PP, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = ha(f.toLowerCase());
    let g = 0;
    const C = [], S = e.footnoteCounts.get(f);
    for (; S !== void 0 && ++g <= S; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let y = typeof t == "string" ? t : t(d, g);
      typeof y == "string" && (y = { type: "text", value: y }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (g > 1 ? "-" + g : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, g),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const N = u[u.length - 1];
    if (N && N.type === "element" && N.tagName === "p") {
      const y = N.children[N.children.length - 1];
      y && y.type === "text" ? y.value += " " : N.children.push({ type: "text", value: " " }), N.children.push(...C);
    } else
      u.push(...C);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, w), l.push(w);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...Os(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const rS = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return UP;
    if (typeof e == "function")
      return ul(e);
    if (typeof e == "object")
      return Array.isArray(e) ? LP(e) : VP(e);
    if (typeof e == "string")
      return zP(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function LP(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = rS(e[t]);
  return ul(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function VP(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return ul(t);
  function t(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function zP(e) {
  return ul(n);
  function n(t) {
    return t && t.type === e;
  }
}
function ul(e) {
  return n;
  function n(t, i, a) {
    return !!(MP(t) && e.call(
      this,
      t,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function UP() {
  return !0;
}
function MP(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const iS = [], BP = !0, Xv = !1, qP = "skip";
function HP(e, n, t, i) {
  let a;
  typeof n == "function" && typeof t != "function" ? (i = t, t = n) : a = n;
  const o = rS(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const g = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (g ? "<" + g + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let g = iS, C, S, N;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (g = WP(t(d, u)), g[0] === Xv))
        return g;
      if ("children" in d && d.children) {
        const w = (
          /** @type {UnistParent} */
          d
        );
        if (w.children && g[0] !== qP)
          for (S = (i ? w.children.length : -1) + s, N = u.concat(w); S > -1 && S < w.children.length; ) {
            const y = w.children[S];
            if (C = l(y, S, N)(), C[0] === Xv)
              return C;
            S = typeof C[1] == "number" ? C[1] : S + s;
          }
      }
      return g;
    }
  }
}
function WP(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [BP, e] : e == null ? iS : [e];
}
function aS(e, n, t, i) {
  let a, o, s;
  typeof n == "function" && typeof t != "function" ? (o = void 0, s = n, a = t) : (o = n, s = t, a = i), HP(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const Fm = {}.hasOwnProperty, GP = {};
function KP(e, n) {
  const t = n || GP, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...EP, ...t.handlers }, l = {
    all: m,
    applyData: QP,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: t,
    patch: YP,
    wrap: XP
  };
  return aS(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, g = l.handlers[h];
    if (Fm.call(l.handlers, h) && g)
      return g(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: S, ...N } = u, w = Os(N);
        return w.children = l.all(u), w;
      }
      return Os(u);
    }
    return (l.options.unknownHandler || JP)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let g = -1;
      for (; ++g < h.length; ) {
        const C = l.one(h[g], u);
        if (C) {
          if (g && h[g - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = Zv(C.value)), !Array.isArray(C) && C.type === "element")) {
            const S = C.children[0];
            S && S.type === "text" && (S.value = Zv(S.value));
          }
          Array.isArray(C) ? f.push(...C) : f.push(C);
        }
      }
    }
    return f;
  }
}
function YP(e, n) {
  e.position && (n.position = ED(e));
}
function QP(e, n) {
  let t = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (t.type === "element")
        t.tagName = i;
      else {
        const s = "children" in t ? t.children : [t];
        t = { type: "element", tagName: i, properties: {}, children: s };
      }
    t.type === "element" && o && Object.assign(t.properties, Os(o)), "children" in t && t.children && a !== null && a !== void 0 && (t.children = a);
  }
  return t;
}
function JP(e, n) {
  const t = n.data || {}, i = "value" in n && !(Fm.call(t, "hProperties") || Fm.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function XP(e, n) {
  const t = [];
  let i = -1;
  for (n && t.push({ type: "text", value: `
` }); ++i < e.length; )
    i && t.push({ type: "text", value: `
` }), t.push(e[i]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function Zv(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function ek(e, n) {
  const t = KP(e, n), i = t.one(e, void 0), a = AP(t), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function ZP(e, n) {
  return e && "run" in e ? async function(t, i) {
    const a = (
      /** @type {HastRoot} */
      ek(t, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(t, i) {
    return (
      /** @type {HastRoot} */
      ek(t, { file: i, ...e || n })
    );
  };
}
function nk(e) {
  if (e)
    throw e;
}
var xu, tk;
function eA() {
  if (tk) return xu;
  tk = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, t = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    t && u.name === "__proto__" ? t(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return xu = function d() {
    var m, u, f, h, g, C, S = arguments[0], N = 1, w = arguments.length, y = !1;
    for (typeof S == "boolean" && (y = S, S = arguments[1] || {}, N = 2), (S == null || typeof S != "object" && typeof S != "function") && (S = {}); N < w; ++N)
      if (m = arguments[N], m != null)
        for (u in m)
          f = l(S, u), h = l(m, u), S !== h && (y && h && (o(h) || (g = a(h))) ? (g ? (g = !1, C = f && a(f) ? f : []) : C = f && o(f) ? f : {}, s(S, { name: u, newValue: d(y, C, h) })) : typeof h < "u" && s(S, { name: u, newValue: h }));
    return S;
  }, xu;
}
var nA = eA();
const _u = /* @__PURE__ */ ep(nA);
function Im(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function tA() {
  const e = [], n = { run: t, use: i };
  return n;
  function t(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? rA(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function rA(e, n) {
  let t;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && t)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    t || (t = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Ir = { basename: iA, dirname: aA, extname: oA, join: sA, sep: "/" };
function iA(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  Fo(e);
  let t = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          t = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(t, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        t = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return t === i ? i = s : i < 0 && (i = e.length), e.slice(t, i);
}
function aA(e) {
  if (Fo(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, i;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (i) {
        n = t;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function oA(e) {
  Fo(e);
  let n = e.length, t = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (s = !0, t = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === t - 1 && a === i + 1 ? "" : e.slice(a, t);
}
function sA(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    Fo(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : lA(t);
}
function lA(e) {
  Fo(e);
  const n = e.codePointAt(0) === 47;
  let t = cA(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function cA(e, n) {
  let t = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (t.length < 2 || i !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (d = t.lastIndexOf("/"), d !== t.length - 1) {
              d < 0 ? (t = "", i = 0) : (t = t.slice(0, d), i = t.length - 1 - t.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", i = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(a + 1, s) : t = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return t;
}
function Fo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const dA = { cwd: uA };
function uA() {
  return "/";
}
function Em(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function mA(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Em(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return pA(e);
}
function pA(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const i = n.codePointAt(t + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const Su = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class oS {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? Em(n) ? t = { path: n } : typeof n == "string" || fA(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : dA.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < Su.length; ) {
      const o = Su[i];
      o in t && t[o] !== void 0 && t[o] !== null && (this[o] = o === "history" ? [...t[o]] : t[o]);
    }
    let a;
    for (a in t)
      Su.includes(a) || (this[a] = t[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Ir.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    ju(n, "basename"), Nu(n, "basename"), this.path = Ir.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Ir.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    rk(this.basename, "dirname"), this.path = Ir.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Ir.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Nu(n, "extname"), rk(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ir.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Em(n) && (n = mA(n)), ju(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Ir.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    ju(n, "stem"), Nu(n, "stem"), this.path = Ir.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, i) {
    const a = this.message(n, t, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, i) {
    const a = this.message(n, t, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, i) {
    const a = new At(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Nu(e, n) {
  if (e && e.includes(Ir.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Ir.sep + "`"
    );
}
function ju(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function rk(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function fA(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const hA = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), yA = {}.hasOwnProperty;
class Yp extends hA {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = tA();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Yp()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const i = this.attachers[t];
      n.use(...i);
    }
    return n.data(_u(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (Fu("data", this.frozen), this.namespace[n] = t, this) : yA.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Fu("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = t.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = qo(n), i = this.parser || this.Parser;
    return wu("parse", i), i(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const i = this;
    return this.freeze(), wu("process", this.parser || this.Parser), Cu("process", this.compiler || this.Compiler), t ? a(void 0, t) : new Promise(a);
    function a(o, s) {
      const l = qo(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const g = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), C = i.stringify(g, h);
        kA(C) ? h.value = C : h.result = C, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : t(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, i;
    return this.freeze(), wu("processSync", this.parser || this.Parser), Cu("processSync", this.compiler || this.Compiler), this.process(n, a), ak("processSync", "process", t), i;
    function a(o, s) {
      t = !0, nk(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, i) {
    ik(n), this.freeze();
    const a = this.transformers;
    return !i && typeof t == "function" && (i = t, t = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = qo(t);
      a.run(n, d, m);
      function m(u, f, h) {
        const g = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(g) : i(void 0, g, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let i = !1, a;
    return this.run(n, t, o), ak("runSync", "run", i), a;
    function o(s, l) {
      nk(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const i = qo(t), a = this.compiler || this.Compiler;
    return Cu("stringify", a), ik(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const i = this.attachers, a = this.namespace;
    if (Fu("use", this.frozen), n != null) if (typeof n == "function")
      d(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = _u(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [g, ...C] = u;
        const S = i[h][1];
        Im(S) && Im(g) && (g = _u(!0, S, g)), i[h] = [m, g, ...C];
      }
    }
  }
}
const gA = new Yp().freeze();
function wu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Cu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Fu(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function ik(e) {
  if (!Im(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function ak(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function qo(e) {
  return vA(e) ? e : new oS(e);
}
function vA(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function kA(e) {
  return typeof e == "string" || bA(e);
}
function bA(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const xA = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", ok = [], sk = { allowDangerousHtml: !0 }, _A = /^(https?|ircs?|mailto|xmpp)$/i, SA = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function NA(e) {
  const n = e.allowedElements, t = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || ok, d = e.remarkPlugins || ok, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...sk } : sk, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || jA, g = gA().use(iP).use(d).use(ZP, m).use(l), C = new oS();
  typeof i == "string" && (C.value = i);
  for (const y of SA)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + xA + y.id, void 0);
  const S = g.parse(C);
  let N = g.runSync(S, C);
  return a && (N = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      N.type === "root" ? N.children : [N]
    )
  }), aS(N, w), PD(N, {
    Fragment: Ve.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ve.jsx,
    jsxs: Ve.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function w(y, z, $) {
    if (y.type === "raw" && $ && typeof z == "number")
      return u ? $.children.splice(z, 1) : $.children[z] = { type: "text", value: y.value }, z;
    if (y.type === "element") {
      let I;
      for (I in vu)
        if (Object.hasOwn(vu, I) && Object.hasOwn(y.properties, I)) {
          const T = y.properties[I], U = vu[I];
          (U === null || U.includes(y.tagName)) && (y.properties[I] = h(String(T || ""), I, y));
        }
    }
    if (y.type === "element") {
      let I = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!I && t && typeof z == "number" && (I = !t(y, z, $)), I && $ && typeof z == "number")
        return f && y.children ? $.children.splice(z, 1, ...y.children) : $.children.splice(z, 1), z;
    }
  }
}
function jA(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || t > -1 && n > t || i > -1 && n > i || // It is a protocol, it should be allowed.
    _A.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Iu = { exports: {} }, Da = {}, lk;
function wA() {
  if (lk) return Da;
  lk = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Da.Fragment = t, Da.jsx = s, Da.jsxs = s, Da;
}
var Ho = {}, ck;
function CA() {
  return ck || (ck = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ho.Fragment = i, Ho.jsx = Rn, Ho.jsxs = Mn;
  })()), Ho;
}
var dk;
function FA() {
  return dk || (dk = 1, process.env.NODE_ENV === "production" ? Iu.exports = wA() : Iu.exports = CA()), Iu.exports;
}
var re = FA();
const IA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, EA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, TA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, $A = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, DA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, RA = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": IA,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": EA,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": TA,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": $A,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": DA
};
function Io(e) {
  return RA[e] ?? {};
}
const OA = Io(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), PA = Io(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), Wo = ({
  title: e,
  children: n
}) => /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), AA = "_issueAvatar_kc0sw_1", LA = "_issueField_kc0sw_9", VA = "_issueDescription_kc0sw_12", Go = {
  issueAvatar: AA,
  issueField: LA,
  issueDescription: VA
}, sS = ({ issue: e }) => /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
  /* @__PURE__ */ re.jsx(Wo, { title: "Assignee", children: /* @__PURE__ */ re.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Go.issueAvatar,
      children: [
        /* @__PURE__ */ re.jsx(
          Xm,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ re.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ re.jsx(Wo, { title: "Team", children: /* @__PURE__ */ re.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Go.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ re.jsx(Wo, { title: "Project", children: /* @__PURE__ */ re.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Go.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ re.jsx(Wo, { title: "Description", children: /* @__PURE__ */ re.jsx(NA, { className: Go.issueDescription, children: e.description }) })
] }), zA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), UA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), MA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), BA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), qA = /* @__PURE__ */ re.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), lS = {
  0: zA,
  1: qA,
  2: BA,
  3: MA,
  4: UA
}, HA = (e) => e in lS, Ps = ({ priority: e }) => HA(e) ? lS[e] : /* @__PURE__ */ re.jsx(An, { "data-testid": "defaultPriorityTag", children: e }), WA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), GA = (e, n) => /* @__PURE__ */ re.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ re.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ re.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), KA = (e, n) => /* @__PURE__ */ re.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ re.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ re.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), YA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), QA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), JA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Tm = {
  backlog: (e, n) => WA(e, n),
  unstarted: (e, n) => GA(e, n),
  started: (e, n) => KA(e, n),
  done: (e, n) => YA(e, n),
  canceled: (e, n) => QA(e, n),
  completed: (e, n) => JA(e, n)
}, XA = (e) => e in Tm, As = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: t = "linear-backlog-icon"
}) => XA(e) ? Tm[e](n, t) : Tm.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), ZA = "_wrapper_e0qj3_1", e2 = "_resultTitle_e0qj3_21", n2 = "_resultTooltipTitle_e0qj3_28", t2 = "_resultLinkIcon_e0qj3_31", Ra = {
  wrapper: ZA,
  resultTitle: e2,
  resultTooltipTitle: n2,
  resultLinkIcon: t2
}, r2 = ({
  issue: e
}) => {
  const [n, t] = le(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Qm(D0()), o = ot(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ re.jsx(
    We,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", className: Ra.wrapper, children: [
        /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ re.jsx(
              As,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ re.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ re.jsx(Ps, { priority: e.priority })
          ] }),
          /* @__PURE__ */ re.jsx(An, { children: e.state.name })
        ] }),
        /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ re.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: Ra.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ re.jsx(sS, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ re.jsx(
        ut.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: Ra.result,
          onMouseEnter: () => t(!0),
          onMouseLeave: () => t(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ re.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ re.jsx(
                    As,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ re.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ re.jsx(Ps, { priority: e.priority })
                ] }),
                /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "4", className: Ra.resultTitle, children: e.title }),
                n && /* @__PURE__ */ re.jsx(
                  pe,
                  {
                    className: Ra.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, i2 = "_loader_13xpk_1", a2 = "_dropdown_13xpk_8", o2 = "_loadMore_13xpk_13", Eu = {
  loader: i2,
  dropdown: a2,
  loadMore: o2
}, s2 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [t, i] = le(), [a, o] = le([]), [s, l] = le(""), [d, m] = le(!1), { useLazyQuery: u } = hn(), [f, { data: h, loading: g, networkStatus: C }] = u(
    OA,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Ti(
    () => {
      !g && s !== "" && C === er.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), He(() => {
    g || o([]);
  }, [s]), He(() => {
    if (h && Object.keys(h).length > 0) {
      const N = h.Linear.searchIssues.edges.map(
        ({ node: $ }) => $
      ), w = a.filter(
        ($) => !n.find((I) => I.id === $.id)
      ), y = w.filter(
        ($) => !N.find(
          (I) => I.id === $.id
        )
      ), z = N.filter(
        ($) => !n.find((I) => I.id === $.id)
      );
      n.length > 0 ? o(
        d ? [...y, ...z] : z
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...w, ...N] : N
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const S = () => {
    !g && s !== "" && C === er.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: t?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ re.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ re.jsxs(
    ei,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (N) => N?.title,
      onChange: (N) => e(N.selectedValues[0]),
      dropdownProps: { className: Eu.dropdown },
      filter: {
        value: s,
        onChange: (N) => {
          const w = N.target.value;
          l(w);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((N) => /* @__PURE__ */ re.jsx(r2, { issue: N }, N.id)),
        t?.hasNextPage && !g && s !== "" && a.length && /* @__PURE__ */ re.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => S(),
            className: Eu.loadMore,
            children: /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        g && s !== "" && /* @__PURE__ */ re.jsx(b, { justifyContent: "center", className: Eu.loader, children: /* @__PURE__ */ re.jsx(un, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !g && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, l2 = "_collapse_su0f9_1", c2 = "_collapseHeader_su0f9_8", d2 = "_collapseContent_su0f9_31", u2 = "_url_su0f9_35", m2 = "_externalLink_su0f9_51", p2 = "_emptyState_su0f9_55", Zr = {
  collapse: l2,
  collapseHeader: c2,
  collapseContent: d2,
  url: u2,
  externalLink: m2,
  emptyState: p2
}, f2 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: t,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = le(s), { track: m } = _n();
  return n ? /* @__PURE__ */ re.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ re.jsx(un, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ re.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: Zr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ re.jsx(
          Et,
          {
            slotEnd: /* @__PURE__ */ re.jsx(pe, { name: "external-link" }),
            variant: "tertiary",
            className: Zr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ re.jsxs(
            mr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: Zr.collapse,
              children: [
                /* @__PURE__ */ re.jsx(mr.Header, { className: Zr.collapseHeader, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ re.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ re.jsx(We, { content: /* @__PURE__ */ re.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(
                        As,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ re.jsxs(
                        A.ExternalLink,
                        {
                          className: Zr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ re.jsx(pe, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ re.jsx(We, { content: /* @__PURE__ */ re.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(Ps, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ re.jsx(An, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ re.jsx(mr.Content, { className: Zr.collapseContent, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ re.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ re.jsx(An, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ re.jsx(sS, { issue: u }),
                  /* @__PURE__ */ re.jsx(
                    Gn,
                    {
                      slotStart: /* @__PURE__ */ re.jsx(pe, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => t(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ re.jsxs(
                    Et,
                    {
                      slotEnd: /* @__PURE__ */ re.jsx(pe, { name: "external-link" }),
                      variant: "tertiary",
                      className: Zr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ re.jsx(
          Gn,
          {
            slotStart: /* @__PURE__ */ re.jsx(pe, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ re.jsx(
          Et,
          {
            slotEnd: /* @__PURE__ */ re.jsx(pe, { name: "external-link" }),
            variant: "tertiary",
            className: Zr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, h2 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((t) => `- ${t}`).join(""),
    ordered_list: (e, n) => `
` + n().map((t) => `1. ${t}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, cS = (e, n) => {
  const t = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => cS(l, s)) : [], a = n.nodes[e.type] || n.default;
  return t(
    a(e, i(e, n))
  );
}, y2 = "_modalBody_iv3ua_1", g2 = "_error_iv3ua_5", v2 = "_dropdown_iv3ua_16", Ui = {
  modalBody: y2,
  error: g2,
  dropdown: v2
}, k2 = Io(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), b2 = Io(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), x2 = Io(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), _2 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: t,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = hn(), { control: m, handleSubmit: u, reset: f } = _t(), [h, g] = le([]), [C, S] = le(), [N, w] = le([]), [y, z] = le(), [$, I] = le([]), [T, U] = le(), [Q, J] = le([]), [ie, X] = le(), [B, O] = le([]), [q, ee] = le(), [ve, ue] = le(!1), { useMutation: ce } = hn(), { track: fe } = _n(), [W, { loading: xe }] = ce(
    k2,
    {
      onError: () => {
        ue(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ee) => {
        const Ge = {
          identifier: Ee.Linear?.issueCreate?.issue?.identifier,
          url: Ee.Linear?.issueCreate?.issue?.url
        };
        Ee.Linear && Ee.Linear?.issueCreate?.issue?.id && (a(Ee.Linear?.issueCreate?.issue?.id), ze(Ge), ue(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ee.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), fe("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ie,
    { data: K, loading: qe, error: Be }
  ] = l(b2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Ge = Ee.Linear.teams.edges.map(
        ({ node: Qe }) => Qe
      );
      g(Ge), J(Ee.Linear.issuePriorityValues), s(`${T2}${Ee.Linear.organization.urlKey}`);
    }
  }), [Oe, { data: Me, loading: $e }] = l(x2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Ge = Ee?.Linear?.team?.projects?.edges?.map(
        ({ node: ge }) => ge
      );
      w(Ge);
      const Qe = Ee?.Linear?.team?.states?.edges?.map(
        ({ node: ge }) => ge
      );
      I(Qe);
      const he = Ee?.Linear?.team?.templates?.edges?.map(
        ({ node: ge }) => ge
      );
      O(
        he.filter(
          (ge) => ge.type === "issue"
        )
      );
    }
  }), ze = (Ee) => {
    t(!1), z(void 0), S(void 0), U(void 0), X(void 0), ee(void 0), Ee && (e(Ee), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Re = (Ee) => {
    K && !qe && (W({
      variables: {
        issueTitle: Ee.title,
        issueDescription: Ee?.description,
        teamId: Ee.team.id,
        projectId: Ee?.project?.id,
        statusId: Ee?.status?.id,
        priority: Ee?.priority?.priority
      }
    }), ue(!0));
  };
  He(() => {
    n && Ie();
  }, [n]);
  const an = () => {
    fe("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ re.jsxs(
    Tt,
    {
      isOpen: n,
      onClose: () => {
        an(), ze();
      },
      children: [
        /* @__PURE__ */ re.jsx(
          $t,
          {
            title: "Create new Linear issue",
            onClose: () => {
              an(), ze();
            }
          }
        ),
        /* @__PURE__ */ re.jsx(
          Dt,
          {
            className: Ui.modalBody,
            "data-testid": "createIssueModalBody",
            children: Be ? /* @__PURE__ */ re.jsx(Fn, { error: Be }) : /* @__PURE__ */ re.jsx("form", { onSubmit: u(Re), id: "issueCreationForm", children: /* @__PURE__ */ re.jsxs(st, { children: [
              /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ee, onChange: Ge },
                    fieldState: { error: Qe }
                  }) => /* @__PURE__ */ re.jsx(
                    ln,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Qe?.message ?? null
                      },
                      children: /* @__PURE__ */ re.jsx(
                        ei,
                        {
                          dropdownProps: { className: Ui.dropdown },
                          placeholder: "Select Linear team",
                          className: it({ [Ui.error]: Qe }),
                          getItemTitleByValue: (he) => he?.name,
                          onChange: (he) => {
                            z(void 0), U(void 0), X(void 0), ee(void 0), S(he.selectedValues[0]), Oe({
                              variables: { teamId: he.selectedValues[0].id }
                            }), Ge(he.selectedValues[0]);
                          },
                          value: C ? [Ee] : void 0,
                          children: h?.map((he) => /* @__PURE__ */ re.jsx(
                            ut.Item,
                            {
                              value: he,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(A.Paragraph, { children: he.name })
                            },
                            he.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ee, onChange: Ge } }) => {
                    const Qe = $e ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ re.jsx(ln, { label: "Project", children: /* @__PURE__ */ re.jsx(
                      ei,
                      {
                        dropdownProps: { className: Ui.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (he) => he?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Linear project" : "Select a Team first",
                        onChange: (he) => {
                          z(he.selectedValues[0]), Ge(he.selectedValues[0]);
                        },
                        value: y ? [Ee] : Qe,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          $e && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(un, { size: 24 })
                            }
                          ),
                          Me && !$e && N.map((he) => /* @__PURE__ */ re.jsx(
                            ut.Item,
                            {
                              value: he,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(A.Paragraph, { children: he.name })
                            },
                            he.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { span: 6, children: /* @__PURE__ */ re.jsx(ln, { label: "Template", children: /* @__PURE__ */ re.jsx(
                ei,
                {
                  clearable: !0,
                  dropdownProps: { className: Ui.dropdown },
                  disabled: !C || $e,
                  placeholder: C ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ee) => Ee?.name,
                  onChange: (Ee) => {
                    if (Ee.selectedValues.length > 0) {
                      ee(Ee.selectedValues[0]);
                      const Ge = JSON.parse(
                        Ee.selectedValues[0].templateData
                      ), Qe = Q.filter(
                        (Le) => Le.priority === Ge.priority
                      );
                      X(
                        Qe ? Qe[0] : void 0
                      );
                      const he = $.filter(
                        (Le) => Le.id === Ge.stateId
                      );
                      U(
                        he ? he[0] : void 0
                      );
                      const ge = N.filter(
                        (Le) => Le.id === Ge.projectId
                      );
                      z(
                        ge ? ge[0] : void 0
                      );
                      const De = Ge.description;
                      f({
                        title: Ge?.title,
                        priority: Qe[0],
                        status: he[0],
                        project: ge[0],
                        description: De ? cS(De, h2) : "",
                        team: C
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: C
                      }), z(void 0), X(void 0), U(void 0), ee(void 0);
                  },
                  value: q ? [q] : void 0,
                  children: B?.map((Ee) => /* @__PURE__ */ re.jsx(
                    ut.Item,
                    {
                      value: Ee,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ re.jsx(A.Paragraph, { children: Ee.name })
                    },
                    Ee.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ re.jsx(be, { span: 6, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ee, value: Ge },
                    fieldState: { error: Qe }
                  }) => /* @__PURE__ */ re.jsx(
                    pr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Ge || "",
                        onChange: Ee
                      },
                      meta: {
                        error: Qe?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ee, onChange: Ge } }) => {
                    const Qe = $e ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(ln, { label: "Status", children: /* @__PURE__ */ re.jsx(
                      ei,
                      {
                        dropdownProps: { className: Ui.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (he) => he?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue status" : "Select a Team first",
                        onChange: (he) => {
                          U(he.selectedValues[0]), Ge(he.selectedValues[0]);
                        },
                        value: T ? [Ee] : Qe,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          $e && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(un, { size: 24 })
                            }
                          ),
                          Me && !$e && $.map((he) => /* @__PURE__ */ re.jsx(
                            ut.Item,
                            {
                              value: he,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      As,
                                      {
                                        type: he.type,
                                        color: he.color,
                                        name: he.name
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(A.Paragraph, { children: he.name })
                                  ]
                                }
                              )
                            },
                            he.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ee, onChange: Ge } }) => {
                    const Qe = qe ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(ln, { label: "Priority", children: /* @__PURE__ */ re.jsx(
                      ei,
                      {
                        clearable: !0,
                        getItemTitleByValue: (he) => he?.label,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue priority" : "Select a Team first",
                        onChange: (he) => {
                          X(he.selectedValues[0]), Ge(he.selectedValues[0]);
                        },
                        value: ie ? [Ee] : Qe,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          $e && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(un, { size: 24 })
                            }
                          ),
                          K && !qe && Q.map((he) => /* @__PURE__ */ re.jsx(
                            ut.Item,
                            {
                              value: he,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      Ps,
                                      {
                                        priority: he.priority
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(A.Paragraph, { children: he.label })
                                  ]
                                }
                              )
                            },
                            he.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ee, value: Ge },
                    fieldState: { error: Qe }
                  }) => /* @__PURE__ */ re.jsx(
                    T0,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Ge || "",
                        onChange: Ee
                      },
                      meta: {
                        error: Qe?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ re.jsx(
          Pt,
          {
            confirmOnClick: u(Re),
            confirmProps: {
              disabled: xe || !K,
              isLoading: ve || qe || $e,
              loadingIndicator: /* @__PURE__ */ re.jsx(un, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              an(), ze();
            }
          }
        )
      ]
    }
  );
}, S2 = "_modalWrapper_4kh9u_1", N2 = "_copyButton_4kh9u_6", j2 = "_copyWrapper_4kh9u_15", w2 = "_copyField_4kh9u_24", C2 = "_externalLink_4kh9u_47", F2 = "_externalLinkIcon_4kh9u_52", I2 = "_textWrapper_4kh9u_56", li = {
  modalWrapper: S2,
  copyButton: N2,
  copyWrapper: j2,
  copyField: w2,
  externalLink: C2,
  externalLinkIcon: F2,
  textWrapper: I2
}, E2 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: t
}) => /* @__PURE__ */ re.jsxs(
  Tt,
  {
    isOpen: !!n && e,
    className: li.modalWrapper,
    onClose: () => t(!1),
    children: [
      /* @__PURE__ */ re.jsx(
        $t,
        {
          title: "Issue creation successful",
          onClose: () => t(!1)
        }
      ),
      /* @__PURE__ */ re.jsx(Dt, { children: /* @__PURE__ */ re.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ re.jsxs(A.Paragraph, { className: li.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ re.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: li.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ re.jsx(pe, { name: "external-link", className: li.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ re.jsx(ln, { label: "Linear issue link", children: /* @__PURE__ */ re.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: li.copyWrapper,
                children: [
                  /* @__PURE__ */ re.jsx(
                    Nr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: li.copyField
                    }
                  ),
                  /* @__PURE__ */ re.jsx(
                    $0,
                    {
                      className: li.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ re.jsx(
        Pt,
        {
          cancelOnClick: () => t(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), T2 = "https://linear.app/", $2 = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = le([]), [a, o] = le([]), [s, l] = le(!1), [d, m] = le(!1), [u, f] = le(!1), [h, g] = le(), { useLazyQuery: C } = hn(), [S, N] = le(""), w = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: z } = _n(), {
    loading: $,
    data: I,
    error: T,
    store: U
  } = Km(e?.conversationId ?? null), [
    Q,
    {
      data: J,
      loading: ie,
      networkStatus: X,
      error: B
    }
  ] = C(PA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    !$ && !T && I && I?.linear?.issues?.length > 0 ? (o(I.linear.issues), Q({
      variables: {
        linkedIssues: I.linear.issues
      }
    })) : !$ && !T && (i([]), o([]));
  }, [I, $, T]), He(() => {
    J && J?.Linear && !ie && X === er.ready && Object.keys(J).length > 0 && i(J.Linear.issues?.edges?.map(({ node: ue }) => ue));
  }, [J, ie, X]);
  const O = (ue) => {
    ue && ue?.team?.organization?.urlKey && z("linear:link:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: ue.id
    });
    const ce = (fe) => fe.id === ue?.id;
    t.some((fe) => fe && ce(fe)) || (I && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, ue.id]
      }
    }));
  }, q = (ue) => {
    const ce = I?.linear.issues.filter((fe) => fe !== ue) || [];
    z("linear:unlink:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: ue
    }), i(t.filter(({ id: fe }) => fe !== ue)), o(ce), U({
      linear: {
        issues: ce
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  }, ve = $ || ie || !I && !T || (I?.linear?.issues?.length ?? 0) > 0 && t.length === 0;
  return !$ && !ie && (B || T) ? /* @__PURE__ */ re.jsx(Fn, { error: B || T }) : /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ re.jsxs(
      Tt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ re.jsx(
            $t,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ re.jsx(Dt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ re.jsx(
            Pt,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      _2,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (ue) => m(ue),
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        addToLinkedIssueIds: (ue) => {
          U({
            linear: {
              issues: [...a, ue]
            }
          });
        },
        setCreatedIssue: (ue) => g(ue),
        organizationUrl: S,
        setOrganizationUrl: (ue) => N(ue)
      }
    ),
    /* @__PURE__ */ re.jsx(
      E2,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ re.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          w && /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
            /* @__PURE__ */ re.jsx(
              Gn,
              {
                variant: "primary",
                onClick: () => {
                  z("linear:create:new:issue:clicked", {
                    linearInstanceUrl: S
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ re.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ re.jsx(s2, { handleSelect: O, linkedIssues: t })
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      f2,
      {
        linkedIssues: t,
        isLoading: ve,
        handleUnlinkIssue: q,
        showUnlinkAllModal: (ue) => l(ue),
        showUnlinkAllButton: y,
        organizationUrl: S
      }
    )
  ] });
}, $m = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], ci = "LINEAR", D2 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, R2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: t,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = _t({
    mode: "onChange",
    defaultValues: D2
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = Ni({
    integrationId: e,
    integrationType: ci,
    handleRedirect: t,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: z
  } = ji({
    integrationId: e,
    fieldDefinitions: $m,
    form: l,
    onMisconfigured: C
  }), { renderConditions: $, setRenderConditions: I, renderConditionsForSubmit: T } = wi({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (J) => Fi(J, {
    fieldDefinitions: $m,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: T
  }), Q = l.watch("name");
  return /* @__PURE__ */ re.jsxs(
    Ci,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ re.jsx(Ii, { cause: g }),
        /* @__PURE__ */ re.jsxs(st, { children: [
          /* @__PURE__ */ re.jsx(be, { children: /* @__PURE__ */ re.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ re.jsx(
            Jn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(be, { span: 3 }),
          /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(ln, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ re.jsx(
            Jn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(be, { span: 3 }),
          /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(ln, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ re.jsx(
            Jn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(be, { span: 3 }),
          !s && e && /* @__PURE__ */ re.jsx(
            sa,
            {
              configuration: n,
              integrationId: e,
              integrationType: ci,
              label: "Authorize with OAuth"
            }
          ),
          o && $ !== null && /* @__PURE__ */ re.jsx(be, { children: o({
            value: $,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ re.jsx(
          Ei,
          {
            integrationType: ci,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ re.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ re.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ re.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  ci,
                  " integration, all links between Dixa and ",
                  ci,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ re.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  ci,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ re.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  ci,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Tu = { exports: {} }, Oa = {}, uk;
function O2() {
  if (uk) return Oa;
  uk = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Oa.Fragment = t, Oa.jsx = s, Oa.jsxs = s, Oa;
}
var Ko = {}, mk;
function P2() {
  return mk || (mk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ko.Fragment = i, Ko.jsx = Rn, Ko.jsxs = Mn;
  })()), Ko;
}
var pk;
function A2() {
  return pk || (pk = 1, process.env.NODE_ENV === "production" ? Tu.exports = O2() : Tu.exports = P2()), Tu.exports;
}
var we = A2();
const L2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, V2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, z2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, U2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, M2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, B2 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": L2,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": V2,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": z2,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": U2,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": M2
};
function ml(e) {
  return B2[e] ?? {};
}
const q2 = ml(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), H2 = ml(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), W2 = ml(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), G2 = ml(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function $u(e = !1, n) {
  const [t, i] = le(e);
  return He(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const K2 = "_wrapper_27vny_1", Y2 = "_copyIcon_27vny_12", Pa = {
  wrapper: K2,
  copyIcon: Y2
}, Q2 = ({
  customer: e
}) => {
  const { isCopied: n, copy: t } = $u(), { isCopied: i, copy: a } = $u(), { isCopied: o, copy: s } = $u();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: g,
    enrolled_at: C,
    referral_url: S
  } = e, N = f ? Ln(f).isSame(Date.now(), "day") : !1, { name: w, first_name: y, last_name: z } = m ?? {}, $ = w ?? (`${y} ${z}`.trim() || "A customer has no name"), I = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ we.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(b, { className: Pa.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Pa.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ we.jsx(A.Heading, { variant: "heading-2", children: $ }),
          N && /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ we.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Ln(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    g && /* @__PURE__ */ we.jsx(b, { gap: "200", children: /* @__PURE__ */ we.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Ln(C).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ we.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ we.jsx(pe, { size: l, name: "mail" }),
        /* @__PURE__ */ we.jsx(A.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ we.jsx(We, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ we.jsx(
        pe,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => t(d),
          className: Pa.copyIcon
        }
      ) })
    ] }),
    I && /* @__PURE__ */ we.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ we.jsx(pe, { size: l, name: "link" }),
        /* @__PURE__ */ we.jsx(We, { content: "Shopify shop", children: /* @__PURE__ */ we.jsx(
          A.ExternalLink,
          {
            href: I,
            target: "_blank",
            rel: "noreferrer",
            children: I.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ we.jsx(We, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ we.jsx(
        pe,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: Pa.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ we.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ we.jsx(pe, { size: l, name: "external-link" }),
        /* @__PURE__ */ we.jsx(We, { content: "Referral link", children: /* @__PURE__ */ we.jsx(
          A.ExternalLink,
          {
            href: S,
            target: "_blank",
            rel: "noreferrer",
            children: S.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ we.jsx(We, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ we.jsx(
        pe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: Pa.copyIcon
        }
      ) })
    ] })
  ] }) });
}, J2 = "_list_1q5b5_5", X2 = "_listItem_1q5b5_8", Z2 = "_listItemEdit_1q5b5_15", eL = "_notificationText_1q5b5_19", aa = {
  list: J2,
  listItem: X2,
  listItemEdit: Z2,
  notificationText: eL
}, nL = "_modalBody_1clhs_1", tL = {
  modalBody: nL
}, rL = ({
  isOpen: e,
  points: n,
  merchantId: t,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = _n(), [d, m] = le(n), [u, f] = le(""), [h, g] = le(), [C, { loading: S }] = o(
    W2,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), X();
      }
    }
  ), [N, { loading: w }] = o(G2), y = S || w, z = !!h, $ = n === d ? "Change the value to update the points" : "", I = isNaN(d), T = I ? "Points can not be empty" : "", U = d > n && d - n > 1e6, Q = U ? "Points can not exceed 1,000,000" : "", J = () => {
    if (!t) {
      g(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && C({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: t
      }
    }).catch((B) => {
      const O = B?.networkError;
      (O ? O?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), X()) : (l("loyaltylion:add:points:failed"), g(["Failed to add points, try again later."]));
    }), d < n && N({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: t
      }
    }).then((B) => {
      B.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), X()) : "errors" in B && (l("loyaltylion:remove:points:failed"), g(
        B.errors?.map((O) => O.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), g(["Failed to remove points, try again later."]);
    });
  }, ie = () => {
    I && m(n), f(""), i();
  }, X = () => {
    a(), ie();
  };
  return /* @__PURE__ */ we.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: ie,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ we.jsx($t, { title: "Change points", onClose: ie }),
        /* @__PURE__ */ we.jsxs(Dt, { className: tL.modalBody, children: [
          /* @__PURE__ */ we.jsxs(st, { children: [
            /* @__PURE__ */ we.jsx(be, { span: 6, children: /* @__PURE__ */ we.jsx(
              pr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Q || T,
                  warning: $
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (B) => m(B?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ we.jsx(be, { span: 6, children: /* @__PURE__ */ we.jsx(
              pr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (B) => f(B?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && z && /* @__PURE__ */ we.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ we.jsx(Ye, { children: h?.map((B, O) => /* @__PURE__ */ we.jsx(
            Ye.Item,
            {
              variant: "dense",
              title: B,
              contentLeft: /* @__PURE__ */ we.jsx(
                pe,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            O
          )) }) })
        ] }),
        /* @__PURE__ */ we.jsx(
          Pt,
          {
            confirmName: "Save",
            confirmOnClick: () => J(),
            confirmProps: {
              isLoading: y,
              disabled: I || U || n === d,
              loadingIndicator: /* @__PURE__ */ we.jsx(un, { size: 16 })
            },
            cancelOnClick: ie
          }
        )
      ]
    }
  );
}, iL = ({
  label: e,
  points: n,
  setIsModalOpen: t
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ we.jsx(Ye.Text, { variant: "dense", className: aa.listItem, children: /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(pe, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      t && /* @__PURE__ */ we.jsx(We, { content: "Edit points", children: /* @__PURE__ */ we.jsx(
        pe,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: aa.listItemEdit,
          onClick: () => t(!0)
        }
      ) }),
      /* @__PURE__ */ we.jsx(Pn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, aL = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [t, i] = le(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ we.jsx(Ye, { className: aa.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: g }) => /* @__PURE__ */ we.jsx(
      iL,
      {
        points: f,
        label: h,
        setIsModalOpen: g
      },
      u
    )) }),
    /* @__PURE__ */ we.jsx(
      rL,
      {
        isOpen: t,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, oL = "_reward_1wxia_1", sL = {
  reward: oL
}, lL = ({ reward: e }) => {
  const {
    title: n,
    point_cost: t,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "column", className: sL.reward, children: /* @__PURE__ */ we.jsx(We, { content: a ?? "No description", children: /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ we.jsx(pe, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ we.jsxs(Pn, { size: "small", variant: "info", children: [
        t ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(pe, { size: 14, name: "external-link" }),
      /* @__PURE__ */ we.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, cL = ({ customer: e }) => {
  const { useQuery: n } = hn(), [t, i] = le(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(H2, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (He(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return vo({ errors: d }) ? /* @__PURE__ */ we.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: aa.notificationText,
        children: "No rewards found"
      }
    ) : Gb({ errors: d }) ? /* @__PURE__ */ we.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: aa.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ we.jsx(Fn, { error: s });
  }
  return /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ we.jsx(un, {}) }) : /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: t?.map((d) => /* @__PURE__ */ we.jsx(lL, { reward: d }, d.id)) })
  ] });
}, dL = ({ customer: e }) => {
  const { blocked: n, guest: t, insights_segment: i } = e ?? {}, a = n || t || i, o = 14;
  return a ? /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ we.jsx(b, { alignItems: "start", children: /* @__PURE__ */ we.jsx(An, { children: /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(
        pe,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    t && /* @__PURE__ */ we.jsx(b, { alignItems: "start", children: /* @__PURE__ */ we.jsx(An, { children: /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(pe, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ we.jsx(b, { alignItems: "start", children: /* @__PURE__ */ we.jsx(We, { content: "Insights segment", children: /* @__PURE__ */ we.jsx(An, { children: /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(pe, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, uL = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = hn(), { track: i } = _n(), [a, o] = le(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: g,
    data: C,
    refetch: S
  } = t(q2, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return He(() => {
    if (C && !h) {
      const N = (C?.LoyaltyLion?.getCustomers).customers;
      N && N.length > 0 && (o(N[0]), i("loyaltylion:customer:received"));
    }
  }, [C, h]), s?.email ? g ? vo({
    errors: g.graphQLErrors
  }) ? /* @__PURE__ */ we.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: aa.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ we.jsx(Fn, { error: g }) : h ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ we.jsx(un, {}) }) : f ? /* @__PURE__ */ we.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ we.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ we.jsxs(we.Fragment, { children: [
        l && /* @__PURE__ */ we.jsx(Q2, { customer: a }),
        d && /* @__PURE__ */ we.jsx(dL, { customer: a }),
        m && /* @__PURE__ */ we.jsx(
          aL,
          {
            customer: a,
            refetchCustomerData: S
          }
        ),
        u && /* @__PURE__ */ we.jsx(cL, { customer: a })
      ] }) : /* @__PURE__ */ we.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ we.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, Dm = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], fk = "LOYALTYLION", mL = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, pL = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: t,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = _t({
    mode: "onChange",
    defaultValues: mL
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: g
  } = Ni({
    integrationId: e,
    integrationType: fk,
    handleRedirect: n,
    showNotification: t
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: w,
    widgetConfiguration: y
  } = ji({
    integrationId: e,
    fieldDefinitions: Dm,
    form: s,
    onMisconfigured: g
  }), { renderConditions: z, setRenderConditions: $, renderConditionsForSubmit: I } = wi({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), T = (Q) => Fi(Q, {
    fieldDefinitions: Dm,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ we.jsxs(
    Ci,
    {
      form: s,
      integrationId: e,
      onValidSubmit: T,
      error: S ?? f,
      onRetry: S ? w : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ we.jsx(Ii, { cause: h }),
        /* @__PURE__ */ we.jsxs(st, { children: [
          /* @__PURE__ */ we.jsx(be, { children: /* @__PURE__ */ we.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(
            h0,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(ln, { label: "Show customer summary", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(ln, { label: "Show tags", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(ln, { label: "Show points balance", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(ln, { label: "Show available rewards", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          a && z !== null && /* @__PURE__ */ we.jsx(be, { children: a({
            value: z,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ we.jsx(
          Ei,
          {
            integrationType: fk,
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Du = { exports: {} }, Aa = {}, hk;
function fL() {
  if (hk) return Aa;
  hk = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Aa.Fragment = t, Aa.jsx = s, Aa.jsxs = s, Aa;
}
var Yo = {}, yk;
function hL() {
  return yk || (yk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Yo.Fragment = i, Yo.jsx = Rn, Yo.jsxs = Mn;
  })()), Yo;
}
var gk;
function yL() {
  return gk || (gk = 1, process.env.NODE_ENV === "production" ? Du.exports = fL() : Du.exports = hL()), Du.exports;
}
var rn = yL();
const gL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, vL = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": gL
};
function kL(e) {
  return vL[e] ?? {};
}
const {
  entries: dS,
  setPrototypeOf: vk,
  isFrozen: bL,
  getPrototypeOf: xL,
  getOwnPropertyDescriptor: _L
} = Object;
let {
  freeze: Gt,
  seal: fr,
  create: Gi
} = Object, {
  apply: Rm,
  construct: Om
} = typeof Reflect < "u" && Reflect;
Gt || (Gt = function(e) {
  return e;
});
fr || (fr = function(e) {
  return e;
});
Rm || (Rm = function(e, n) {
  for (var t = arguments.length, i = new Array(t > 2 ? t - 2 : 0), a = 2; a < t; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
Om || (Om = function(e) {
  for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    t[i - 1] = arguments[i];
  return new e(...t);
});
const La = gt(Array.prototype.forEach), SL = gt(Array.prototype.lastIndexOf), kk = gt(Array.prototype.pop), Va = gt(Array.prototype.push), NL = gt(Array.prototype.splice), Vt = Array.isArray, eo = gt(String.prototype.toLowerCase), Ru = gt(String.prototype.toString), bk = gt(String.prototype.match), Mi = gt(String.prototype.replace), xk = gt(String.prototype.indexOf), jL = gt(String.prototype.trim), wL = gt(Number.prototype.toString), CL = gt(Boolean.prototype.toString), _k = typeof BigInt > "u" ? null : gt(BigInt.prototype.toString), Sk = typeof Symbol > "u" ? null : gt(Symbol.prototype.toString), at = gt(Object.prototype.hasOwnProperty), za = gt(Object.prototype.toString), jt = gt(RegExp.prototype.test), Qo = FL(TypeError);
function gt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
      i[a - 1] = arguments[a];
    return Rm(e, n, i);
  };
}
function FL(e) {
  return function() {
    for (var n = arguments.length, t = new Array(n), i = 0; i < n; i++)
      t[i] = arguments[i];
    return Om(e, t);
  };
}
function En(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : eo;
  if (vk && vk(e, null), !Vt(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = t(a);
      o !== a && (bL(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function IL(e) {
  for (let n = 0; n < e.length; n++)
    at(e, n) || (e[n] = null);
  return e;
}
function Qt(e) {
  const n = Gi(null);
  for (const [t, i] of dS(e))
    at(e, t) && (Vt(i) ? n[t] = IL(i) : i && typeof i == "object" && i.constructor === Object ? n[t] = Qt(i) : n[t] = i);
  return n;
}
function EL(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return wL(e);
    case "boolean":
      return CL(e);
    case "bigint":
      return _k ? _k(e) : "0";
    case "symbol":
      return Sk ? Sk(e) : "Symbol()";
    case "undefined":
      return za(e);
    case "function":
    case "object": {
      if (e === null)
        return za(e);
      const n = e, t = Ki(n, "toString");
      if (typeof t == "function") {
        const i = t(n);
        return typeof i == "string" ? i : za(i);
      }
      return za(e);
    }
    default:
      return za(e);
  }
}
function Ki(e, n) {
  for (; e !== null; ) {
    const i = _L(e, n);
    if (i) {
      if (i.get)
        return gt(i.get);
      if (typeof i.value == "function")
        return gt(i.value);
    }
    e = xL(e);
  }
  function t() {
    return null;
  }
  return t;
}
function TL(e) {
  try {
    return jt(e, ""), !0;
  } catch {
    return !1;
  }
}
const Nk = Gt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Ou = Gt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Pu = Gt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), $L = Gt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Au = Gt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), DL = Gt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), jk = Gt(["#text"]), wk = Gt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Lu = Gt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Ck = Gt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Jo = Gt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), RL = fr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), OL = fr(/<%[\w\W]*|[\w\W]*%>/gm), PL = fr(/\$\{[\w\W]*/gm), AL = fr(/^data-[\-\w.\u00B7-\uFFFF]+$/), LL = fr(/^aria-[\-\w]+$/), uS = fr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), VL = fr(/^(?:\w+script|data):/i), zL = fr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), mS = fr(/^html$/i), UL = fr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Fk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: LL,
  ATTR_WHITESPACE: zL,
  CUSTOM_ELEMENT: UL,
  DATA_ATTR: AL,
  DOCTYPE_NAME: mS,
  ERB_EXPR: OL,
  IS_ALLOWED_URI: uS,
  IS_SCRIPT_OR_DATA: VL,
  MUSTACHE_EXPR: RL,
  TMPLIT_EXPR: PL
});
const Ua = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, ML = function() {
  return typeof window > "u" ? null : window;
}, BL = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let t = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (t = n.getAttribute(i));
  const a = "dompurify" + (t ? "#" + t : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, Ik = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function pS() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ML();
  const n = (_) => pS(_);
  if (n.version = "3.4.2", n.removed = [], !e || !e.document || e.document.nodeType !== Ua.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: t
  } = e;
  const i = t, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: g
  } = e, C = d.prototype, S = Ki(C, "cloneNode"), N = Ki(C, "remove"), w = Ki(C, "nextSibling"), y = Ki(C, "childNodes"), z = Ki(C, "parentNode");
  if (typeof s == "function") {
    const _ = t.createElement("template");
    _.content && _.content.ownerDocument && (t = _.content.ownerDocument);
  }
  let $, I = "";
  const {
    implementation: T,
    createNodeIterator: U,
    createDocumentFragment: Q,
    getElementsByTagName: J
  } = t, {
    importNode: ie
  } = i;
  let X = Ik();
  n.isSupported = typeof dS == "function" && typeof z == "function" && T && T.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: B,
    ERB_EXPR: O,
    TMPLIT_EXPR: q,
    DATA_ATTR: ee,
    ARIA_ATTR: ve,
    IS_SCRIPT_OR_DATA: ue,
    ATTR_WHITESPACE: ce,
    CUSTOM_ELEMENT: fe
  } = Fk;
  let {
    IS_ALLOWED_URI: W
  } = Fk, xe = null;
  const Ie = En({}, [...Nk, ...Ou, ...Pu, ...Au, ...jk]);
  let K = null;
  const qe = En({}, [...wk, ...Lu, ...Ck, ...Jo]);
  let Be = Object.seal(Gi(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Oe = null, Me = null;
  const $e = Object.seal(Gi(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let ze = !0, Re = !0, an = !1, Ee = !0, Ge = !1, Qe = !0, he = !1, ge = !1, De = !1, Le = !1, Pe = !1, mn = !1, E = !0, x = !1;
  const D = "user-content-";
  let H = !0, Y = !1, R = {}, V = null;
  const ae = En({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let me = null;
  const Ne = En({}, ["audio", "video", "img", "source", "image", "track"]);
  let nn = null;
  const fn = En({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), tn = "http://www.w3.org/1998/Math/MathML", cn = "http://www.w3.org/2000/svg", pn = "http://www.w3.org/1999/xhtml";
  let dn = pn, xn = !1, en = null;
  const jn = En({}, [tn, cn, pn], Ru);
  let Ae = En({}, ["mi", "mo", "mn", "ms", "mtext"]), on = En({}, ["annotation-xml"]);
  const sn = En({}, ["title", "style", "font", "a", "script"]);
  let vn = null;
  const qn = ["application/xhtml+xml", "text/html"], wn = "text/html";
  let kn = null, gn = null;
  const Cn = t.createElement("form"), Un = function(_) {
    return _ instanceof RegExp || _ instanceof Function;
  }, Vn = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (gn && gn === _)
      return;
    (!_ || typeof _ != "object") && (_ = {}), _ = Qt(_), vn = // eslint-disable-next-line unicorn/prefer-includes
    qn.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? wn : _.PARSER_MEDIA_TYPE, kn = vn === "application/xhtml+xml" ? Ru : eo, xe = at(_, "ALLOWED_TAGS") && Vt(_.ALLOWED_TAGS) ? En({}, _.ALLOWED_TAGS, kn) : Ie, K = at(_, "ALLOWED_ATTR") && Vt(_.ALLOWED_ATTR) ? En({}, _.ALLOWED_ATTR, kn) : qe, en = at(_, "ALLOWED_NAMESPACES") && Vt(_.ALLOWED_NAMESPACES) ? En({}, _.ALLOWED_NAMESPACES, Ru) : jn, nn = at(_, "ADD_URI_SAFE_ATTR") && Vt(_.ADD_URI_SAFE_ATTR) ? En(Qt(fn), _.ADD_URI_SAFE_ATTR, kn) : fn, me = at(_, "ADD_DATA_URI_TAGS") && Vt(_.ADD_DATA_URI_TAGS) ? En(Qt(Ne), _.ADD_DATA_URI_TAGS, kn) : Ne, V = at(_, "FORBID_CONTENTS") && Vt(_.FORBID_CONTENTS) ? En({}, _.FORBID_CONTENTS, kn) : ae, Oe = at(_, "FORBID_TAGS") && Vt(_.FORBID_TAGS) ? En({}, _.FORBID_TAGS, kn) : Qt({}), Me = at(_, "FORBID_ATTR") && Vt(_.FORBID_ATTR) ? En({}, _.FORBID_ATTR, kn) : Qt({}), R = at(_, "USE_PROFILES") ? _.USE_PROFILES && typeof _.USE_PROFILES == "object" ? Qt(_.USE_PROFILES) : _.USE_PROFILES : !1, ze = _.ALLOW_ARIA_ATTR !== !1, Re = _.ALLOW_DATA_ATTR !== !1, an = _.ALLOW_UNKNOWN_PROTOCOLS || !1, Ee = _.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ge = _.SAFE_FOR_TEMPLATES || !1, Qe = _.SAFE_FOR_XML !== !1, he = _.WHOLE_DOCUMENT || !1, Le = _.RETURN_DOM || !1, Pe = _.RETURN_DOM_FRAGMENT || !1, mn = _.RETURN_TRUSTED_TYPE || !1, De = _.FORCE_BODY || !1, E = _.SANITIZE_DOM !== !1, x = _.SANITIZE_NAMED_PROPS || !1, H = _.KEEP_CONTENT !== !1, Y = _.IN_PLACE || !1, W = TL(_.ALLOWED_URI_REGEXP) ? _.ALLOWED_URI_REGEXP : uS, dn = typeof _.NAMESPACE == "string" ? _.NAMESPACE : pn, Ae = at(_, "MATHML_TEXT_INTEGRATION_POINTS") && _.MATHML_TEXT_INTEGRATION_POINTS && typeof _.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Qt(_.MATHML_TEXT_INTEGRATION_POINTS) : En({}, ["mi", "mo", "mn", "ms", "mtext"]), on = at(_, "HTML_INTEGRATION_POINTS") && _.HTML_INTEGRATION_POINTS && typeof _.HTML_INTEGRATION_POINTS == "object" ? Qt(_.HTML_INTEGRATION_POINTS) : En({}, ["annotation-xml"]);
    const Z = at(_, "CUSTOM_ELEMENT_HANDLING") && _.CUSTOM_ELEMENT_HANDLING && typeof _.CUSTOM_ELEMENT_HANDLING == "object" ? Qt(_.CUSTOM_ELEMENT_HANDLING) : Gi(null);
    if (Be = Gi(null), at(Z, "tagNameCheck") && Un(Z.tagNameCheck) && (Be.tagNameCheck = Z.tagNameCheck), at(Z, "attributeNameCheck") && Un(Z.attributeNameCheck) && (Be.attributeNameCheck = Z.attributeNameCheck), at(Z, "allowCustomizedBuiltInElements") && typeof Z.allowCustomizedBuiltInElements == "boolean" && (Be.allowCustomizedBuiltInElements = Z.allowCustomizedBuiltInElements), Ge && (Re = !1), Pe && (Le = !0), R && (xe = En({}, jk), K = Gi(null), R.html === !0 && (En(xe, Nk), En(K, wk)), R.svg === !0 && (En(xe, Ou), En(K, Lu), En(K, Jo)), R.svgFilters === !0 && (En(xe, Pu), En(K, Lu), En(K, Jo)), R.mathMl === !0 && (En(xe, Au), En(K, Ck), En(K, Jo))), $e.tagCheck = null, $e.attributeCheck = null, at(_, "ADD_TAGS") && (typeof _.ADD_TAGS == "function" ? $e.tagCheck = _.ADD_TAGS : Vt(_.ADD_TAGS) && (xe === Ie && (xe = Qt(xe)), En(xe, _.ADD_TAGS, kn))), at(_, "ADD_ATTR") && (typeof _.ADD_ATTR == "function" ? $e.attributeCheck = _.ADD_ATTR : Vt(_.ADD_ATTR) && (K === qe && (K = Qt(K)), En(K, _.ADD_ATTR, kn))), at(_, "ADD_URI_SAFE_ATTR") && Vt(_.ADD_URI_SAFE_ATTR) && En(nn, _.ADD_URI_SAFE_ATTR, kn), at(_, "FORBID_CONTENTS") && Vt(_.FORBID_CONTENTS) && (V === ae && (V = Qt(V)), En(V, _.FORBID_CONTENTS, kn)), at(_, "ADD_FORBID_CONTENTS") && Vt(_.ADD_FORBID_CONTENTS) && (V === ae && (V = Qt(V)), En(V, _.ADD_FORBID_CONTENTS, kn)), H && (xe["#text"] = !0), he && En(xe, ["html", "head", "body"]), xe.table && (En(xe, ["tbody"]), delete Oe.tbody), _.TRUSTED_TYPES_POLICY) {
      if (typeof _.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Qo('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof _.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Qo('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      $ = _.TRUSTED_TYPES_POLICY, I = $.createHTML("");
    } else
      $ === void 0 && ($ = BL(g, a)), $ !== null && typeof I == "string" && (I = $.createHTML(""));
    Gt && Gt(_), gn = _;
  }, Sn = En({}, [...Ou, ...Pu, ...$L]), Nn = En({}, [...Au, ...DL]), Hn = function(_) {
    let Z = z(_);
    (!Z || !Z.tagName) && (Z = {
      namespaceURI: dn,
      tagName: "template"
    });
    const de = eo(_.tagName), Se = eo(Z.tagName);
    return en[_.namespaceURI] ? _.namespaceURI === cn ? Z.namespaceURI === pn ? de === "svg" : Z.namespaceURI === tn ? de === "svg" && (Se === "annotation-xml" || Ae[Se]) : !!Sn[de] : _.namespaceURI === tn ? Z.namespaceURI === pn ? de === "math" : Z.namespaceURI === cn ? de === "math" && on[Se] : !!Nn[de] : _.namespaceURI === pn ? Z.namespaceURI === cn && !on[Se] || Z.namespaceURI === tn && !Ae[Se] ? !1 : !Nn[de] && (sn[de] || !Sn[de]) : !!(vn === "application/xhtml+xml" && en[_.namespaceURI]) : !1;
  }, Dn = function(_) {
    Va(n.removed, {
      element: _
    });
    try {
      z(_).removeChild(_);
    } catch {
      N(_);
    }
  }, Rn = function(_, Z) {
    try {
      Va(n.removed, {
        attribute: Z.getAttributeNode(_),
        from: Z
      });
    } catch {
      Va(n.removed, {
        attribute: null,
        from: Z
      });
    }
    if (Z.removeAttribute(_), _ === "is")
      if (Le || Pe)
        try {
          Dn(Z);
        } catch {
        }
      else
        try {
          Z.setAttribute(_, "");
        } catch {
        }
  }, Mn = function(_) {
    let Z = null, de = null;
    if (De)
      _ = "<remove></remove>" + _;
    else {
      const Ke = bk(_, /^[\r\n\t ]+/);
      de = Ke && Ke[0];
    }
    vn === "application/xhtml+xml" && dn === pn && (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + "</body></html>");
    const Se = $ ? $.createHTML(_) : _;
    if (dn === pn)
      try {
        Z = new h().parseFromString(Se, vn);
      } catch {
      }
    if (!Z || !Z.documentElement) {
      Z = T.createDocument(dn, "template", null);
      try {
        Z.documentElement.innerHTML = xn ? I : Se;
      } catch {
      }
    }
    const ne = Z.body || Z.documentElement;
    return _ && de && ne.insertBefore(t.createTextNode(de), ne.childNodes[0] || null), dn === pn ? J.call(Z, he ? "html" : "body")[0] : he ? Z.documentElement : ne;
  }, r = function(_) {
    return U.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(_) {
    return _ instanceof f && (typeof _.nodeName != "string" || typeof _.textContent != "string" || typeof _.removeChild != "function" || !(_.attributes instanceof u) || typeof _.removeAttribute != "function" || typeof _.setAttribute != "function" || typeof _.namespaceURI != "string" || typeof _.insertBefore != "function" || typeof _.hasChildNodes != "function");
  }, p = function(_) {
    return typeof l == "function" && _ instanceof l;
  };
  function v(_, Z, de) {
    La(_, (Se) => {
      Se.call(n, Z, de, gn);
    });
  }
  const P = function(_) {
    let Z = null;
    if (v(X.beforeSanitizeElements, _, null), c(_))
      return Dn(_), !0;
    const de = kn(_.nodeName);
    if (v(X.uponSanitizeElement, _, {
      tagName: de,
      allowedTags: xe
    }), Qe && _.hasChildNodes() && !p(_.firstElementChild) && jt(/<[/\w!]/g, _.innerHTML) && jt(/<[/\w!]/g, _.textContent) || Qe && _.namespaceURI === pn && de === "style" && p(_.firstElementChild) || _.nodeType === Ua.progressingInstruction || Qe && _.nodeType === Ua.comment && jt(/<[/\w]/g, _.data))
      return Dn(_), !0;
    if (Oe[de] || !($e.tagCheck instanceof Function && $e.tagCheck(de)) && !xe[de]) {
      if (!Oe[de] && j(de) && (Be.tagNameCheck instanceof RegExp && jt(Be.tagNameCheck, de) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(de)))
        return !1;
      if (H && !V[de]) {
        const Se = z(_) || _.parentNode, ne = y(_) || _.childNodes;
        if (ne && Se) {
          const Ke = ne.length;
          for (let $n = Ke - 1; $n >= 0; --$n) {
            const Tn = S(ne[$n], !0);
            Se.insertBefore(Tn, w(_));
          }
        }
      }
      return Dn(_), !0;
    }
    return _ instanceof d && !Hn(_) || (de === "noscript" || de === "noembed" || de === "noframes") && jt(/<\/no(script|embed|frames)/i, _.innerHTML) ? (Dn(_), !0) : (Ge && _.nodeType === Ua.text && (Z = _.textContent, La([B, O, q], (Se) => {
      Z = Mi(Z, Se, " ");
    }), _.textContent !== Z && (Va(n.removed, {
      element: _.cloneNode()
    }), _.textContent = Z)), v(X.afterSanitizeElements, _, null), !1);
  }, L = function(_, Z, de) {
    if (Me[Z] || E && (Z === "id" || Z === "name") && (de in t || de in Cn))
      return !1;
    const Se = K[Z] || $e.attributeCheck instanceof Function && $e.attributeCheck(Z, _);
    if (!(Re && !Me[Z] && jt(ee, Z)) && !(ze && jt(ve, Z))) {
      if (!Se || Me[Z]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(j(_) && (Be.tagNameCheck instanceof RegExp && jt(Be.tagNameCheck, _) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(_)) && (Be.attributeNameCheck instanceof RegExp && jt(Be.attributeNameCheck, Z) || Be.attributeNameCheck instanceof Function && Be.attributeNameCheck(Z, _)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          Z === "is" && Be.allowCustomizedBuiltInElements && (Be.tagNameCheck instanceof RegExp && jt(Be.tagNameCheck, de) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(de)))
        ) return !1;
      } else if (!nn[Z] && !jt(W, Mi(de, ce, "")) && !((Z === "src" || Z === "xlink:href" || Z === "href") && _ !== "script" && xk(de, "data:") === 0 && me[_]) && !(an && !jt(ue, Mi(de, ce, ""))) && de)
        return !1;
    }
    return !0;
  }, F = En({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), j = function(_) {
    return !F[eo(_)] && jt(fe, _);
  }, te = function(_) {
    v(X.beforeSanitizeAttributes, _, null);
    const {
      attributes: Z
    } = _;
    if (!Z || c(_))
      return;
    const de = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let Se = Z.length;
    for (; Se--; ) {
      const ne = Z[Se], {
        name: Ke,
        namespaceURI: $n,
        value: Tn
      } = ne, Lt = kn(Ke), Jr = Tn;
      let St = Ke === "value" ? Jr : jL(Jr);
      if (de.attrName = Lt, de.attrValue = St, de.keepAttr = !0, de.forceKeepAttr = void 0, v(X.uponSanitizeAttribute, _, de), St = de.attrValue, x && (Lt === "id" || Lt === "name") && xk(St, D) !== 0 && (Rn(Ke, _), St = D + St), Qe && jt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, St)) {
        Rn(Ke, _);
        continue;
      }
      if (Lt === "attributename" && bk(St, "href")) {
        Rn(Ke, _);
        continue;
      }
      if (de.forceKeepAttr)
        continue;
      if (!de.keepAttr) {
        Rn(Ke, _);
        continue;
      }
      if (!Ee && jt(/\/>/i, St)) {
        Rn(Ke, _);
        continue;
      }
      Ge && La([B, O, q], (t0) => {
        St = Mi(St, t0, " ");
      });
      const hf = kn(_.nodeName);
      if (!L(hf, Lt, St)) {
        Rn(Ke, _);
        continue;
      }
      if ($ && typeof g == "object" && typeof g.getAttributeType == "function" && !$n)
        switch (g.getAttributeType(hf, Lt)) {
          case "TrustedHTML": {
            St = $.createHTML(St);
            break;
          }
          case "TrustedScriptURL": {
            St = $.createScriptURL(St);
            break;
          }
        }
      if (St !== Jr)
        try {
          $n ? _.setAttributeNS($n, Ke, St) : _.setAttribute(Ke, St), c(_) ? Dn(_) : kk(n.removed);
        } catch {
          Rn(Ke, _);
        }
    }
    v(X.afterSanitizeAttributes, _, null);
  }, G = function(_) {
    let Z = null;
    const de = r(_);
    for (v(X.beforeSanitizeShadowDOM, _, null); Z = de.nextNode(); )
      v(X.uponSanitizeShadowNode, Z, null), P(Z), te(Z), Z.content instanceof o && G(Z.content);
    v(X.afterSanitizeShadowDOM, _, null);
  };
  return n.sanitize = function(_) {
    let Z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, de = null, Se = null, ne = null, Ke = null;
    if (xn = !_, xn && (_ = "<!-->"), typeof _ != "string" && !p(_) && (_ = EL(_), typeof _ != "string"))
      throw Qo("dirty is not a string, aborting");
    if (!n.isSupported)
      return _;
    if (ge || Vn(Z), n.removed = [], typeof _ == "string" && (Y = !1), Y) {
      const Lt = _.nodeName;
      if (typeof Lt == "string") {
        const Jr = kn(Lt);
        if (!xe[Jr] || Oe[Jr])
          throw Qo("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (_ instanceof l)
      de = Mn("<!---->"), Se = de.ownerDocument.importNode(_, !0), Se.nodeType === Ua.element && Se.nodeName === "BODY" || Se.nodeName === "HTML" ? de = Se : de.appendChild(Se);
    else {
      if (!Le && !Ge && !he && // eslint-disable-next-line unicorn/prefer-includes
      _.indexOf("<") === -1)
        return $ && mn ? $.createHTML(_) : _;
      if (de = Mn(_), !de)
        return Le ? null : mn ? I : "";
    }
    de && De && Dn(de.firstChild);
    const $n = r(Y ? _ : de);
    for (; ne = $n.nextNode(); )
      P(ne), te(ne), ne.content instanceof o && G(ne.content);
    if (Y)
      return _;
    if (Le) {
      if (Ge) {
        de.normalize();
        let Lt = de.innerHTML;
        La([B, O, q], (Jr) => {
          Lt = Mi(Lt, Jr, " ");
        }), de.innerHTML = Lt;
      }
      if (Pe)
        for (Ke = Q.call(de.ownerDocument); de.firstChild; )
          Ke.appendChild(de.firstChild);
      else
        Ke = de;
      return (K.shadowroot || K.shadowrootmode) && (Ke = ie.call(i, Ke, !0)), Ke;
    }
    let Tn = he ? de.outerHTML : de.innerHTML;
    return he && xe["!doctype"] && de.ownerDocument && de.ownerDocument.doctype && de.ownerDocument.doctype.name && jt(mS, de.ownerDocument.doctype.name) && (Tn = "<!DOCTYPE " + de.ownerDocument.doctype.name + `>
` + Tn), Ge && La([B, O, q], (Lt) => {
      Tn = Mi(Tn, Lt, " ");
    }), $ && mn ? $.createHTML(Tn) : Tn;
  }, n.setConfig = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(_), ge = !0;
  }, n.clearConfig = function() {
    gn = null, ge = !1;
  }, n.isValidAttribute = function(_, Z, de) {
    gn || Vn({});
    const Se = kn(_), ne = kn(Z);
    return L(Se, ne, de);
  }, n.addHook = function(_, Z) {
    typeof Z == "function" && Va(X[_], Z);
  }, n.removeHook = function(_, Z) {
    if (Z !== void 0) {
      const de = SL(X[_], Z);
      return de === -1 ? void 0 : NL(X[_], de, 1)[0];
    }
    return kk(X[_]);
  }, n.removeHooks = function(_) {
    X[_] = [];
  }, n.removeAllHooks = function() {
    X = Ik();
  }, n;
}
var qL = pS();
const HL = "_messageContainer_1rxr4_1", WL = "_chip_1rxr4_7", GL = "_chipLabel_1rxr4_10", KL = "_chipValue_1rxr4_13", Xo = {
  messageContainer: HL,
  chip: WL,
  chipLabel: GL,
  chipValue: KL
}, Ek = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, YL = ({
  messages: e,
  customFields: n,
  attachments: t,
  conversationContext: i
}) => {
  He(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ rn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ rn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ rn.jsx(We, { content: "Conversation Attributes", children: /* @__PURE__ */ rn.jsx(
        Xm,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ rn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ rn.jsx(An, { className: Xo.chip, children: /* @__PURE__ */ rn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ rn.jsxs(et, { className: Xo.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ rn.jsx(et, { className: Xo.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ rn.jsx(
      b,
      {
        className: Xo.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? Ek[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? Ek[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ rn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ rn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ rn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ rn.jsx(R0, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ rn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: qL.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    t && /* @__PURE__ */ rn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: t.map((o, s) => /* @__PURE__ */ rn.jsx(
      O0,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ rn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, QL = "_conversation_1draa_1", JL = "_conversationSubLine_1draa_9", XL = "_modal_1draa_14", Vu = {
  conversation: QL,
  conversationSubLine: JL,
  modal: XL
}, ZL = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), eV = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, t]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: t?.value ? t.value.toString() : ""
})), nV = ({
  conversation: e,
  conversationContext: n
}) => {
  const [t, i] = le(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ rn.jsxs(b, { className: Vu.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ rn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ rn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ rn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ rn.jsx(Pn, { size: "small", variant: "info", children: Ln(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ rn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Vu.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ rn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ rn.jsx(An, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ rn.jsx(We, { content: "Show conversation preview", children: /* @__PURE__ */ rn.jsx(
        nr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ rn.jsxs(
      Tt,
      {
        isOpen: t,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Vu.modal,
        children: [
          /* @__PURE__ */ rn.jsx(
            $t,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ rn.jsx(Dt, { children: /* @__PURE__ */ rn.jsx(
            YL,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: ZL(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: eV(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, tV = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: t
}) => {
  const [i, a] = le(!1), o = t > 0 ? t : 1, s = e?.length > o, l = Bn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ rn.jsx(
      nV,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ rn.jsxs(
      Gn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, rV = kL(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), iV = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = le([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = hn(), { data: l, loading: d, error: m } = s(rV, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return He(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ rn.jsx(Fn, { error: m }) : d ? /* @__PURE__ */ rn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ rn.jsx(un, {}) }) : t?.length === 0 ? /* @__PURE__ */ rn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ rn.jsx(
    tV,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: t,
      conversationContext: e
    }
  );
}, Pm = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], zu = "MIUROS", aV = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, oV = ({
  integrationId: e,
  configuration: n,
  handleRedirect: t,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = _t({
    mode: "onChange",
    defaultValues: aV
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = Ni({
    integrationId: e,
    integrationType: zu,
    handleRedirect: t,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: z
  } = ji({
    integrationId: e,
    fieldDefinitions: Pm,
    form: l,
    onMisconfigured: C
  }), { renderConditions: $, setRenderConditions: I, renderConditionsForSubmit: T } = wi({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (J) => Fi(J, {
    fieldDefinitions: Pm,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: T
  }), Q = l.watch("name");
  return /* @__PURE__ */ rn.jsxs(
    Ci,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ rn.jsx(Ii, { cause: g }),
        /* @__PURE__ */ rn.jsxs(st, { children: [
          /* @__PURE__ */ rn.jsx(be, { children: /* @__PURE__ */ rn.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ rn.jsx(
            Jn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3, children: /* @__PURE__ */ rn.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3 }),
          /* @__PURE__ */ rn.jsx(be, { span: 3, children: /* @__PURE__ */ rn.jsx(
            tt,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3 }),
          /* @__PURE__ */ rn.jsx(be, { span: 3, children: /* @__PURE__ */ rn.jsx(
            Ym,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3 }),
          /* @__PURE__ */ rn.jsx(be, { span: 3, children: /* @__PURE__ */ rn.jsx(
            tt,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (J) => !Number.isNaN(Number.parseInt(J, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3 }),
          !s && e && /* @__PURE__ */ rn.jsx(
            sa,
            {
              configuration: n,
              integrationId: e,
              integrationType: zu,
              label: "Authorize"
            }
          ),
          o && $ !== null && /* @__PURE__ */ rn.jsx(be, { children: o({
            value: $,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ rn.jsx(
          Ei,
          {
            integrationType: zu,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Uu = { exports: {} }, Ma = {}, Tk;
function sV() {
  if (Tk) return Ma;
  Tk = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ma.Fragment = t, Ma.jsx = s, Ma.jsxs = s, Ma;
}
var Zo = {}, $k;
function lV() {
  return $k || ($k = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Zo.Fragment = i, Zo.jsx = Rn, Zo.jsxs = Mn;
  })()), Zo;
}
var Dk;
function cV() {
  return Dk || (Dk = 1, process.env.NODE_ENV === "production" ? Uu.exports = sV() : Uu.exports = lV()), Uu.exports;
}
var je = cV();
const dV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, uV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, mV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, pV = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": dV,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": uV,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": mV
};
function Qp(e) {
  return pV[e] ?? {};
}
const fV = Qp(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), hV = Qp(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), yV = Qp(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function Am(e = !1, n) {
  const [t, i] = le(e);
  return He(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const gV = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, fS = "DD MMM YYYY @ HH:mm", vV = "_list_2c4dq_1", kV = "_listItem_2c4dq_4", bV = "_copyIcon_2c4dq_12", xi = {
  list: vV,
  listItem: kV,
  copyIcon: bV
}, Lm = ({
  address: e,
  icon: n,
  title: t,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = Am(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: g,
    country_code: C
  } = e ?? {}, S = `${d} ${m}`.trim() || void 0, N = `${h} ${g}`.trim() || void 0, w = [S, u, f, N, C].filter(
    Boolean
  );
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ je.jsx(pe, { size: l, name: n }),
      i ? /* @__PURE__ */ je.jsx(un, { size: l }) : /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
        t && /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "3", children: t }),
        /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: w.map((y, z) => /* @__PURE__ */ je.jsx(et, { children: y }, z)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ je.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ je.jsx(We, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ je.jsx(
        pe,
        {
          size: l,
          name: "exclamation",
          className: xi.copyIcon
        }
      ) }),
      /* @__PURE__ */ je.jsx(We, { content: `Copy ${t ? t.toLowerCase() : "address"}`, children: /* @__PURE__ */ je.jsx(
        pe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(w.join(", ")),
          className: xi.copyIcon
        }
      ) })
    ] })
  ] });
}, xV = "_wrapper_1nher_1", _V = {
  wrapper: xV
}, SV = ({
  customer: e,
  store: n
}) => {
  const { track: t } = _n(), { isCopied: i, copy: a } = Am(), { isCopied: o, copy: s } = Am(), { useQuery: l } = hn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(hV, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, g = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, C = (h?.addresses?.length ?? 0) > 1;
  if (He(() => {
    g && t("recharge:profile:received");
  }, [g, t]), u)
    return /* @__PURE__ */ je.jsx(Fn, { error: u });
  if (!e)
    return null;
  const {
    id: S,
    phone: N,
    email: w,
    first_name: y,
    last_name: z,
    created_at: $,
    has_valid_payment_method: I
  } = e, T = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${S}` : null, Q = `${y || ""} ${z || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ je.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(b, { className: _V.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(A.Heading, { variant: "heading-2", children: Q }),
    $ && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: Ln($).format(fS) })
    ] }),
    w && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(pe, { size: T, name: "mail" }),
        /* @__PURE__ */ je.jsx(A.ExternalLink, { href: `mailto:${w}`, children: w })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: "Copy email", children: /* @__PURE__ */ je.jsx(
        pe,
        {
          size: T,
          name: i ? "done" : "copy",
          onClick: () => a(w),
          className: xi.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(pe, { size: T, name: "phone" }),
        /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: N })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ je.jsx(
        pe,
        {
          size: T,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: xi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ je.jsx(
      Lm,
      {
        address: g,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: C
      }
    ),
    /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(pe, { size: T, name: "credit-card" }),
        /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ je.jsx(
        pe,
        {
          size: T,
          name: I ? "check-circle" : "close-circle-filled",
          color: I ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ je.jsx(pe, { size: T, name: "external-link" }),
      /* @__PURE__ */ je.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => t("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, NV = "_order_1dlaa_1", jV = "_orderIsOpen_1dlaa_9", wV = "_orderHeader_1dlaa_12", CV = "_note_1dlaa_16", es = {
  order: NV,
  orderIsOpen: jV,
  orderHeader: wV,
  note: CV
}, FV = ({
  order: e,
  isOpenByDefault: n,
  store: t
}) => {
  const { track: i } = _n(), [a, o] = le(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: g,
    total_price: C,
    is_prepaid: S
  } = e, N = 14, w = t ? `https://${t.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      className: it(es.order, {
        [es.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ je.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: es.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ je.jsx(b, { alignItems: "center", children: /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: Ln(f).format(fS) }) }),
                /* @__PURE__ */ je.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ je.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ je.jsx(We, { content: "Note", children: /* @__PURE__ */ je.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: es.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(pe, { size: N, name: "activity" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: gV(l) })
            ] })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(pe, { size: N, name: "credit-card" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: S ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(pe, { size: N, name: "cog" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(pe, { size: N, name: "chart-bar" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ je.jsxs(A.Paragraph, { variant: "4", children: [
                C,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ je.jsx(
            Lm,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ je.jsx(
            Lm,
            {
              address: g,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          w && /* @__PURE__ */ je.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(w, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ je.jsx(pe, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, IV = ({
  customerId: e,
  store: n
}) => {
  const { track: t } = _n(), { useQuery: i } = hn(), {
    loading: a,
    error: o,
    data: s
  } = i(yV, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ je.jsx(Fn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ je.jsx(Pn, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ je.jsx(un, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ je.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ je.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ je.jsx(
        FV,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ je.jsx(
        Et,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ je.jsx(pe, { name: "external-link" }),
          onClick: () => t("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, EV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: t
  } = e, i = t ?? 0, a = n ?? 0;
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ je.jsxs(Ye, { className: xi.list, children: [
      /* @__PURE__ */ je.jsx(Ye.Text, { variant: "dense", className: xi.listItem, children: /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ je.jsx(Ye.Text, { variant: "dense", className: xi.listItem, children: /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ je.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, TV = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = hn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = t(fV, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const g = m.graphQLErrors;
    return Wm({ errors: g }) ? /* @__PURE__ */ je.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Gm({ errors: g }) ? /* @__PURE__ */ je.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ je.jsx(Fn, { error: m });
  }
  return d ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ je.jsx(un, {}) }) : f ? l ? /* @__PURE__ */ je.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ je.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ je.jsx(SV, { customer: f, store: h }),
        o && /* @__PURE__ */ je.jsx(EV, { customer: f }),
        s && /* @__PURE__ */ je.jsx(IV, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ je.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, Vm = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], $V = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, DV = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: t,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = _t({
    mode: "onChange",
    defaultValues: $V
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: g
  } = Ni({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: t
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: w,
    widgetConfiguration: y
  } = ji({
    integrationId: e,
    fieldDefinitions: Vm,
    form: s,
    onMisconfigured: g
  }), { renderConditions: z, setRenderConditions: $, renderConditionsForSubmit: I } = wi({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), T = (Q) => Fi(Q, {
    fieldDefinitions: Vm,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ je.jsxs(
    Ci,
    {
      form: s,
      integrationId: e,
      onValidSubmit: T,
      error: S ?? f,
      onRetry: S ? w : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ je.jsx(Ii, { cause: h }),
        /* @__PURE__ */ je.jsxs(st, { children: [
          /* @__PURE__ */ je.jsx(be, { children: /* @__PURE__ */ je.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ je.jsx(
            Jn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(
            Ym,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(ln, { label: "Displays details of a customer", children: /* @__PURE__ */ je.jsx(
            Jn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(ln, { label: "Displays the subscription overview", children: /* @__PURE__ */ je.jsx(
            Jn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(ln, { label: "Displays the last 5 orders", children: /* @__PURE__ */ je.jsx(
            Jn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          a && z !== null && /* @__PURE__ */ je.jsx(be, { children: a({
            value: z,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          Ei,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_yc0fe_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._order_yc0fe_6{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_yc0fe_6:hover,._orderIsOpen_yc0fe_14{border-color:var(--dixa-color-neutral-400)}._orderHeader_yc0fe_17{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Mu = { exports: {} }, Ba = {}, Rk;
function RV() {
  if (Rk) return Ba;
  Rk = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ba.Fragment = t, Ba.jsx = s, Ba.jsxs = s, Ba;
}
var ns = {}, Ok;
function OV() {
  return Ok || (Ok = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ns.Fragment = i, ns.jsx = Rn, ns.jsxs = Mn;
  })()), ns;
}
var Pk;
function PV() {
  return Pk || (Pk = 1, process.env.NODE_ENV === "production" ? Mu.exports = RV() : Mu.exports = OV()), Mu.exports;
}
var k = PV();
const Ak = "__PairingContext__", AV = () => globalThis[Ak] ?? (() => {
  const e = Yb({});
  return globalThis[Ak] = e, e;
})(), LV = AV(), VV = () => Qm(LV), zV = "_banner_d9pot_1", UV = "_list_d9pot_8", Lk = {
  banner: zV,
  list: UV
}, Vk = "https://apps.shopify.com/dixa-dashboard", MV = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, hS = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: t } = VV(), [i, a] = le(!1), [o, s] = le(null), l = MV[n], d = async () => {
    if (n === "install" && t) {
      a(!0), s(null);
      try {
        const u = await t();
        window.open(
          u ?? Vk,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Vk, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: Lk.banner, children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(pe, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: Lk.list, children: l.listItems.map((u, f) => /* @__PURE__ */ k.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Gn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(un, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, BV = (e) => /* @__PURE__ */ k.jsx(hS, { ...e, bannerVariant: "install" }), qV = (e) => /* @__PURE__ */ k.jsx(hS, { ...e, bannerVariant: "migration" }), HV = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], WV = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], GV = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: BV
  }
], KV = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], zk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: qV,
    additionalProperties: { renderAboveForm: !0 }
  }
], yS = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Uk = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => qb(e)
  },
  ...yS
];
var Yi = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Yi || {}), _i = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(_i || {}), $r = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))($r || {}), gS = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(gS || {}), pi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(pi || {}), Wr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Wr || {}), bs = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(bs || {}), vS = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(vS || {});
const YV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, QV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, JV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, XV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, ZV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, e3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, n3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, t3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, r3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, i3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, a3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, o3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, s3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, l3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, c3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, d3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, u3 = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": YV,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": QV,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": JV,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": XV,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": ZV,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": e3,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": n3,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": t3,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": r3,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": i3,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": a3,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": o3,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": s3,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": l3,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": c3,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": d3
};
function yr(e) {
  return u3[e] ?? {};
}
const m3 = yr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), p3 = yr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), f3 = yr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), h3 = yr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Jp = yr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), y3 = yr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), g3 = yr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), v3 = yr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), k3 = yr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), b3 = yr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), x3 = yr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), _3 = yr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), kS = Ks`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, S3 = Ks`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, N3 = ({
  conversationContext: e
}) => {
  const { useQuery: n } = hn(), t = e.customer?.email, i = e.customer?.phone_number, a = t ? `email:"${t}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(m3, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, j3 = () => {
  const { useLazyQuery: e } = hn(), [
    n,
    {
      loading: t,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(p3);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: t,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Pr(e = !1, n) {
  const [t, i] = le(e);
  return He(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const w3 = "_list_alvh6_1", C3 = "_listItem_alvh6_4", F3 = "_fullWidth_alvh6_15", I3 = "_boxWrapper_alvh6_19", Ot = {
  list: w3,
  listItem: C3,
  fullWidth: F3,
  boxWrapper: I3
}, E3 = "_modal_1vkwz_1", T3 = "_disabled_1vkwz_5", Bu = {
  modal: E3,
  disabled: T3
}, Mk = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: _i.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: _i.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: _i.Unknown
  }
], Bk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: $r.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: $r.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: $r.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: $r.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: $r.Unsubscribed
  }
], $3 = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: t,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = _n(), { useMutation: l, showNotification: d } = hn(), [m, u] = le(), [f, h] = le(), [g, C] = Jf(!0), [S, N] = Jf(!0), w = !!m, y = e.customer?.email, z = e.customer?.phone_number, $ = e.customer?.given_name, I = e.customer?.family_name, T = {
    email: y ?? "",
    phone: z ?? "",
    firstName: $ ?? "",
    lastName: I ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = _t({
    defaultValues: T
  });
  He(() => {
    f?.forEach((O) => {
      const q = O?.field?.[0];
      q && (U.setError(q, {
        type: "server",
        message: O.message
      }), U.setFocus(q));
    });
  }, [f, U]);
  const [Q, { error: J, reset: ie }] = l(x3, {
    onError: (O) => {
      u(O.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (O) => {
      const q = O?.Shopify?.customerCreate?.userErrors || [];
      q.length > 0 ? (h(q), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), t(!1));
    }
  }), X = ot(
    (O) => {
      a(!0), u(void 0), Q({
        variables: {
          input: {
            firstName: O.firstName,
            lastName: O.lastName,
            ...g && { email: O.email },
            ...S && { phone: O.phone },
            ...O.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: O.smsMarketingState,
                marketingOptInLevel: O.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Q, a, S, g]
  ), B = () => {
    t(!1), ie(), u(void 0), U.reset(T);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: n, onClose: B, className: Bu.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: "Create new customer", onClose: B }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(st, { children: [
      /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: g ? "Email is required" : void 0
          },
          componentProps: {
            className: it({
              [Bu.disabled]: !g
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                im,
                {
                  disabled: !S,
                  name: "hasEmail",
                  value: "email",
                  checked: g,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: S ? "Phone is required" : void 0
          },
          componentProps: {
            className: it({
              [Bu.disabled]: !S
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                im,
                {
                  disabled: !g,
                  name: "hasPhone",
                  value: "phone",
                  checked: S,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = Bk.find(
                (ee) => ee.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: Bk.map((O) => /* @__PURE__ */ k.jsx(ut.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = Mk.find(
                (ee) => ee.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: Mk.map((O) => /* @__PURE__ */ k.jsx(ut.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      w && /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(pe, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(X),
        cancelOnClick: B,
        confirmName: J ? "Close" : "Save",
        cancelName: J ? void 0 : "Cancel"
      }
    )
  ] });
}, D3 = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [t, i] = le(!1), [a, o] = le(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Gn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(pe, { size: 14, name: "user-plus", color: "green.500" }),
        className: Ot.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      $3,
      {
        isOpen: t,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Xp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, zm = "DD MMM YYYY @ HH:mm", R3 = "_wrapper_10fld_1", O3 = "_copyIcon_10fld_7", ts = {
  wrapper: R3,
  copyIcon: O3
}, P3 = ({
  customer: e,
  shopifyDomain: n,
  refresh: t,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Pr(), { isCopied: l, copy: d } = Pr(), { track: m } = _n();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: g,
    tags: C = [],
    verifiedEmail: S
  } = e, N = h?.emailAddress, w = g?.phoneNumber, y = Xp(u), z = `https://${n}/admin/customers/${y ?? ""}`, $ = i && a === er.refetch, I = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: ts.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        $ ? /* @__PURE__ */ k.jsx(un, { size: I }) : /* @__PURE__ */ k.jsx(We, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: I,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), t();
            },
            className: ts.copyIcon
          }
        ) })
      ] }),
      N && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(pe, { size: I, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${N}`, children: N }),
          /* @__PURE__ */ k.jsx(
            We,
            {
              content: S ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                pe,
                {
                  size: I,
                  color: S ? "green.500" : "red.500",
                  name: S ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(We, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: I,
            name: o ? "done" : "copy",
            onClick: () => s(N),
            className: ts.copyIcon
          }
        ) })
      ] }),
      w && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(pe, { size: I, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${w}`, children: w })
        ] }),
        /* @__PURE__ */ k.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: I,
            name: l ? "done" : "copy",
            onClick: () => d(w),
            className: ts.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(pe, { size: I, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: z,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    C.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: C.map((T) => /* @__PURE__ */ k.jsx(An, { children: T }, `${u}-${T}`)) })
    ] })
  ] });
}, A3 = "_creationModal_pbe64_1", L3 = "_detailsModal_pbe64_5", V3 = "_percentageSuffix_pbe64_9", qu = {
  creationModal: A3,
  detailsModal: L3,
  percentageSuffix: V3
}, z3 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, U3 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, t = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: gS.All
    },
    ...t && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [t]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, qk = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], Hk = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Wk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], M3 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: t, copy: i } = or(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Ye, { children: [
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            pe,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: Ln(e?.startsAt).format(xt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(ln, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      Nr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: t ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, B3 = "shopify-discount-code-form", Gk = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, q3 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: t } = _n(), { useMutation: i, showNotification: a } = hn(), [o, s] = le(
    []
  ), [l, d] = le(), m = _t({
    mode: "all",
    defaultValues: Gk
  });
  He(() => {
    o?.forEach((I) => {
      const T = I?.field?.[1];
      T && m.setError(T, {
        type: "server",
        message: I.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), g = Bn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    C,
    {
      loading: S,
      error: N,
      reset: w
    }
  ] = i(_3, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (I) => {
      const T = I?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (T && T.length > 0)
        s(T);
      else {
        const U = I?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && d(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), t("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", z3(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, z = (I) => {
    C({
      variables: {
        input: U3(I)
      }
    });
  }, $ = () => {
    m.reset(Gk), s([]), w(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: $,
      className: it({
        [qu.creationModal]: !u,
        [qu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          $t,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: $
          }
        ),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          u && /* @__PURE__ */ k.jsx(M3, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: B3, onSubmit: m.handleSubmit(z), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              Gs,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(st, { children: [
              /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (I, T) => I === T,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (I) => {
                      const T = qk.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T?.label }) });
                    }
                  },
                  children: qk.map((I) => /* @__PURE__ */ k.jsx(ut.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (I) => {
                      if (I) {
                        if (h === "percentage" && (I < 0 || I > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && I < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: qu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (I, T) => I === T,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (I) => {
                      const T = Hk.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T?.label }) });
                    }
                  },
                  children: Hk.map((I) => /* @__PURE__ */ k.jsx(ut.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  name: "minimumRequirementValue",
                  label: g,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (I) => {
                      if (I && f !== "none" && I < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (I, T) => I === T,
                    getItemTitleByValue: (I) => {
                      const T = Wk.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T?.label }) });
                    }
                  },
                  children: Wk.map((I) => /* @__PURE__ */ k.jsx(ut.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) })
            ] })
          ] }),
          N && /* @__PURE__ */ k.jsx(Fn, { error: N })
        ] }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: S,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? $ : m.handleSubmit(z),
            cancelOnClick: u ? void 0 : $
          }
        )
      ]
    }
  );
}, H3 = ({ code: e }) => {
  const { isCopied: n, copy: t } = Pr();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(pe, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          nr,
          {
            icon: n ? "done" : "copy",
            onClick: () => t(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, W3 = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const t = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    t && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(Ye, { children: i.map((a) => /* @__PURE__ */ k.jsx(Ye.Item, { className: Ot.listItem, children: /* @__PURE__ */ k.jsx(H3, { code: a.code }, a.id) }, a.id)) })
  ] });
}, G3 = "_modal_11d6e_1", K3 = "_modalBody_11d6e_4", Y3 = "_codeContainer_11d6e_9", Hu = {
  modal: G3,
  modalBody: K3,
  codeContainer: Y3
}, Q3 = [50, 100, 250], bS = 50, J3 = {
  maxNumberOfCodesToDisplay: bS
}, X3 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: t } = hn(), [i, a] = le(
    bS
  ), [o, s] = le([]), l = o.length === 0, d = o.length > i, m = _t({
    mode: "all",
    defaultValues: J3
  }), { loading: u, error: f } = t(y3, {
    variables: {
      first: i
    },
    onCompleted: (g) => {
      const C = g?.Shopify?.codeDiscountNodes?.nodes ?? [];
      C && C.length > 0 && s(C);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: e, onClose: h, className: Hu.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(Dt, { className: Hu.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(st, { children: /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (g) => {
              a(g.selectedValues[0]);
            },
            getItemTitleByValue: (g) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: g }) })
          },
          children: Q3.map((g) => /* @__PURE__ */ k.jsx(ut.Item, { value: g, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: g }) }, g))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        Ns,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((g) => /* @__PURE__ */ k.jsx("div", { className: Hu.codeContainer, children: /* @__PURE__ */ k.jsx(W3, { discountCode: g }) }, g.id))
    ] }),
    /* @__PURE__ */ k.jsx(Pt, { confirmName: "Close", confirmOnClick: h })
  ] });
}, Z3 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, t] = le(!1), [i, a] = le(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Gn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Gn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => t(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      X3,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      q3,
      {
        isOpen: n,
        setIsOpen: t
      }
    )
  ] });
}, ez = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: t } = e, i = (h) => h ? Wb(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Yi.Invalid:
      case Yi.NotSubscribed:
      case $r.NotSubscribed:
        return "red.500";
      case Yi.Pending:
      case $r.Pending:
      case Yi.Unsubscribed:
      case $r.Unsubscribed:
        return "orange.500";
      case Yi.Subscribed:
      case $r.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case _i.SingleOptIn:
      case _i.ConfirmedOptIn:
        return "green.500";
      case _i.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = t ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(pe, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "info", children: Ln(l).format(zm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(We, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(An, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(We, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(An, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(pe, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "info", children: Ln(u).format(zm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(We, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(An, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(We, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(An, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, nz = ({
  ordersData: e
}) => {
  const n = (t) => t?.fulfillments?.length > 0 ? t.fulfillments[0].trackingInfo : [];
  return e.map(({ node: t }) => ({
    id: t.id,
    name: t.name,
    createdAt: new Date(t.createdAt),
    cancelledAt: t.cancelledAt ? new Date(t.cancelledAt) : void 0,
    status: `${t.displayFulfillmentStatus?.toLowerCase()}, ${t.displayFinancialStatus?.toLowerCase()}${t.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: t.displayFinancialStatus,
    currentTotalPriceSet: t.currentTotalPriceSet,
    value: t.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: t.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: t.shippingAddress,
    billingAddress: t.billingAddress,
    lineItems: t.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: t.id,
      amount: t.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: t.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: t.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: t.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: vS.Refund,
          orderId: t.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(t),
    shippingLines: t.shippingLines?.edges?.map(({ node: i }) => i),
    tags: t.tags,
    refunds: t.refunds
  }));
}, Kk = [
  {
    value: Wr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Wr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Wr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Wr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Wr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Wr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Wr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], Yk = [
  {
    value: bs.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: bs.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: bs.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], xS = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), Qi = (e) => tz(rz(e)), tz = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), rz = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: t, ...i } = n;
    return {
      ...i,
      ...t && { countryCode: t }
    };
  }
  return e;
}, di = ({
  control: e,
  name: n,
  label: t,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  Wt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      pr,
      {
        required: a,
        label: t,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), iz = "_modal_1wlra_1", az = {
  modal: iz
};
function Qk(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Jk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Xk = "shopify-shiping-address-form", oz = ({
  title: e,
  address: n,
  isOpen: t,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = hn(), { track: f } = _n(), [h, g] = le(!1), [C, S] = le({}), N = !l, [
    w,
    { error: y, reset: z }
  ] = m(g3, {
    onError: () => {
      g(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (X) => {
      g(!1);
      const B = X?.Shopify?.orderUpdate?.userErrors;
      if (B != null && B.length > 0) {
        const O = B.reduce(
          (q, ee) => {
            const ve = ee.field;
            if (ve == null || ve.length === 0)
              return q;
            const ue = ve[ve.length - 1];
            return ue != null && (q[ue] = ee.message), q;
          },
          {}
        );
        S(O);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ie();
    }
  }), $ = ot(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: Jk.find(
        (X) => X === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: I, handleSubmit: T, formState: U, reset: Q } = _t({
    mode: "all",
    defaultValues: $()
  }), J = T((X) => {
    if (N) {
      if (g(!0), !o || !a) {
        g(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: B, ...O } = X, q = {
        ...O,
        countryCode: B
      };
      w({
        variables: {
          input: {
            id: a,
            shippingAddress: q
          }
        }
      });
    } else
      l(X), ie();
  });
  He(() => {
    t && Q($());
  }, [t, n, Q, $]);
  const ie = () => {
    Q($()), S({}), z(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: t,
      onClose: ie,
      className: az.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx($t, { title: e, onClose: () => ie() }),
        /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Xk, onSubmit: J, children: [
          y && /* @__PURE__ */ k.jsx(Fn, { error: y }),
          /* @__PURE__ */ k.jsxs(st, { children: [
            /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: I,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: I,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 6, children: /* @__PURE__ */ k.jsx(
              di,
              {
                control: I,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 6, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: I,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 6, children: /* @__PURE__ */ k.jsx(
              di,
              {
                control: I,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: I,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
              di,
              {
                required: !0,
                control: I,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 6, children: /* @__PURE__ */ k.jsx(
              jr,
              {
                name: "countryCodeV2",
                control: I,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (X) => X ? Qk(X) : ""
                },
                children: Jk.filter((X) => s.includes(X)).map((X) => /* @__PURE__ */ k.jsx(ut.Item, { value: X, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: Qk(X) }) }, X))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: Xk,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
            },
            confirmOnClick: () => {
              y && ie();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ie();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, sz = "_clickableIcon_33mqm_1", Wu = {
  clickableIcon: sz
}, Zk = ({
  formFieldName: e,
  ...n
}) => {
  const t = Lr(), { field: i } = fp({
    control: t.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    Um,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, Um = ({
  labelText: e,
  address: n,
  orderId: t,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = le(!1), [h, g] = le(m), { isCopied: C, copy: S } = Pr(), { track: N } = _n(), w = 14, y = o && (!!t || !!l), z = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), $ = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), I = n?.countryCodeV2 && y0(n.countryCodeV2), T = ot(() => [
    $,
    n?.company,
    n?.address1,
    n?.address2,
    z,
    n?.province,
    I
  ].filter(Boolean).join(`
`), [n, $, z, I]);
  if (!n)
    return null;
  const U = () => {
    i && t && N("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: t
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(pe, { size: w, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => g(!h),
              className: Wu.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: w,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            $ && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: $ }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            z && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: z }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            I && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: I })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(We, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: w,
            name: "pen",
            onClick: () => U(),
            className: Wu.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(We, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: w,
            name: C ? "done" : "copy",
            onClick: () => S(T()),
            className: Wu.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      oz,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: t,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, Zp = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const t = Lr(), i = fs({ control: t.control, name: "lineItems" }), a = fs({
    control: t.control,
    name: "billingAddress"
  }), o = fs({
    control: t.control,
    name: "shippingAddress"
  }), s = Bn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Bn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        Zk,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        Zk,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, lz = "_productTableHeader_6h6pl_1", cz = "_productImage_6h6pl_5", oo = {
  productTableHeader: lz,
  productImage: cz
}, ef = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, dz = ({
  product: e,
  index: n,
  onRemove: t
}) => {
  const i = Lr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = ef(e);
  return /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        la,
        {
          src: d,
          alt: e.title,
          className: oo.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
      tt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(nr, { icon: "trash", variant: "secondary", onClick: t }) }) })
  ] });
}, uz = 300, qa = 2, mz = 25, pz = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: t } = hn(), [i, a] = le(""), [o, s] = le([]), l = Lr(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Jp, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (S) => {
      const N = S?.Shopify?.products?.nodes || [];
      s(
        N.filter((w) => !!w).sort((w, y) => w.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), t({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  Ti(
    () => {
      i.trim().length >= qa && !u && f === er.ready ? m({
        variables: {
          query: i.trim(),
          productCount: mz,
          mediaCount: 1
        }
      }) : i.trim().length < qa && s([]);
    },
    uz,
    [i]
  ), He(() => {
    if (!d) return;
    const S = o.find(
      (N) => N.id === d
    );
    S && e(S), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== er.ready, g = i.trim().length >= qa, C = !o.length && !h && g;
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${qa} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (S) => {
          const N = o.find(
            (w) => w.id === S
          );
          return N ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: N.title }) : null;
        },
        filter: {
          value: i,
          onChange: (S) => {
            a(S.target.value);
          }
        },
        onToggleDropdown: (S) => {
          !S && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(un, {}) }) }),
        !h && o.map((S) => {
          const N = S.totalInventory <= 0, w = ef(S);
          return /* @__PURE__ */ k.jsx(
            ut.Item,
            {
              value: S.id,
              isDisabled: N,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  w && /* @__PURE__ */ k.jsx(
                    la,
                    {
                      src: w,
                      alt: S.title,
                      className: oo.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    P0,
                    {
                      text: S.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: S.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: N ? "Out of stock" : `${S.totalInventory} in stock` })
              ] })
            },
            S.id
          );
        }),
        C && /* @__PURE__ */ k.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Ns,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !g && !h && /* @__PURE__ */ k.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Ns,
          {
            title: "Search for products",
            description: `Type at least ${qa} characters to search.`
          }
        ) })
      ] })
    }
  );
}, nf = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: t = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Lr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (N) => !o.includes(N?.id)
  ) : [], g = h.length > 0 && h.every(
    (N) => a.includes(N?.id)
  ), C = h.some(
    (N) => a.includes(N?.id)
  ) && !g, S = ot(
    (N) => {
      const w = m.getValues("lineItems"), y = w.findIndex(
        (z) => z?.id === N.id
      );
      if (y > -1) {
        const z = m.getValues(`lineItems.${y}.quantity`) || 0, $ = [...w];
        $[y] = {
          ...$[y],
          quantity: z + 1
        }, m.setValue("lineItems", $);
      } else
        m.setValue("lineItems", [
          ...w,
          { ...N, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(pz, { onProductSelected: S }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Ot.boxWrapper,
        children: /* @__PURE__ */ k.jsx(un, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Ot.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          Ns,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Xn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: oo.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Xn.Thead, { className: oo.productTableHeader, children: /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(Xn.Th, { children: /* @__PURE__ */ k.jsx(
              yf,
              {
                checked: g,
                indeterminate: C,
                onChange: () => d?.(!g)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Total" }),
            !t && /* @__PURE__ */ k.jsx(Xn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Xn.Tbody, { children: u?.map((N, w) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                dz,
                {
                  product: N,
                  index: w,
                  onRemove: () => {
                    const B = u.filter(
                      (O, q) => q !== w
                    );
                    m.setValue("lineItems", B);
                  }
                },
                `${N?.id}-${w}`
              );
            const y = N, z = y.priceRangeV2.minVariantPrice.amount, $ = y.priceRangeV2.minVariantPrice.currencyCode, I = `lineItems.${w}.quantity`, T = m.watch(I) || 0, U = z * T, Q = ef(y), J = a.includes(y.id), ie = o.includes(y.id), X = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              Xn.Tr,
              {
                style: ie ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    yf,
                    {
                      checked: J,
                      disabled: ie,
                      onChange: () => l?.(y.id, !J)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    Q && /* @__PURE__ */ k.jsx(
                      la,
                      {
                        src: Q,
                        alt: y.title,
                        className: oo.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.title }),
                      ie && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${z} ${$}` }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    tt,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ie || X <= 1,
                      name: I,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: X,
                        tabIndex: 0
                      }
                    },
                    `${I}-${m.watch(I)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${U} ${$}` }) }),
                  !t && /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    nr,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const B = u.filter(
                          (O, q) => q !== w
                        );
                        m.setValue("lineItems", B), J && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${w}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, _S = ({
  previousOrderStatus: e
} = {}) => {
  const n = Lr();
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (t) => {
          const i = Kk.find(
            (a) => a.value === t
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Kk.map((t) => {
        const i = e && t.value === e;
        return /* @__PURE__ */ k.jsx(ut.Item, { value: t.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: t.label }),
            i && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: t.description })
        ] }) }, t.value);
      })
    }
  );
}, SS = () => {
  const e = Lr();
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const t = Yk.find(
            (i) => i.value === n
          );
          return t ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: t.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              t.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Yk.map((n) => /* @__PURE__ */ k.jsx(ut.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, fz = "_modal_1mprq_1", hz = {
  modal: fz
}, Gu = "create-shopify-order-form", yz = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: t,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = _n(), [d, m] = le(!1), [
    u,
    f
  ] = le(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, g = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Wr.Pending,
    fulfillmentStatus: void 0
  }, [C, S] = le([]), N = _t({
    mode: "all",
    defaultValues: g
  }), w = N.watch("lineItems").length > 0, y = () => {
    N.reset(g), S([]), i(!1);
  };
  He(() => {
    C.length > 0 && N.setValue("tags", C, { shouldDirty: !0 });
  }, [C, N]);
  const [z, { error: $ }] = o(
    kS,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [I, { error: T }] = o(
    S3,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), U = (J) => {
    const ie = J.lineItems.map((O) => ({
      productId: O.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: O.priceRangeV2.maxVariantPrice.amount,
          currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: O.quantity
    }));
    m(!0);
    const X = Qi(J?.billingAddress), B = Qi(
      J?.shippingAddress
    );
    z({
      variables: {
        order: {
          lineItems: ie,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: J.customNote,
          tags: J.tags,
          financialStatus: J.financialStatus,
          fulfillmentStatus: J.fulfillmentStatus,
          shippingAddress: B,
          billingAddress: X
        }
      }
    });
  }, Q = (J) => {
    const ie = J.lineItems.map((O) => ({
      title: O.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: O.priceRangeV2.maxVariantPrice.amount,
        currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: O.quantity
    }));
    f(!0);
    const X = Qi(J?.billingAddress), B = Qi(
      J?.shippingAddress
    );
    I({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: J.customNote,
          tags: J.tags,
          lineItems: ie,
          shippingAddress: B,
          billingAddress: X
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: y,
      className: hz.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx($t, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(pp, { ...N, children: /* @__PURE__ */ k.jsx("form", { id: Gu, children: /* @__PURE__ */ k.jsxs(st, { children: [
            /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(nf, {}) }),
            /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
              Wt,
              {
                name: "tags",
                render: ({ fieldState: { error: J } }) => /* @__PURE__ */ k.jsx(
                  ln,
                  {
                    label: "Tags",
                    meta: {
                      error: J?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ie) => {
                          ie.key === "Enter" && (ie.preventDefault(), ie.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ws,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: C,
                            onChange: (ie) => {
                              S(ie);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(_S, {}),
              /* @__PURE__ */ k.jsx(SS, {}),
              /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(be, { span: 2, children: /* @__PURE__ */ k.jsx(ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ot.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Zp, {})
              }
            ) }) })
          ] }) }) }),
          ($ || T) && /* @__PURE__ */ k.jsx(Fn, { error: $ || T })
        ] }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              type: "submit",
              form: Gu,
              disabled: !w || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: N.handleSubmit(U),
            ...t && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                N.handleSubmit(Q)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Gu,
                disabled: !w || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, gz = "_modal_al73g_1", vz = {
  modal: gz
}, eb = [
  {
    label: "Customer",
    value: pi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: pi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: pi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: pi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: pi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: pi.Staff,
    description: "Staff made an error."
  }
], kz = ({
  orderId: e,
  isOpen: n,
  orderName: t,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = _n(), { useMutation: d, showNotification: m } = hn(), [u, f] = le([]), h = u.length > 0, g = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, C = _t({
    defaultValues: g
  }), [S, { error: N, reset: w }] = d(k3, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async ($) => {
      const I = $.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (I.length > 0)
        o(!1), f(I), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const T = $.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, T ? 0 : 4e3), m({
          title: "Success",
          text: `${T ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = ot(
    ($) => {
      $.reason != null && (o(!0), S({
        variables: {
          orderId: $.orderId,
          reason: $.reason,
          refundMethod: $.refundMethod,
          restock: $.restock,
          notifyCustomer: $.notifyCustomer,
          staffNote: $.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), z = () => {
    i(!1), w(), f([]), C.reset(g);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: n, onClose: z, className: vz.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: `Cancel order ${t}`, onClose: z }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(st, { children: [
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: C.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: ($, I) => $ === I,
            getItemTitleByValue: ($) => {
              if (!$)
                return "";
              const I = eb.find(
                (T) => T.value === $
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
              ] });
            }
          },
          children: eb.map(($) => /* @__PURE__ */ k.jsx(ut.Item, { value: $.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: $.description })
          ] }) }, $.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(ln, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Jn,
        {
          control: C.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(ln, { label: "Restock items", children: /* @__PURE__ */ k.jsx(Jn, { control: C.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(ln, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Jn, { control: C.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          name: "staffNote",
          label: "Staff note",
          control: C.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map(($) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(pe, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              $.field?.join(","),
              ") ",
              $.message
            ] })
          ]
        },
        $.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          disabled: !(C.formState.isValid && C.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: C.handleSubmit(y),
        cancelOnClick: z,
        confirmName: N ? "Close" : "Cancel order",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, bz = ({
  orderId: e,
  orderName: n,
  refetchOrders: t,
  disabled: i
}) => {
  const [a, o] = le(!1), [s, l] = le(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Gn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Ot.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      kz,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: t
      }
    )
  ] });
}, xz = "_modal_1mprq_1", _z = {
  modal: xz
}, Sz = ({
  order: e,
  orderName: n,
  isOpen: t,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = hn(), { track: m } = _n(), [u, f] = le(!1), [h, g] = le(e?.tags || []), C = "duplicate-shopify-order-form", S = (B) => ({
    firstName: B?.firstName,
    lastName: B?.lastName,
    company: B?.company,
    address1: B?.address1,
    address2: B?.address2,
    city: B?.city,
    provinceCode: B?.provinceCode,
    zip: B?.zip,
    countryCode: B?.countryCodeV2,
    phone: B?.phone
  }), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: S(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: S(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, w = _t({
    mode: "all",
    defaultValues: N
  }), y = w.watch("lineItems").length > 0, z = Bn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), $ = Bn(
    () => xS(z),
    [z]
  ), {
    data: I,
    loading: T,
    error: U
  } = d(Jp, {
    skip: !$,
    variables: {
      query: $,
      productCount: z.length,
      mediaCount: 1
    }
  });
  He(() => {
    U && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [U, l]), He(() => {
    if (!t || T || !I || w.getValues("lineItems")?.length)
      return;
    const B = I?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const ee = B.find(
        (ve) => ve.id === q.product?.id
      );
      ee && O.push({
        ...ee,
        quantity: q.quantity || 1,
        sku: q.sku,
        discountedUnitPrice: q.discountedUnitPriceSet?.shopMoney
      });
    }), O.length > 0 && w.setValue("lineItems", O, { shouldDirty: !0 });
  }, [t, I, T, e, w]), He(() => {
    (h.length > 0 || (w.getValues("tags") || []).length > 0) && w.setValue("tags", h, { shouldDirty: !0 });
  }, [h, w]);
  const [Q, { error: J }] = s(
    kS,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), X();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), X();
      }
    }
  ), ie = (B) => {
    const O = B.lineItems.map((ee) => ({
      productId: ee.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ee.discountedUnitPrice?.amount ?? ee.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ee.discountedUnitPrice?.currencyCode ?? ee.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ee.quantity,
      sku: ee.sku
    })), q = (e?.shippingLines ?? []).map(
      (ee) => ({
        title: ee.title,
        code: ee.code,
        source: ee.source,
        priceSet: {
          shopMoney: {
            amount: ee.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ee.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), Q({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: O,
          shippingLines: q,
          note: B.customNote,
          tags: B.tags,
          financialStatus: B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          shippingAddress: Qi(B?.shippingAddress),
          billingAddress: Qi(B?.billingAddress)
        }
      }
    });
  }, X = () => {
    w.reset(N), g(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: t,
      onClose: X,
      className: _z.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx($t, { title: `Duplicate order ${n}`, onClose: X }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(pp, { ...w, children: /* @__PURE__ */ k.jsx("form", { id: C, children: /* @__PURE__ */ k.jsxs(st, { children: [
            /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(nf, { loading: T }) }),
            /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
              Wt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ k.jsx(
                  ln,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (O) => {
                          O.key === "Enter" && (O.preventDefault(), O.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ws,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (O) => {
                              g(O);
                            }
                          },
                          `tags-input-${t}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                _S,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(SS, {}),
              /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(be, { span: 2, children: /* @__PURE__ */ k.jsx(ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ot.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Zp, {})
              }
            ) }) })
          ] }) }) }),
          J && /* @__PURE__ */ k.jsx(Fn, { error: J })
        ] }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              type: "submit",
              form: C,
              disabled: !y || u || T,
              isLoading: u || T,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: w.handleSubmit(ie)
          }
        )
      ]
    }
  );
}, Nz = "_copyIcon_1dlzg_1", jz = {
  copyIcon: Nz
}, wz = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: t = {}
}) => {
  const { isCopied: i, copy: a } = Pr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(t).some(
    (l) => l > 0
  ), s = n.map(
    ({ title: l, quantity: d, variantTitle: m }) => m ? `${d}x ${l} (${m})` : `${d}x ${l}`
  ).join(`
`);
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(pe, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ k.jsx(We, { content: "Copy line items", children: /* @__PURE__ */ k.jsx(
            pe,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(s),
              className: jz.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(An, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Ye, { children: n.map(({ id: l, title: d, quantity: m, variantTitle: u, image: f }) => {
      const h = t[l], g = h > 0, C = h > 1 ? `Refunded (${h} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: m }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            d,
            " ",
            u && `(${u})`,
            g && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: C })
          ] }),
          contentRight: f?.url && /* @__PURE__ */ k.jsx(la, { src: `${f?.url}&height=48`, alt: d })
        },
        `list-${e}-${l}`
      );
    }) })
  ] });
}, Cz = Ks`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, Fz = (e) => {
  const n = [];
  return e.refunds.forEach((t) => {
    const i = t.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...t,
      refundLineItems: {
        ...t.refundLineItems,
        edges: i
      }
    });
  }), n;
}, NS = (e) => {
  const n = {}, t = Fz(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), t.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, Iz = "_modal_21e62_1", Ez = {
  modal: Iz
}, nb = "partial-refund-shopify-order-form", Tz = ({
  order: e,
  orderName: n,
  isOpen: t,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = _n(), { useQuery: d } = hn(), [m, u] = le(!1), [f, h] = le([]), g = Bn(
    () => e?.refunds ? NS(e) : {},
    [e]
  ), C = Bn(
    () => (e?.lineItems || []).filter((B) => (g[B.id] || 0) >= (B.quantity || 0)).map((B) => B.product?.id).filter((B) => !!B),
    [e, g]
  ), S = Bn(() => {
    const B = {};
    return (e?.lineItems || []).forEach((O) => {
      if (O.product?.id) {
        const q = g[O.id] || 0, ee = Math.max(
          0,
          (O.quantity || 0) - q
        );
        B[O.product.id] = ee;
      }
    }), B;
  }, [e, g]), N = Bn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), w = Bn(
    () => xS(N),
    [N]
  ), {
    data: y,
    loading: z,
    error: $
  } = d(Jp, {
    skip: !w,
    variables: {
      query: w,
      productCount: N.length,
      mediaCount: 1
    }
  });
  He(() => {
    $ && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [$, s]);
  const I = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, T = _t({
    mode: "all",
    defaultValues: I
  }), U = f.length > 0, [Q, { error: J }] = o(
    Cz,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), X();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), X();
      }
    }
  );
  He(() => {
    if (!t || z || !y || T.getValues("lineItems")?.length)
      return;
    const B = y?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const ee = B.find(
        (ve) => ve.id === q.product?.id
      );
      if (ee) {
        const ve = g[q.id] || 0, ue = (q.quantity || 1) - ve;
        O.push({
          ...ee,
          quantity: ue > 0 ? ue : q.quantity || 1
        });
      }
    }), O.length > 0 && (T.setValue("lineItems", O, { shouldDirty: !0 }), h([]));
  }, [
    t,
    y,
    z,
    e,
    T,
    g
  ]);
  const ie = (B) => {
    u(!0);
    const O = (B.lineItems || []).filter(
      (q) => f.includes(q.id)
    ).map((q) => {
      const ee = e?.lineItems?.find(
        (fe) => fe.product?.id === q.id
      ), ve = g[ee?.id || ""] || 0, ue = (ee?.quantity || 0) - ve, ce = Math.max(
        0,
        Math.min(ue, q.quantity || 0)
      );
      return ee && ce > 0 ? { lineItemId: ee.id, quantity: ce } : void 0;
    }).filter((q) => !!q);
    Q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: O,
          note: B.customNote || void 0,
          notify: !0
        }
      }
    });
  }, X = () => {
    T.reset(I), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: t, onClose: X, className: Ez.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: `Refund order ${n}`, onClose: X }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(pp, { ...T, children: /* @__PURE__ */ k.jsx("form", { id: nb, children: /* @__PURE__ */ k.jsxs(st, { children: [
        /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
          nf,
          {
            loading: z,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: C,
            maxQuantities: S,
            onToggleSelect: (B, O) => {
              h((q) => O ? Array.from(/* @__PURE__ */ new Set([...q, B])) : q.filter((ee) => ee !== B));
            },
            onToggleSelectAll: (B) => {
              const O = (T.getValues("lineItems") || []).map((q) => q.id).filter((q) => !C.includes(q));
              h(B ? O : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(be, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          tt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(be, { span: 2, children: /* @__PURE__ */ k.jsx(ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Ot.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              Zp,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      J && /* @__PURE__ */ k.jsx(Fn, { error: J })
    ] }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          type: "submit",
          form: nb,
          disabled: !U || m || z,
          isLoading: m || z,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: T.handleSubmit(ie)
      }
    )
  ] });
}, $z = ({
  order: e,
  shopifyId: n,
  orderLink: t,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = hn(), { track: l } = _n(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, h = parseFloat(String(d?.amount)), g = !isNaN(h) && h > 0, [C] = a(v3, {
    onError: (w) => {
      setTimeout(() => N(w), 500);
    },
    onCompleted: (w) => {
      const y = w.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? N(
        new ex({
          graphQLErrors: y.map((z) => ({
            message: z.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), S = ot(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: w, ...y } = d;
    s(g ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        w,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), C({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    g,
    s,
    C,
    l
  ]), N = ot(
    (w) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(Fn, { error: w }),
          /* @__PURE__ */ k.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(t, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [t]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Gn,
    {
      variant: "secondary",
      onClick: S,
      disabled: d?.refundLineItems?.length === 0 || !g,
      slotStart: /* @__PURE__ */ k.jsx(pe, { size: 14, name: "undo" }),
      className: Ot.fullWidth,
      children: "Full refund"
    }
  ) });
}, Dz = "_modal_al73g_1", Rz = {
  modal: Dz
}, Oz = ({
  orderId: e,
  tags: n,
  isOpen: t,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = _n(), { useMutation: s, showNotification: l } = hn(), [d, m] = le(n), [u, f] = le(!1), h = _t({
    defaultValues: {
      tags: n
    }
  });
  He(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [g, { error: C, reset: S }] = s(b3, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), N = ot(
    (y) => {
      f(!0), g({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((z) => {
        const $ = z.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: $ });
      });
    },
    [e, h, g]
  ), w = () => {
    i(!1), S();
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: t, onClose: w, className: Rz.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: "Manage tags for order", onClose: w }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(st, { children: /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        Wt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            ln,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Ws,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (z) => m(z)
                }
              )
            }
          )
        }
      ) }) }),
      C && /* @__PURE__ */ k.jsx(Fn, { error: C })
    ] }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(N),
        cancelOnClick: w,
        confirmName: C ? "Close" : "Save",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, Pz = "_editIcon_1yp2k_1", Az = "_copyIcon_1yp2k_2", tb = {
  editIcon: Pz,
  copyIcon: Az
}, Lz = ({
  orderId: e,
  tags: n,
  refetchOrders: t
}) => {
  const [i, a] = le(!1), { isCopied: o, copy: s } = Pr(), l = 14, d = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(pe, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !d && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            d && n.map((m, u) => /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "primary", children: m }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(We, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: l,
            name: "pen",
            className: tb.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        d && /* @__PURE__ */ k.jsx(We, { content: "Copy tags", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: l,
            name: o ? "done" : "copy",
            className: tb.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      Oz,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: t
      }
    )
  ] });
}, Vz = "_icon_cddi1_1", zz = "_link_cddi1_6", rb = {
  icon: Vz,
  link: zz
}, Uz = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: t } = Pr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: rb.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(We, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        pe,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => t(a.toString()),
          className: rb.icon
        }
      ) })
    }
  );
}, Mz = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(pe, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Ye, { children: e.map((n) => /* @__PURE__ */ k.jsx(Uz, { trackingInfo: n }, n.number)) })
] }), Bz = "_copyIcon_yc0fe_1", qz = "_order_yc0fe_6", Hz = "_orderIsOpen_yc0fe_14", Wz = "_orderHeader_yc0fe_17", Bi = {
  copyIcon: Bz,
  order: qz,
  orderIsOpen: Hz,
  orderHeader: Wz
}, Gz = ({
  order: e,
  shopifyId: n,
  openByDefault: t,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = _n(), { isCopied: h, copy: g } = Pr(), { isCopied: C, copy: S } = Pr(), { isCopied: N, copy: w } = Pr(), [y, z] = le(!1), [$, I] = le(!1), [T, U] = le(t), {
    id: Q,
    name: J,
    createdAt: ie,
    status: X,
    currentTotalPriceSet: B,
    currencyCode: O,
    lineItems: q,
    billingAddress: ee,
    shippingAddress: ve,
    trackingInfos: ue,
    tags: ce
  } = e, fe = !!ve, W = Xp(Q), xe = `https://${l}/admin/orders/${W ?? ""}`, Ie = B?.shopMoney?.amount ?? 0, K = X.includes("cancelled"), qe = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: O
  }).format(Ie), Be = e?.refunds ? NS(e) : {}, Oe = !!q?.length && q.every((Me) => (Be[Me.id] || 0) >= (Me.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: it(Bi.order, {
        [Bi.orderIsOpen]: T
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Bi.orderHeader,
            onClick: () => U(!T),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                ie && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: Ln(ie).format(zm) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  J
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: T ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        T && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(pe, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: J.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(We, { content: "Copy order number", children: /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => g(J.replace("#", "")),
                    className: Bi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(pe, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: X })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(We, { content: "Copy order status", children: /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: 14,
                    name: N ? "done" : "copy",
                    onClick: () => w(X),
                    className: Bi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(pe, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: qe })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(We, { content: "Copy order value", children: /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: 14,
                    name: C ? "done" : "copy",
                    onClick: () => S(Ie),
                    className: Bi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsx(
            Lz,
            {
              orderId: Q,
              tags: ce,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            Um,
            {
              openByDefault: !fe,
              labelText: "Billing address",
              address: ee,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            Um,
            {
              openByDefault: fe,
              shopifyId: n,
              orderId: Q,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ve,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            wz,
            {
              orderId: Q,
              lineItems: q,
              refundedQuantities: Be
            }
          ),
          /* @__PURE__ */ k.jsx(Mz, { trackingInfos: ue }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              $z,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: xe
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Gn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => I(!0),
                className: Ot.fullWidth,
                disabled: K || Oe,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Gn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => z(!0),
                className: Ot.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              bz,
              {
                orderId: Q,
                orderName: J,
                disabled: K,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(xe, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: Q
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        y && /* @__PURE__ */ k.jsx(
          Sz,
          {
            order: e,
            shopifyId: n,
            orderName: J,
            isOpen: y,
            setIsOpen: z,
            refetchOrders: u
          }
        ),
        $ && /* @__PURE__ */ k.jsx(
          Tz,
          {
            order: e,
            orderName: J,
            isOpen: $,
            setIsOpen: I,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, Kz = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: t,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = _n(), [f, h] = le([]), [g, C] = le(!1), S = Xp(m?.id), N = `https://${n}/admin/orders?customer_id=${S ?? ""}`, {
    getCustomerOrders: w,
    isCustomerOrdersLoading: y,
    customerOrdersError: z,
    customerOrders: $,
    refetchCustomerOrders: I
  } = j3();
  return He(() => {
    !y && S && w({
      variables: {
        query: `customer_id:${S}`
      }
    });
  }, [S]), He(() => {
    const T = $?.Shopify?.orders?.edges;
    T && h(nz({ ordersData: T }));
  }, [$]), m ? z ? /* @__PURE__ */ k.jsx(Fn, { error: z }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(Pn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Gn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => C(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((T, U) => /* @__PURE__ */ k.jsx(
        Gz,
        {
          order: T,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: t,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: I,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${T.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        Et,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(N, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      yz,
      {
        isOpen: g,
        setIsOpen: C,
        shopifyCustomer: m,
        refetchCustomerOrders: I,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, Yz = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const t = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(t).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Ye, { className: Ot.list, children: [
      /* @__PURE__ */ k.jsx(Ye.Text, { variant: "dense", className: Ot.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { variant: "dense", className: Ot.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, Qz = "_segmentName_1dkhk_1", Jz = {
  segmentName: Qz
}, Xz = 100, rs = 10, Zz = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: t } = hn(), [i, a] = le([]), [o, s] = le(rs), [l, d] = le(!1), m = Bn(
    () => i.filter((S) => S.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    f3,
    {
      skip: !e,
      variables: {
        first: Xz
      },
      onCompleted: (S) => {
        const N = S?.Shopify?.segments?.edges;
        if (N && N.length > 0) {
          const w = N.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, z) => y.name.localeCompare(z.name));
          a(w), h({
            variables: {
              customerId: e,
              segmentIds: w.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: g, error: C }
  ] = t(h3, {
    onCompleted: (S) => {
      const N = S?.Shopify?.customerSegmentMembership?.memberships;
      if (N && N.length > 0) {
        const w = i.map((y) => {
          const z = N.find(
            ($) => $.segmentId === y.id
          );
          return {
            ...y,
            ...z?.isMember && { isMember: z.isMember }
          };
        }).sort(
          (y, z) => y.isMember === z.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(w);
      }
    }
  });
  return He(() => {
    s(l ? i.length : rs);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(Pn, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(Fn, { error: f }),
    C && /* @__PURE__ */ k.jsx(Fn, { error: C }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(Ye, { className: Ot.list, children: [
      i.slice(0, o).map(({ id: S, name: N, isMember: w }) => /* @__PURE__ */ k.jsx(Ye.Text, { className: Ot.listItem, children: /* @__PURE__ */ k.jsx(
        We,
        {
          content: `${w ? "Member of" : "Not a member of"} ${N}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: Jz.segmentName, children: N }),
            g && /* @__PURE__ */ k.jsx(un, { size: 12 }),
            !g && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              pe,
              {
                color: w ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, S)),
      i.length > rs && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Gn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - rs} more`
        }
      ) })
    ] })
  ] }) : null;
}, eU = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: t,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = N3({ conversationContext: e }), [l, d] = le(), [m, u] = le(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, g = n.displayCancelOrder ?? !1, C = n.enableEditShippingAddress ?? !1, S = n.displayEmailMarketingConsent ?? !1, N = n.displayOrdersOverview ?? !1, w = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, z = n.displayDiscountCodes ?? !1, $ = n.displayCreateOrder ?? !1, I = n.displayDuplicateOrder ?? !1, T = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (He(() => {
    const Q = a?.Shopify?.customers?.edges[0]?.node;
    Q && !t ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(Q)) : d(void 0);
  }, [a]), !t && i)
    return /* @__PURE__ */ k.jsx(Fn, { error: i, retry: o });
  if (!t && !i && !l) {
    const Q = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              D3,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              Et,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Q, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return t && s !== er.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(un, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          P3,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: t,
            networkStatus: s
          }
        ),
        N && /* @__PURE__ */ k.jsx(
          Yz,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        w && /* @__PURE__ */ k.jsx(Zz, { shopifyId: l?.id }),
        S && /* @__PURE__ */ k.jsx(ez, { customer: l }),
        z && /* @__PURE__ */ k.jsx(
          Z3,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ k.jsx(
          Kz,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: g,
            displayCreateOrder: $,
            displayCreateDraftOrder: T,
            enableEditShippingAddress: C,
            customerCountryCodes: m,
            displayDuplicateOrder: I,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, wt = [];
for (let e = 0; e < 256; ++e)
  wt.push((e + 256).toString(16).slice(1));
function nU(e, n = 0) {
  return (wt[e[n + 0]] + wt[e[n + 1]] + wt[e[n + 2]] + wt[e[n + 3]] + "-" + wt[e[n + 4]] + wt[e[n + 5]] + "-" + wt[e[n + 6]] + wt[e[n + 7]] + "-" + wt[e[n + 8]] + wt[e[n + 9]] + "-" + wt[e[n + 10]] + wt[e[n + 11]] + wt[e[n + 12]] + wt[e[n + 13]] + wt[e[n + 14]] + wt[e[n + 15]]).toLowerCase();
}
const tU = new Uint8Array(16);
function rU() {
  return crypto.getRandomValues(tU);
}
function iU(e, n, t) {
  return crypto.randomUUID ? crypto.randomUUID() : aU(e);
}
function aU(e, n, t) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? rU();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, nU(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ku = { exports: {} }, Ha = {}, ib;
function oU() {
  if (ib) return Ha;
  ib = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ha.Fragment = t, Ha.jsx = s, Ha.jsxs = s, Ha;
}
var is = {}, ab;
function sU() {
  return ab || (ab = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    is.Fragment = i, is.jsx = Rn, is.jsxs = Mn;
  })()), is;
}
var ob;
function lU() {
  return ob || (ob = 1, process.env.NODE_ENV === "production" ? Ku.exports = oU() : Ku.exports = sU()), Ku.exports;
}
var M = lU(), jS = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(jS || {}), Mm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Mm || {});
const cU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, dU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, uU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, mU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, pU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, fU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, hU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, yU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, gU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, vU = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": cU,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": dU,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": uU,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": mU,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": pU,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": fU,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": hU,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": yU,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": gU
};
function Qr(e) {
  return vU[e] ?? {};
}
const kU = Qr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), bU = Qr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), xU = Qr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), _U = Qr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), SU = Qr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), NU = Qr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), jU = Qr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), wU = Qr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), CU = Qr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), FU = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: t } = _n(), [i, a] = le(), [o, s] = le(), [l, d] = le(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(kU, {
    skip: !e,
    variables: { contactId: e }
  });
  return He(() => {
    const g = f?.Voyado?.ContactsV_GetContactById;
    !m && g && typeof g == "object" && ("id" in g && t("voyado:profile:received", { hasProfile: !0 }), "attributes" in g && a(g.attributes), "preferences" in g && s(g.preferences), "consents" in g && d(
      g?.consents?.filter(
        (C) => C !== null
      ) || void 0
    )), !m && (!g || typeof g != "object") && t("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Bn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function xs(e = !1, n) {
  const [t, i] = le(e);
  return He(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const IU = {
  count: 0,
  items: []
}, EU = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: t } = _n(), [i, a] = le(IU), {
    loading: o,
    error: s,
    data: l
  } = n(_U, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), t("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, TU = {
  count: 0,
  totalCount: 0,
  items: []
}, $U = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: t } = _n(), [i, a] = le(
    TU
  ), {
    loading: o,
    error: s,
    data: l
  } = n(SU, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && t("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, DU = ({
  conversationContext: e
}) => {
  const { useQuery: n } = hn(), [t, i] = le(void 0), [a, o] = le(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(xU, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return He(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: t,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, RU = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: t } = hn(), [i, a] = le(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = t(bU, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return He(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Bn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, OU = "_pointer_ls8kj_48", PU = "_list_ls8kj_53", AU = "_listItem_ls8kj_63", rt = {
  pointer: OU,
  list: PU,
  listItem: AU
};
var Eo = (e) => e.type === "checkbox", yi = (e) => e instanceof Date, qt = (e) => e == null;
const wS = (e) => typeof e == "object";
var pt = (e) => !qt(e) && !Array.isArray(e) && wS(e) && !yi(e), CS = (e) => pt(e) && e.target ? Eo(e.target) ? e.target.checked : e.target.value : e, LU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, FS = (e, n) => e.has(LU(n)), VU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return pt(n) && n.hasOwnProperty("isPrototypeOf");
}, tf = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ft(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(tf && (e instanceof Blob || i)) && (t || pt(e)))
    if (n = t ? [] : {}, !t && !VU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ft(e[a]));
  else
    return e;
  return n;
}
var pl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ct = (e) => e === void 0, Xe = (e, n, t) => {
  if (!n || !pt(e))
    return t;
  const i = pl(n.split(/[,[\].]+?/)).reduce((a, o) => qt(a) ? a : a[o], e);
  return ct(i) || i === e ? ct(e[n]) ? t : e[n] : i;
}, ir = (e) => typeof e == "boolean", rf = (e) => /^\w*$/.test(e), IS = (e) => pl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, t) => {
  let i = -1;
  const a = rf(n) ? [n] : IS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = t;
    if (i !== s) {
      const m = e[l];
      d = pt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Ls = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, br = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, qr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, zU = Fe.createContext(null), af = () => Fe.useContext(zU);
var ES = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== br.all && (n._proxyFormState[s] = !i || br.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function UU(e) {
  const n = af(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Fe.useState(t._formState), d = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Fe.useRef(a);
  return m.current = a, Fe.useEffect(() => t._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...t._formState,
        ...u
      });
    }
  }), [t, i, o]), Fe.useEffect(() => {
    d.current.isValid && t._setValid(!0);
  }, [t]), Fe.useMemo(() => ES(s, t, d.current, !1), [s, t]);
}
var Rr = (e) => typeof e == "string", TS = (e, n, t, i, a) => Rr(e) ? (i && n.watch.add(e), Xe(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Xe(t, o))) : (i && (n.watchAll = !0), t);
function $S(e) {
  const n = af(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Fe.useRef(i), d = Fe.useRef(a);
  l.current = i, Fe.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(TS(l.current, t._names, f.values || t._formValues, !1, d.current))
  }), [t, o, s]);
  const [m, u] = Fe.useState(t._getWatch(i, a));
  return Fe.useEffect(() => t._removeUnmounted()), m;
}
function MU(e) {
  const n = af(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = FS(a._names.array, t), l = $S({
    control: a,
    name: t,
    defaultValue: Xe(a._formValues, t, Xe(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), d = UU({
    control: a,
    name: t,
    exact: !0
  }), m = Fe.useRef(e), u = Fe.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...ir(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Fe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Xe(d.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Xe(d.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Xe(d.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Xe(d.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Xe(d.errors, t)
    }
  }), [d, t]), h = Fe.useCallback((N) => u.current.onChange({
    target: {
      value: CS(N),
      name: t
    },
    type: Ls.CHANGE
  }), [t]), g = Fe.useCallback(() => u.current.onBlur({
    target: {
      value: Xe(a._formValues, t),
      name: t
    },
    type: Ls.BLUR
  }), [t, a._formValues]), C = Fe.useCallback((N) => {
    const w = Xe(a._fields, t);
    w && N && (w._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, t]), S = Fe.useMemo(() => ({
    name: t,
    value: l,
    ...ir(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: g,
    ref: C
  }), [t, i, d.disabled, h, g, C, l]);
  return Fe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...ir(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (y, z) => {
      const $ = Xe(a._fields, y);
      $ && $._f && ($._f.mount = z);
    };
    if (w(t, !0), N) {
      const y = Ft(Xe(a._options.defaultValues, t));
      Yn(a._defaultValues, t, y), ct(Xe(a._formValues, t)) && Yn(a._formValues, t, y);
    }
    return !s && a.register(t), () => {
      (s ? N && !a._state.action : N) ? a.unregister(t) : w(t, !1);
    };
  }, [t, a, s, o]), Fe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), Fe.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const sb = (e) => e.render(MU(e));
var BU = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, so = (e) => Array.isArray(e) ? e : [e], lb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const t of e)
        t.next && t.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((t) => t !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Bm = (e) => qt(e) || !wS(e);
function ti(e, n) {
  if (Bm(e) || Bm(n))
    return e === n;
  if (yi(e) && yi(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (yi(o) && yi(s) || pt(o) && pt(s) || Array.isArray(o) && Array.isArray(s) ? !ti(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Ut = (e) => pt(e) && !Object.keys(e).length, of = (e) => e.type === "file", xr = (e) => typeof e == "function", Vs = (e) => {
  if (!tf)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, DS = (e) => e.type === "select-multiple", sf = (e) => e.type === "radio", qU = (e) => sf(e) || Eo(e), Yu = (e) => Vs(e) && e.isConnected;
function HU(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = ct(e) ? i++ : e[n[i++]];
  return e;
}
function WU(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ct(e[n]))
      return !1;
  return !0;
}
function kt(e, n) {
  const t = Array.isArray(n) ? n : rf(n) ? [n] : IS(n), i = t.length === 1 ? e : HU(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (pt(i) && Ut(i) || Array.isArray(i) && WU(i)) && kt(e, t.slice(0, -1)), e;
}
var RS = (e) => {
  for (const n in e)
    if (xr(e[n]))
      return !0;
  return !1;
};
function zs(e, n = {}) {
  const t = Array.isArray(e);
  if (pt(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || pt(e[i]) && !RS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, zs(e[i], n[i])) : qt(e[i]) || (n[i] = !0);
  return n;
}
function OS(e, n, t) {
  const i = Array.isArray(e);
  if (pt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || pt(e[a]) && !RS(e[a]) ? ct(n) || Bm(t[a]) ? t[a] = Array.isArray(e[a]) ? zs(e[a], []) : { ...zs(e[a]) } : OS(e[a], qt(n) ? {} : n[a], t[a]) : t[a] = !ti(e[a], n[a]);
  return t;
}
var Wa = (e, n) => OS(e, n, zs(n));
const cb = {
  value: !1,
  isValid: !1
}, db = { value: !0, isValid: !0 };
var PS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ct(e[0].attributes.value) ? ct(e[0].value) || e[0].value === "" ? db : { value: e[0].value, isValid: !0 } : db
    ) : cb;
  }
  return cb;
}, AS = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => ct(e) ? e : n ? e === "" ? NaN : e && +e : t && Rr(e) ? new Date(e) : i ? i(e) : e;
const ub = {
  isValid: !1,
  value: null
};
var LS = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, ub) : ub;
function mb(e) {
  const n = e.ref;
  return of(n) ? n.files : sf(n) ? LS(e.refs).value : DS(n) ? [...n.selectedOptions].map(({ value: t }) => t) : Eo(n) ? PS(e.refs).value : AS(ct(n.value) ? e.ref.value : n.value, e);
}
var GU = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Xe(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Us = (e) => e instanceof RegExp, Ga = (e) => ct(e) ? e : Us(e) ? e.source : pt(e) ? Us(e.value) ? e.value.source : e.value : e, pb = (e) => ({
  isOnSubmit: !e || e === br.onSubmit,
  isOnBlur: e === br.onBlur,
  isOnChange: e === br.onChange,
  isOnAll: e === br.all,
  isOnTouch: e === br.onTouched
});
const fb = "AsyncFunction";
var KU = (e) => !!e && !!e.validate && !!(xr(e.validate) && e.validate.constructor.name === fb || pt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === fb)), YU = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), hb = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const lo = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Xe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (lo(l, n))
          break;
      } else if (pt(l) && lo(l, n))
        break;
    }
  }
};
function yb(e, n, t) {
  const i = Xe(e, t);
  if (i || rf(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Xe(n, o), l = Xe(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var QU = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return Ut(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || br.all));
}, JU = (e, n, t) => !e || !n || e === n || so(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), XU = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, ZU = (e, n) => !pl(Xe(e, n)).length && kt(e, n), eM = (e, n, t) => {
  const i = so(Xe(e, t));
  return Yn(i, "root", n[t]), Yn(e, t, i), e;
}, _s = (e) => Rr(e);
function gb(e, n, t = "validate") {
  if (_s(e) || Array.isArray(e) && e.every(_s) || ir(e) && !e)
    return {
      type: t,
      message: _s(e) ? e : "",
      ref: n
    };
}
var qi = (e) => pt(e) && !Us(e) ? e : {
  value: e,
  message: ""
}, vb = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: g, validate: C, name: S, valueAsNumber: N, mount: w } = e._f, y = Xe(t, S);
  if (!w || n.has(S))
    return {};
  const z = l ? l[0] : s, $ = (B) => {
    a && z.reportValidity && (z.setCustomValidity(ir(B) ? "" : B || ""), z.reportValidity());
  }, I = {}, T = sf(s), U = Eo(s), Q = T || U, J = (N || of(s)) && ct(s.value) && ct(y) || Vs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = BU.bind(null, S, i, I), X = (B, O, q, ee = qr.maxLength, ve = qr.minLength) => {
    const ue = B ? O : q;
    I[S] = {
      type: B ? ee : ve,
      message: ue,
      ref: s,
      ...ie(B ? ee : ve, ue)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Q && (J || qt(y)) || ir(y) && !y || U && !PS(l).isValid || T && !LS(l).isValid)) {
    const { value: B, message: O } = _s(d) ? { value: !!d, message: d } : qi(d);
    if (B && (I[S] = {
      type: qr.required,
      message: O,
      ref: z,
      ...ie(qr.required, O)
    }, !i))
      return $(O), I;
  }
  if (!J && (!qt(f) || !qt(h))) {
    let B, O;
    const q = qi(h), ee = qi(f);
    if (!qt(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      qt(q.value) || (B = ve > q.value), qt(ee.value) || (O = ve < ee.value);
    } else {
      const ve = s.valueAsDate || new Date(y), ue = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), ce = s.type == "time", fe = s.type == "week";
      Rr(q.value) && y && (B = ce ? ue(y) > ue(q.value) : fe ? y > q.value : ve > new Date(q.value)), Rr(ee.value) && y && (O = ce ? ue(y) < ue(ee.value) : fe ? y < ee.value : ve < new Date(ee.value));
    }
    if ((B || O) && (X(!!B, q.message, ee.message, qr.max, qr.min), !i))
      return $(I[S].message), I;
  }
  if ((m || u) && !J && (Rr(y) || o && Array.isArray(y))) {
    const B = qi(m), O = qi(u), q = !qt(B.value) && y.length > +B.value, ee = !qt(O.value) && y.length < +O.value;
    if ((q || ee) && (X(q, B.message, O.message), !i))
      return $(I[S].message), I;
  }
  if (g && !J && Rr(y)) {
    const { value: B, message: O } = qi(g);
    if (Us(B) && !y.match(B) && (I[S] = {
      type: qr.pattern,
      message: O,
      ref: s,
      ...ie(qr.pattern, O)
    }, !i))
      return $(O), I;
  }
  if (C) {
    if (xr(C)) {
      const B = await C(y, t), O = gb(B, z);
      if (O && (I[S] = {
        ...O,
        ...ie(qr.validate, O.message)
      }, !i))
        return $(O.message), I;
    } else if (pt(C)) {
      let B = {};
      for (const O in C) {
        if (!Ut(B) && !i)
          break;
        const q = gb(await C[O](y, t), z, O);
        q && (B = {
          ...q,
          ...ie(O, q.message)
        }, $(q.message), i && (I[S] = B));
      }
      if (!Ut(B) && (I[S] = {
        ref: z,
        ...B
      }, !i))
        return I;
    }
  }
  return $(!0), I;
};
const nM = {
  mode: br.onSubmit,
  reValidateMode: br.onChange,
  shouldFocusError: !0
};
function tM(e = {}) {
  let n = {
    ...nM,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: xr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = pt(n.defaultValues) || pt(n.values) ? Ft(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ft(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: lb(),
    state: lb()
  }, g = pb(n.mode), C = pb(n.reValidateMode), S = n.criteriaMode === br.all, N = (E) => (x) => {
    clearTimeout(m), m = setTimeout(E, x);
  }, w = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const x = n.resolver ? Ut((await J()).errors) : await X(i, !0);
      x !== t.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (E, x) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((D) => {
      D && (x ? Yn(t.validatingFields, D, x) : kt(t.validatingFields, D));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !Ut(t.validatingFields)
    }));
  }, z = (E, x = [], D, H, Y = !0, R = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Xe(i, E))) {
        const V = D(Xe(i, E), H.argA, H.argB);
        Y && Yn(i, E, V);
      }
      if (R && Array.isArray(Xe(t.errors, E))) {
        const V = D(Xe(t.errors, E), H.argA, H.argB);
        Y && Yn(t.errors, E, V), ZU(t.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Xe(t.touchedFields, E))) {
        const V = D(Xe(t.touchedFields, E), H.argA, H.argB);
        Y && Yn(t.touchedFields, E, V);
      }
      (u.dirtyFields || f.dirtyFields) && (t.dirtyFields = Wa(a, o)), h.state.next({
        name: E,
        isDirty: O(E, x),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Yn(o, E, x);
  }, $ = (E, x) => {
    Yn(t.errors, E, x), h.state.next({
      errors: t.errors
    });
  }, I = (E) => {
    t.errors = E, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, T = (E, x, D, H) => {
    const Y = Xe(i, E);
    if (Y) {
      const R = Xe(o, E, ct(D) ? Xe(a, E) : D);
      ct(R) || H && H.defaultChecked || x ? Yn(o, E, x ? R : mb(Y._f)) : ve(E, R), s.mount && w();
    }
  }, U = (E, x, D, H, Y) => {
    let R = !1, V = !1;
    const ae = {
      name: E
    };
    if (!n.disabled) {
      if (!D || H) {
        (u.isDirty || f.isDirty) && (V = t.isDirty, t.isDirty = ae.isDirty = O(), R = V !== ae.isDirty);
        const me = ti(Xe(a, E), x);
        V = !!Xe(t.dirtyFields, E), me ? kt(t.dirtyFields, E) : Yn(t.dirtyFields, E, !0), ae.dirtyFields = t.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && V !== !me;
      }
      if (D) {
        const me = Xe(t.touchedFields, E);
        me || (Yn(t.touchedFields, E, D), ae.touchedFields = t.touchedFields, R = R || (u.touchedFields || f.touchedFields) && me !== D);
      }
      R && Y && h.state.next(ae);
    }
    return R ? ae : {};
  }, Q = (E, x, D, H) => {
    const Y = Xe(t.errors, E), R = (u.isValid || f.isValid) && ir(x) && t.isValid !== x;
    if (n.delayError && D ? (d = N(() => $(E, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Yn(t.errors, E, D) : kt(t.errors, E)), (D ? !ti(Y, D) : Y) || !Ut(H) || R) {
      const V = {
        ...H,
        ...R && ir(x) ? { isValid: x } : {},
        errors: t.errors,
        name: E
      };
      t = {
        ...t,
        ...V
      }, h.state.next(V);
    }
  }, J = async (E) => {
    y(E, !0);
    const x = await n.resolver(o, n.context, GU(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(E), x;
  }, ie = async (E) => {
    const { errors: x } = await J(E);
    if (E)
      for (const D of E) {
        const H = Xe(x, D);
        H ? Yn(t.errors, D, H) : kt(t.errors, D);
      }
    else
      t.errors = x;
    return x;
  }, X = async (E, x, D = {
    valid: !0
  }) => {
    for (const H in E) {
      const Y = E[H];
      if (Y) {
        const { _f: R, ...V } = Y;
        if (R) {
          const ae = l.array.has(R.name), me = Y._f && KU(Y._f);
          me && u.validatingFields && y([H], !0);
          const Ne = await vb(Y, l.disabled, o, S, n.shouldUseNativeValidation && !x, ae);
          if (me && u.validatingFields && y([H]), Ne[R.name] && (D.valid = !1, x))
            break;
          !x && (Xe(Ne, R.name) ? ae ? eM(t.errors, Ne, R.name) : Yn(t.errors, R.name, Ne[R.name]) : kt(t.errors, R.name));
        }
        !Ut(V) && await X(V, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const E of l.unMount) {
      const x = Xe(i, E);
      x && (x._f.refs ? x._f.refs.every((D) => !Yu(D)) : !Yu(x._f.ref)) && ze(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (E, x) => !n.disabled && (E && x && Yn(o, E, x), !ti(Ie(), a)), q = (E, x, D) => TS(E, l, {
    ...s.mount ? o : ct(x) ? a : Rr(E) ? { [E]: x } : x
  }, D, x), ee = (E) => pl(Xe(s.mount ? o : a, E, n.shouldUnregister ? Xe(a, E, []) : [])), ve = (E, x, D = {}) => {
    const H = Xe(i, E);
    let Y = x;
    if (H) {
      const R = H._f;
      R && (!R.disabled && Yn(o, E, AS(x, R)), Y = Vs(R.ref) && qt(x) ? "" : x, DS(R.ref) ? [...R.ref.options].forEach((V) => V.selected = Y.includes(V.value)) : R.refs ? Eo(R.ref) ? R.refs.length > 1 ? R.refs.forEach((V) => (!V.defaultChecked || !V.disabled) && (V.checked = Array.isArray(Y) ? !!Y.find((ae) => ae === V.value) : Y === V.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((V) => V.checked = V.value === Y) : of(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: E,
        values: Ft(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(E, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && xe(E);
  }, ue = (E, x, D) => {
    for (const H in x) {
      const Y = x[H], R = `${E}.${H}`, V = Xe(i, R);
      (l.array.has(E) || pt(Y) || V && !V._f) && !yi(Y) ? ue(R, Y, D) : ve(R, Y, D);
    }
  }, ce = (E, x, D = {}) => {
    const H = Xe(i, E), Y = l.array.has(E), R = Ft(x);
    Yn(o, E, R), Y ? (h.array.next({
      name: E,
      values: Ft(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: E,
      dirtyFields: Wa(a, o),
      isDirty: O(E, R)
    })) : H && !H._f && !qt(R) ? ue(E, R, D) : ve(E, R, D), hb(E, l) && h.state.next({ ...t }), h.state.next({
      name: s.mount ? E : void 0,
      values: Ft(o)
    });
  }, fe = async (E) => {
    s.mount = !0;
    const x = E.target;
    let D = x.name, H = !0;
    const Y = Xe(i, D), R = (V) => {
      H = Number.isNaN(V) || yi(V) && isNaN(V.getTime()) || ti(V, Xe(o, D, V));
    };
    if (Y) {
      let V, ae;
      const me = x.type ? mb(Y._f) : CS(E), Ne = E.type === Ls.BLUR || E.type === Ls.FOCUS_OUT, nn = !YU(Y._f) && !n.resolver && !Xe(t.errors, D) && !Y._f.deps || XU(Ne, Xe(t.touchedFields, D), t.isSubmitted, C, g), fn = hb(D, l, Ne);
      Yn(o, D, me), Ne ? (Y._f.onBlur && Y._f.onBlur(E), d && d(0)) : Y._f.onChange && Y._f.onChange(E);
      const tn = U(D, me, Ne), cn = !Ut(tn) || fn;
      if (!Ne && h.state.next({
        name: D,
        type: E.type,
        values: Ft(o)
      }), nn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && w() : Ne || w()), cn && h.state.next({ name: D, ...fn ? {} : tn });
      if (!Ne && fn && h.state.next({ ...t }), n.resolver) {
        const { errors: pn } = await J([D]);
        if (R(me), H) {
          const dn = yb(t.errors, i, D), xn = yb(pn, i, dn.name || D);
          V = xn.error, D = xn.name, ae = Ut(pn);
        }
      } else
        y([D], !0), V = (await vb(Y, l.disabled, o, S, n.shouldUseNativeValidation))[D], y([D]), R(me), H && (V ? ae = !1 : (u.isValid || f.isValid) && (ae = await X(i, !0)));
      H && (Y._f.deps && xe(Y._f.deps), Q(D, ae, V, tn));
    }
  }, W = (E, x) => {
    if (Xe(t.errors, x) && E.focus)
      return E.focus(), 1;
  }, xe = async (E, x = {}) => {
    let D, H;
    const Y = so(E);
    if (n.resolver) {
      const R = await ie(ct(E) ? E : Y);
      D = Ut(R), H = E ? !Y.some((V) => Xe(R, V)) : D;
    } else E ? (H = (await Promise.all(Y.map(async (R) => {
      const V = Xe(i, R);
      return await X(V && V._f ? { [R]: V } : V);
    }))).every(Boolean), !(!H && !t.isValid) && w()) : H = D = await X(i);
    return h.state.next({
      ...!Rr(E) || (u.isValid || f.isValid) && D !== t.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: D } : {},
      errors: t.errors
    }), x.shouldFocus && !H && lo(i, W, E ? Y : l.mount), H;
  }, Ie = (E) => {
    const x = {
      ...s.mount ? o : a
    };
    return ct(E) ? x : Rr(E) ? Xe(x, E) : E.map((D) => Xe(x, D));
  }, K = (E, x) => ({
    invalid: !!Xe((x || t).errors, E),
    isDirty: !!Xe((x || t).dirtyFields, E),
    error: Xe((x || t).errors, E),
    isValidating: !!Xe(t.validatingFields, E),
    isTouched: !!Xe((x || t).touchedFields, E)
  }), qe = (E) => {
    E && so(E).forEach((x) => kt(t.errors, x)), h.state.next({
      errors: E ? t.errors : {}
    });
  }, Be = (E, x, D) => {
    const H = (Xe(i, E, { _f: {} })._f || {}).ref, Y = Xe(t.errors, E) || {}, { ref: R, message: V, type: ae, ...me } = Y;
    Yn(t.errors, E, {
      ...me,
      ...x,
      ref: H
    }), h.state.next({
      name: E,
      errors: t.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, Oe = (E, x) => xr(E) ? h.state.subscribe({
    next: (D) => E(q(void 0, x), D)
  }) : q(E, x, !0), Me = (E) => h.state.subscribe({
    next: (x) => {
      JU(E.name, x.name, E.exact) && QU(x, E.formState || u, Pe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...t,
        ...x
      });
    }
  }).unsubscribe, $e = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Me({
    ...E,
    formState: f
  })), ze = (E, x = {}) => {
    for (const D of E ? so(E) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (kt(i, D), kt(o, D)), !x.keepError && kt(t.errors, D), !x.keepDirty && kt(t.dirtyFields, D), !x.keepTouched && kt(t.touchedFields, D), !x.keepIsValidating && kt(t.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && kt(a, D);
    h.state.next({
      values: Ft(o)
    }), h.state.next({
      ...t,
      ...x.keepDirty ? { isDirty: O() } : {}
    }), !x.keepIsValid && w();
  }, Re = ({ disabled: E, name: x }) => {
    (ir(E) && s.mount || E || l.disabled.has(x)) && (E ? l.disabled.add(x) : l.disabled.delete(x));
  }, an = (E, x = {}) => {
    let D = Xe(i, E);
    const H = ir(x.disabled) || ir(n.disabled);
    return Yn(i, E, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...x
      }
    }), l.mount.add(E), D ? Re({
      disabled: ir(x.disabled) ? x.disabled : n.disabled,
      name: E
    }) : T(E, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: Ga(x.min),
        max: Ga(x.max),
        minLength: Ga(x.minLength),
        maxLength: Ga(x.maxLength),
        pattern: Ga(x.pattern)
      } : {},
      name: E,
      onChange: fe,
      onBlur: fe,
      ref: (Y) => {
        if (Y) {
          an(E, x), D = Xe(i, E);
          const R = ct(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, V = qU(R), ae = D._f.refs || [];
          if (V ? ae.find((me) => me === R) : R === D._f.ref)
            return;
          Yn(i, E, {
            _f: {
              ...D._f,
              ...V ? {
                refs: [
                  ...ae.filter(Yu),
                  R,
                  ...Array.isArray(Xe(a, E)) ? [{}] : []
                ],
                ref: { type: R.type, name: E }
              } : { ref: R }
            }
          }), T(E, !1, void 0, R);
        } else
          D = Xe(i, E, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(FS(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && lo(i, W, l.mount), Ge = (E) => {
    ir(E) && (h.state.next({ disabled: E }), lo(i, (x, D) => {
      const H = Xe(i, D);
      H && (x.disabled = H._f.disabled || E, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || E;
      }));
    }, 0, !1));
  }, Qe = (E, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = Ft(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: V } = await J();
      t.errors = R, Y = V;
    } else
      await X(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Yn(Y, R, void 0);
    if (kt(t.errors, "root"), Ut(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(Y, D);
      } catch (R) {
        H = R;
      }
    } else
      x && await x({ ...t.errors }, D), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ut(t.errors) && !H,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), H)
      throw H;
  }, he = (E, x = {}) => {
    Xe(i, E) && (ct(x.defaultValue) ? ce(E, Ft(Xe(a, E))) : (ce(E, x.defaultValue), Yn(a, E, Ft(x.defaultValue))), x.keepTouched || kt(t.touchedFields, E), x.keepDirty || (kt(t.dirtyFields, E), t.isDirty = x.defaultValue ? O(E, Ft(Xe(a, E))) : O()), x.keepError || (kt(t.errors, E), u.isValid && w()), h.state.next({ ...t }));
  }, ge = (E, x = {}) => {
    const D = E ? Ft(E) : a, H = Ft(D), Y = Ut(E), R = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const V = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Wa(a, o))
        ]);
        for (const ae of Array.from(V))
          Xe(t.dirtyFields, ae) ? Yn(R, ae, Xe(o, ae)) : ce(ae, Xe(R, ae));
      } else {
        if (tf && ct(E))
          for (const V of l.mount) {
            const ae = Xe(i, V);
            if (ae && ae._f) {
              const me = Array.isArray(ae._f.refs) ? ae._f.refs[0] : ae._f.ref;
              if (Vs(me)) {
                const Ne = me.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const V of l.mount)
          ce(V, Xe(R, V));
      }
      o = Ft(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? t.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? t.isDirty : !!(x.keepDefaultValues && !ti(E, a)),
      isSubmitted: x.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? Wa(a, o) : t.dirtyFields : x.keepDefaultValues && E ? Wa(a, E) : x.keepDirty ? t.dirtyFields : {},
      touchedFields: x.keepTouched ? t.touchedFields : {},
      errors: x.keepErrors ? t.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, De = (E, x) => ge(xr(E) ? E(o) : E, x), Le = (E, x = {}) => {
    const D = Xe(i, E), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && xr(Y.select) && Y.select());
    }
  }, Pe = (E) => {
    t = {
      ...t,
      ...E
    };
  }, mn = {
    control: {
      register: an,
      unregister: ze,
      getFieldState: K,
      handleSubmit: Qe,
      setError: Be,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: q,
      _getDirty: O,
      _setValid: w,
      _setFieldArray: z,
      _setDisabledField: Re,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: ge,
      _resetDefaultValues: () => xr(n.defaultValues) && n.defaultValues().then((E) => {
        De(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ge,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: $e,
    trigger: xe,
    register: an,
    handleSubmit: Qe,
    watch: Oe,
    setValue: ce,
    getValues: Ie,
    reset: De,
    resetField: he,
    clearErrors: qe,
    unregister: ze,
    setError: Be,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...mn,
    formControl: mn
  };
}
function rM(e = {}) {
  const n = Fe.useRef(void 0), t = Fe.useRef(void 0), [i, a] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: xr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: xr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : tM(e),
    formState: i
  }, e.formControl && e.defaultValues && !xr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Fe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Fe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Fe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Fe.useEffect(() => {
    e.values && !ti(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Fe.useEffect(() => {
    e.errors && !Ut(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Fe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Fe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = ES(i, o), n.current;
}
const iM = "_modalBody_1clhs_1", aM = {
  modalBody: iM
}, oM = ({
  isOpen: e,
  onClose: n,
  pointsAccount: t,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = _n(), d = t?.id, m = t?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: g } = rM({
    defaultValues: u,
    mode: "onChange"
  }), C = $S({ control: f }), S = parseInt(C?.balance ?? "0", 10), N = m === S, w = N ? "Change the value to update the points" : "", y = S < 0, z = y ? "Points can not be negative" : "", $ = C.description === "", I = $ ? "Description can not be empty" : "";
  He(() => {
    S > m ? h(
      "transactionType",
      Mm.Addition
    ) : S < m && h(
      "transactionType",
      Mm.Deduction
    );
  }, [m, S, h]);
  const [T, { loading: U, error: Q, reset: J }] = o(CU, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ie = () => {
    if (d) {
      const B = iU();
      T({
        variables: {
          input: {
            accountId: d,
            transactionId: B,
            amount: Math.abs(S - m),
            transactionType: C.transactionType,
            description: C.description,
            source: jS.UpdateBalance
          }
        }
      }).then(async (O) => {
        O?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), X());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, X = () => {
    g(u), J(), n();
  };
  return /* @__PURE__ */ M.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: X,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ M.jsx($t, { title: "Update points balance", onClose: X }),
        /* @__PURE__ */ M.jsxs(Dt, { className: aM.modalBody, children: [
          /* @__PURE__ */ M.jsxs(st, { children: [
            /* @__PURE__ */ M.jsx(be, { span: 6, children: /* @__PURE__ */ M.jsx(
              sb,
              {
                name: "balance",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ M.jsx(
                  pr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: w || z
                    },
                    input: {
                      ...B,
                      value: B.value.toString(),
                      onChange: (O) => B.onChange(O)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ M.jsx(be, { span: 6, children: /* @__PURE__ */ M.jsx(
              sb,
              {
                name: "description",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ M.jsx(
                  pr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: B,
                    meta: {
                      warning: I
                    }
                  }
                )
              }
            ) })
          ] }),
          Q && /* @__PURE__ */ M.jsx(Fn, { error: Q })
        ] }),
        /* @__PURE__ */ M.jsx(
          Pt,
          {
            confirmName: "Save",
            confirmOnClick: () => ie(),
            confirmProps: {
              isLoading: U,
              disabled: N || y || $,
              loadingIndicator: /* @__PURE__ */ M.jsx(un, { size: 16 })
            },
            cancelOnClick: X
          }
        )
      ]
    }
  );
}, sM = "_wrapper_1ge6c_1", lM = "_block_1ge6c_12", kb = {
  wrapper: sM,
  block: lM
}, cM = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: t } = hn(), { isCopied: i, copy: a } = xs(), { isCopied: o, copy: s } = xs(), { isCopied: l, copy: d } = xs(), [m, u] = le(!1), [f, h] = le(), [g, C] = le(!1), {
    loading: S,
    data: N,
    refetch: w
  } = t(jU, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  He(() => {
    if (N) {
      const ee = N?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [N]);
  const y = !!f?.id, z = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: $,
    lastName: I,
    street: T,
    zipCode: U,
    city: Q,
    country: J,
    isRegistrationCompleted: ie,
    email: X,
    mobilePhone: B
  } = e, O = 14, q = `${$ || ""} ${I || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", className: kb.wrapper, children: [
    /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: kb.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: q }),
          S && /* @__PURE__ */ M.jsx(un, { size: 12 }),
          y && !S && /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ M.jsxs(Pn, { size: "small", variant: "warning", children: [
              z,
              " points"
            ] }),
            /* @__PURE__ */ M.jsx(We, { content: "Update points balance", children: /* @__PURE__ */ M.jsx(
              pe,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: rt.pointer
              }
            ) }),
            g && /* @__PURE__ */ M.jsx(We, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ M.jsx(
              pe,
              {
                name: "info",
                size: 12,
                className: rt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (T || Q || U || J || B || X) && /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
      B && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(pe, { size: O, name: "phone" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: B })
        ] }),
        /* @__PURE__ */ M.jsx(
          pe,
          {
            size: O,
            name: o ? "done" : "copy",
            onClick: () => s(B),
            className: rt.pointer
          }
        )
      ] }),
      X && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(pe, { size: O, name: "mail" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: X })
        ] }),
        /* @__PURE__ */ M.jsx(
          pe,
          {
            size: O,
            name: i ? "done" : "copy",
            onClick: () => a(X),
            className: rt.pointer
          }
        )
      ] }),
      (T || Q || U || J) && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(pe, { size: O, name: "home" }),
          /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ M.jsx(et, { children: T }),
            /* @__PURE__ */ M.jsxs(et, { children: [
              U,
              " ",
              Q
            ] }),
            /* @__PURE__ */ M.jsx(et, { children: J })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(
          pe,
          {
            size: O,
            name: l ? "done" : "copy",
            onClick: () => d(`${T}, ${U} ${Q}, ${J}`),
            className: rt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(pe, { size: O, name: "sign-in" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ M.jsx(
          pe,
          {
            name: ie ? "check-circle-filled" : "close-circle-filled",
            color: ie ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ M.jsx(
      oM,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: C,
        refetchPointsQuery: w
      }
    )
  ] });
}, dM = "_list_yud4a_7", uM = "_listItem_yud4a_11", mM = "_listItemTooltip_yud4a_15", pM = "_listItemTimestamp_yud4a_18", as = {
  list: dM,
  listItem: uM,
  listItemTooltip: mM,
  listItemTimestamp: pM
}, fM = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ M.jsx(Ye, { className: as.list, children: e.map((n, t) => /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: as.listItem, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ M.jsx(We, { content: n?.comment, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: it({
          [as.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { className: as.listItemTimestamp, children: Ln(n.date).format(xt) }),
          n?.comment && /* @__PURE__ */ M.jsx(pe, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ M.jsx(
      pe,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, t)) })
] }), hM = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, t = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Ln(e.latestChange).format(xt) : null, o = e?.expires ? `${Ln(e.expires).fromNow()} (${Ln(e.expires).format(xt)})` : null, s = !n && !a && !t && !i && !o;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ M.jsx(We, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ M.jsx(
        pe,
        {
          name: "question",
          size: 14,
          className: rt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsxs(Ye, { className: rt.list, children: [
      s && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ M.jsx(Pn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ M.jsx(Pn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      t && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ M.jsx(Pn, { variant: "success", size: "small", children: t })
      ] }) }) }),
      a && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, yM = "_tagHover_kzbzk_1", gM = "_channelUnsubscribed_kzbzk_6", bb = {
  tagHover: yM,
  channelUnsubscribed: gM
}, Qu = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: t,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = _n(), { useMutation: l } = hn(), [d, m] = le(!1), [u, { loading: f }] = l(wU), h = async ({
    newPreference: C,
    isSubscribed: S,
    channelType: N
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...C
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? S ? s("voyado:channel:unsubscribe:succeeded", { channel: N }) : s("voyado:channel:subscribe:succeeded", { channel: N }) : S ? s("voyado:channel:unsubscribe:failed", { channel: N }) : s("voyado:channel:subscribe:failed", { channel: N }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, g = d || f;
  return /* @__PURE__ */ M.jsx(We, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ M.jsx(
    An,
    {
      className: bb.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ M.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: it({
            [bb.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            g ? /* @__PURE__ */ M.jsx(un, { size: 16 }) : /* @__PURE__ */ M.jsx(pe, { size: 16, name: t }),
            n
          ]
        }
      )
    }
  ) });
}, vM = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: t
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        Qu,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      ),
      /* @__PURE__ */ M.jsx(
        Qu,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      ),
      /* @__PURE__ */ M.jsx(
        Qu,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      )
    ] })
  ] }) });
}, kM = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: t,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = FU({ contactId: e }), {
    isLoading: g,
    error: C,
    memberLevel: S
  } = RU({ contactId: e, skip: !s }), N = g || l, w = Bn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return d || C ? vo({
    errors: d?.graphQLErrors || C?.graphQLErrors || []
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: d || C }) : !t && !i && !a && !o && !s ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : N ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    t && /* @__PURE__ */ M.jsx(
      cM,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ M.jsx(hM, { memberLevel: S }),
    i && /* @__PURE__ */ M.jsx(
      vM,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ M.jsx(fM, { contactConsents: w })
  ] });
}, qm = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, bM = "_list_zu4s7_1", xM = "_listItem_zu4s7_4", _M = "_listSum_zu4s7_7", os = {
  list: bM,
  listItem: xM,
  listSum: _M
}, SM = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: t
}) => /* @__PURE__ */ M.jsxs(Ye, { className: os.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: os.listItem, children: /* @__PURE__ */ M.jsx(We, { content: s, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ M.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flex: "auto", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ M.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: qm(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ M.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: it(os.listItem, os.listSum),
      children: /* @__PURE__ */ M.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: qm(t, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), NM = "_transaction_1kr8d_1", jM = "_transactionIsOpen_1kr8d_9", wM = "_transactionHeader_1kr8d_12", CM = "_transactionHeaderSubLine_1kr8d_15", FM = "_transactionHeaderAlignItemRight_1kr8d_19", Hi = {
  transaction: NM,
  transactionIsOpen: jM,
  transactionHeader: wM,
  transactionHeaderSubLine: CM,
  transactionHeaderAlignItemRight: FM
}, IM = ({
  transaction: e,
  openByDefault: n
}) => {
  const [t, i] = le(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", g = f ?? 0, C = m?.length ? m : [];
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: it(Hi.transaction, {
        [Hi.transactionIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Hi.transactionHeader,
            onClick: () => i(!t),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ M.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: Ln(o).format(xt) }),
                  /* @__PURE__ */ M.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: Hi.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Hi.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-4", children: qm(g, h) }),
                      /* @__PURE__ */ M.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: Hi.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        t && /* @__PURE__ */ M.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ M.jsx(Jm, {}),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ M.jsx(
                  SM,
                  {
                    lineItems: C,
                    localCurrency: h,
                    localNetPriceSum: g
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, EM = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: t,
    transactions: i
  } = $U({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return t ? /* @__PURE__ */ M.jsx(Fn, { error: t }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          s === 0 && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ M.jsx(
            IM,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, TM = "_message_unsvt_48", $M = "_messageIsOpen_unsvt_56", DM = "_messageHeader_unsvt_60", RM = "_messageText_unsvt_64", OM = "_buttonLink_unsvt_86", Ka = {
  message: TM,
  messageIsOpen: $M,
  messageHeader: DM,
  messageText: RM,
  buttonLink: OM
}, Ju = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Xu = (e, n) => n && e in Ju && n in Ju[e] ? Ju[e][n] : null, PM = ({
  message: e,
  openByDefault: n
}) => {
  const [t, i] = le(n), { track: a } = _n();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, g = l ? Xu("type", l) : null, C = d ? Xu("source", d) : null, S = u ? Xu("status", u) : null, N = l?.replace("Message", "");
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: it(Ka.message, {
        [Ka.messageIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ka.messageHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
                  g && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                    /* @__PURE__ */ M.jsx(pe, { name: g, size: 16 }),
                    " ",
                    N
                  ] }),
                  s && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: Ln(s).format(xt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ M.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ M.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ M.jsx(Jm, {}),
          /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            S && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(pe, { name: S }),
              " ",
              u
            ] }) }),
            C && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(pe, { name: C }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(pe, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", className: Ka.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ M.jsx(
            Et,
            {
              slotEnd: /* @__PURE__ */ M.jsx(pe, { name: "external-link" }),
              variant: "tertiary",
              className: Ka.buttonLink,
              navigate: () => {
                N && a("voyado:message:external-link:opened", {
                  channel: N.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, AM = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: t,
    lastMessages: i
  } = EU({ contactId: e });
  if (!e)
    return null;
  if (t)
    return /* @__PURE__ */ M.jsx(Fn, { error: t });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ M.jsx(Pn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ M.jsx(
        PM,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, fl = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, xb = ({
  labelText: e,
  address: n,
  icon: t = "home"
}) => {
  const { isCopied: i, copy: a } = xs(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = ot(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(pe, { size: l, name: t, color: "green.500" }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ M.jsx(We, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ M.jsx(
      pe,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: rt.pointer
      }
    ) })
  ] });
}, LM = "_order_19t4p_1", VM = "_orderIsOpen_19t4p_9", zM = "_orderHeader_19t4p_12", UM = "_orderIconColor_19t4p_15", Er = {
  order: LM,
  orderIsOpen: VM,
  orderHeader: zM,
  orderIconColor: UM
}, MM = "_delivery_1m9nb_1", BM = "_deliveryCode_1m9nb_4", Zu = {
  delivery: MM,
  deliveryCode: BM
}, qM = ({
  delivery: e
}) => {
  const { isCopied: n, copy: t } = or();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ M.jsx(
      pe,
      {
        size: l,
        name: "eye",
        className: Er.orderIconColor
      }
    ),
    /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ M.jsx(
        We,
        {
          content: /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Ln(s).format(xt)
          ] }),
          children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ M.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Zu.delivery,
                    children: [
                      /* @__PURE__ */ M.jsx(pe, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ M.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: it(Zu.delivery, Zu.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ M.jsx(We, { content: "Copy tracking code", children: /* @__PURE__ */ M.jsx(
      pe,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => t(a.toString()),
        className: rt.pointer
      }
    ) })
  ] });
}, HM = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        pe,
        {
          size: 14,
          name: "file-text",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ M.jsx(Ye, { className: rt.list, children: t?.map((i, a) => /* @__PURE__ */ M.jsx(Ye.Item, { className: rt.listItem, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ M.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ M.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: rt.listItemAlignRight,
              children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: fl({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, WM = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        pe,
        {
          size: 14,
          name: "tag",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ M.jsx(Ye, { className: rt.list, children: t?.map((i) => /* @__PURE__ */ M.jsx(
      Ye.Item,
      {
        className: rt.listItem,
        contentLeft: /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ M.jsx(
          We,
          {
            content: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ M.jsx(b, { children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: fl({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ M.jsx(
          la,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, GM = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        pe,
        {
          size: 14,
          name: "credit-card",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ M.jsx(Ye, { className: rt.list, children: t?.map((i, a) => /* @__PURE__ */ M.jsx(
      Ye.Item,
      {
        className: rt.listItem,
        children: /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ M.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: rt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: Ln(i?.paidAt).format(xt) }),
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: fl({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, KM = ({
  order: e,
  openByDefault: n
}) => {
  const [t, i] = le(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: g,
    totalPrice: C
  } = e, S = 14;
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: it(Er.order, {
        [Er.orderIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Er.orderHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Ln(m).format(xt) }) }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ M.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              pe,
              {
                size: S,
                name: "activity",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ M.jsx(We, { content: "Internal status", children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ M.jsx(We, { content: "External status", children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: s }) }) }),
                /* @__PURE__ */ M.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ M.jsx(A.Paragraph, { as: "span", variant: "5", children: Ln(u).format(xt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              pe,
              {
                size: S,
                name: "chart-bar",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: fl({
                value: C,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              pe,
              {
                size: S,
                name: "channels",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(xb, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ M.jsx(
            xb,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: g
            }
          ),
          /* @__PURE__ */ M.jsx(qM, { delivery: e.delivery }),
          /* @__PURE__ */ M.jsx(WM, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ M.jsx(HM, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ M.jsx(
            GM,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, YM = ({
  error: e,
  itemCount: n,
  children: t
}) => e ? n === 0 || vo({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: e }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: t }), QM = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), [t, i] = le([]), { track: a } = _n(), {
    loading: o,
    error: s,
    data: l
  } = n(NU, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return He(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      t.length > 0 && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "success", children: t.length })
    ] }),
    o ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsx(YM, { error: s, itemCount: t.length, children: t.map((d, m) => /* @__PURE__ */ M.jsx(
      KM,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, JM = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: t, contactId: i, hasMultipleContacts: a, error: o } = DU({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: g,
    showOrders: C
  } = n;
  return s ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? vo({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: o }) : !d && !m && !u && !f && !h && !g ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : t ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ M.jsx(kM, { contactId: i, settings: n }),
        h && /* @__PURE__ */ M.jsx(AM, { contactId: i }),
        g && /* @__PURE__ */ M.jsx(EM, { contactId: i }),
        C && /* @__PURE__ */ M.jsx(QM, { contactId: i }),
        !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, XM = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_11mz1_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_11mz1_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_11mz1_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_11mz1_63:last-child{box-shadow:none}._listItemHighlighted_11mz1_72{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var em = { exports: {} }, Ya = {}, _b;
function ZM() {
  if (_b) return Ya;
  _b = 1;
  var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ya.Fragment = t, Ya.jsx = s, Ya.jsxs = s, Ya;
}
var ss = {}, Sb;
function e4() {
  return Sb || (Sb = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = C && r[C] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", r, p);
      }
    }
    function z(r, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, P = v.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Q || r === a || r === m || r === u || U || r === g || $ || I || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === J || r.getModuleId !== void 0));
    }
    function X(r, c, p) {
      var v = r.displayName;
      if (v)
        return v;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return B(c) + ".Consumer";
          case s:
            var p = r;
            return B(p._context) + ".Provider";
          case d:
            return X(r, r.render, "ForwardRef");
          case f:
            var v = r.displayName || null;
            return v !== null ? v : O(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, F = P._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, r, {
              value: ve
            }),
            info: q({}, r, {
              value: ue
            }),
            warn: q({}, r, {
              value: ce
            }),
            error: q({}, r, {
              value: fe
            }),
            group: q({}, r, {
              value: W
            }),
            groupCollapsed: q({}, r, {
              value: xe
            }),
            groupEnd: q({}, r, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(r, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var v = P.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + r;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(r, c) {
      if (!r || ze)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(r, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            r.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return r.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var de = r ? r.displayName || r.name : "", Se = de ? $e(de) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function Ge(r, c, p) {
      return Ee(r, !1);
    }
    function Qe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ee(r, Qe(r));
      if (typeof r == "string")
        return $e(r);
      switch (r) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            return Ge(r.render);
          case f:
            return he(r.type, c, p);
          case h: {
            var v = r, P = v._payload, L = v._init;
            try {
              return he(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(r, c, p, v, P) {
      {
        var L = Function.call.bind(ge);
        for (var F in r)
          if (L(r, F)) {
            var j = void 0;
            try {
              if (typeof r[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = r[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Pe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Pe(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Pe(P), y("Failed %s type: %s", p, j.message), Pe(null));
          }
      }
    }
    var E = Array.isArray;
    function x(r) {
      return E(r);
    }
    function D(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function H(r) {
      try {
        return Y(r), !1;
      } catch {
        return !0;
      }
    }
    function Y(r) {
      return "" + r;
    }
    function R(r) {
      if (H(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(r)), Y(r);
    }
    var V = w.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(r) {
      if (ge.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function fn(r) {
      if (ge.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && V.current;
    }
    function cn(r, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(r, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(r, c, p, v, P, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(r, c, p, v, P) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ae.hasOwnProperty(L) && (F[L] = c[L]);
        if (r && r.defaultProps) {
          var G = r.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(r, j, te, P, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Ae(r) {
      if (r) {
        var c = r._owner, p = he(r.type, r._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var r = O(en.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function qn(r) {
      return "";
    }
    var wn = {};
    function kn(r) {
      {
        var c = vn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        r && r._owner && r._owner !== en.current && (v = " It was passed a child from " + O(r._owner.type) + "."), Ae(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Ae(null);
      }
    }
    function Cn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (x(r))
          for (var p = 0; p < r.length; p++) {
            var v = r[p];
            sn(v) && gn(v, c);
          }
        else if (sn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, r.props, "prop", v, r);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Ae(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Ae(null);
            break;
          }
        }
        r.ref !== null && (Ae(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(r, c, p, v, P, L) {
      {
        var F = ie(r);
        if (!F) {
          var j = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          r === null ? G = "null" : x(r) ? G = "array" : r !== void 0 && r.$$typeof === n ? (G = "<" + (O(r.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(r, c, p, P, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], r);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, r);
        }
        if (ge.call(c, "key")) {
          var Se = O(r), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return r === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(r, c, p) {
      return Nn(r, c, p, !0);
    }
    function Dn(r, c, p) {
      return Nn(r, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ss.Fragment = i, ss.jsx = Rn, ss.jsxs = Mn;
  })()), ss;
}
var Nb;
function n4() {
  return Nb || (Nb = 1, process.env.NODE_ENV === "production" ? em.exports = ZM() : em.exports = e4()), em.exports;
}
var Te = n4();
const t4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, r4 = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": t4
};
function i4(e) {
  return r4[e] ?? {};
}
const a4 = i4(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), o4 = "_copyIcon_11mz1_48", s4 = "_list_11mz1_53", l4 = "_listItem_11mz1_63", c4 = "_listItemHighlighted_11mz1_72", oa = {
  copyIcon: o4,
  list: s4,
  listItem: l4,
  listItemHighlighted: c4
}, d4 = "_wrapper_1xucg_1", u4 = "_externalLink_1xucg_7", nm = {
  wrapper: d4,
  externalLink: u4
}, m4 = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: t } = or(), { isCopied: i, copy: a } = or();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Te.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Te.jsxs(b, { className: nm.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "space-between",
        className: nm.block,
        alignItems: "center",
        children: /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: Ln(m).format(xt) })
    ] }),
    l && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(pe, { size: u, name: "mail" }),
        /* @__PURE__ */ Te.jsx("span", { className: nm.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Te.jsx(We, { content: "Copy email", children: /* @__PURE__ */ Te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Te.jsx(
        pe,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => t(l),
          className: oa.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(pe, { size: u, name: "phone" }),
        /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Te.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ Te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Te.jsx(
        pe,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: oa.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Wn = ({
  description: e,
  content: n,
  tooltip: t,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = C0(n);
  return /* @__PURE__ */ Te.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: it(oa.listItem, {
        [oa.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Te.jsx(We, { content: t, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: e }),
        a ? n : po(n)
      ] }) })
    }
  );
}, p4 = ({
  loyalty: e
}) => /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Te.jsxs(Ye, { className: oa.list, children: [
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), f4 = 0.8, h4 = 0.4, jb = (e) => {
  if (e != null)
    return e >= f4 ? /* @__PURE__ */ Te.jsx(Pn, { variant: "success", size: "small", children: "Positive" }) : e <= h4 ? /* @__PURE__ */ Te.jsx(Pn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Te.jsx(Pn, { variant: "warning", size: "small", children: "Neutral" });
}, y4 = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Te.jsxs(Ye, { className: oa.list, children: [
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: jb(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: jb(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Ln(e.last_review_date).format(
          xt
        )
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Te.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, t) => /* @__PURE__ */ Te.jsx(Pn, { variant: "info", size: "small", children: /* @__PURE__ */ Te.jsx(Te.Fragment, { children: n }) }, t))
          }
        )
      }
    )
  ] })
] }), g4 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = hn(), { track: i } = _n(), [a, o] = le(), [s, l] = le(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, g = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, S = n?.displaySubscriptions ?? !1, N = !f, w = !h && !g && !C && !S, {
    loading: y,
    error: z,
    data: $
  } = t(a4, {
    skip: u || N,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (He(() => {
    const I = $?.Yotpo?.getCustomers?.customers?.[0];
    I ? (o(I), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [$?.Yotpo, y]), N)
    return /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(
      Fn,
      {
        error: new ex({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (w)
    return /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (y)
    return /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Te.jsx(un, {}) });
  if (s)
    return /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (z) {
    const I = z.graphQLErrors;
    return Wm({ errors: I }) ? /* @__PURE__ */ Te.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Gm({ errors: I }) ? /* @__PURE__ */ Te.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Te.jsx(Fn, { error: z });
  }
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Te.jsx(m4, { customerDetails: a }),
        g && /* @__PURE__ */ Te.jsx(
          y4,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ Te.jsx(p4, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var To = (e) => e.type === "checkbox", gi = (e) => e instanceof Date, Ht = (e) => e == null;
const VS = (e) => typeof e == "object";
var ft = (e) => !Ht(e) && !Array.isArray(e) && VS(e) && !gi(e), zS = (e) => ft(e) && e.target ? To(e.target) ? e.target.checked : e.target.value : e, v4 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, US = (e, n) => e.has(v4(n)), k4 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ft(n) && n.hasOwnProperty("isPrototypeOf");
}, lf = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function It(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(lf && (e instanceof Blob || i)) && (t || ft(e)))
    if (n = t ? [] : {}, !t && !k4(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = It(e[a]));
  else
    return e;
  return n;
}
var hl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], dt = (e) => e === void 0, Ze = (e, n, t) => {
  if (!n || !ft(e))
    return t;
  const i = hl(n.split(/[,[\].]+?/)).reduce((a, o) => Ht(a) ? a : a[o], e);
  return dt(i) || i === e ? dt(e[n]) ? t : e[n] : i;
}, ar = (e) => typeof e == "boolean", cf = (e) => /^\w*$/.test(e), MS = (e) => hl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Qn = (e, n, t) => {
  let i = -1;
  const a = cf(n) ? [n] : MS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = t;
    if (i !== s) {
      const m = e[l];
      d = ft(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Ms = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, _r = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Hr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, b4 = Fe.createContext(null), df = () => Fe.useContext(b4);
var BS = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== _r.all && (n._proxyFormState[s] = !i || _r.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function x4(e) {
  const n = df(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Fe.useState(t._formState), d = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Fe.useRef(a);
  return m.current = a, Fe.useEffect(() => t._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...t._formState,
        ...u
      });
    }
  }), [t, i, o]), Fe.useEffect(() => {
    d.current.isValid && t._setValid(!0);
  }, [t]), Fe.useMemo(() => BS(s, t, d.current, !1), [s, t]);
}
var Or = (e) => typeof e == "string", qS = (e, n, t, i, a) => Or(e) ? (i && n.watch.add(e), Ze(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ze(t, o))) : (i && (n.watchAll = !0), t);
function HS(e) {
  const n = df(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Fe.useRef(i), d = Fe.useRef(a);
  l.current = i, Fe.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(qS(l.current, t._names, f.values || t._formValues, !1, d.current))
  }), [t, o, s]);
  const [m, u] = Fe.useState(t._getWatch(i, a));
  return Fe.useEffect(() => t._removeUnmounted()), m;
}
function _4(e) {
  const n = df(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = US(a._names.array, t), l = HS({
    control: a,
    name: t,
    defaultValue: Ze(a._formValues, t, Ze(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), d = x4({
    control: a,
    name: t,
    exact: !0
  }), m = Fe.useRef(e), u = Fe.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...ar(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Fe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ze(d.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ze(d.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ze(d.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ze(d.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Ze(d.errors, t)
    }
  }), [d, t]), h = Fe.useCallback((N) => u.current.onChange({
    target: {
      value: zS(N),
      name: t
    },
    type: Ms.CHANGE
  }), [t]), g = Fe.useCallback(() => u.current.onBlur({
    target: {
      value: Ze(a._formValues, t),
      name: t
    },
    type: Ms.BLUR
  }), [t, a._formValues]), C = Fe.useCallback((N) => {
    const w = Ze(a._fields, t);
    w && N && (w._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, t]), S = Fe.useMemo(() => ({
    name: t,
    value: l,
    ...ar(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: g,
    ref: C
  }), [t, i, d.disabled, h, g, C, l]);
  return Fe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...ar(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (y, z) => {
      const $ = Ze(a._fields, y);
      $ && $._f && ($._f.mount = z);
    };
    if (w(t, !0), N) {
      const y = It(Ze(a._options.defaultValues, t));
      Qn(a._defaultValues, t, y), dt(Ze(a._formValues, t)) && Qn(a._formValues, t, y);
    }
    return !s && a.register(t), () => {
      (s ? N && !a._state.action : N) ? a.unregister(t) : w(t, !1);
    };
  }, [t, a, s, o]), Fe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), Fe.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const wb = (e) => e.render(_4(e));
var S4 = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, co = (e) => Array.isArray(e) ? e : [e], Cb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const t of e)
        t.next && t.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((t) => t !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Hm = (e) => Ht(e) || !VS(e);
function ri(e, n) {
  if (Hm(e) || Hm(n))
    return e === n;
  if (gi(e) && gi(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (gi(o) && gi(s) || ft(o) && ft(s) || Array.isArray(o) && Array.isArray(s) ? !ri(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Mt = (e) => ft(e) && !Object.keys(e).length, uf = (e) => e.type === "file", Sr = (e) => typeof e == "function", Bs = (e) => {
  if (!lf)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, WS = (e) => e.type === "select-multiple", mf = (e) => e.type === "radio", N4 = (e) => mf(e) || To(e), tm = (e) => Bs(e) && e.isConnected;
function j4(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = dt(e) ? i++ : e[n[i++]];
  return e;
}
function w4(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !dt(e[n]))
      return !1;
  return !0;
}
function bt(e, n) {
  const t = Array.isArray(n) ? n : cf(n) ? [n] : MS(n), i = t.length === 1 ? e : j4(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (ft(i) && Mt(i) || Array.isArray(i) && w4(i)) && bt(e, t.slice(0, -1)), e;
}
var GS = (e) => {
  for (const n in e)
    if (Sr(e[n]))
      return !0;
  return !1;
};
function qs(e, n = {}) {
  const t = Array.isArray(e);
  if (ft(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || ft(e[i]) && !GS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, qs(e[i], n[i])) : Ht(e[i]) || (n[i] = !0);
  return n;
}
function KS(e, n, t) {
  const i = Array.isArray(e);
  if (ft(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ft(e[a]) && !GS(e[a]) ? dt(n) || Hm(t[a]) ? t[a] = Array.isArray(e[a]) ? qs(e[a], []) : { ...qs(e[a]) } : KS(e[a], Ht(n) ? {} : n[a], t[a]) : t[a] = !ri(e[a], n[a]);
  return t;
}
var Qa = (e, n) => KS(e, n, qs(n));
const Fb = {
  value: !1,
  isValid: !1
}, Ib = { value: !0, isValid: !0 };
var YS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !dt(e[0].attributes.value) ? dt(e[0].value) || e[0].value === "" ? Ib : { value: e[0].value, isValid: !0 } : Ib
    ) : Fb;
  }
  return Fb;
}, QS = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => dt(e) ? e : n ? e === "" ? NaN : e && +e : t && Or(e) ? new Date(e) : i ? i(e) : e;
const Eb = {
  isValid: !1,
  value: null
};
var JS = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, Eb) : Eb;
function Tb(e) {
  const n = e.ref;
  return uf(n) ? n.files : mf(n) ? JS(e.refs).value : WS(n) ? [...n.selectedOptions].map(({ value: t }) => t) : To(n) ? YS(e.refs).value : QS(dt(n.value) ? e.ref.value : n.value, e);
}
var C4 = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Ze(n, o);
    s && Qn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Hs = (e) => e instanceof RegExp, Ja = (e) => dt(e) ? e : Hs(e) ? e.source : ft(e) ? Hs(e.value) ? e.value.source : e.value : e, $b = (e) => ({
  isOnSubmit: !e || e === _r.onSubmit,
  isOnBlur: e === _r.onBlur,
  isOnChange: e === _r.onChange,
  isOnAll: e === _r.all,
  isOnTouch: e === _r.onTouched
});
const Db = "AsyncFunction";
var F4 = (e) => !!e && !!e.validate && !!(Sr(e.validate) && e.validate.constructor.name === Db || ft(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Db)), I4 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Rb = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const uo = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Ze(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (uo(l, n))
          break;
      } else if (ft(l) && uo(l, n))
        break;
    }
  }
};
function Ob(e, n, t) {
  const i = Ze(e, t);
  if (i || cf(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ze(n, o), l = Ze(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var E4 = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return Mt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || _r.all));
}, T4 = (e, n, t) => !e || !n || e === n || co(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), $4 = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, D4 = (e, n) => !hl(Ze(e, n)).length && bt(e, n), R4 = (e, n, t) => {
  const i = co(Ze(e, t));
  return Qn(i, "root", n[t]), Qn(e, t, i), e;
}, Ss = (e) => Or(e);
function Pb(e, n, t = "validate") {
  if (Ss(e) || Array.isArray(e) && e.every(Ss) || ar(e) && !e)
    return {
      type: t,
      message: Ss(e) ? e : "",
      ref: n
    };
}
var Wi = (e) => ft(e) && !Hs(e) ? e : {
  value: e,
  message: ""
}, Ab = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: g, validate: C, name: S, valueAsNumber: N, mount: w } = e._f, y = Ze(t, S);
  if (!w || n.has(S))
    return {};
  const z = l ? l[0] : s, $ = (B) => {
    a && z.reportValidity && (z.setCustomValidity(ar(B) ? "" : B || ""), z.reportValidity());
  }, I = {}, T = mf(s), U = To(s), Q = T || U, J = (N || uf(s)) && dt(s.value) && dt(y) || Bs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = S4.bind(null, S, i, I), X = (B, O, q, ee = Hr.maxLength, ve = Hr.minLength) => {
    const ue = B ? O : q;
    I[S] = {
      type: B ? ee : ve,
      message: ue,
      ref: s,
      ...ie(B ? ee : ve, ue)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Q && (J || Ht(y)) || ar(y) && !y || U && !YS(l).isValid || T && !JS(l).isValid)) {
    const { value: B, message: O } = Ss(d) ? { value: !!d, message: d } : Wi(d);
    if (B && (I[S] = {
      type: Hr.required,
      message: O,
      ref: z,
      ...ie(Hr.required, O)
    }, !i))
      return $(O), I;
  }
  if (!J && (!Ht(f) || !Ht(h))) {
    let B, O;
    const q = Wi(h), ee = Wi(f);
    if (!Ht(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      Ht(q.value) || (B = ve > q.value), Ht(ee.value) || (O = ve < ee.value);
    } else {
      const ve = s.valueAsDate || new Date(y), ue = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), ce = s.type == "time", fe = s.type == "week";
      Or(q.value) && y && (B = ce ? ue(y) > ue(q.value) : fe ? y > q.value : ve > new Date(q.value)), Or(ee.value) && y && (O = ce ? ue(y) < ue(ee.value) : fe ? y < ee.value : ve < new Date(ee.value));
    }
    if ((B || O) && (X(!!B, q.message, ee.message, Hr.max, Hr.min), !i))
      return $(I[S].message), I;
  }
  if ((m || u) && !J && (Or(y) || o && Array.isArray(y))) {
    const B = Wi(m), O = Wi(u), q = !Ht(B.value) && y.length > +B.value, ee = !Ht(O.value) && y.length < +O.value;
    if ((q || ee) && (X(q, B.message, O.message), !i))
      return $(I[S].message), I;
  }
  if (g && !J && Or(y)) {
    const { value: B, message: O } = Wi(g);
    if (Hs(B) && !y.match(B) && (I[S] = {
      type: Hr.pattern,
      message: O,
      ref: s,
      ...ie(Hr.pattern, O)
    }, !i))
      return $(O), I;
  }
  if (C) {
    if (Sr(C)) {
      const B = await C(y, t), O = Pb(B, z);
      if (O && (I[S] = {
        ...O,
        ...ie(Hr.validate, O.message)
      }, !i))
        return $(O.message), I;
    } else if (ft(C)) {
      let B = {};
      for (const O in C) {
        if (!Mt(B) && !i)
          break;
        const q = Pb(await C[O](y, t), z, O);
        q && (B = {
          ...q,
          ...ie(O, q.message)
        }, $(q.message), i && (I[S] = B));
      }
      if (!Mt(B) && (I[S] = {
        ref: z,
        ...B
      }, !i))
        return I;
    }
  }
  return $(!0), I;
};
const O4 = {
  mode: _r.onSubmit,
  reValidateMode: _r.onChange,
  shouldFocusError: !0
};
function P4(e = {}) {
  let n = {
    ...O4,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Sr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ft(n.defaultValues) || ft(n.values) ? It(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : It(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Cb(),
    state: Cb()
  }, g = $b(n.mode), C = $b(n.reValidateMode), S = n.criteriaMode === _r.all, N = (E) => (x) => {
    clearTimeout(m), m = setTimeout(E, x);
  }, w = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const x = n.resolver ? Mt((await J()).errors) : await X(i, !0);
      x !== t.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (E, x) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((D) => {
      D && (x ? Qn(t.validatingFields, D, x) : bt(t.validatingFields, D));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !Mt(t.validatingFields)
    }));
  }, z = (E, x = [], D, H, Y = !0, R = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Ze(i, E))) {
        const V = D(Ze(i, E), H.argA, H.argB);
        Y && Qn(i, E, V);
      }
      if (R && Array.isArray(Ze(t.errors, E))) {
        const V = D(Ze(t.errors, E), H.argA, H.argB);
        Y && Qn(t.errors, E, V), D4(t.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Ze(t.touchedFields, E))) {
        const V = D(Ze(t.touchedFields, E), H.argA, H.argB);
        Y && Qn(t.touchedFields, E, V);
      }
      (u.dirtyFields || f.dirtyFields) && (t.dirtyFields = Qa(a, o)), h.state.next({
        name: E,
        isDirty: O(E, x),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Qn(o, E, x);
  }, $ = (E, x) => {
    Qn(t.errors, E, x), h.state.next({
      errors: t.errors
    });
  }, I = (E) => {
    t.errors = E, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, T = (E, x, D, H) => {
    const Y = Ze(i, E);
    if (Y) {
      const R = Ze(o, E, dt(D) ? Ze(a, E) : D);
      dt(R) || H && H.defaultChecked || x ? Qn(o, E, x ? R : Tb(Y._f)) : ve(E, R), s.mount && w();
    }
  }, U = (E, x, D, H, Y) => {
    let R = !1, V = !1;
    const ae = {
      name: E
    };
    if (!n.disabled) {
      if (!D || H) {
        (u.isDirty || f.isDirty) && (V = t.isDirty, t.isDirty = ae.isDirty = O(), R = V !== ae.isDirty);
        const me = ri(Ze(a, E), x);
        V = !!Ze(t.dirtyFields, E), me ? bt(t.dirtyFields, E) : Qn(t.dirtyFields, E, !0), ae.dirtyFields = t.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && V !== !me;
      }
      if (D) {
        const me = Ze(t.touchedFields, E);
        me || (Qn(t.touchedFields, E, D), ae.touchedFields = t.touchedFields, R = R || (u.touchedFields || f.touchedFields) && me !== D);
      }
      R && Y && h.state.next(ae);
    }
    return R ? ae : {};
  }, Q = (E, x, D, H) => {
    const Y = Ze(t.errors, E), R = (u.isValid || f.isValid) && ar(x) && t.isValid !== x;
    if (n.delayError && D ? (d = N(() => $(E, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Qn(t.errors, E, D) : bt(t.errors, E)), (D ? !ri(Y, D) : Y) || !Mt(H) || R) {
      const V = {
        ...H,
        ...R && ar(x) ? { isValid: x } : {},
        errors: t.errors,
        name: E
      };
      t = {
        ...t,
        ...V
      }, h.state.next(V);
    }
  }, J = async (E) => {
    y(E, !0);
    const x = await n.resolver(o, n.context, C4(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(E), x;
  }, ie = async (E) => {
    const { errors: x } = await J(E);
    if (E)
      for (const D of E) {
        const H = Ze(x, D);
        H ? Qn(t.errors, D, H) : bt(t.errors, D);
      }
    else
      t.errors = x;
    return x;
  }, X = async (E, x, D = {
    valid: !0
  }) => {
    for (const H in E) {
      const Y = E[H];
      if (Y) {
        const { _f: R, ...V } = Y;
        if (R) {
          const ae = l.array.has(R.name), me = Y._f && F4(Y._f);
          me && u.validatingFields && y([H], !0);
          const Ne = await Ab(Y, l.disabled, o, S, n.shouldUseNativeValidation && !x, ae);
          if (me && u.validatingFields && y([H]), Ne[R.name] && (D.valid = !1, x))
            break;
          !x && (Ze(Ne, R.name) ? ae ? R4(t.errors, Ne, R.name) : Qn(t.errors, R.name, Ne[R.name]) : bt(t.errors, R.name));
        }
        !Mt(V) && await X(V, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const E of l.unMount) {
      const x = Ze(i, E);
      x && (x._f.refs ? x._f.refs.every((D) => !tm(D)) : !tm(x._f.ref)) && ze(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (E, x) => !n.disabled && (E && x && Qn(o, E, x), !ri(Ie(), a)), q = (E, x, D) => qS(E, l, {
    ...s.mount ? o : dt(x) ? a : Or(E) ? { [E]: x } : x
  }, D, x), ee = (E) => hl(Ze(s.mount ? o : a, E, n.shouldUnregister ? Ze(a, E, []) : [])), ve = (E, x, D = {}) => {
    const H = Ze(i, E);
    let Y = x;
    if (H) {
      const R = H._f;
      R && (!R.disabled && Qn(o, E, QS(x, R)), Y = Bs(R.ref) && Ht(x) ? "" : x, WS(R.ref) ? [...R.ref.options].forEach((V) => V.selected = Y.includes(V.value)) : R.refs ? To(R.ref) ? R.refs.length > 1 ? R.refs.forEach((V) => (!V.defaultChecked || !V.disabled) && (V.checked = Array.isArray(Y) ? !!Y.find((ae) => ae === V.value) : Y === V.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((V) => V.checked = V.value === Y) : uf(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: E,
        values: It(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(E, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && xe(E);
  }, ue = (E, x, D) => {
    for (const H in x) {
      const Y = x[H], R = `${E}.${H}`, V = Ze(i, R);
      (l.array.has(E) || ft(Y) || V && !V._f) && !gi(Y) ? ue(R, Y, D) : ve(R, Y, D);
    }
  }, ce = (E, x, D = {}) => {
    const H = Ze(i, E), Y = l.array.has(E), R = It(x);
    Qn(o, E, R), Y ? (h.array.next({
      name: E,
      values: It(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: E,
      dirtyFields: Qa(a, o),
      isDirty: O(E, R)
    })) : H && !H._f && !Ht(R) ? ue(E, R, D) : ve(E, R, D), Rb(E, l) && h.state.next({ ...t }), h.state.next({
      name: s.mount ? E : void 0,
      values: It(o)
    });
  }, fe = async (E) => {
    s.mount = !0;
    const x = E.target;
    let D = x.name, H = !0;
    const Y = Ze(i, D), R = (V) => {
      H = Number.isNaN(V) || gi(V) && isNaN(V.getTime()) || ri(V, Ze(o, D, V));
    };
    if (Y) {
      let V, ae;
      const me = x.type ? Tb(Y._f) : zS(E), Ne = E.type === Ms.BLUR || E.type === Ms.FOCUS_OUT, nn = !I4(Y._f) && !n.resolver && !Ze(t.errors, D) && !Y._f.deps || $4(Ne, Ze(t.touchedFields, D), t.isSubmitted, C, g), fn = Rb(D, l, Ne);
      Qn(o, D, me), Ne ? (Y._f.onBlur && Y._f.onBlur(E), d && d(0)) : Y._f.onChange && Y._f.onChange(E);
      const tn = U(D, me, Ne), cn = !Mt(tn) || fn;
      if (!Ne && h.state.next({
        name: D,
        type: E.type,
        values: It(o)
      }), nn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && w() : Ne || w()), cn && h.state.next({ name: D, ...fn ? {} : tn });
      if (!Ne && fn && h.state.next({ ...t }), n.resolver) {
        const { errors: pn } = await J([D]);
        if (R(me), H) {
          const dn = Ob(t.errors, i, D), xn = Ob(pn, i, dn.name || D);
          V = xn.error, D = xn.name, ae = Mt(pn);
        }
      } else
        y([D], !0), V = (await Ab(Y, l.disabled, o, S, n.shouldUseNativeValidation))[D], y([D]), R(me), H && (V ? ae = !1 : (u.isValid || f.isValid) && (ae = await X(i, !0)));
      H && (Y._f.deps && xe(Y._f.deps), Q(D, ae, V, tn));
    }
  }, W = (E, x) => {
    if (Ze(t.errors, x) && E.focus)
      return E.focus(), 1;
  }, xe = async (E, x = {}) => {
    let D, H;
    const Y = co(E);
    if (n.resolver) {
      const R = await ie(dt(E) ? E : Y);
      D = Mt(R), H = E ? !Y.some((V) => Ze(R, V)) : D;
    } else E ? (H = (await Promise.all(Y.map(async (R) => {
      const V = Ze(i, R);
      return await X(V && V._f ? { [R]: V } : V);
    }))).every(Boolean), !(!H && !t.isValid) && w()) : H = D = await X(i);
    return h.state.next({
      ...!Or(E) || (u.isValid || f.isValid) && D !== t.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: D } : {},
      errors: t.errors
    }), x.shouldFocus && !H && uo(i, W, E ? Y : l.mount), H;
  }, Ie = (E) => {
    const x = {
      ...s.mount ? o : a
    };
    return dt(E) ? x : Or(E) ? Ze(x, E) : E.map((D) => Ze(x, D));
  }, K = (E, x) => ({
    invalid: !!Ze((x || t).errors, E),
    isDirty: !!Ze((x || t).dirtyFields, E),
    error: Ze((x || t).errors, E),
    isValidating: !!Ze(t.validatingFields, E),
    isTouched: !!Ze((x || t).touchedFields, E)
  }), qe = (E) => {
    E && co(E).forEach((x) => bt(t.errors, x)), h.state.next({
      errors: E ? t.errors : {}
    });
  }, Be = (E, x, D) => {
    const H = (Ze(i, E, { _f: {} })._f || {}).ref, Y = Ze(t.errors, E) || {}, { ref: R, message: V, type: ae, ...me } = Y;
    Qn(t.errors, E, {
      ...me,
      ...x,
      ref: H
    }), h.state.next({
      name: E,
      errors: t.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, Oe = (E, x) => Sr(E) ? h.state.subscribe({
    next: (D) => E(q(void 0, x), D)
  }) : q(E, x, !0), Me = (E) => h.state.subscribe({
    next: (x) => {
      T4(E.name, x.name, E.exact) && E4(x, E.formState || u, Pe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...t,
        ...x
      });
    }
  }).unsubscribe, $e = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Me({
    ...E,
    formState: f
  })), ze = (E, x = {}) => {
    for (const D of E ? co(E) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (bt(i, D), bt(o, D)), !x.keepError && bt(t.errors, D), !x.keepDirty && bt(t.dirtyFields, D), !x.keepTouched && bt(t.touchedFields, D), !x.keepIsValidating && bt(t.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && bt(a, D);
    h.state.next({
      values: It(o)
    }), h.state.next({
      ...t,
      ...x.keepDirty ? { isDirty: O() } : {}
    }), !x.keepIsValid && w();
  }, Re = ({ disabled: E, name: x }) => {
    (ar(E) && s.mount || E || l.disabled.has(x)) && (E ? l.disabled.add(x) : l.disabled.delete(x));
  }, an = (E, x = {}) => {
    let D = Ze(i, E);
    const H = ar(x.disabled) || ar(n.disabled);
    return Qn(i, E, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...x
      }
    }), l.mount.add(E), D ? Re({
      disabled: ar(x.disabled) ? x.disabled : n.disabled,
      name: E
    }) : T(E, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: Ja(x.min),
        max: Ja(x.max),
        minLength: Ja(x.minLength),
        maxLength: Ja(x.maxLength),
        pattern: Ja(x.pattern)
      } : {},
      name: E,
      onChange: fe,
      onBlur: fe,
      ref: (Y) => {
        if (Y) {
          an(E, x), D = Ze(i, E);
          const R = dt(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, V = N4(R), ae = D._f.refs || [];
          if (V ? ae.find((me) => me === R) : R === D._f.ref)
            return;
          Qn(i, E, {
            _f: {
              ...D._f,
              ...V ? {
                refs: [
                  ...ae.filter(tm),
                  R,
                  ...Array.isArray(Ze(a, E)) ? [{}] : []
                ],
                ref: { type: R.type, name: E }
              } : { ref: R }
            }
          }), T(E, !1, void 0, R);
        } else
          D = Ze(i, E, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(US(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && uo(i, W, l.mount), Ge = (E) => {
    ar(E) && (h.state.next({ disabled: E }), uo(i, (x, D) => {
      const H = Ze(i, D);
      H && (x.disabled = H._f.disabled || E, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || E;
      }));
    }, 0, !1));
  }, Qe = (E, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = It(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: V } = await J();
      t.errors = R, Y = V;
    } else
      await X(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Qn(Y, R, void 0);
    if (bt(t.errors, "root"), Mt(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(Y, D);
      } catch (R) {
        H = R;
      }
    } else
      x && await x({ ...t.errors }, D), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Mt(t.errors) && !H,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), H)
      throw H;
  }, he = (E, x = {}) => {
    Ze(i, E) && (dt(x.defaultValue) ? ce(E, It(Ze(a, E))) : (ce(E, x.defaultValue), Qn(a, E, It(x.defaultValue))), x.keepTouched || bt(t.touchedFields, E), x.keepDirty || (bt(t.dirtyFields, E), t.isDirty = x.defaultValue ? O(E, It(Ze(a, E))) : O()), x.keepError || (bt(t.errors, E), u.isValid && w()), h.state.next({ ...t }));
  }, ge = (E, x = {}) => {
    const D = E ? It(E) : a, H = It(D), Y = Mt(E), R = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const V = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Qa(a, o))
        ]);
        for (const ae of Array.from(V))
          Ze(t.dirtyFields, ae) ? Qn(R, ae, Ze(o, ae)) : ce(ae, Ze(R, ae));
      } else {
        if (lf && dt(E))
          for (const V of l.mount) {
            const ae = Ze(i, V);
            if (ae && ae._f) {
              const me = Array.isArray(ae._f.refs) ? ae._f.refs[0] : ae._f.ref;
              if (Bs(me)) {
                const Ne = me.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const V of l.mount)
          ce(V, Ze(R, V));
      }
      o = It(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? t.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? t.isDirty : !!(x.keepDefaultValues && !ri(E, a)),
      isSubmitted: x.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? Qa(a, o) : t.dirtyFields : x.keepDefaultValues && E ? Qa(a, E) : x.keepDirty ? t.dirtyFields : {},
      touchedFields: x.keepTouched ? t.touchedFields : {},
      errors: x.keepErrors ? t.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, De = (E, x) => ge(Sr(E) ? E(o) : E, x), Le = (E, x = {}) => {
    const D = Ze(i, E), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && Sr(Y.select) && Y.select());
    }
  }, Pe = (E) => {
    t = {
      ...t,
      ...E
    };
  }, mn = {
    control: {
      register: an,
      unregister: ze,
      getFieldState: K,
      handleSubmit: Qe,
      setError: Be,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: q,
      _getDirty: O,
      _setValid: w,
      _setFieldArray: z,
      _setDisabledField: Re,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: ge,
      _resetDefaultValues: () => Sr(n.defaultValues) && n.defaultValues().then((E) => {
        De(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ge,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: $e,
    trigger: xe,
    register: an,
    handleSubmit: Qe,
    watch: Oe,
    setValue: ce,
    getValues: Ie,
    reset: De,
    resetField: he,
    clearErrors: qe,
    unregister: ze,
    setError: Be,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...mn,
    formControl: mn
  };
}
function A4(e = {}) {
  const n = Fe.useRef(void 0), t = Fe.useRef(void 0), [i, a] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Sr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Sr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : P4(e),
    formState: i
  }, e.formControl && e.defaultValues && !Sr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Fe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Fe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Fe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Fe.useEffect(() => {
    e.values && !ri(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Fe.useEffect(() => {
    e.errors && !Mt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Fe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Fe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = BS(i, o), n.current;
}
const L4 = "_settingsWrapper_1ycvy_1", V4 = "_settingsWrapperHeader_1ycvy_6", z4 = "_settingsWrapperContent_1ycvy_10", U4 = "_settingsWrapperContentCode_1ycvy_18", M4 = "_settingsWrapperContentCURL_1ycvy_26", Xa = {
  settingsWrapper: L4,
  settingsWrapperHeader: V4,
  settingsWrapperContent: z4,
  settingsWrapperContentCode: U4,
  settingsWrapperContentCURL: M4
}, B4 = ({
  handleChangeText: e
}) => {
  const [n, t] = le(!1), { isCopied: i, copy: a } = or(), { control: o } = A4({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = HS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = ot(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Te.jsx(Te.Fragment, { children: /* @__PURE__ */ Te.jsx(be, { span: 6, children: /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", className: Xa.settingsWrapper, children: [
    /* @__PURE__ */ Te.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Xa.settingsWrapperHeader,
        onClick: () => t(!n),
        children: [
          /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Te.jsx(pe, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Te.jsxs(
      b,
      {
        flexDirection: "column",
        className: Xa.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Te.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Te.jsx(
            Gs,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Te.jsxs("ol", { children: [
                /* @__PURE__ */ Te.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Te.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Te.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Te.jsx("span", { className: Xa.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Te.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Te.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Te.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Te.jsx(
            wb,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Te.jsx(
                pr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Te.jsx(
            wb,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Te.jsx(
                pr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
            /* @__PURE__ */ Te.jsx(ln, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Te.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Xa.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Te.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Te.jsx(
              We,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Te.jsx(
                  Gn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, q4 = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], H4 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: sa
  }
], W4 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: B4
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], G4 = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, K4 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, Y4 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: t = !1
}) => t ? {
  authSettings: GV,
  featureSettings: []
} : n ? {
  authSettings: KV,
  featureSettings: [...yS]
} : e ? {
  authSettings: [
    ...zk,
    ...HV
  ],
  featureSettings: [...Uk]
} : {
  authSettings: [
    ...zk,
    ...WV
  ],
  featureSettings: [...Uk]
}, XS = (e, n) => ({
  hasOAuth: t = !1,
  isCreationMode: i = !1
}) => t || i ? e : n, Q4 = XS(
  H4,
  W4
), J4 = XS(
  oD,
  sD
), ZS = ({
  key: e,
  configuration: n,
  settingType: t,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = K4(a?.value, t), s = i !== void 0 ? i : G4(
    t
  );
  return o !== void 0 ? o : s;
}, pf = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: t, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = Y4(n), s = Q4(t), l = J4(i);
  return {
    SHOPIFY: {
      widget: eU,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: DT,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: gm,
      WidgetSettings: PT
    },
    GITHUB: {
      widget: OI,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: fm,
      WidgetSettings: AI
    },
    MIUROS: {
      widget: iV,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: Pm,
      WidgetSettings: oV
    },
    KLAVIYO: {
      widget: iD,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...aD]
    },
    LINEAR: {
      widget: $2,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: $m,
      WidgetSettings: R2
    },
    VOYADO: {
      widget: JM,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...XM]
    },
    LOYALTYLION: {
      widget: uL,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: Dm,
      WidgetSettings: pL
    },
    RECHARGE: {
      widget: TV,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: Vm,
      WidgetSettings: DV
    },
    BRAZE: {
      widget: Jw,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...Xw]
    },
    YOTPO: {
      widget: g4,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...q4]
    },
    INGRID: {
      widget: dE,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: hm,
      WidgetSettings: mE
    }
  };
}, X4 = (e, n) => {
  const t = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? g0(t, e.defaultValue) : v0(t, e.defaultValue);
}, Z4 = (e, n) => e.map((t) => ({
  key: t.key,
  value: X4(t, n)
})), eB = (e, n) => e.map(({ key: t, type: i, defaultValue: a }) => ({
  key: t,
  value: ZS({
    key: t,
    configuration: n,
    settingType: i,
    settingDefault: a
  })
})), nB = ({ fieldDefinitions: e, settingsConfiguration: n }, t) => e ? Z4(
  e.filter(({ secret: i }) => !i),
  t
) : eB(
  (n ?? []).filter(({ secret: i }) => !i),
  t
), tB = (e) => {
  const n = pf();
  return e.map(
    ({
      id: t,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: d
    }) => {
      const u = n[i];
      return {
        id: t,
        type: i,
        name: a,
        settings: nB(u, o),
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: d
      };
    }
  );
}, JB = ({
  widgets: e,
  configuration: n,
  conversationContext: t,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: u
}) => {
  const f = vi(
    {}
  ), h = (T) => (f.current[T] || (f.current[T] = { current: null }), f.current[T]), { track: g } = _n(), C = Bn(
    () => tB(e),
    [e]
  ), S = {
    headline: "",
    text: "",
    onConfirm: () => I(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [N, w] = le(S), [y, z] = le(!1), $ = (T) => {
    z(!0), w(T);
  }, I = () => {
    z(!1), w(S);
  };
  return /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
    C.map(
      ({
        id: T,
        name: U,
        type: Q,
        widget: J,
        settings: ie,
        misconfigured: X,
        renderConditions: B,
        icon: O,
        iconColors: q,
        integrationKey: ee
      }, ve) => {
        const ue = `partner-integration-${Q}`, ce = u?.get(T) === !1, fe = /* @__PURE__ */ Ve.jsx(Xm, { icon: O, color: q }), W = ie?.reduce(
          (xe, Ie) => (xe[Ie.key] = Ie.value, xe),
          {}
        );
        return s ? /* @__PURE__ */ Ve.jsx("div", { className: "icon-holder", children: fe }, `partner-icon-${T}`) : /* @__PURE__ */ Ve.jsxs(
          mr,
          {
            onToggle: () => {
              g(
                o(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: T,
                  widgetType: Q.toLowerCase()
                }
              ), a(ee);
            },
            isOpen: o(ee),
            className: ue,
            containerRef: (xe) => {
              h(ee).current = xe;
            },
            children: [
              /* @__PURE__ */ Ve.jsx(
                mr.Header,
                {
                  className: it({
                    [Sw.unmatchedHeader]: ce
                  }),
                  wrap: "normal",
                  avatar: fe,
                  slotBeforeTitle: d?.(
                    ee,
                    ve,
                    h(ee)
                  ),
                  slotAfterTitle: /* @__PURE__ */ Ve.jsx(Ve.Fragment, { children: l?.(ee) }),
                  children: /* @__PURE__ */ Ve.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    U,
                    m?.(
                      B ?? [],
                      T
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ Ve.jsx(mr.Content, { children: X ? /* @__PURE__ */ Ve.jsx(Fn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ve.jsx(
                Qb.Provider,
                {
                  value: {
                    onError: (xe, Ie) => console.warn(
                      `Something went wrong with a partner widget of type '${Q}' and id '${T}'`,
                      xe,
                      Ie
                    )
                  },
                  children: /* @__PURE__ */ Ve.jsx(
                    Ex,
                    {
                      integrationId: T,
                      type: Q,
                      configuration: n,
                      showNotification: i,
                      showModal: $,
                      children: F0(J, {
                        conversationContext: t,
                        settings: W
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Kb,
      {
        isOpen: y,
        setIsOpen: z,
        headline: N.headline,
        text: N.text,
        confirmLabel: N.confirmLabel,
        confirmVariant: N.confirmVariant,
        cancelLabel: N.cancelLabel,
        cancelVariant: N.cancelVariant,
        onConfirm: N.onConfirm ? () => {
          try {
            N.onConfirm && N.onConfirm();
          } finally {
            z(!1), w(S);
          }
        } : void 0,
        onCancel: N.onCancel ? () => {
          try {
            N.onCancel && N.onCancel();
          } finally {
            z(!1), w(S);
          }
        } : void 0,
        children: N.children
      }
    )
  ] });
}, rB = Ks`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function XB(e, { skip: n = !1 } = {}) {
  const [t, i] = le([]), [a, o] = le(!1);
  return He(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Ix(e).query({
      query: rB
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: t
  };
}
const iB = ({
  widgetConfiguration: e
}) => {
  const n = Bn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), t = Bn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: t,
    initialValuesForShopify: []
  };
}, aB = "FULL_ACCESS", oB = "2", sB = ({
  type: e,
  baseUrl: n
}) => {
  const t = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: t,
        scopes: [aB],
        version: oB
      })
    }).then((l) => l.json())
  };
}, lB = "dixaApiToken", ff = "dixaApiTokenId", e0 = "dixaApiTokenName", Lb = (e) => [ff, e0].every(
  (t) => e.find((i) => i?.key === t)
);
function cB({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const t = dB(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(t, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const dB = (e) => [
  {
    key: lB,
    value: e.value,
    secret: !0
  },
  {
    key: ff,
    value: e.id,
    secret: !1
  },
  {
    key: e0,
    value: e.name,
    secret: !1
  }
], uB = "_wrapper_1lmim_1", mB = "_wrapperBox_1lmim_4", pB = "_wrapperBoxErrorBorder_1lmim_9", rm = {
  wrapper: uB,
  wrapperBox: mB,
  wrapperBoxErrorBorder: pB
}, fB = ({
  required: e,
  readOnly: n,
  isSecret: t,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (z) => z.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: g } = f, C = `Insert your ${h.label.toLowerCase()}`, S = `Insert your ${g.label.toLowerCase()}`, [N, w] = le({
    username: "",
    password: ""
  }), y = ot(
    (z) => {
      m({
        target: {
          name: s,
          value: z
        }
      });
    },
    [s, m]
  );
  return He(() => {
    y(
      N.username !== "" && N.password !== "" ? window.btoa(`${N.username}:${N.password}`) : ""
    );
  }, [N]), /* @__PURE__ */ Ve.jsx(
    ln,
    {
      required: e,
      label: a,
      meta: l,
      className: rm.wrapper,
      children: /* @__PURE__ */ Ve.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: it(rm.wrapperBox, {
            [rm.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ve.jsx(
              pr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: C,
                input: {
                  name: s,
                  value: N.username,
                  onChange: (z) => w({
                    username: z?.target.value ?? "",
                    password: N.password
                  })
                },
                ...t && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ve.jsx(
              pr,
              {
                noAlert: !0,
                required: e,
                label: g.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: N.password,
                  onChange: (z) => w({
                    username: N.username,
                    password: z?.target.value ?? ""
                  })
                },
                ...t && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function Vb({
  isSecret: e,
  widgetSettingsKey: n,
  label: t,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: g,
  isCreationMode: C,
  prefix: S,
  integrationId: N,
  integrationType: w,
  configuration: y,
  settings: z,
  otherProps: $
}) {
  const I = g === "custom" && $?.component, T = u(n)?.value;
  return I ? /* @__PURE__ */ Ve.jsx(
    I,
    {
      configuration: y,
      integrationId: N,
      integrationType: w,
      label: t,
      settings: z,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
    /* @__PURE__ */ Ve.jsx(be, { span: 3, children: /* @__PURE__ */ Ve.jsx(
      hB,
      {
        widgetSettingsKey: n,
        label: t,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: C,
        children: g === "input" ? /* @__PURE__ */ Ve.jsx(
          pr,
          {
            required: i,
            readOnly: a,
            label: t,
            placeholder: o,
            input: {
              name: n,
              value: T,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: S,
            ...e && !C && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : g === "basicAuthInput" ? /* @__PURE__ */ Ve.jsx(
          fB,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: C,
            label: t,
            widgetSettingsKey: n,
            settings: z,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : g === "switch" ? /* @__PURE__ */ Ve.jsx(ln, { label: t, children: /* @__PURE__ */ Ve.jsx(
          Jb,
          {
            input: {
              name: n,
              value: "",
              checked: T,
              onChange: l
            }
          }
        ) }) : g === "select" ? /* @__PURE__ */ Ve.jsx(ln, { label: t, children: /* @__PURE__ */ Ve.jsx(
          ei,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => d(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ Ve.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ Ve.jsx(Ve.Fragment, {}),
            value: T ? [
              {
                label: ($?.selectItems || []).find(
                  (U) => U.value === T
                )?.label,
                value: T
              }
            ] : [],
            equalityFn: (U, Q) => U.value === Q.value,
            children: ($?.selectItems || []).map((U) => /* @__PURE__ */ Ve.jsx(ut.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ Ve.jsx(Ve.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ve.jsx(be, { span: 3 })
  ] });
}
function hB({
  widgetSettingsKey: e,
  label: n,
  isEditingField: t,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return t || o ? a : /* @__PURE__ */ Ve.jsx(ln, { label: n, children: /* @__PURE__ */ Ve.jsxs(
    Gn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const mo = "partner-integrations-widget-name-form-field", zb = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: t = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: ZS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: t ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), yB = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [t, i] = le(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = le({}), s = ($) => i($), l = ($) => !$ || $ === "", d = ($) => {
    const { [$]: I, ...T } = a;
    o(T);
  }, m = ($) => ({
    ...$,
    settings: $.settings.filter(({ isEditing: I }) => I).map(({ key: I, value: T, secret: U }) => ({
      key: I,
      value: T,
      secret: U
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = ($) => {
    if (!$)
      return;
    const {
      target: { name: I, value: T }
    } = $;
    a[I] && !l(T) && d(I), i({
      ...t,
      settings: t.settings.map(
        (U) => U.key === I ? { ...U, value: T } : U
      )
    });
  }, h = ($) => {
    if (!$)
      return;
    const {
      target: { name: I, checked: T }
    } = $;
    i({
      ...t,
      settings: t.settings.map(
        (U) => U.key === I ? { ...U, value: T } : U
      )
    });
  }, g = ($, I) => {
    if (!I)
      return;
    const { selectedValues: T } = I, U = T?.[0];
    if (U) {
      const Q = t.settings.map(
        (J) => J.key === $ ? { ...J, value: U?.value } : J
      );
      i({
        ...t,
        settings: Q
      });
    } else {
      const Q = t.settings.filter(
        (J) => J.key !== $
      );
      i({
        ...t,
        settings: Q
      });
    }
  }, C = ($) => {
    i({
      ...t,
      enabled: $
    });
  }, S = ($) => {
    if (!$)
      return;
    const {
      target: { value: I }
    } = $;
    a[mo] && !l(I) && d(mo), i({
      ...t,
      name: I
    });
  }, N = ($, I) => {
    const { settings: T } = t, U = T.map((Q) => Q.key === I ? {
      ...Q,
      isEditing: $,
      ...!$ && { value: "" }
    } : Q);
    a[I] && !$ && d(I), i({
      ...t,
      settings: U
    });
  }, w = ($) => t.settings.find(
    (I) => I.key === $
  ), y = async ($) => {
    $.preventDefault(), z() && n(m(t));
  }, z = () => {
    const $ = {}, { name: I, settings: T } = t;
    return l(I) && ($[mo] = u.input), T.forEach(
      ({ key: U, value: Q, required: J, isEditing: ie, type: X, customValidation: B }) => {
        if (J && ie)
          if (B) {
            const O = B(Q);
            typeof O == "string" && ($[U] = O);
          } else
            typeof Q == "string" && l(Q) && ($[U] = u[X]);
      }
    ), o($), !Object.keys($)?.length;
  };
  return {
    formData: t,
    errors: a,
    handleIsEnabled: C,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: g,
    handleEditSecret: N,
    handleChangeName: S,
    handleSubmit: y,
    getSettingValueByKey: w,
    initializeFormData: s,
    validate: z
  };
}, gB = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], Ub = "The configuration of the integration is not correct. Please check the settings.", vB = (e) => {
  const n = pf()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ Ve.jsx(n, { ...e }) : /* @__PURE__ */ Ve.jsx(kB, { ...e });
}, kB = ({
  integrationId: e,
  type: n,
  handleRedirect: t,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = _n(), { deleteDixaApiToken: d, createDixaApiToken: m } = sB({
    type: n,
    baseUrl: a.baseUrl
  }), f = W0().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, g = gB.includes(n), [C, S] = le(), [N, w] = le(!1), [y, z] = le(!1), [$, I] = le(!1), [T, U] = le(null), [Q, J] = le(), [ie, X] = le(h ? [] : null);
  He(() => {
    X(h ? [] : null);
  }, [e, h]), He(() => {
    Q && ie === null && X(Q.renderConditions ?? []);
  }, [Q, ie]);
  const { isInboundOAuth: B } = k0(), O = B && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: q,
    isShopifyMarketplaceApp: ee,
    initialValuesForShopify: ve
  } = iB({
    featureFlags: a.featureFlags,
    widgetConfiguration: Q
  }), ue = n === "YOTPO" && !!Q?.additionalProperties?.isUsingOAuth, ce = n === "KLAVIYO" && !!Q?.additionalProperties?.isUsingOAuth, fe = h && n === "SHOPIFY", Ie = pf({
    SHOPIFY: {
      hasShopifyOAuth: q,
      isShopifyMarketplaceApp: ee,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: ue,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: ce,
      isCreationMode: h
    }
  })[n].settingsConfiguration ?? [], K = Ie.filter(({ type: H }) => H !== "hidden").filter(({ hideOnCreate: H }) => h ? !H : !0), qe = K.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm === !0
  ), Be = K.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm !== !0
  ), {
    error: Oe,
    loading: Me,
    refetch: $e
  } = B0(b0, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (H) => {
      if (Object.keys(H).length === 0)
        I(!0);
      else {
        I(!1);
        const Y = H?.Management?.widgetConfigurations?.[0];
        Y && J({
          ...Y,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${Y.id}`,
          additionalProperties: Y.additionalProperties ?? void 0
        });
      }
    }
  }), [ze, { error: Re }] = gf(
    h ? x0 : _0,
    {
      onError: (H) => {
        S(H), w(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (H) => {
        if (w(!1), Object.keys(H).length !== 0) {
          if (h && t(
            H.Management?.createWidgetConfiguration?.id
          ), !h) {
            const R = H.Management?.updateWidgetConfiguration;
            R?.misconfigured ? U(
              R.misconfigurationCause ?? Ub
            ) : U(null);
          }
          if ((h || s) && ie) {
            const Y = (Q?.renderConditions?.length ?? 0) > 0;
            S0(
              l,
              h,
              ie,
              Y
            );
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [an] = gf(N0, {
    onError: (H) => {
      S(H), w(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      w(!1), t(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ee,
    handleIsEnabled: Ge,
    errors: Qe,
    handleChangeText: he,
    handleChangeBoolean: ge,
    handleChangeSelect: De,
    handleEditSecret: Le,
    handleChangeName: Pe,
    handleSubmit: mn,
    getSettingValueByKey: E,
    initializeFormData: x
  } = yB({
    onSubmit: async (H) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), w(!0);
      const Y = H.settings.map(
        (me) => typeof me.value == "boolean" ? { ...me, value: me.value.toString() } : me
      ), R = Lb(Y) && h;
      let V = [];
      if (R) {
        const me = await m().catch(
          (Ne) => {
            w(!1), console.warn("API-Token (creation) error resonse", Ne), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        me?.data && (V = cB({
          token: me.data,
          settings: Y
        }));
      }
      const ae = {
        ...H,
        settings: [
          ...V.length > 0 ? V : Y
        ]
      };
      (R && V.length > 1 || !R && V.length === 0) && (ze({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...ae,
          ...(h || !!s) && ie !== null && { renderConditions: ie }
        }
      }), Y.forEach(
        (Ne) => Ne.secret && Le(!1, Ne.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: zb({
          settingsFromBackend: ve,
          settingsConfiguration: Ie,
          creating: !0
        })
      }
    }
  });
  He(() => {
    if (Q) {
      const H = zb({
        settingsFromBackend: Q.settings,
        settingsConfiguration: Ie
      });
      x({
        enabled: !!Q.enabled,
        name: Q.name,
        settings: H
      }), Q.misconfigured ? U(
        Q?.misconfigurationCause ?? Ub
      ) : U(null);
    }
  }, [Q]);
  const D = Bn(() => o ? !o.isCoupled : !0, [o]);
  return Oe || Re || C ? /* @__PURE__ */ Ve.jsx(
    Fn,
    {
      error: Oe || C,
      retry: Oe ? $e : void 0
    }
  ) : N || Me ? /* @__PURE__ */ Ve.jsx(un, { "data-testid": "widget-settings-loading" }) : $ ? /* @__PURE__ */ Ve.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ve.jsx(An, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ve.jsxs("form", { children: [
    T && /* @__PURE__ */ Ve.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ve.jsx(
      Gs,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ve.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ve.jsx(A.Paragraph, { children: T }),
          /* @__PURE__ */ Ve.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ve.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ve.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ve.jsxs(
      st,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          qe.map(
            ({ key: H, label: Y, ...R }) => /* @__PURE__ */ Ve.jsx(
              Vb,
              {
                widgetSettingsKey: H,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: E,
                isSecret: !1,
                label: Y,
                placeholder: "",
                required: !1,
                errors: Qe,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: Ie,
                otherProps: R
              },
              H
            )
          ),
          !fe && /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
            /* @__PURE__ */ Ve.jsx(be, { children: /* @__PURE__ */ Ve.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ve.jsx(
              Jb,
              {
                input: {
                  name: "enabled",
                  checked: Ee.enabled,
                  value: "dummy",
                  onChange: (H) => Ge(H.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ve.jsx(be, { span: 3, children: /* @__PURE__ */ Ve.jsx(
              pr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: mo,
                  value: Ee.name,
                  onChange: Pe
                },
                meta: {
                  error: Qe[mo]
                }
              }
            ) }),
            /* @__PURE__ */ Ve.jsx(be, { span: 3 })
          ] }),
          !fe && s && ie !== null && /* @__PURE__ */ Ve.jsx(be, { children: s({
            value: ie,
            onChange: X,
            configurationKey: Q?.id
          }) }),
          Be?.map(
            ({
              key: H,
              secret: Y,
              label: R,
              placeholder: V = "",
              required: ae = !1,
              type: me,
              prefix: Ne,
              readOnly: nn,
              ...fn
            }) => {
              const { settings: tn } = Ee, cn = tn.find(
                (pn) => pn.key === H
              );
              return /* @__PURE__ */ Ve.jsx(I0, { children: /* @__PURE__ */ Ve.jsx(
                Vb,
                {
                  widgetSettingsKey: H,
                  isEditingField: !!cn?.isEditing,
                  handleEditSecret: Le,
                  handleChangeText: he,
                  handleChangeBoolean: ge,
                  handleChangeSelect: De,
                  getValueByKey: E,
                  isSecret: Y,
                  label: R,
                  placeholder: V,
                  required: ae,
                  errors: Qe,
                  type: me,
                  isCreationMode: h,
                  prefix: Ne,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: nn,
                  settings: Ie,
                  otherProps: fn
                }
              ) }, H);
            }
          )
        ]
      }
    ),
    !fe && /* @__PURE__ */ Ve.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ve.jsx(Gn, { onClick: mn, children: O }),
      !h && /* @__PURE__ */ Ve.jsx(
        We,
        {
          content: "The widget is used in automations",
          disabled: D,
          children: /* @__PURE__ */ Ve.jsx(
            Gn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), z(!0);
              },
              disabled: !D,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ve.jsx(
      Kb,
      {
        isOpen: y,
        setIsOpen: z,
        confirmVariant: g ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), Lb(Ee.settings)) {
            const H = Ee.settings.find(
              ({ key: Y }) => Y === ff
            )?.value;
            H && d(H).catch((Y) => {
              console.warn("API-Token (deletion) error response", Y), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          an({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ve.jsx(b, { children: g ? /* @__PURE__ */ Ve.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ve.jsx(
            pe,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ve.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ve.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ve.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ee.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ee.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, ZB = ({
  configuration: e,
  integrationId: n,
  type: t,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ Ve.jsx(
  Qb.Provider,
  {
    value: {
      onError: (l, d) => console.warn(
        `Something went wrong with the partner widget settings of type ${t} and id ${n}`,
        l,
        d
      )
    },
    children: /* @__PURE__ */ Ve.jsx(
      Ex,
      {
        integrationId: n,
        type: t,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ve.jsx(
          vB,
          {
            configuration: e,
            integrationId: n,
            type: t,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), Mb = "__PairingContext__", n0 = globalThis[Mb] ?? (() => {
  const e = Yb({});
  return globalThis[Mb] = e, e;
})(), e5 = () => Qm(n0), n5 = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Ve.jsx(n0.Provider, { value: e, children: n });
var ls = { exports: {} }, Bb;
function bB() {
  if (Bb) return ls.exports;
  Bb = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(I, T, U) {
    return Function.prototype.apply.call(I, T, U);
  }, t;
  e && typeof e.ownKeys == "function" ? t = e.ownKeys : Object.getOwnPropertySymbols ? t = function(I) {
    return Object.getOwnPropertyNames(I).concat(Object.getOwnPropertySymbols(I));
  } : t = function(I) {
    return Object.getOwnPropertyNames(I);
  };
  function i($) {
    console && console.warn && console.warn($);
  }
  var a = Number.isNaN || function(I) {
    return I !== I;
  };
  function o() {
    o.init.call(this);
  }
  ls.exports = o, ls.exports.once = w, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l($) {
    if (typeof $ != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof $);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function($) {
      if (typeof $ != "number" || $ < 0 || a($))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + $ + ".");
      s = $;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(I) {
    if (typeof I != "number" || I < 0 || a(I))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + I + ".");
    return this._maxListeners = I, this;
  };
  function d($) {
    return $._maxListeners === void 0 ? o.defaultMaxListeners : $._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(I) {
    for (var T = [], U = 1; U < arguments.length; U++) T.push(arguments[U]);
    var Q = I === "error", J = this._events;
    if (J !== void 0)
      Q = Q && J.error === void 0;
    else if (!Q)
      return !1;
    if (Q) {
      var ie;
      if (T.length > 0 && (ie = T[0]), ie instanceof Error)
        throw ie;
      var X = new Error("Unhandled error." + (ie ? " (" + ie.message + ")" : ""));
      throw X.context = ie, X;
    }
    var B = J[I];
    if (B === void 0)
      return !1;
    if (typeof B == "function")
      n(B, this, T);
    else
      for (var O = B.length, q = C(B, O), U = 0; U < O; ++U)
        n(q[U], this, T);
    return !0;
  };
  function m($, I, T, U) {
    var Q, J, ie;
    if (l(T), J = $._events, J === void 0 ? (J = $._events = /* @__PURE__ */ Object.create(null), $._eventsCount = 0) : (J.newListener !== void 0 && ($.emit(
      "newListener",
      I,
      T.listener ? T.listener : T
    ), J = $._events), ie = J[I]), ie === void 0)
      ie = J[I] = T, ++$._eventsCount;
    else if (typeof ie == "function" ? ie = J[I] = U ? [T, ie] : [ie, T] : U ? ie.unshift(T) : ie.push(T), Q = d($), Q > 0 && ie.length > Q && !ie.warned) {
      ie.warned = !0;
      var X = new Error("Possible EventEmitter memory leak detected. " + ie.length + " " + String(I) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      X.name = "MaxListenersExceededWarning", X.emitter = $, X.type = I, X.count = ie.length, i(X);
    }
    return $;
  }
  o.prototype.addListener = function(I, T) {
    return m(this, I, T, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(I, T) {
    return m(this, I, T, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f($, I, T) {
    var U = { fired: !1, wrapFn: void 0, target: $, type: I, listener: T }, Q = u.bind(U);
    return Q.listener = T, U.wrapFn = Q, Q;
  }
  o.prototype.once = function(I, T) {
    return l(T), this.on(I, f(this, I, T)), this;
  }, o.prototype.prependOnceListener = function(I, T) {
    return l(T), this.prependListener(I, f(this, I, T)), this;
  }, o.prototype.removeListener = function(I, T) {
    var U, Q, J, ie, X;
    if (l(T), Q = this._events, Q === void 0)
      return this;
    if (U = Q[I], U === void 0)
      return this;
    if (U === T || U.listener === T)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Q[I], Q.removeListener && this.emit("removeListener", I, U.listener || T));
    else if (typeof U != "function") {
      for (J = -1, ie = U.length - 1; ie >= 0; ie--)
        if (U[ie] === T || U[ie].listener === T) {
          X = U[ie].listener, J = ie;
          break;
        }
      if (J < 0)
        return this;
      J === 0 ? U.shift() : S(U, J), U.length === 1 && (Q[I] = U[0]), Q.removeListener !== void 0 && this.emit("removeListener", I, X || T);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(I) {
    var T, U, Q;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[I] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[I]), this;
    if (arguments.length === 0) {
      var J = Object.keys(U), ie;
      for (Q = 0; Q < J.length; ++Q)
        ie = J[Q], ie !== "removeListener" && this.removeAllListeners(ie);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (T = U[I], typeof T == "function")
      this.removeListener(I, T);
    else if (T !== void 0)
      for (Q = T.length - 1; Q >= 0; Q--)
        this.removeListener(I, T[Q]);
    return this;
  };
  function h($, I, T) {
    var U = $._events;
    if (U === void 0)
      return [];
    var Q = U[I];
    return Q === void 0 ? [] : typeof Q == "function" ? T ? [Q.listener || Q] : [Q] : T ? N(Q) : C(Q, Q.length);
  }
  o.prototype.listeners = function(I) {
    return h(this, I, !0);
  }, o.prototype.rawListeners = function(I) {
    return h(this, I, !1);
  }, o.listenerCount = function($, I) {
    return typeof $.listenerCount == "function" ? $.listenerCount(I) : g.call($, I);
  }, o.prototype.listenerCount = g;
  function g($) {
    var I = this._events;
    if (I !== void 0) {
      var T = I[$];
      if (typeof T == "function")
        return 1;
      if (T !== void 0)
        return T.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? t(this._events) : [];
  };
  function C($, I) {
    for (var T = new Array(I), U = 0; U < I; ++U)
      T[U] = $[U];
    return T;
  }
  function S($, I) {
    for (; I + 1 < $.length; I++)
      $[I] = $[I + 1];
    $.pop();
  }
  function N($) {
    for (var I = new Array($.length), T = 0; T < I.length; ++T)
      I[T] = $[T].listener || $[T];
    return I;
  }
  function w($, I) {
    return new Promise(function(T, U) {
      function Q(ie) {
        $.removeListener(I, J), U(ie);
      }
      function J() {
        typeof $.removeListener == "function" && $.removeListener("error", Q), T([].slice.call(arguments));
      }
      z($, I, J, { once: !0 }), I !== "error" && y($, Q, { once: !0 });
    });
  }
  function y($, I, T) {
    typeof $.on == "function" && z($, "error", I, T);
  }
  function z($, I, T, U) {
    if (typeof $.on == "function")
      U.once ? $.once(I, T) : $.on(I, T);
    else if (typeof $.addEventListener == "function")
      $.addEventListener(I, function Q(J) {
        U.once && $.removeEventListener(I, Q), T(J);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof $);
  }
  return ls.exports;
}
var xB = bB();
function t5() {
  const e = new xB.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  vw as GraphQLClientProvider,
  n0 as PairingContext,
  n5 as PairingProvider,
  JB as PartnerIntegrations,
  ZB as PartnerIntegrationsSettings,
  pf as getWidgetDefinitions,
  t5 as initializePartnerEventEmitter,
  e5 as usePairing,
  XB as usePartnerIntegrationWidgetConfigurations,
  iB as useShopifyConfiguration
};
